import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactTable from 'react-table';
import {
    Row,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Col,
    ButtonGroup,
    Badge,
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import ReactBSAlert from 'react-bootstrap-sweetalert';
import axios from 'axios';
import moment from 'moment';
import Select from 'react-select';
import { useQuery, useSubscription } from '@apollo/react-hooks';
import { ResizableBox } from 'react-resizable';
import io from 'socket.io-client';
import config from '../../config';

import {
    FaHourglassHalf,
    FaPeopleCarry,
    FaHome,
    FaRegCheckCircle,
    FaClock,
    FaBookmark,
    FaExclamationTriangle,
    FaCaretDown,
    FaCaretRight,
    FaExclamationCircle
} from 'react-icons/fa';

import { GET_DISPATCH_COMPLETED_ROUTE_PAGE, GET_DISPATCH_MONTHLY_METRICS, GET_DISPATCH_ROUTE_LIST, GET_DISPATCH_SHIPMENTS, SUBSCRIBE_TO_SHIPMENTS, SUBSCRIBE_TO_ROUTES } from '../../graphql/ShipmentQueries';
// import { SUBSCRIBE_TO_DRIVERS } from '../../graphql/GetDriversQueries';
// import { usersClient } from '../../Auth/apolloClientUser';
import * as shipment_urls from '../../urls/api-shipments/admin';
import * as user_urls from '../../urls/api-users/admin';
import states from '../../us_states';
import { formatTimestamp } from '../../helpers/formatter';
// import Multiplayer from '../Multiplayer';

import Loading from '../../components/Global/Loading';
import './DispatchOrderTable.css';
import './react-resizable.css';
import './Marker.css';

import DispatchMap from './DispatchMap';
import MapFilters from './MapFilters';
import FloatingChatWindow from './FloatingChatWindow';
import crmClient from '../../views/crm/crmClient';
// import { gql } from 'apollo-boost';
import DispatchMarketsSelection from './DispatchMarketsSelection';
import { useGlobalContext } from '../../context';
import { useTheme } from '../../contexts/ThemeContext';
import {
    buildAuthorizationHeader,
    decodeJwtPayload,
    getStoredAccessToken,
    getStoredIdToken,
    hasStoredSessionTokens,
    notifySessionExpired,
    renewSessionSilently
} from '../../Auth/session';

import ReorderWaypoints from './ReorderWaypoints';

import useSound from 'use-sound';
import Sound from '../../assets/CashRegister.mp3';
import IncomingTextSound from '../../assets/example.mp3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faPhone, faEnvelope, faPaperPlane, faPaperclip, faTimes, faCopy } from '@fortawesome/free-solid-svg-icons';
import DriverSMSRefreshButton from './HelperComponents/DriverSMSRefreshButton';
import MessageLogsContainer from './HelperComponents/MessageLogsContainer';
import { getCustomerNameFromRoute } from './HelperFunctions/CustomerNames';
import { RouteTotalDriverPays } from './HelperFunctions/RouteTotalDriverPays';
import ETAUpdate from './HelperComponents/ETAUpdate';
import FileUpload from '../SharedComponents/FileUpload';
import FileViewer from '../SharedComponents/FileViewer';
import CompleteOrderButton from './HelperComponents/CompleteOrderButton';
import CompleteOrderModal from './HelperComponents/CompleteOrderModal';
import ArrivalOverrideRequestModal from './HelperComponents/ArrivalOverrideRequestModal';
import FedexLabelModal from '../SharedComponents/FedexLabelModal';
import FedexTrackingModal from '../SharedComponents/FedexTrackingModal';
import PaymentRetryModal from '../SharedComponents/PaymentRetryModal';
import PhotoGallery from '../SharedComponents/PhotoGallery';
import DriverPartnerPanel from '../Drivers/DriverPartnerPanel';
import DriverCompliancePanel, { DriverComplianceValidBadge } from '../Drivers/DriverCompliancePanel';
import laptop from '../../assets/img/laptop.png';
import mobile from '../../assets/img/mobile-phone.png';
import { checkPaymentStatus, extractInvoiceLinks, getPaymentErrorMessage } from '../../services/paymentService';
import { DASHBOARD_PERF_MARKS, markDashboardPerformance, measureDashboardPerformance } from '../../utils/dashboardPerformance';
import { getRealtimeTransportPolicy, isDashboardLocalDebugMode, isLocalLikeHost, isProductionStage, resolveDashboardClientEnv } from '../../utils/environmentMode';
import { getVehicleRenderUrl, getVehicleIdentity, resolveDriverActiveVehicle, resolveDriverVehicle } from '../../utils/vehicleImage';

const vehicleTypeOptions = require('../../vehicle_types');

const dispatchUsersHost = user_urls.dispatchUsersHost || user_urls.usersHost;
const DEFAULT_DEV_USERS_HASURA_HOST = 'https://dev-api-users.hasura.gophr.app/v1/graphql';
const DEFAULT_PROD_USERS_HASURA_HOST = 'https://api-users.hasura.gophr.app/v1/graphql';
const apiFilesHost = config.config.api_files.host;
const claimedOrderChatEndpoint = `${shipment_urls.shipmentHost}/dispatch/chat/thread`;
const claimedOrderChatSummariesEndpoint = `${claimedOrderChatEndpoint}/summaries`;
const preClaimOrderChatEndpoint = `${shipment_urls.shipmentHost}/dispatch/chat/preclaim/thread`;
const preClaimOrderChatSummariesEndpoint = `${preClaimOrderChatEndpoint}/summaries`;
const OPTIONAL_DISPATCH_ENDPOINT_CACHE_PREFIX = 'dispatch_optional_endpoint_unsupported:';
const clientEnv = resolveDashboardClientEnv();
const CLAIMED_ORDER_CHAT_POLL_INTERVAL_MS = 5 * 1000;
const OPEN_CHAT_THREAD_POLL_INTERVAL_MS = 60 * 1000;
const SESSION_RECOVERED_EVENT = 'gophr:session-recovered';
const VEHICLE_TYPE_LABELS = vehicleTypeOptions.reduce(
    (lookup, option) => {
        lookup[option.val] = option.label;
        return lookup;
    },
    {}
);

Object.assign(VEHICLE_TYPE_LABELS, {
    car: 'Car',
    pickup_truck: '1/2 Ton Pickup',
    truck: '1/2 Ton Pickup',
    heavy_duty_truck: '1 Ton Pickup',
    trailer: 'Truck and Trailer',
    van: 'Sprinter Van',
    semi_truck: 'Semi/Tractor',
    tractor_semi: 'Semi/Tractor'
}
);
const formatFuelPrice = value => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toFixed(2) : 'N/A';
};

const DEFAULT_COMPLETED_ROUTE_PAGE_SIZE = 50;
const COMPLETED_ROUTE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const getVehicleTypeLabel = vehicleType => {
    if (!vehicleType) {
        return '';
    }

    return (
        VEHICLE_TYPE_LABELS[vehicleType] ||
        vehicleType
            .split('_')
            .map(segment => segment.charAt(0).toUpperCase() + segment.substring(1))
            .join(' ')
    );
};

const getAlternateUsersHasuraHost = host => {
    if (typeof host !== 'string' || host.trim() === '') {
        return null;
    }

    if (host.includes('dev-api-users.hasura.gophr.app')) {
        return DEFAULT_PROD_USERS_HASURA_HOST;
    }

    if (host.includes('api-users.hasura.gophr.app') && !host.includes('dev-api-users.hasura.gophr.app')) {
        return DEFAULT_DEV_USERS_HASURA_HOST;
    }

    return null;
};

const normalizeDriverStatusFlag = value => {
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value === 1;
    }

    if (typeof value === 'string') {
        const normalizedValue = value.trim().toLowerCase();

        if (['true', '1', 'yes', 'y', 'on', 'online', 'available'].includes(normalizedValue)) {
            return true;
        }

        if (['false', '0', 'no', 'n', 'off', 'offline', 'unavailable', 'enroute', 'busy'].includes(normalizedValue)) {
            return false;
        }
    }

    return Boolean(value);
};

const ACTIVE_DRIVER_ROUTE_STATUSES = new Set([
    'route_claimed',
    'route_assigned',
    'route_enroute',
    'route_temp_claimed',
    'route_temp_claimed_dispatch',
]);

const getActiveRouteDriverIdentifiers = routeRecords => {
    const identifiers = new Set();

    (Array.isArray(routeRecords) ? routeRecords : []).forEach(route => {
        if (!route || !ACTIVE_DRIVER_ROUTE_STATUSES.has(route.status)) {
            return;
        }

        (Array.isArray(route.RouteDrivers) ? route.RouteDrivers : []).forEach(routeDriver => {
            [routeDriver && routeDriver.driver_id, routeDriver && routeDriver.driver_auth0_id]
                .filter(Boolean)
                .forEach(identifier => identifiers.add(String(identifier)));
        });
    });

    return identifiers;
};

const DRIVER_STATUS_FILTER_OPTIONS = [
    { value: 'available', label: 'Available' },
    { value: 'enroute', label: 'Enroute' },
    { value: 'unavailable', label: 'Offline' }
];

const DRIVER_VEHICLE_FILTER_OPTIONS = [
    { value: 'compact_car', label: 'Compact Car' },
    { value: 'sedan', label: 'Sedan' },
    { value: 'suv', label: 'SUV' },
    { value: 'minivan', label: 'Minivan' },
    { value: 'sprinter_van', label: 'Sprinter Van' },
    { value: 'pickup_truck', label: '1/2 Ton Pickup' },
    { value: 'truck', label: '1/2 Ton Pickup' },
    { value: 'box_truck', label: 'Box Truck' },
    { value: 'tractor_semi', label: 'Semi/Tractor' }
];

const DRIVER_PERMIT_FILTER_OPTIONS = [
    { value: 'alcohol', label: 'Alcohol' },
    { value: 'hazmat', label: 'Hazmat' },
    { value: 'twic', label: 'TWIC' }
];

const normalizeClientType = clientType => {
    if (typeof clientType !== 'string') {
        return '';
    }

    return clientType.trim().toLowerCase().replace(/[\s-]+/g, '_');
};

const isMobileClientType = clientType => {
    const normalized = normalizeClientType(clientType);

    if (!normalized) {
        return false;
    }

    if (['dashboard', 'web', 'desktop', 'browser', 'admin_dashboard'].includes(normalized)) {
        return false;
    }

    return [
        'mobile',
        'mobile_app',
        'cellphone',
        'cell_phone',
        'phone',
        'ios',
        'android',
        'ios_merchant',
        'android_merchant',
        'merchant_app',
        'driver_app',
        'flutter',
    ].includes(normalized);
};

const getDemurrageStopOrderInfo = (shipment, stop) => {
    if (!shipment || !stop) {
        return { orderFriendlyId: '', addressLabel: '' };
    }

    const shipmentOrders = Array.isArray(shipment.orders)
        ? shipment.orders
        : (Array.isArray(shipment.Orders) ? shipment.Orders : []);

    if (shipmentOrders.length === 0) {
        return { orderFriendlyId: '', addressLabel: '' };
    }

    const stopId = stop.stop_id || null;
    const orderId = stop.order_id || null;

    const matchedOrder = shipmentOrders.find(order => {
        if (!order) {
            return false;
        }

        return (orderId && order.order_id === orderId) || (stopId && order.order_id === stopId);
    });

    if (!matchedOrder) {
        return { orderFriendlyId: '', addressLabel: '' };
    }

    const location = matchedOrder.location_blob || {};
    const orderFriendlyId = matchedOrder.order_friendly_id || '';
    const addressLabel =
        location.address
        || [location.address_1, location.city, location.state, location.zip].filter(Boolean).join(', ')
        || '';

    return { orderFriendlyId, addressLabel };
};

const REGION_ORDER = [
    'California',
    'Central Atlantic',
    'Gulf Coast',
    'Lower Atlantic',
    'Midwest',
    'New England',
    'Northwest',
    'Rocky Mountain'
];

const ENTIRE_US_LABEL = 'Entire US';
const DEFAULT_COUNTRY_COORDINATES = { latitude: 39.8283, longitude: -98.5795 };
const REGION_NAME_ALIASES = {
    california: 'California',
    'california region': 'California',
    'central atlantic': 'Central Atlantic',
    'central atlantic region': 'Central Atlantic',
    'gulf coast': 'Gulf Coast',
    'gulf coast region': 'Gulf Coast',
    'lower atlantic': 'Lower Atlantic',
    'lower atlantic region': 'Lower Atlantic',
    midwest: 'Midwest',
    'mid west': 'Midwest',
    'midwest region': 'Midwest',
    'new england': 'New England',
    'new england region': 'New England',
    northwest: 'Northwest',
    'north west': 'Northwest',
    'northwest region': 'Northwest',
    'rocky mountain': 'Rocky Mountain',
    'rocky mountains': 'Rocky Mountain',
    'rocky mountain region': 'Rocky Mountain'
};

const PENDING_SHIPMENT_STATUSES = [
    'shipment_created',
    'shipment_pending',
    'shipment_pending_schedule',
    'shipment_pending_payment'
];
const QUOTE_EDITABLE_PENDING_STATUSES = [
    'shipment_pending',
    'shipment_pending_schedule',
    'shipment_pending_saved',
    'shipment_pending_payment',
    'shipment_saved_pending_payment_retry'
];
const QUOTE_EDITABLE_SHIPMENT_TYPES = ['direct', 'routed_direct', 'multidrop_direct'];
const SCHEDULED_SHIPMENT_STATUSES = ['shipment_scheduled', 'shipment_saved', 'shipment_pending_saved', 'shipment_saved_pending_payment_retry'];
const READY_ROUTE_STATUSES = ['route_ready', 'route_temp_claimed', 'route_temp_claimed_dispatch'];
const PROGRESSING_ROUTE_STATUSES = ['route_claimed', 'route_assigned', 'route_enroute'];
// Dispatch may fully edit an order in any tab except completed/terminal shipments.
// The server re-quotes and charges/refunds any price difference on save.
const DISPATCH_NON_EDITABLE_SHIPMENT_STATUSES = new Set([
    'shipment_completed',
    'shipment_cancelled',
    'shipment_declined',
]);
const DISPATCH_EDIT_ACTIVE_SHIPMENT_TYPES = new Set(['direct', 'routed_direct', 'multidrop_direct']);
const ACTIVE_ORDER_EDIT_PATH = '/admin/delivery_creation';
const COMPLETED_ROUTE_STATUSES = ['route_completed'];
const ARRIVAL_OVERRIDE_ACTIVE_STATUSES = new Set(['pending', 'claimed_by_admin']);
const DISPATCH_ADMIN_OVERRIDE_ORDER_STATUSES = new Set(['awaiting_driver', 'order_scheduled', 'order_accepted', 'order_ready', 'driver_assigned', 'driver_claimed', 'order_enroute']);
const DISPATCH_DRIVER_PROGRESS_ORDER_STATUSES = new Set(['driver_assigned', 'driver_claimed', 'order_enroute']);
const CLAIMED_ORDER_CHAT_SUMMARY_BATCH_SIZE = 100;
const CLAIMED_ORDER_CHAT_SUMMARY_THREAD_TYPES = ['claimed_order', 'customer_driver', 'customer_dispatch'];
const ON_TIME_DELIVERY_GRACE_MINUTES = 30;
const ON_TIME_PICKUP_EXPEDITED_HOURS = 1;
const ON_TIME_PICKUP_STANDARD_HOURS = 4;

const parseExpeditedFlag = value => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return ['true', 't', '1', 'yes'].includes(value.trim().toLowerCase());
    return value === 1;
};

const parseTimestampMs = value => {
    if (value == null || value === '') {
        return null;
    }

    const parsed = moment(value);
    return parsed.isValid() ? parsed.valueOf() : null;
};

const getRouteWaypointForMetrics = (shipment, order) => {
    const route = shipment && shipment.Route ? shipment.Route : null;

    if (!route || !Array.isArray(route.path) || !order || typeof order !== 'object') {
        return null;
    }

    return route.path.find(waypoint => {
        if (!waypoint || typeof waypoint !== 'object') {
            return false;
        }

        if (order.order_id && (waypoint.order_id === order.order_id || waypoint.waypoint_id === order.order_id)) {
            return true;
        }

        return false;
    }) || null;
};

const getWaypointArrivalMsForMetrics = waypoint => {
    if (!waypoint || typeof waypoint !== 'object') {
        return null;
    }

    return (
        parseTimestampMs(waypoint.arrived_at)
        || parseTimestampMs(waypoint.arrivedAt)
        || parseTimestampMs(waypoint.arrival_validation && waypoint.arrival_validation.timestamp)
    );
};

const getOrderArrivalEvidenceMsForMetrics = (shipment, order) => {
    const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;
    const matchedWaypoint = getRouteWaypointForMetrics(shipment, order);

    return (
        parseTimestampMs(order && order.arrived_at)
        || parseTimestampMs(actions && actions.arrival_validation && actions.arrival_validation.timestamp)
        || parseTimestampMs(actions && (actions.arrived_at || actions.arrivedAt || actions.driver_arrived_at || actions.driver_arrivedAt))
        || getWaypointArrivalMsForMetrics(matchedWaypoint)
    );
};

const getOrderEtaMsForMetrics = order => {
    const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;

    return (
        parseTimestampMs(order && order.estimated_arrival_time)
        || parseTimestampMs(order && order.estimatedArrivalTime)
        || parseTimestampMs(actions && (actions.estimated_arrival_time || actions.estimatedArrivalTime || actions.eta || actions.dropoff_eta || actions.drop_off_eta))
    );
};

const hasDispatchCompletionActor = actions => {
    if (!actions || typeof actions !== 'object') {
        return false;
    }

    const actorCandidates = [
        actions.completed_by,
        actions.completedBy,
        actions.completed_by_role,
        actions.completedByRole,
        actions.completion_source,
        actions.completionSource,
        actions.actor
    ];

    return actorCandidates.some(candidate => {
        const normalized = String(candidate || '').trim().toLowerCase();
        return normalized.includes('dispatch') || normalized.includes('admin');
    });
};

const hasExplicitDispatchArrivalOverride = actions => {
    const arrivalOverride = actions && actions.arrival_override && typeof actions.arrival_override === 'object'
        ? actions.arrival_override
        : null;

    if (!arrivalOverride) {
        return false;
    }

    const reason = String(arrivalOverride.reason || '').trim();
    const actorCandidates = [
        arrivalOverride.created_by,
        arrivalOverride.createdBy,
        arrivalOverride.updated_by,
        arrivalOverride.updatedBy,
        arrivalOverride.actor,
        arrivalOverride.role,
        arrivalOverride.source
    ];

    const hasDispatchActor = actorCandidates.some(candidate => {
        const normalized = String(candidate || '').trim().toLowerCase();
        return normalized.includes('dispatch') || normalized.includes('admin');
    });

    return reason.length > 0 || hasDispatchActor;
};

const resolveDispatchMonthlyCustomerKey = shipment => {
    const customerBlob = shipment && shipment.customer_blob && typeof shipment.customer_blob === 'object'
        ? shipment.customer_blob
        : {};

    const nameFromBlob = [customerBlob.first_name, customerBlob.last_name].filter(Boolean).join(' ').trim();
    const normalizeKeyPart = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

    // Active customer KPI is store-level, so associate users from the same store count once.
    const storeId = normalizeKeyPart(customerBlob.store_id);
    if (storeId) {
        return `store_id:${storeId}`;
    }

    const storeName = normalizeKeyPart(customerBlob.store_name);
    if (storeName) {
        return `store_name:${storeName}`;
    }

    const fallbackCandidates = [
        shipment && shipment.cust_auth0_id,
        customerBlob.auth0_id,
        customerBlob.customer_id,
        customerBlob.email,
        customerBlob.phone,
        nameFromBlob
    ];

    const match = fallbackCandidates.find(value => String(value || '').trim() !== '');
    return match ? normalizeKeyPart(match) : null;
};

const resolveDispatchMonthlyCustomerDisplayName = shipment => {
    const customerBlob = shipment && shipment.customer_blob && typeof shipment.customer_blob === 'object'
        ? shipment.customer_blob
        : {};

    const nameFromBlob = [customerBlob.first_name, customerBlob.last_name].filter(Boolean).join(' ').trim();
    const candidateValues = [
        customerBlob.store_name,
        nameFromBlob,
        shipment && shipment.placed_by,
        customerBlob.email,
        customerBlob.phone,
        shipment && shipment.cust_auth0_id,
    ];

    const match = candidateValues.find(value => String(value || '').trim() !== '');
    return match ? String(match).trim() : 'Unknown Customer';
};

const formatRateWithCounts = (ratePercent, onTimeCount, evaluatedCount) => {
    if (ratePercent == null || evaluatedCount <= 0) {
        return 'N/A';
    }

    const rounded = Math.round(ratePercent * 10) / 10;
    const roundedText = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
    return `${roundedText}% (${onTimeCount}/${evaluatedCount})`;
};

const canDispatchAdminOverrideOrder = order => Boolean(order && DISPATCH_ADMIN_OVERRIDE_ORDER_STATUSES.has(order.status));
const canShowDispatchDriverProgressOrder = order => Boolean(order && DISPATCH_DRIVER_PROGRESS_ORDER_STATUSES.has(order.status));
const hasDispatchAdminOverrideOrders = orders => Array.isArray(orders) && orders.some(canDispatchAdminOverrideOrder);
const canDispatchAdminOverrideRouteOrder = (order, route = null) => Boolean(
    canDispatchAdminOverrideOrder(order) ||
    (
        order &&
        route &&
        (
            PROGRESSING_ROUTE_STATUSES.includes(route.status) ||
            READY_ROUTE_STATUSES.includes(route.status) ||
            (Array.isArray(route.RouteDrivers) && route.RouteDrivers.some(driver => driver && driver.status !== 'unassigned'))
        ) &&
        !['order_completed', 'order_declined', 'order_cancelled', 'order_saved', 'order_created'].includes(order.status)
    )
);

const hasExpandableDispatchPreviewDetails = routeRecord => {
    if (!routeRecord || !routeRecord.__dispatchPreview) {
        return true;
    }

    const hasPathDetails = Array.isArray(routeRecord.path) && routeRecord.path.length > 0;
    const hasOrderActionDetails = Array.isArray(routeRecord.Shipments)
        && routeRecord.Shipments.some(shipment => Array.isArray(shipment && shipment.Orders)
            && shipment.Orders.some(order => order && typeof order === 'object' && order.actions));

    return hasPathDetails && hasOrderActionDetails;
};

const getClaimedOrderChatThreadTypeParam = threadType => {
    if (!threadType || threadType === 'claimed_order') {
        return '';
    }

    return threadType;
};

const STATE_LOOKUP = states.reduce((lookup, stateOption) => {
    lookup[stateOption.val.toLowerCase()] = stateOption.label;
    lookup[stateOption.label.toLowerCase()] = stateOption.val;
    return lookup;
}, {});

const normalizeText = value =>
    String(value || '')
        .toLowerCase()
        .replace(/,/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const isDispatchRealtimeInteractionActive = () => {
    if (typeof document === 'undefined') {
        return false;
    }

    if (document.body && document.body.classList && document.body.classList.contains('dispatch-realtime-interaction-active')) {
        return true;
    }

    const activeElement = document.activeElement;
    if (
        activeElement
        && typeof activeElement.closest === 'function'
        && activeElement.closest('.dispatch-realtime-interaction')
    ) {
        return true;
    }

    if (typeof window !== 'undefined' && typeof window.getSelection === 'function') {
        const selection = window.getSelection();
        if (selection && !selection.isCollapsed && String(selection).trim().length > 0) {
            return true;
        }
    }

    return false;
};

const hasExpandedDispatchRows = expandedState => {
    if (!expandedState || typeof expandedState !== 'object') {
        return false;
    }

    return Object.keys(expandedState).some(key => {
        const value = expandedState[key];

        if (value === true) {
            return true;
        }

        if (value && typeof value === 'object') {
            return hasExpandedDispatchRows(value);
        }

        return false;
    });
};

const supportsDispatchDriversRestEndpoint = baseHost => typeof baseHost === 'string' && baseHost.trim() !== '';
const LOCAL_BROWSER_USERS_HOST = 'http://127.0.0.1:8082';

const LOCAL_DISPATCH_DRIVERS_RETRY_COOLDOWN_MS = 15000;
const LOCAL_DISPATCH_POLL_SUCCESS_MS = 15000;
const LOCAL_DISPATCH_POLL_FAILURE_BASE_MS = 30000;
const LOCAL_DISPATCH_POLL_FAILURE_MAX_MS = 120000;
const LOCAL_DISPATCH_BOOTSTRAP_TIMEOUT_MS = 3000;
const HOSTED_DISPATCH_BOOTSTRAP_TIMEOUT_MS = 5000;
const HOSTED_DISPATCH_DRIVERS_TIMEOUT_MS = 30000;
const LOCAL_PROXY_USERS_HASURA_TIMEOUT_MS = 120000;
const GOPILOT_REVIEW_POLL_MS = 30000;
const DISPATCH_CURRENT_RECORD_MISS_THRESHOLD = 3;

const isLocalShipmentNetworkFailure = error => {
    const requestUrl = error && error.config && typeof error.config.url === 'string'
        ? error.config.url
        : '';

    if (!isLocalLikeHost(requestUrl) || (error && error.response)) {
        return false;
    }

    const message = String(error && error.message ? error.message : '');
    return /Network Error|ECONNREFUSED|ERR_CONNECTION_REFUSED/i.test(message);
};

const getDispatchBootstrapRequestTimeout = url => (
    isLocalLikeHost(url) ? LOCAL_DISPATCH_BOOTSTRAP_TIMEOUT_MS : HOSTED_DISPATCH_BOOTSTRAP_TIMEOUT_MS
);

const isMissingOptionalDispatchEndpoint = error => {
    const statusCode = error && error.response ? error.response.status : null;
    return statusCode === 404;
};

const isUnavailableOptionalDispatchEndpoint = error => {
    const statusCode = error && error.response ? error.response.status : null;
    return statusCode === 404 || statusCode === 500 || statusCode === 502 || statusCode === 503;
};

const getOptionalDispatchEndpointCacheKey = requestUrl => `${OPTIONAL_DISPATCH_ENDPOINT_CACHE_PREFIX}${String(requestUrl || '')}`;

const isOptionalDispatchEndpointCachedMissing = requestUrl => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return false;
    }

    try {
        return window.sessionStorage.getItem(getOptionalDispatchEndpointCacheKey(requestUrl)) === '1';
    } catch (_) {
        return false;
    }
};

const cacheMissingOptionalDispatchEndpoint = requestUrl => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }

    try {
        window.sessionStorage.setItem(getOptionalDispatchEndpointCacheKey(requestUrl), '1');
    } catch (_) {}
};

const clearMissingOptionalDispatchEndpointCache = requestUrl => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }

    try {
        window.sessionStorage.removeItem(getOptionalDispatchEndpointCacheKey(requestUrl));
    } catch (_) {}
};

const formatCurrencyAmount = value => {
    const normalizedValue = Number(value);
    return Number.isFinite(normalizedValue) ? normalizedValue.toFixed(2) : '0.00';
};

const getShipmentFeeBlob = shipment => {
    if (!shipment || !shipment.shipping_fee_blob || typeof shipment.shipping_fee_blob !== 'object') {
        return {};
    }

    return shipment.shipping_fee_blob;
};

const hasShipmentSetupFee = shipment => Object.prototype.hasOwnProperty.call(getShipmentFeeBlob(shipment), 'setup_fee');

const mergeShipmentSnapshot = (existingShipment, incomingShipment) => {
    if (!existingShipment) {
        return incomingShipment;
    }

    const mergedShipment = { ...existingShipment };
    Object.keys(incomingShipment || {}).forEach(key => {
        const value = incomingShipment[key];
        if (typeof value !== 'undefined') {
            mergedShipment[key] = value;
        }
    });

    if (!incomingShipment || !incomingShipment.shipping_fee_blob || typeof incomingShipment.shipping_fee_blob !== 'object') {
        mergedShipment.shipping_fee_blob = existingShipment.shipping_fee_blob;
    }

    if (!incomingShipment || !Array.isArray(incomingShipment.Orders)) {
        mergedShipment.Orders = existingShipment.Orders;
    }

    if (!incomingShipment || !Array.isArray(incomingShipment.ShipmentActions)) {
        mergedShipment.ShipmentActions = existingShipment.ShipmentActions;
    }

    if (!incomingShipment || !Array.isArray(incomingShipment.ShipmentHandshakes)) {
        mergedShipment.ShipmentHandshakes = existingShipment.ShipmentHandshakes;
    }

    return mergedShipment;
};

const shouldAttemptHostedDispatchFallback = requestUrl => {
    const normalizedUrl = String(requestUrl || '');

    return !/\/admins\/shipments\/gopilot\/reviews/.test(normalizedUrl);
};

const canonicalizeRegionName = regionName => {
    const normalizedRegionName = normalizeText(regionName);
    const aliasedRegionName = REGION_NAME_ALIASES[normalizedRegionName];

    if (aliasedRegionName) {
        return aliasedRegionName;
    }

    const matchedRegion = REGION_ORDER.find(region => normalizeText(region) === normalizedRegionName);

    return matchedRegion || regionName;
};

const getLocationDisplay = location => {
    if (!location) {
        return 'Location unavailable';
    }

    const city = location.city || '';
    const state = location.state || '';

    if (city && state) {
        return `${city}, ${state}`;
    }

    return city || state || 'Location unavailable';
};

const formatGoPilotPhotoLocation = photo => {
    if (!photo || photo.latitude == null || photo.longitude == null) {
        return 'GPS unavailable';
    }

    const latitude = Number(photo.latitude);
    const longitude = Number(photo.longitude);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return 'GPS unavailable';
    }

    return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
};

const formatGoPilotConversationAction = note => {
    if (!note) {
        return 'Update';
    }

    if (note.category === 'arrival_override' && note.action === 'driver_request') {
        return 'Out-of-radius request';
    }

    if (note.category === 'arrival_override' && note.action === 'admin_response') {
        return 'Out-of-radius response';
    }

    if (note.category === 'gopilot' && note.action === 'driver_request') {
        return 'Driver request';
    }

    if (note.category === 'gopilot' && note.action === 'admin_response') {
        return 'Admin response';
    }

    return 'Update';
};

const getImmutableCreatedAt = row => row.display_created_at || row.original_created_at || row.created_at || row.createdAt || null;

const formatEmploymentTypeLabel = employmentType => {
    const normalized = String(employmentType || '')
        .replace(/1099/gi, '')
        .replace(/\(\s*\)/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([/,&-])/g, '$1')
        .replace(/([/,&-])\s+/g, '$1 ')
        .trim();

    return normalized || null;
};

const getWaypointColumnKey = (waypoint, index) => {
    if (!waypoint) {
        return `waypoint-${index}`;
    }

    if (waypoint.type === 'merged') {
        return `merged-${waypoint.pickupOrder && waypoint.pickupOrder.order_id ? waypoint.pickupOrder.order_id : `pickup-${index}`}-${
            waypoint.dropoffOrder && waypoint.dropoffOrder.order_id ? waypoint.dropoffOrder.order_id : `dropoff-${index}`
        }`;
    }

    if (waypoint.order && waypoint.order.order_id) {
        return `${waypoint.type || 'waypoint'}-${waypoint.order.order_id}`;
    }

    return `${waypoint.type || 'waypoint'}-${index}`;
};

const buildArrivalOverrideRequestKey = (route, waypoint, request, index) => {
    if (request && request.request_id) {
        return request.request_id;
    }

    const fallbackWaypointIdentifier = waypoint && (
        waypoint.waypoint_id
        || waypoint.order_id
        || waypoint.shipment_id
        || waypoint.stop_id
    );

    return `${route && route.route_id ? route.route_id : 'route'}:${fallbackWaypointIdentifier || index}`;
};

const getRoutePrimaryDriverName = route => {
    const primaryDriver = route && Array.isArray(route.RouteDrivers) && route.RouteDrivers[0] ? route.RouteDrivers[0] : null;
    const driverBlob = primaryDriver && primaryDriver.driver_blob ? primaryDriver.driver_blob : null;

    if (!driverBlob) {
        return '';
    }

    return `${driverBlob.firstname || ''} ${driverBlob.lastname || ''}`.trim();
};

const getAuthProfileDisplayName = authProfile => {
    if (!authProfile) {
        return '';
    }

    const fullName = String(authProfile.name || `${authProfile.given_name || ''} ${authProfile.family_name || ''}`).trim();

    if (fullName) {
        return fullName;
    }

    return String(authProfile.nickname || authProfile.email || '').trim();
};

const getUserRecordDisplayName = userRecord => {
    if (!userRecord) {
        return '';
    }

    return String(
        [userRecord.firstname || userRecord.first_name, userRecord.lastname || userRecord.last_name]
            .filter(Boolean)
            .join(' ') || userRecord.username || userRecord.email || ''
    ).trim();
};

const isAuth0LikeIdentifier = value => {
    const normalized = String(value || '').trim();
    return normalized.includes('|') && /^[a-z0-9_-]+\|[a-z0-9_.:@-]+$/i.test(normalized);
};

const getShipmentCustomerName = shipment => {
    if (!shipment || !shipment.customer_blob) {
        return '';
    }

    return shipment.customer_blob.store_name || `${shipment.customer_blob.first_name || ''} ${shipment.customer_blob.last_name || ''}`.trim();
};

const MIN_LIVE_DEMURRAGE_FREE_MINUTES = 30;
const DEFAULT_DEMURRAGE_INCREMENT_MINUTES = 15;

const parseLiveDemurrageTimestamp = value => {
    if (!value) {
        return null;
    }

    const parsed = value instanceof Date ? value : new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const normalizeLiveFreeMinutes = value => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed) || parsed <= 0) {
        return MIN_LIVE_DEMURRAGE_FREE_MINUTES;
    }

    return Math.max(MIN_LIVE_DEMURRAGE_FREE_MINUTES, parsed);
};

const getStageFreeMinutesFallback = (shipmentBlob, stopType) => {
    const candidates = stopType === 'pickup'
        ? [shipmentBlob && shipmentBlob.pickup_stop_time, shipmentBlob && shipmentBlob.pickupStopTime, shipmentBlob && shipmentBlob.load_time, shipmentBlob && shipmentBlob.loadTime, shipmentBlob && shipmentBlob.loading_time, shipmentBlob && shipmentBlob.loadingTime]
        : [shipmentBlob && shipmentBlob.dropoff_stop_time, shipmentBlob && shipmentBlob.dropoffStopTime, shipmentBlob && shipmentBlob.unload_time, shipmentBlob && shipmentBlob.unloadTime, shipmentBlob && shipmentBlob.unloading_time, shipmentBlob && shipmentBlob.unloadingTime];

    for (const candidate of candidates) {
        const parsed = Number(candidate);

        if (Number.isFinite(parsed) && parsed > 0) {
            return normalizeLiveFreeMinutes(parsed);
        }
    }

    return MIN_LIVE_DEMURRAGE_FREE_MINUTES;
};

const getLiveDemurrageClockContext = (shipment, route, demurrage, shipmentBlob) => {
    if (!shipment || !demurrage) {
        return null;
    }

    const demurrageStops = Array.isArray(demurrage.stops) ? demurrage.stops : [];
    const getMatchedStop = ids => demurrageStops.find(stop => stop && ids.some(id => id && stop.stop_id === id)) || null;
    const routePath = Array.isArray(route && route.path) ? route.path : [];
    const shipmentOrders = Array.isArray(shipment.Orders) ? shipment.Orders : [];

    for (const waypoint of routePath) {
        const arrivalAt = waypoint && (waypoint.arrived_at || (waypoint.arrival_validation && waypoint.arrival_validation.timestamp));
        const completedAt = waypoint && waypoint.completed_at;
        const waypointMatchesShipment = waypoint && (
            waypoint.shipment_id === shipment.shipment_id
            || waypoint.waypoint_id === shipment.shipment_id
            || shipmentOrders.some(order => order && order.order_id && order.order_id === waypoint.waypoint_id)
            || shipmentOrders.some(order => order && order.order_id && order.order_id === waypoint.order_id)
        );

        if (!waypointMatchesShipment || !arrivalAt || completedAt || (waypoint && waypoint.is_waypoint_completed === true)) {
            continue;
        }

        const matchedStop = getMatchedStop([waypoint.order_id, waypoint.shipment_id, waypoint.waypoint_id]);
        const stopType = waypoint && waypoint.actions && waypoint.actions.pick_up ? 'pickup' : 'dropoff';

        return {
            arrivalAt,
            stopId: matchedStop && matchedStop.stop_id ? matchedStop.stop_id : (waypoint.order_id || waypoint.shipment_id || waypoint.waypoint_id || null),
            stopType,
            freeMinutes: normalizeLiveFreeMinutes(
                (waypoint && waypoint.stop_time)
                || (matchedStop && (matchedStop.minimum_free_minutes || matchedStop.free_minutes))
                || getStageFreeMinutesFallback(shipmentBlob, stopType)
            ),
        };
    }

    const activeOrder = shipmentOrders.find(order => {
        const arrivalAt = order && (order.arrived_at || (order.arrival_validation && order.arrival_validation.timestamp));
        return arrivalAt && !(order && order.completed_at);
    });

    if (!activeOrder) {
        return null;
    }

    const matchedStop = getMatchedStop([activeOrder.order_id, shipment.shipment_id]);

    return {
        arrivalAt: activeOrder.arrived_at || (activeOrder.arrival_validation && activeOrder.arrival_validation.timestamp),
        stopId: matchedStop && matchedStop.stop_id ? matchedStop.stop_id : activeOrder.order_id,
        stopType: matchedStop && matchedStop.stop_type ? matchedStop.stop_type : 'dropoff',
        freeMinutes: normalizeLiveFreeMinutes(
            (matchedStop && (matchedStop.minimum_free_minutes || matchedStop.free_minutes))
            || getStageFreeMinutesFallback(shipmentBlob, 'dropoff')
        ),
    };
};

const getDemurrageDisplayAmount = (demurrage, demurrageApplication, shippingFeeBlob = {}) => {
    return [
        demurrageApplication && demurrageApplication.applied_amount,
        demurrage && demurrage.total_amount,
        demurrage && demurrage.review_amount,
        demurrage && demurrage.preview_amount,
        shippingFeeBlob && shippingFeeBlob.demurrage_fee,
    ]
        .map(value => Number(value))
        .find(value => Number.isFinite(value) && value > 0) || 0;
};

const buildDemurrageReviewPromptKey = shipment => {
    if (!shipment || !shipment.shipment_id) {
        return null;
    }

    const demurrage = shipment.billing_details && shipment.billing_details.demurrage ? shipment.billing_details.demurrage : null;

    if (!demurrage) {
        return `${shipment.shipment_id}:none`;
    }

    const approvalStatus = demurrage.approval && demurrage.approval.status ? demurrage.approval.status : 'pending';
    const materializationStatus = demurrage.materialization && demurrage.materialization.status ? demurrage.materialization.status : '';
    const reviewReasons = Array.isArray(demurrage.stops)
        ? demurrage.stops.flatMap(stop => (stop && Array.isArray(stop.review_reasons) ? stop.review_reasons : [])).join('|')
        : '';

    return [
        shipment.shipment_id,
        demurrage.review_required === true ? 'required' : 'optional',
        demurrage.status || '',
        materializationStatus,
        approvalStatus,
        Number(demurrage.review_billable_minutes || 0),
        Number(demurrage.review_amount || 0),
        reviewReasons,
    ].join(':');
};

const hasPendingDemurrageReview = shipment => {
    const demurrage = shipment && shipment.billing_details && shipment.billing_details.demurrage;
    const approval = demurrage && demurrage.approval;

    return Boolean(
        demurrage && (
            demurrage.review_required === true
            || demurrage.status === 'review_required'
            || (demurrage.materialization && demurrage.materialization.status === 'awaiting_review')
            || Number(demurrage.review_billable_minutes || 0) > 0
            || Number(demurrage.review_amount || 0) > 0
        ) && (!approval || approval.status === 'pending')
    );
};

const clearDemurrageReviewPromptKeysForShipment = (promptKeys, shipmentId) => {
    if (!promptKeys || !shipmentId) {
        return;
    }

    Array.from(promptKeys).forEach(promptKey => {
        if (typeof promptKey === 'string' && promptKey.startsWith(`${shipmentId}:`)) {
            promptKeys.delete(promptKey);
        }
    });
};

const normalizeDemurrageIncrementMinutes = value => {
    const parsed = Number(value);

    if (!Number.isFinite(parsed) || parsed <= 0) {
        return DEFAULT_DEMURRAGE_INCREMENT_MINUTES;
    }

    return Math.floor(parsed);
};

const roundDemurrageCurrency = value => Math.round(Number(value || 0) * 100) / 100;

const getDemurrageAmountFromTiming = ({ hourlyRate, waitMinutes, freeMinutes, incrementMinutes }) => {
    const normalizedHourlyRate = Number(hourlyRate);

    if (!Number.isFinite(normalizedHourlyRate) || normalizedHourlyRate <= 0) {
        return 0;
    }

    const normalizedWaitMinutes = Math.max(0, Number(waitMinutes || 0));
    const normalizedFreeMinutes = Math.max(0, Number(freeMinutes || 0));
    const normalizedIncrementMinutes = normalizeDemurrageIncrementMinutes(incrementMinutes);
    const overageMinutes = Math.max(0, normalizedWaitMinutes - normalizedFreeMinutes);
    const billableMinutes = Math.floor(overageMinutes / normalizedIncrementMinutes) * normalizedIncrementMinutes;

    return roundDemurrageCurrency((billableMinutes / 60) * normalizedHourlyRate);
};

const extractArrivalOverrideRequests = routes => {
    if (!Array.isArray(routes)) {
        return [];
    }

    return routes.flatMap(route => {
        const path = Array.isArray(route && route.path) ? route.path : [];
        const shipments = Array.isArray(route && route.Shipments) ? route.Shipments : [];

        return path.flatMap((waypoint, index) => {
            const request = waypoint && waypoint.arrival_override_request && typeof waypoint.arrival_override_request === 'object'
                ? waypoint.arrival_override_request
                : null;

            if (waypoint.is_waypoint_completed || !request || !ARRIVAL_OVERRIDE_ACTIVE_STATUSES.has(request.status)) {
                return [];
            }

            const shipment = shipments.find(item => {
                if (!item) {
                    return false;
                }

                if (item.shipment_id === (waypoint.shipment_id || waypoint.waypoint_id)) {
                    return true;
                }

                return Boolean(
                    waypoint
                    && waypoint.order_id
                    && Array.isArray(item.Orders)
                    && item.Orders.some(orderItem => orderItem && orderItem.order_id === waypoint.order_id)
                );
            }) || null;
            const order = shipment && Array.isArray(shipment.Orders)
                ? shipment.Orders.find(item => item && item.order_id === waypoint.order_id) || null
                : null;
            const stopType = waypoint && waypoint.actions && waypoint.actions.pick_up ? 'pickup' : 'dropoff';
            const waypointType = waypoint && waypoint.waypoint_type === 'shipment'
                ? 'shipment'
                : waypoint && waypoint.order_id
                    ? 'order'
                    : 'shipment';

            return [{
                requestKey: buildArrivalOverrideRequestKey(route, waypoint, request, index),
                routeId: route && route.route_id,
                routeFriendlyId: route && route.route_friendly_id,
                marketId: route && route.market_id,
                waypointId: waypoint && waypoint.waypoint_id,
                waypointType,
                stopType,
                shipmentId: shipment && shipment.shipment_id ? shipment.shipment_id : waypoint && waypoint.shipment_id,
                orderId: order && order.order_id ? order.order_id : waypoint && waypoint.order_id,
                customerName: getShipmentCustomerName(shipment),
                driverName: getRoutePrimaryDriverName(route),
                request,
            }];
        });
    });
};

const getArrivalOverrideRequestPriority = (requestItem, currentUserSub) => {
    if (!requestItem || !requestItem.request) {
        return 99;
    }

    if (requestItem.request.status === 'claimed_by_admin' && requestItem.request.claimed_by === currentUserSub) {
        return 0;
    }

    if (requestItem.request.status === 'pending') {
        return 1;
    }

    if (requestItem.request.status === 'claimed_by_admin') {
        return 2;
    }

    return 3;
};

const buildArrivalOverrideShipmentKey = (routeId, shipmentId) => `${routeId || ''}:${shipmentId || ''}`;

const canSelectArrivalOverrideRequest = (requestItem, currentUserSub) => {
    if (!requestItem || !requestItem.request) {
        return false;
    }

    if (requestItem.request.status === 'pending') {
        return true;
    }

    return requestItem.request.status === 'claimed_by_admin' && requestItem.request.claimed_by === currentUserSub;
};

const mergeArrivalOverrideSelection = (currentSelection, nextSelection, currentUserSub) => {
    if (!currentSelection || !currentSelection.request || !nextSelection || !nextSelection.request) {
        return nextSelection;
    }

    if (currentSelection.requestKey !== nextSelection.requestKey) {
        return nextSelection;
    }

    const currentRequest = currentSelection.request;
    const nextRequest = nextSelection.request;
    const currentClaimedByUser = currentRequest.status === 'claimed_by_admin' && currentRequest.claimed_by === currentUserSub;
    const nextStillPending = nextRequest.status === 'pending';

    if (currentClaimedByUser && nextStillPending) {
        return currentSelection;
    }

    return nextSelection;
};

const areArrivalOverrideSelectionsEquivalent = (leftSelection, rightSelection) => {
    if (leftSelection === rightSelection) {
        return true;
    }

    if (!leftSelection || !rightSelection) {
        return false;
    }

    const leftRequest = leftSelection.request || {};
    const rightRequest = rightSelection.request || {};

    return leftSelection.requestKey === rightSelection.requestKey
        && leftSelection.routeId === rightSelection.routeId
        && leftSelection.routeFriendlyId === rightSelection.routeFriendlyId
        && leftSelection.waypointId === rightSelection.waypointId
        && leftSelection.shipmentId === rightSelection.shipmentId
        && leftSelection.orderId === rightSelection.orderId
        && leftRequest.status === rightRequest.status
        && leftRequest.claimed_by === rightRequest.claimed_by
        && leftRequest.created_at === rightRequest.created_at
        && leftRequest.updated_at === rightRequest.updated_at
        && leftRequest.override_reason === rightRequest.override_reason;
};

const getDriverOptionKey = (driver, index) => {
    const user = driver && driver.User ? driver.User : {};
    const vehicle = driver && Array.isArray(driver.Vehicles) && driver.Vehicles.length > 0 ? driver.Vehicles[0] : {};

    return (
        driver.driver_id ||
        driver.user_id ||
        user.id ||
        user.auth0_id ||
        vehicle.vehicle_id ||
        `${user.firstname || 'driver'}-${user.lastname || 'unknown'}-${vehicle.type || 'vehicle'}-${index}`
    );
};

const getMarketRowKey = (market, index) => market.market_id || market.id || market.market_name || `market-${index}`;

const getStateSearchTerms = stateValue => {
    const normalizedState = normalizeText(stateValue);

    if (!normalizedState) {
        return [];
    }

    const mappedStateValue = STATE_LOOKUP[normalizedState];
    const terms = new Set([normalizedState]);

    if (mappedStateValue) {
        terms.add(normalizeText(mappedStateValue));
    }

    return Array.from(terms);
};

const getLocationSearchTerms = location => {
    if (!location) {
        return [];
    }

    const city = normalizeText(location.city);
    const stateTerms = getStateSearchTerms(location.state);
    const terms = new Set();

    if (city) {
        terms.add(city);
    }

    stateTerms.forEach(term => terms.add(term));

    stateTerms.forEach(term => {
        if (city) {
            terms.add(`${city} ${term}`);
        }
    });

    return Array.from(terms);
};

const extractShipmentLocations = shipment => {
    if (!shipment || !Array.isArray(shipment.Orders)) {
        return [];
    }

    return shipment.Orders.map(order => order && order.location_blob).filter(Boolean);
};

const extractRouteLocations = route => {
    if (!route || !Array.isArray(route.Shipments)) {
        return [];
    }

    return route.Shipments.flatMap(shipment => extractShipmentLocations(shipment));
};

const getShipmentOriginLocation = shipment => {
    if (!shipment || !Array.isArray(shipment.Orders) || shipment.Orders.length === 0) {
        return null;
    }

    const pickupOrder = shipment.Orders[0];

    return pickupOrder && pickupOrder.location_blob ? pickupOrder.location_blob : null;
};

const getRouteShipments = route => {
    if (!route || !Array.isArray(route.Shipments) || route.Shipments.length === 0) {
        return [];
    }

    return route.Shipments.filter(Boolean);
};

// Returns the preferred-driver selection stored on a route's shipments (from
// shipping_fee_blob.preferred_dispatch), or null when no driver was preferred.
const getRoutePreferredDispatch = route => {
    const shipments = getRouteShipments(route);

    for (let index = 0; index < shipments.length; index += 1) {
        const shipment = shipments[index];
        const blob = shipment && shipment.shipping_fee_blob;
        const preferred = blob && typeof blob === 'object' ? blob.preferred_dispatch : null;

        if (preferred && typeof preferred === 'object' && (preferred.driver_name || preferred.driver_auth0_id)) {
            return preferred;
        }
    }

    return null;
};

const getClaimedOrderChatSeenStorageKey = sub => ['dispatch-claimed-order-chat-seen', sub || 'anonymous'].join(':');
const getPreClaimOrderChatSeenStorageKey = sub => ['dispatch-preclaim-order-chat-seen', sub || 'anonymous'].join(':');

const readClaimedOrderChatSeenMap = sub => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return {};
    }

    try {
        const rawValue = window.localStorage.getItem(getClaimedOrderChatSeenStorageKey(sub));

        if (!rawValue) {
            return {};
        }

        const parsedValue = JSON.parse(rawValue);

        return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : {};
    } catch (error) {
        return {};
    }
};

const persistClaimedOrderChatSeenMap = (sub, nextValue) => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    try {
        window.localStorage.setItem(getClaimedOrderChatSeenStorageKey(sub), JSON.stringify(nextValue));
    } catch (error) {
        return;
    }
};

const readPreClaimOrderChatSeenMap = sub => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return {};
    }

    try {
        const rawValue = window.localStorage.getItem(getPreClaimOrderChatSeenStorageKey(sub));

        if (!rawValue) {
            return {};
        }

        const parsedValue = JSON.parse(rawValue);

        return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : {};
    } catch (error) {
        return {};
    }
};

const persistPreClaimOrderChatSeenMap = (sub, nextValue) => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    try {
        window.localStorage.setItem(getPreClaimOrderChatSeenStorageKey(sub), JSON.stringify(nextValue));
    } catch (error) {
        return;
    }
};

const buildChatThreadSignature = messages => {
    if (!Array.isArray(messages) || messages.length === 0) {
        return '';
    }

    return messages
        .map(message => [
            message && (message.message_id || message.sid || ''),
            message && (message.updated_at || message.created_at || message.dateCreated || ''),
            message && (message.status || ''),
            message && (message.body || ''),
        ].join(':'))
        .join('|');
};

const buildPreClaimOrderThreadKey = thread => {
    if (!thread) {
        return '';
    }

    if (thread.thread_id) {
        return thread.thread_id;
    }

    if (!thread.shipment_id || !thread.driver_auth0_id) {
        return '';
    }

    return `${thread.shipment_id}:${thread.driver_auth0_id}`;
};

const buildClaimedOrderThreadKey = thread => {
    if (!thread || !thread.shipment_id) {
        return '';
    }

    const threadType = thread.thread_type && thread.thread_type !== 'claimed_order'
        ? thread.thread_type
        : 'claimed_order';

    if (threadType === 'claimed_order') {
        return thread.shipment_id;
    }

    return `${thread.shipment_id}:${threadType}:${thread.participant_auth0_id || ''}`;
};

const normalizeClaimedOrderChatSummary = (summary, requestedThreadType = 'claimed_order') => {
    if (!summary || typeof summary !== 'object') {
        return null;
    }

    const latestMessage = summary.latest_message || {};
    const shipmentId = (summary.thread && summary.thread.shipment_id) || summary.shipment_id || latestMessage.shipment_id;
    if (!shipmentId) {
        return null;
    }

    const thread = summary.thread || {
        shipment_id: shipmentId,
        thread_type: latestMessage.thread_type || requestedThreadType || 'claimed_order',
        participant_auth0_id: latestMessage.participant_auth0_id || null,
        participant_role: latestMessage.participant_role || null,
    };

    return {
        ...summary,
        thread,
        latest_message: {
            ...latestMessage,
            direction: latestMessage.direction || (latestMessage.sender_role === 'admin' ? 'sent' : 'received'),
        },
    };
};

const normalizePreClaimOrderChatSummary = summary => {
    if (!summary || typeof summary !== 'object') {
        return null;
    }

    const latestMessage = summary.latest_message || {};
    const shipmentId = (summary.thread && summary.thread.shipment_id) || summary.shipment_id || latestMessage.shipment_id;
    const driverAuth0Id = (summary.thread && summary.thread.driver_auth0_id) || latestMessage.participant_auth0_id;
    if (!shipmentId || !driverAuth0Id) {
        return null;
    }

    return {
        ...summary,
        thread: summary.thread || {
            thread_type: 'pre_claim_order',
            thread_id: `${shipmentId}:${driverAuth0Id}`,
            shipment_id: shipmentId,
            driver_auth0_id: driverAuth0Id,
        },
        latest_message: {
            ...latestMessage,
            driver_auth0_id: driverAuth0Id,
            direction: latestMessage.direction || (latestMessage.sender_role === 'admin' ? 'sent' : 'received'),
        },
    };
};

const getRouteOriginLocation = route => {
    const routeShipments = getRouteShipments(route);

    for (const shipment of routeShipments) {
        const originLocation = getShipmentOriginLocation(shipment);
        if (originLocation) {
            return originLocation;
        }
    }

    return null;
};

const matchesCityStateQuery = (locations, query, extraTerms = []) => {
    const normalizedQuery = normalizeText(query);

    if (!normalizedQuery) {
        return true;
    }

    const haystack = new Set(extraTerms.map(normalizeText).filter(Boolean));
    locations.forEach(location => {
        getLocationSearchTerms(location).forEach(term => haystack.add(term));
    });

    return Array.from(haystack).some(term => term.includes(normalizedQuery));
};

const DispatchOrderTable = props => {
    const { isDarkMode } = useTheme();
    const isMountedRef = useRef(true);
    const rowSurfaceBackground = isDarkMode ? '#27293d' : '#ffffff';
    const detailSurfaceBackground = isDarkMode ? '#17192D' : '#ffffff';
    const summarySurfaceBackground = isDarkMode ? '#17192D' : '#f4f6fb';
    const summaryTextColor = isDarkMode ? '#cdcaca' : '#2b3553';

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const isSavedDraftOrderStatus = status =>
        status === 'order_saved' || status === 'order_pending_saved' || status === 'order_saved_pending_payment_retry';

    const isSavedDraftShipmentStatus = status =>
        status === 'shipment_saved' || status === 'shipment_pending_saved' || status === 'shipment_saved_pending_payment_retry';

    const isSavedDraftShipment = shipment =>
        isSavedDraftShipmentStatus(shipment && shipment.status) ||
        (shipment &&
            shipment.status === 'shipment_ready_for_driver' &&
            Array.isArray(shipment.Orders) &&
            shipment.Orders.length > 0 &&
            shipment.Orders.every(order => isSavedDraftOrderStatus(order && order.status)));

    const isFedexShipment = shipment => {
        const shippingFeeBlob = shipment && shipment.shipping_fee_blob;
        return Boolean(
            shippingFeeBlob &&
                Object.prototype.hasOwnProperty.call(shippingFeeBlob, 'is_fedex') &&
                shippingFeeBlob.is_fedex
        );
    };

    const isFedexRoute = route => Array.isArray(route && route.Shipments) && route.Shipments.some(shipment => isFedexShipment(shipment));

    const isDispatchVisibleShipment = shipment => !isFedexShipment(shipment);

    const isSavedOnlyRoute = route =>
        Array.isArray(route && route.Shipments) && route.Shipments.length > 0 && route.Shipments.every(shipment => isSavedDraftShipment(shipment));

    const hasDispatchReadyShipment = route =>
        Array.isArray(route && route.Shipments) &&
        route.Shipments.some(
            shipment => shipment && shipment.status === 'shipment_ready_for_driver' && !isSavedDraftShipment(shipment)
        );

    const isPreClaimChatTrackedShipment = shipment => Boolean(
        shipment &&
        shipment.shipment_id &&
        !isSavedDraftShipment(shipment)
    );

    const isDispatchVisibleRoute = route => {
        if (getRouteShipments(route).length === 0) {
            return false;
        }

        if (isFedexRoute(route)) {
            return false;
        }

        if (isSavedOnlyRoute(route)) {
            return false;
        }

        if (
            route &&
            (route.status === 'route_ready' || route.status === 'route_temp_claimed' || route.status === 'route_temp_claimed_dispatch')
        ) {
            return hasDispatchReadyShipment(route);
        }

        return true;
    };

    const routeMatchesCompletedTab = route => {
        if (!route) {
            return false;
        }

        if (isSavedOnlyRoute(route)) {
            return false;
        }

        if (route.status === 'route_completed') {
            return true;
        }

        if (route.completed_at) {
            return true;
        }

        return getRouteShipments(route).some(shipmentRecord => {
            if (!shipmentRecord) {
                return false;
            }

            if (shipmentRecord.status === 'shipment_completed' || shipmentRecord.completed_at) {
                return true;
            }

            const shipmentOrders = Array.isArray(shipmentRecord.Orders) ? shipmentRecord.Orders : [];
            return shipmentOrders.some(orderRecord => orderRecord && (orderRecord.status === 'order_completed' || orderRecord.completed_at));
        });
    };

    const DECODED_ACCESS = decodeJwtPayload(getStoredAccessToken()) || {};
    const DECODED_ID = decodeJwtPayload(getStoredIdToken()) || {};
    const CURRENT_USER_AUTH = {
        ...DECODED_ACCESS,
        ...DECODED_ID,
        sub: DECODED_ACCESS.sub || DECODED_ID.sub || ''
    };
    const SUB = CURRENT_USER_AUTH.sub;

    const now = moment();
    const tomorrow = moment().add(1, 'day');
    const isLocalDashboardEnvironment = isDashboardLocalDebugMode();
    const currentMonthStartIso = useMemo(() => moment().startOf('month').toISOString(), []);
    const currentMonthEndIso = useMemo(() => moment().startOf('month').add(1, 'month').toISOString(), []);
    const currentMonthLabel = useMemo(() => moment().format('MMMM YYYY'), []);

    // State variables
    const {
        marketId,
        marketIdArray,
        setMarketIdArray,
        isSingleMarket,
        // singleMarketId,
        // setSingleMarketId,
        // regionMarketId,
        // setRegionMarketId,
        // superRegionMarketId,
        // setSuperRegionMarketId,
        regionId,
        coordinates,
        trafficLayer,
        weatherLayer,
        routesReadyCheck,
        routesDeliveringCheck,
        routesExpeditedCheck,
        routesAlcoholCheck,
        routeClick,
        setRouteClick,
        enrouteClickDriver,
        setEnrouteClickDriver,
        setRouteClickTwice,
        readyRoutes,
        setReadyRoutes,
        deliveringRoutes,
        setDeliveringRoutes,
        setAvailableDrivers,
        setEnrouteDrivers,
        setOfflineDrivers,
        selectedMergingRoutes,
        setSelectedMergingRoutes,
        openedMergingRoutes,
        setOpenedMergingRoutes,
        showMergingRoutesMap,
        setShowMergingRoutesMap
    } = useGlobalContext();
    // Memoized so query variables keep a stable identity across renders. An always-new []
    // churned the completed-route query's refetch identity, re-firing its refetch effect
    // every render into an infinite loop (Completed tab spinner never cleared).
    const effectiveMarketScopeIds = useMemo(
        () => (Array.isArray(marketIdArray) && marketIdArray.length > 0 ? marketIdArray : []),
        [marketIdArray]
    );
    const [liveSubscriptionsEnabled, setLiveSubscriptionsEnabled] = useState(false);

    useEffect(() => {
        let timeoutId = null;
        let idleCallbackId = null;
        let cancelled = false;

        const enableSubscriptions = () => {
            if (!cancelled) {
                setLiveSubscriptionsEnabled(true);
            }
        };

        if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
            idleCallbackId = window.requestIdleCallback(enableSubscriptions, { timeout: 1200 });
        } else {
            timeoutId = setTimeout(enableSubscriptions, 250);
        }

        return () => {
            cancelled = true;
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }
            if (idleCallbackId !== null && typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') {
                window.cancelIdleCallback(idleCallbackId);
            }
        };
    }, []);

    const [selected, setSelected] = useState('ready');
    const [completedRoutesPageIndex, setCompletedRoutesPageIndex] = useState(0);
    const [completedRoutesPageSize, setCompletedRoutesPageSize] = useState(DEFAULT_COMPLETED_ROUTE_PAGE_SIZE);
    const demurrageReviewSinceRef = useRef(new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString());

    const { loading: apolloading, error, data } = useSubscription(SUBSCRIBE_TO_SHIPMENTS, {
        variables: {
            market_id: effectiveMarketScopeIds,
            demurrage_review_since: demurrageReviewSinceRef.current,
        },
        skip: isLocalDashboardEnvironment || !liveSubscriptionsEnabled,
    });
    const subscriptionHasScheduledShipments = Boolean(
        data &&
        Array.isArray(data.Shipments) &&
        data.Shipments.some(shipmentRecord => shipmentRecord && SCHEDULED_SHIPMENT_STATUSES.includes(shipmentRecord.status))
    );
    // Changes only when a shipment is created/deleted/status-moved (not on tracking updates),
    // used to refresh the admin fallback so deleted/moved orders clear from pending/saved.
    const shipmentSubscriptionSignature = useMemo(() => {
        if (!data || !Array.isArray(data.Shipments)) {
            return '';
        }
        return data.Shipments
            .map(shipmentRecord => `${shipmentRecord && shipmentRecord.shipment_id}:${shipmentRecord && shipmentRecord.status}`)
            .sort()
            .join('|');
    }, [data]);
    const { data: shipmentQueryFallbackData } = useQuery(GET_DISPATCH_SHIPMENTS, {
        variables: {
            market_id: effectiveMarketScopeIds,
            demurrage_review_since: demurrageReviewSinceRef.current,
        },
        skip:
            isLocalDashboardEnvironment ||
            !liveSubscriptionsEnabled ||
            selected !== 'saved' ||
            subscriptionHasScheduledShipments,
        fetchPolicy: 'network-only',
    });
    const { data: routeListData } = useQuery(GET_DISPATCH_ROUTE_LIST, {
        variables: { market_id: effectiveMarketScopeIds },
        skip: isLocalDashboardEnvironment || !liveSubscriptionsEnabled || selected === 'completed',
        fetchPolicy: 'network-only',
    });
    const { loading: apolloadingRoute, data: dataRoute } = useSubscription(SUBSCRIBE_TO_ROUTES, {
        variables: { market_id: effectiveMarketScopeIds },
        skip: isLocalDashboardEnvironment || !liveSubscriptionsEnabled || selected === 'completed',
    });
    const completedRoutesPageOffset = completedRoutesPageIndex * completedRoutesPageSize;
    const {
        loading: completedRoutesPageLoading,
        data: completedRoutesPageData,
        refetch: refetchCompletedRoutesPage,
    } = useQuery(GET_DISPATCH_COMPLETED_ROUTE_PAGE, {
        variables: {
            market_id: effectiveMarketScopeIds,
            limit: completedRoutesPageSize + 1,
            offset: completedRoutesPageOffset,
        },
        // Keep the query mounted across tab changes so session recovery can refetch it.
        // cache-and-network + not gating on the live-subscriptions defer so returning to the
        // dashboard shows the last-known completed page immediately (no spinner flash) while it
        // refetches in the background.
        skip: isLocalDashboardEnvironment,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });
    const didKickCompletedRefetchOnSelectionRef = useRef(false);

    useEffect(() => {
        if (isLocalDashboardEnvironment || !liveSubscriptionsEnabled) {
            return;
        }

        if (didKickCompletedRefetchOnSelectionRef.current) {
            return;
        }

        didKickCompletedRefetchOnSelectionRef.current = true;
        refetchCompletedRoutesPage().catch(() => null);
    }, [isLocalDashboardEnvironment, liveSubscriptionsEnabled, refetchCompletedRoutesPage]);

    useEffect(() => {
        if (selected !== 'completed' || isLocalDashboardEnvironment || !liveSubscriptionsEnabled) {
            return;
        }

        refetchCompletedRoutesPage().catch(() => null);
    }, [isLocalDashboardEnvironment, liveSubscriptionsEnabled, refetchCompletedRoutesPage, selected]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined;
        }

        const handleSessionRecovered = () => {
            if (!isLocalDashboardEnvironment && liveSubscriptionsEnabled) {
                refetchCompletedRoutesPage().catch(() => null);
            }
        };

        window.addEventListener(SESSION_RECOVERED_EVENT, handleSessionRecovered);

        return () => {
            window.removeEventListener(SESSION_RECOVERED_EVENT, handleSessionRecovered);
        };
    }, [isLocalDashboardEnvironment, liveSubscriptionsEnabled, refetchCompletedRoutesPage]);
    const {
        data: dispatchMonthlyMetricsData,
        loading: dispatchMonthlyMetricsLoading,
        error: dispatchMonthlyMetricsError
    } = useQuery(GET_DISPATCH_MONTHLY_METRICS, {
        variables: {
            market_id: effectiveMarketScopeIds,
            month_start: currentMonthStartIso,
            month_end: currentMonthEndIso,
        },
        // cache-and-network so the top metrics cards keep showing last-known values instantly
        // when returning to the dashboard, refreshing quietly instead of flashing 'Loading...'.
        skip: effectiveMarketScopeIds.length === 0,
        fetchPolicy: 'cache-and-network',
    });

    const dispatchMonthlyKpis = useMemo(() => {
        const isExcludedMetricsTestShipment = shipment => {
            const shippingFee = Number(shipment && shipment.shipping_fee);
            const driverPayout = Number(shipment && shipment.driver_1099_earning);
            const isTestAmount = value => Number.isFinite(value) && Math.abs(value - 0.01) < 0.0001;

            return isTestAmount(shippingFee) || isTestAmount(driverPayout);
        };
        const getOrderCompletedMs = order => {
            const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;
            return (
                parseTimestampMs(order && order.completed_at)
                || parseTimestampMs(actions && (actions.completed_at || actions.completedAt || actions.dropoff_completed_at || actions.dropoffCompletedAt || actions.pickup_completed_at || actions.pickupCompletedAt))
            );
        };
        const isCompletedMetricOrder = order => getOrderCompletedMs(order) != null;
        const monthlyShipments = (dispatchMonthlyMetricsData && Array.isArray(dispatchMonthlyMetricsData.Shipments))
            ? dispatchMonthlyMetricsData.Shipments
            : [];
        const monthlyRouteShipments = (dispatchMonthlyMetricsData && Array.isArray(dispatchMonthlyMetricsData.Routes))
            ? dispatchMonthlyMetricsData.Routes.reduce((shipments, route) => {
                const routeShipments = route && Array.isArray(route.Shipments) ? route.Shipments : [];
                return shipments.concat(routeShipments.map(shipment => ({ ...shipment, Route: route })));
            }, [])
            : [];

        const chosenShipmentsSource = monthlyRouteShipments.length > 0
            ? monthlyRouteShipments
            : monthlyShipments;

        const shipmentRows = chosenShipmentsSource.filter(shipment => !isExcludedMetricsTestShipment(shipment));
        const activeCustomerKeys = new Set();
        const activeCustomerNameByKey = new Map();
        const deliveryGraceWindowMs = ON_TIME_DELIVERY_GRACE_MINUTES * 60 * 1000;

        let totalOrders = 0;
        let pickupEvaluatedCount = 0;
        let pickupOnTimeCount = 0;
        let deliveryEvaluatedCount = 0;
        let deliveryOnTimeCount = 0;

        shipmentRows.forEach(shipment => {
            const orders = Array.isArray(shipment && shipment.Orders) ? shipment.Orders : [];
            const completedOrders = orders.filter(isCompletedMetricOrder);
            const completedDropoffOrders = completedOrders.filter(order => {
                const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
                const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;
                const hasDropOffAction = Boolean(actions && Object.prototype.hasOwnProperty.call(actions, 'drop_off'));
                const hasPickUpAction = Boolean(actions && Object.prototype.hasOwnProperty.call(actions, 'pick_up'));
                return normalizedAction === 'dropoff' || normalizedAction === 'drop_off' || hasDropOffAction || (normalizedAction === '' && !hasPickUpAction);
            });
            totalOrders += completedDropoffOrders.length;

            if (completedOrders.length > 0) {
                const customerKey = resolveDispatchMonthlyCustomerKey(shipment);
                if (customerKey) {
                    activeCustomerKeys.add(customerKey);
                    if (!activeCustomerNameByKey.has(customerKey)) {
                        activeCustomerNameByKey.set(customerKey, resolveDispatchMonthlyCustomerDisplayName(shipment));
                    }
                }
            }

            const pickupOrders = completedOrders.filter(order => {
                const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
                if (normalizedAction === 'pickup' || normalizedAction === 'pick_up') {
                    return true;
                }

                const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : {};
                if (!actions || !actions.pick_up) {
                    return false;
                }

                const pickupInstruction = Array.isArray(actions.pick_up)
                    ? String(actions.pick_up[0] || '').toLowerCase()
                    : String(actions.pick_up).toLowerCase();

                return !pickupInstruction.includes('(drop)');
            });

            const pickupOrdersForTiming = pickupOrders.length > 0
                ? pickupOrders
                : completedOrders.filter(order => {
                    const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
                    return normalizedAction !== 'dropoff' && normalizedAction !== 'drop_off';
                });

            const pickupTimestampCandidates = pickupOrdersForTiming
                .map(order => getOrderArrivalEvidenceMsForMetrics(shipment, order))
                .filter(value => value != null)
                .sort((left, right) => left - right);

            const pickupActualMs = pickupTimestampCandidates.length > 0 ? pickupTimestampCandidates[0] : null;
            const pickupEtaCandidates = pickupOrdersForTiming
                .map(order => getOrderEtaMsForMetrics(order))
                .filter(value => value != null)
                .sort((left, right) => left - right);
            const pickupEtaMs = pickupEtaCandidates.length > 0 ? pickupEtaCandidates[0] : null;

            // Use route created_at as the "pushed to ready" anchor for the SLA window.
            const routeReadyMs = parseTimestampMs(shipment && shipment.Route && shipment.Route.created_at);
            const scheduledMs = parseTimestampMs(shipment && shipment.scheduled_for);
            const windowAnchorMs = routeReadyMs || parseTimestampMs(shipment && shipment.created_at);

            if (pickupActualMs != null) {
                let pickupDeadlineMs = null;
                if (scheduledMs != null) {
                    // Scheduled: must pick up within 30 min of scheduled time (driver may grab day before)
                    pickupDeadlineMs = scheduledMs + deliveryGraceWindowMs;
                } else if (windowAnchorMs != null) {
                    // Standard: 4h from route-ready; Expedited: 1h from route-ready
                    const pickupWindowMs = parseExpeditedFlag(shipment && shipment.is_expedited)
                        ? ON_TIME_PICKUP_EXPEDITED_HOURS * 60 * 60 * 1000
                        : ON_TIME_PICKUP_STANDARD_HOURS * 60 * 60 * 1000;
                    pickupDeadlineMs = windowAnchorMs + pickupWindowMs;
                }

                // Also credit drivers who arrived by their committed pickup ETA even when that's
                // later than the on-demand window (e.g. expedited orders the merchant didn't
                // actually want picked up until later). On-time = met the window OR beat the ETA.
                if (pickupEtaMs != null) {
                    const etaDeadlineMs = pickupEtaMs + deliveryGraceWindowMs;
                    pickupDeadlineMs = pickupDeadlineMs == null ? etaDeadlineMs : Math.max(pickupDeadlineMs, etaDeadlineMs);
                }

                if (pickupDeadlineMs != null) {
                    pickupEvaluatedCount += 1;
                    if (pickupActualMs <= pickupDeadlineMs) {
                        pickupOnTimeCount += 1;
                    }
                }
            }

            const eligibleDeliveryOrders = completedOrders.filter(order => {
                const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;
                const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
                const hasDropOffAction = Boolean(actions && Object.prototype.hasOwnProperty.call(actions, 'drop_off'));
                const hasPickUpAction = Boolean(actions && Object.prototype.hasOwnProperty.call(actions, 'pick_up'));
                const isDelivery = normalizedAction === 'dropoff' || normalizedAction === 'drop_off' || hasDropOffAction || (normalizedAction === '' && !hasPickUpAction);

                if (!isDelivery) {
                    return false;
                }

                const isDispatchMarkedComplete = Boolean(
                    (actions && actions.completion_override)
                    || hasDispatchCompletionActor(actions)
                );

                if (isDispatchMarkedComplete) {
                    return false;
                }

                return true;
            });

            eligibleDeliveryOrders.forEach(order => {
                const etaMs = getOrderEtaMsForMetrics(order);
                const arrivalMs = getOrderArrivalEvidenceMsForMetrics(shipment, order);

                if (etaMs == null) {
                    return;
                }

                deliveryEvaluatedCount += 1;

                if (arrivalMs == null) {
                    deliveryOnTimeCount += 1;
                    return;
                }

                if (arrivalMs <= (etaMs + deliveryGraceWindowMs)) {
                    deliveryOnTimeCount += 1;
                }
            });
        });

        return {
            activeCustomersCount: activeCustomerKeys.size,
            activeCustomerNames: Array.from(activeCustomerNameByKey.values())
                .filter(value => String(value || '').trim() !== '')
                .sort((left, right) => left.localeCompare(right)),
            totalOrders,
            pickupOnTimeCount,
            pickupEvaluatedCount,
            pickupRatePercent: pickupEvaluatedCount > 0 ? (pickupOnTimeCount / pickupEvaluatedCount) * 100 : null,
            deliveryOnTimeCount,
            deliveryEvaluatedCount,
            deliveryRatePercent: deliveryEvaluatedCount > 0 ? (deliveryOnTimeCount / deliveryEvaluatedCount) * 100 : null,
        };
    }, [dispatchMonthlyMetricsData, completedRoutesPageData]);
    const dispatchMonthlyKpiCards = [
        {
            key: 'active-customers',
            label: 'Active Customers',
            value: (dispatchMonthlyMetricsLoading && !dispatchMonthlyMetricsData)
                ? 'Loading...'
                : (dispatchMonthlyMetricsError ? 'Error' : String(dispatchMonthlyKpis.activeCustomersCount))
        },
        {
            key: 'total-orders',
            label: 'Total Number of Orders',
            value: (dispatchMonthlyMetricsLoading && !dispatchMonthlyMetricsData)
                ? 'Loading...'
                : (dispatchMonthlyMetricsError ? 'Error' : String(dispatchMonthlyKpis.totalOrders))
        },
        {
            key: 'on-time-pickup',
            label: 'On-Time Pickup',
            value: (dispatchMonthlyMetricsLoading && !dispatchMonthlyMetricsData)
                ? 'Loading...'
                : (dispatchMonthlyMetricsError
                    ? 'Error'
                : formatRateWithCounts(
                    dispatchMonthlyKpis.pickupRatePercent,
                    dispatchMonthlyKpis.pickupOnTimeCount,
                    dispatchMonthlyKpis.pickupEvaluatedCount
                ))
        },
        {
            key: 'on-time-delivery',
            label: 'On-Time Delivery',
            value: (dispatchMonthlyMetricsLoading && !dispatchMonthlyMetricsData)
                ? 'Loading...'
                : (dispatchMonthlyMetricsError
                    ? 'Error'
                : formatRateWithCounts(
                    dispatchMonthlyKpis.deliveryRatePercent,
                    dispatchMonthlyKpis.deliveryOnTimeCount,
                    dispatchMonthlyKpis.deliveryEvaluatedCount
                ))
        }
    ];
    const activeCustomerNames = dispatchMonthlyKpis && Array.isArray(dispatchMonthlyKpis.activeCustomerNames)
        ? dispatchMonthlyKpis.activeCustomerNames
        : [];
    const canOpenActiveCustomersModal = !dispatchMonthlyMetricsLoading
        && !dispatchMonthlyMetricsError
        && activeCustomerNames.length > 0;
    const hasMarkedDispatchDataReady = useRef(false);

    useEffect(() => {
        if (hasMarkedDispatchDataReady.current || isLocalDashboardEnvironment) {
            return;
        }

        if (!apolloading && !apolloadingRoute && data && dataRoute) {
            hasMarkedDispatchDataReady.current = true;
            markDashboardPerformance(DASHBOARD_PERF_MARKS.DISPATCH_DATA_READY, {
                shipments: data && data.Shipments ? data.Shipments.length : 0,
                routes: dataRoute && dataRoute.Routes ? dataRoute.Routes.length : 0,
            });
            measureDashboardPerformance('login_to_dispatch_data_ready_ms', DASHBOARD_PERF_MARKS.LOGIN_AUTHENTICATED, DASHBOARD_PERF_MARKS.DISPATCH_DATA_READY);
            measureDashboardPerformance('admin_mount_to_dispatch_data_ready_ms', DASHBOARD_PERF_MARKS.ADMIN_MOUNTED, DASHBOARD_PERF_MARKS.DISPATCH_DATA_READY);
        }
    }, [apolloading, apolloadingRoute, data, dataRoute]);

    // Subscribe to all markets for total counts
    // Note: We'll need to create a separate query for all markets or use axios to fetch total counts

    const [currentRecordId, setCurrentRecordId] = useState(null);
    const [currentRecord, setCurrentRecord] = useState(null);
    const shipmentCurrentRecordMissCountRef = useRef(0);
    const routeCurrentRecordMissCountRef = useRef(0);
    // Subscription updates that arrived while a realtime interaction (open modal,
    // active edit, text selection) was in progress; flushed once it ends so the
    // user's own change is not dropped and lost until a hard refresh.
    const pendingShipmentSubscriptionDataRef = useRef(null);
    const pendingRouteSubscriptionDataRef = useRef(null);
    const [shipmentsData, setShipmentsData] = useState([]);
    const [routesData, setRoutesData] = useState([]);
    const [adminDispatchShipmentFallbackData, setAdminDispatchShipmentFallbackData] = useState(null);
    const [localDispatchShipments, setLocalDispatchShipments] = useState([]);
    const [localDispatchShipmentsLoading, setLocalDispatchShipmentsLoading] = useState(false);
    const [localDispatchRoutes, setLocalDispatchRoutes] = useState([]);
    const [localDispatchRoutesLoading, setLocalDispatchRoutesLoading] = useState(false);
    const [localDispatchShipmentsLoaded, setLocalDispatchShipmentsLoaded] = useState(false);
    const [localDispatchRoutesLoaded, setLocalDispatchRoutesLoaded] = useState(false);
    const [useHostedLocalDispatchShipmentsFallback, setUseHostedLocalDispatchShipmentsFallback] = useState(false);
    const [useHostedLocalDispatchRoutesFallback, setUseHostedLocalDispatchRoutesFallback] = useState(false);
    const [useHostedLocalDispatchReviewsFallback, setUseHostedLocalDispatchReviewsFallback] = useState(false);

    // Payment retry modal state
    const [paymentRetryModalOpen, setPaymentRetryModalOpen] = useState(false);
    const [selectedShipmentForPayment, setSelectedShipmentForPayment] = useState(null);
    const [pendingPaymentActionShipmentId, setPendingPaymentActionShipmentId] = useState('');
    const isHostedDevelopmentDashboard = !isLocalDashboardEnvironment && !isProductionStage();
    const [gopilotReviews, setGoPilotReviews] = useState([]);
    const [gopilotReviewsLoading, setGoPilotReviewsLoading] = useState(false);
    const [gopilotReviewsSupported, setGoPilotReviewsSupported] = useState(() => !isOptionalDispatchEndpointCachedMissing(shipment_urls.adminGoPilotReviews));
    const [gopilotReviewModalOpen, setGoPilotReviewModalOpen] = useState(false);
    const [selectedGoPilotReviewId, setSelectedGoPilotReviewId] = useState(null);
    const [selectedGoPilotReviewSummary, setSelectedGoPilotReviewSummary] = useState(null);
    const [selectedGoPilotReviewLoading, setSelectedGoPilotReviewLoading] = useState(false);
    const [gopilotReviewApprovalReason, setGoPilotReviewApprovalReason] = useState('');
    const [gopilotReviewActionShipmentId, setGoPilotReviewActionShipmentId] = useState('');
    const [claimedOrderChatSummariesSupported, setClaimedOrderChatSummariesSupported] = useState(() => !isOptionalDispatchEndpointCachedMissing(claimedOrderChatSummariesEndpoint));
    const [preClaimOrderChatSummariesSupported, setPreClaimOrderChatSummariesSupported] = useState(() => !isOptionalDispatchEndpointCachedMissing(preClaimOrderChatSummariesEndpoint));
    const [showSmartDispatchSummary, setShowSmartDispatchSummary] = useState(false);
    const [smartDispatchSummaryLoading, setSmartDispatchSummaryLoading] = useState(false);
    const [smartDispatchSummaryRouteId, setSmartDispatchSummaryRouteId] = useState('');
    const [smartDispatchSummaryContext, setSmartDispatchSummaryContext] = useState(null);
    const [smartDispatchSummaryPayload, setSmartDispatchSummaryPayload] = useState(null);
    const [smartDispatchProfileNameByAuth0Id, setSmartDispatchProfileNameByAuth0Id] = useState({});
    const [smartDispatchActionRouteId, setSmartDispatchActionRouteId] = useState('');
    const [activeCustomersModalOpen, setActiveCustomersModalOpen] = useState(false);

    // const { loading: apolloadingDriver, error: errorDriver, data: dataDriver } = useQuery(SUBSCRIBE_TO_DRIVERS, {
    //   context: { clientName: 'userClient' },
    //   variables: { market_id: marketId }
    // });
    const [filter, setFilter] = useState([]);
    const [filterRoutes, setFilterRoutes] = useState([]);
    const [shipmentsToDisplay, setShipmentsToDisplay] = useState([]);
    const [routesToDisplay, setRoutesToDisplay] = useState([]);
    const [driversToDisplay, setDriversToDisplay] = useState([]);
    const [driversToSMS, setDriversToSMS] = useState([]);
    const [expandedDriverListSnapshot, setExpandedDriverListSnapshot] = useState(null);
    const [modal, setModal] = useState(false);
    const [modalReassign, setModalReassign] = useState(false);
    const [modalAssignPassengerOnly, setModalAssignPassengerOnly] = useState(false);
    const [completeOrderModal, setCompleteOrderModal] = useState({ isOpen: false, shipmentId: null, orderId: null, actionType: null, stopLabel: null });
    const [arrivalOverrideModalOpen, setArrivalOverrideModalOpen] = useState(false);
    const [selectedArrivalOverrideRequest, setSelectedArrivalOverrideRequest] = useState(null);
    const [expandedItems] = useState(props.expandedItems);
    const prevSelectedRef = useRef(selected); // Track the previous 'selected' value
    const [driversLoading, setLoading] = useState(false);
    const [amountReady, setAmountReady] = useState(0);
    const [amountPending, setAmountPending] = useState(0);
    const [amountApproval, setAmountApproval] = useState(0);
    const [amountDelivering, setAmountDelivering] = useState(0);

    // Total counts across all markets
    const [totalAmountReady, setTotalAmountReady] = useState(0);
    const [totalAmountDelivering, setTotalAmountDelivering] = useState(0);
    const [amountMerging, setAmountMerging] = useState(0);

    const [, setDrivers] = useState([]);
    const [driverSelected, setDriverSelected] = useState(false);
    const [order, setOrder] = useState(null);
    const [primaryDriver, setPrimaryDriver] = useState('');
    const [passenger1, setPassenger1] = useState('');
    const [passenger2, setPassenger2] = useState('');
    const [passenger1Selected, setPassenger1Selected] = useState(false);
    const [, setPassenger2Selected] = useState(false);
    const [driverReassign, setDriverReassign] = useState('');
    const [, setDriverReassignSelected] = useState(false);
    const [passenger1OnlyAssigned, setPassenger1OnlyAssigned] = useState('');
    const [passenger2OnlyAssigned, setPassenger2OnlyAssigned] = useState('');
    const [passenger1OnlyAssignedSelected, setPassenger1OnlyAssignedSelected] = useState(false);
    const [passenger2OnlyAssignedSelected, setPassenger2OnlyAssignedSelected] = useState(false);
    const [driversForAssign, setDriversForAssign] = useState([]);
    const [driverName, setDriverName] = useState('');
    const [filterDriversForAssign, setFilterDriversForAssign] = useState([]);
    const [isFilterDrivers, setIsFilterDrivers] = useState(false);

    const [shipment, setShipment] = useState('');
    const [route, setRoute] = useState({ RouteDrivers: [] });

    const [showAlert, setShowAlert] = useState(false);
    const [showAlertCancelOrder, setShowAlertCancelOrder] = useState(false);
    const [showAlertCancelShipment, setShowAlertCancelShipment] = useState(false);
    const [showAlertRemoveShipment, setShowAlertRemoveShipment] = useState(false);
    const [showAlertUnassignRoute, setShowAlertUnassignRoute] = useState(false);
    const [showAlertBreakRoute, setShowAlertBreakRoute] = useState(false);
    const [showAlertMergeRoute, setShowAlertMergeRoute] = useState(false);
    const [showUpdateShippingFee, setShowUpdateShippingFee] = useState(false);
    const [showChargeSetupFee, setShowChargeSetupFee] = useState(false);
    const [shippingFee, setShippingFee] = useState('');
    const [setupDuration, setSetupDuration] = useState('');
    const [showDriverPay, setShowDriverPay] = useState(false);
    const [driverPay, setDriverPay] = useState({
        distance_earning: 0,
        expedited_earning: 0,
        overweight_earning: 0,
        setup_earning: 0,
        tools_earning: 0,
        gratuity: 0,
        bonus: 0,
        min_pay: 0,
        total_earning: 0
    });
    const [driverPayRecords, setDriverPayRecords] = useState([]);
    const [externalPaymentReference, setExternalPaymentReference] = useState('');
    const [externalPaymentNote, setExternalPaymentNote] = useState('');
    const [resolvingDriverPayId, setResolvingDriverPayId] = useState('');
    const [driverBonus, setDriverBonus] = useState('');
    const [bonusReason, setBonusReason] = useState('');
    const [shippingFeeReason, setShippingFeeReason] = useState('');
    const [showDemurrageReviewModal, setShowDemurrageReviewModal] = useState(false);
    const [demurrageDecisionNotes, setDemurrageDecisionNotes] = useState('');
    const [isSubmittingDemurrageDecision, setIsSubmittingDemurrageDecision] = useState(false);
    const autoPromptedDemurrageReviewKeysRef = useRef(new Set());
    const [showUpdateDriverPayBeforeClaim, setShowUpdateDriverPayBeforeClaim] = useState(false);
    const [updateDriverPayBeforeClaimReason, setUpdateDriverPayBeforeClaimReason] = useState('');
    const [driverPayBeforeClaimTotalAmount, setDriverPayBeforeClaimTotalAmount] = useState('');

    const [showOrder, setShowOrder] = useState(false);
    const [almostReady] = useState([]);
    const [ready] = useState([]);
    const [availableDriversCopy, setAvailableDriversCopy] = useState([]);
    const [enrouteDriversCopy, setEnrouteDriversCopy] = useState([]);
    const [offlineDriversCopy, setOfflineDriversCopy] = useState([]);

    // Merging routes
    const [mergeRoutesList, setMergeRoutesList] = useState([]);
    const [mergingCheckState, setMergingCheckedState] = useState([]);
    const [mergingCheckStateAllChecked, setMergingCheckStateAllChecked] = useState(false);
    const [isRouteBuilderAccessible, setIsRouteBuilderAccessible] = useState(false);
    const [mergeRouteWaypointsSelected, setMergeRouteWaypointsSelected] = useState(0);
    const [mergingRoutes, setMergingRoutes] = useState([]);
    const mergeRouteWaypointsWarning = 24;

    const effectiveShipmentSubscriptionData = useMemo(() => {
        if (!isLocalDashboardEnvironment) {
            // Pending and saved lists use the authoritative admin fallback fetch because the
            // live subscription can lag or drop non-active shipments, leaving the list empty
            // while the count still shows them.
            if (selected === 'saved' || selected === 'pending') {
                return adminDispatchShipmentFallbackData || shipmentQueryFallbackData || data;
            }

            return data;
        }

        return {
            Shipments: localDispatchShipments,
        };
    }, [adminDispatchShipmentFallbackData, data, isLocalDashboardEnvironment, localDispatchShipments, selected, shipmentQueryFallbackData, subscriptionHasScheduledShipments]);

    useEffect(() => {
        if (showDemurrageReviewModal) {
            return;
        }

        const reviewShipments = effectiveShipmentSubscriptionData && Array.isArray(effectiveShipmentSubscriptionData.DemurrageReviewShipments)
            ? effectiveShipmentSubscriptionData.DemurrageReviewShipments
            : [];
        const pendingShipment = reviewShipments.find(candidate => {
            const promptKey = buildDemurrageReviewPromptKey(candidate);

            return hasPendingDemurrageReview(candidate)
                && promptKey
                && !autoPromptedDemurrageReviewKeysRef.current.has(promptKey);
        });

        if (!pendingShipment) {
            return;
        }

        autoPromptedDemurrageReviewKeysRef.current.add(buildDemurrageReviewPromptKey(pendingShipment));
        setShipment(pendingShipment);
        setDemurrageDecisionNotes('');
        setShowDemurrageReviewModal(true);
    }, [effectiveShipmentSubscriptionData, showDemurrageReviewModal]);

    const localCompletedRoutesPageSourceRows = useMemo(() => {
        if (!isLocalDashboardEnvironment || selected !== 'completed') {
            return [];
        }

        const completedRoutes = (Array.isArray(localDispatchRoutes) ? localDispatchRoutes : [])
            .filter(routeRecord => routeMatchesCompletedTab(routeRecord))
            .sort((leftRoute, rightRoute) => new Date(rightRoute.completed_at) - new Date(leftRoute.completed_at));
        const pageStart = completedRoutesPageIndex * completedRoutesPageSize;

        return completedRoutes.slice(pageStart, pageStart + completedRoutesPageSize + 1);
    }, [completedRoutesPageIndex, completedRoutesPageSize, isLocalDashboardEnvironment, localDispatchRoutes, selected]);

    const effectiveRouteSubscriptionData = useMemo(() => {
        if (isLocalDashboardEnvironment) {
            if (selected === 'completed') {
                return {
                    Routes: localCompletedRoutesPageSourceRows.slice(0, completedRoutesPageSize),
                };
            }

            return {
                Routes: localDispatchRoutes,
            };
        }

        if (selected === 'completed') {
            return completedRoutesPageData && Array.isArray(completedRoutesPageData.Routes)
                ? {
                      ...completedRoutesPageData,
                      Routes: completedRoutesPageData.Routes.slice(0, completedRoutesPageSize)
                  }
                : { Routes: [] };
        }

        return dataRoute;
    }, [completedRoutesPageData, completedRoutesPageSize, dataRoute, isLocalDashboardEnvironment, localCompletedRoutesPageSourceRows, localDispatchRoutes, selected]);
    const hostedRouteListPreviewData = useMemo(() => {
        if (isLocalDashboardEnvironment || !(routeListData && Array.isArray(routeListData.Routes))) {
            return null;
        }

        const hydratedRouteMap = new Map(
            ((dataRoute && Array.isArray(dataRoute.Routes)) ? dataRoute.Routes : [])
                .filter(routeRecord => routeRecord && routeRecord.route_id)
                .map(routeRecord => [routeRecord.route_id, routeRecord])
        );
        const mergedRoutes = routeListData.Routes.map(routeRecord => {
            if (!routeRecord) {
                return routeRecord;
            }

            return hydratedRouteMap.get(routeRecord.route_id) || { ...routeRecord, __dispatchPreview: true };
        });

        hydratedRouteMap.forEach((routeRecord, routeId) => {
            if (!mergedRoutes.some(candidate => candidate && candidate.route_id === routeId)) {
                mergedRoutes.push(routeRecord);
            }
        });

        return {
            Routes: mergedRoutes,
        };
    }, [dataRoute, isLocalDashboardEnvironment, routeListData]);
    const routeListSourceData = useMemo(() => {
        if (isLocalDashboardEnvironment) {
            return effectiveRouteSubscriptionData;
        }

        if (selected === 'completed') {
            return effectiveRouteSubscriptionData;
        }

        if (routesData && Array.isArray(routesData.Routes) && routesData.Routes.length > 0) {
            return routesData;
        }

        return hostedRouteListPreviewData;
    }, [effectiveRouteSubscriptionData, hostedRouteListPreviewData, isLocalDashboardEnvironment, routesData]);
    const seenGoPilotReviewIdsRef = useRef(new Set());
    const manuallyOpenedArrivalOverrideRequestKeysRef = useRef(new Set());
    const previousClaimedOrderChatMessageIdsRef = useRef({});
    const previousClaimedOrderChatUnreadCountsRef = useRef({});
    const countedClaimedOrderChatMessageIdsRef = useRef({});
    const previousDeliveringTabUnreadCountRef = useRef(0);
    const hasHydratedClaimedOrderChatSummariesRef = useRef(false);
    const hasHydratedPreClaimOrderChatSummariesRef = useRef(false);
    const previousPreClaimOrderChatMessageIdsRef = useRef({});
    const previousPreClaimOrderChatUnreadCountsRef = useRef({});
    const countedPreClaimOrderChatMessageIdsRef = useRef({});
    const previousReadyTabUnreadCountRef = useRef(0);
    const selectedGoPilotReview = useMemo(
        () => gopilotReviews.find(review => review && review.shipment_id === selectedGoPilotReviewId) || null,
        [gopilotReviews, selectedGoPilotReviewId]
    );
    const seenArrivalOverrideRequestKeysRef = useRef(new Set());
    const dismissedArrivalOverrideRequestKeysRef = useRef(new Set());
    const selectedGoPilotReviewStage = useMemo(
        () => selectedGoPilotReview && selectedGoPilotReview.gopilot_review_stage ? selectedGoPilotReview.gopilot_review_stage : 'delivery',
        [selectedGoPilotReview]
    );
    const selectedGoPilotReviewType = useMemo(
        () => selectedGoPilotReview && selectedGoPilotReview.gopilot_review_type ? selectedGoPilotReview.gopilot_review_type : 'delivery_completion',
        [selectedGoPilotReview]
    );
    const selectedGoPilotStageAttempt = useMemo(() => {
        if (!selectedGoPilotReviewSummary) {
            return null;
        }

        const attempts = selectedGoPilotReviewStage === 'pickup'
            ? selectedGoPilotReviewSummary.pickup_attempts
            : selectedGoPilotReviewSummary.delivery_attempts;

        if (!Array.isArray(attempts)) {
            return null;
        }

        return attempts.length > 0 ? attempts[attempts.length - 1] : null;
    }, [selectedGoPilotReviewStage, selectedGoPilotReviewSummary]);
    const selectedGoPilotStagePhotos = useMemo(() => {
        if (!selectedGoPilotStageAttempt || !Array.isArray(selectedGoPilotStageAttempt.photos)) {
            return [];
        }

        return selectedGoPilotStageAttempt.photos
            .map((photo, index) => {
                const photoUrl = photo && (photo.url || photo.signed_url || photo.download_url || '');

                if (!photo || !photoUrl) {
                    return null;
                }

                return {
                    fileId: photo.gopilot_photo_id || `${photo.file_name || 'gopilot-photo'}-${index}`,
                    url: photoUrl,
                    metadata: {
                        photoIndex: index,
                        capturedAtLabel: photo.captured_at ? formatTimestamp(photo.captured_at) : 'Capture time unavailable',
                        locationLabel: formatGoPilotPhotoLocation(photo),
                    },
                };
            })
            .filter(Boolean);
    }, [selectedGoPilotStageAttempt]);
    const mapGoPilotAttemptsToPhotos = useCallback(attempts => {
        if (!Array.isArray(attempts) || attempts.length === 0) {
            return [];
        }

        const latestAttempt = attempts[attempts.length - 1];
        if (!latestAttempt || !Array.isArray(latestAttempt.photos)) {
            return [];
        }

        return latestAttempt.photos
            .map((photo, index) => {
                const photoUrl = photo && (photo.url || photo.signed_url || photo.download_url || '');

                if (!photo || !photoUrl) {
                    return null;
                }

                return {
                    fileId: photo.gopilot_photo_id || `${photo.file_name || 'gopilot-photo'}-${index}`,
                    url: photoUrl,
                    metadata: {
                        photoIndex: index,
                        capturedAtLabel: photo.captured_at ? formatTimestamp(photo.captured_at) : 'Capture time unavailable',
                        locationLabel: formatGoPilotPhotoLocation(photo),
                    },
                };
            })
            .filter(Boolean);
    }, []);
    const selectedGoPilotBeforePhotos = useMemo(
        () => (selectedGoPilotReviewSummary ? mapGoPilotAttemptsToPhotos(selectedGoPilotReviewSummary.pickup_attempts) : []),
        [selectedGoPilotReviewSummary, mapGoPilotAttemptsToPhotos]
    );
    const selectedGoPilotAfterPhotos = useMemo(
        () => (selectedGoPilotReviewSummary ? mapGoPilotAttemptsToPhotos(selectedGoPilotReviewSummary.delivery_attempts) : []),
        [selectedGoPilotReviewSummary, mapGoPilotAttemptsToPhotos]
    );
    const selectedGoPilotConversationNotes = useMemo(() => {
        if (!selectedGoPilotReviewSummary || !Array.isArray(selectedGoPilotReviewSummary.conversation_notes)) {
            return [];
        }

        return [...selectedGoPilotReviewSummary.conversation_notes].sort((left, right) => {
            const leftTime = new Date(left && left.created_at ? left.created_at : 0).getTime();
            const rightTime = new Date(right && right.created_at ? right.created_at : 0).getTime();
            return leftTime - rightTime;
        });
    }, [selectedGoPilotReviewSummary]);
    const sortDriverSmsList = useCallback(driverList => {
        return [...(Array.isArray(driverList) ? driverList : [])].sort((left, right) => {
            const leftUnread = Number(left && left.unread_message_count) || 0;
            const rightUnread = Number(right && right.unread_message_count) || 0;

            if (leftUnread !== rightUnread) {
                return rightUnread - leftUnread;
            }

            if (Boolean(left && left.is_online) !== Boolean(right && right.is_online)) {
                return left && left.is_online ? -1 : 1;
            }

            if (Boolean(left && left.is_available) !== Boolean(right && right.is_available)) {
                return left && left.is_available ? -1 : 1;
            }

            const leftUser = left && left.User ? left.User : {};
            const rightUser = right && right.User ? right.User : {};
            const leftName = `${leftUser.firstname || ''} ${leftUser.lastname || ''}`.trim().toLowerCase();
            const rightName = `${rightUser.firstname || ''} ${rightUser.lastname || ''}`.trim().toLowerCase();

            return leftName.localeCompare(rightName);
        });
    }, []);
    const driverListSourceData = useMemo(() => {
        if (Array.isArray(driversToSMS) && driversToSMS.length > 0) {
            return sortDriverSmsList(driversToSMS);
        }

        if (Array.isArray(driversToDisplay) && driversToDisplay.length > 0) {
            return sortDriverSmsList(driversToDisplay);
        }

        return [];
    }, [driversToDisplay, driversToSMS, sortDriverSmsList]);

    useEffect(() => {
        const unreadMessageCount = (Array.isArray(driverListSourceData) ? driverListSourceData : []).reduce(
            (sum, driverRecord) => sum + (driverRecord && driverRecord.unread_message_count ? driverRecord.unread_message_count : 0),
            0
        );

        setTotalUnreadDriverMessages(unreadMessageCount);
    }, [driverListSourceData]);

    const smartDispatchDriverNameByAuth0Id = useMemo(() => {
        const nameByAuth0Id = {};

        (Array.isArray(driverListSourceData) ? driverListSourceData : []).forEach(driverRecord => {
            const userRecord = driverRecord && driverRecord.User ? driverRecord.User : {};
            const auth0Id = String(
                (driverRecord && (driverRecord.driver_auth0_id || driverRecord.auth0_id))
                || userRecord.auth0_id
                || ''
            ).trim();

            if (!auth0Id) {
                return;
            }

            const fullName = String([
                (driverRecord && (driverRecord.first_name || driverRecord.firstname)),
                (driverRecord && (driverRecord.last_name || driverRecord.lastname)),
                userRecord.firstname || userRecord.first_name,
                userRecord.lastname || userRecord.last_name,
            ].filter(Boolean).join(' ') || '').trim();

            if (fullName) {
                nameByAuth0Id[auth0Id] = fullName;
            }
        });

        return nameByAuth0Id;
    }, [driverListSourceData]);
    useEffect(() => {
        if (!showSmartDispatchSummary || !smartDispatchSummaryPayload || typeof smartDispatchSummaryPayload !== 'object') {
            return;
        }

        const workflowSummary = smartDispatchSummaryPayload.workflow || {};
        const notifications = Array.isArray(smartDispatchSummaryPayload.notified_drivers)
            ? smartDispatchSummaryPayload.notified_drivers
            : (Array.isArray(workflowSummary.notified_drivers)
                ? workflowSummary.notified_drivers
                : (Array.isArray(workflowSummary.DriverDispatchNotifications) ? workflowSummary.DriverDispatchNotifications : []));

        const auth0IdsToResolve = Array.from(new Set(
            notifications
                .map(notification => {
                    const snapshot = notification && notification.candidate_snapshot ? notification.candidate_snapshot : {};
                    const preferredName = String(notification && notification.name ? notification.name : snapshot.driver_name || snapshot.display_name || '').trim();
                    const auth0Id = String(notification && notification.driver_auth0_id ? notification.driver_auth0_id : snapshot.auth0_id || '').trim();
                    const normalizedAuth0Id = auth0Id || (isAuth0LikeIdentifier(preferredName) ? preferredName : '');

                    if (!normalizedAuth0Id) {
                        return '';
                    }

                    if (smartDispatchDriverNameByAuth0Id[normalizedAuth0Id] || smartDispatchProfileNameByAuth0Id[normalizedAuth0Id]) {
                        return '';
                    }

                    return normalizedAuth0Id;
                })
                .filter(Boolean)
        ));

        if (auth0IdsToResolve.length === 0) {
            return;
        }

        let cancelled = false;

        axios({
            method: 'post',
            url: user_urls.hasuraHost,
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            data: {
                query: `query LoadSmartDispatchDriverNames($auth0Ids: [String!]!) {
                    Users(where: { auth0_id: { _in: $auth0Ids } }) {
                        auth0_id
                        firstname
                        lastname
                        username
                        email
                    }
                }`,
                variables: { auth0Ids: auth0IdsToResolve }
            }
        })
            .then(response => {
                if (cancelled) {
                    return;
                }

                const users = response && response.data && response.data.data && Array.isArray(response.data.data.Users)
                    ? response.data.data.Users
                    : [];

                const resolvedNames = users.reduce((lookup, userRecord) => {
                    const auth0Id = String(userRecord && userRecord.auth0_id ? userRecord.auth0_id : '').trim();
                    const displayName = getUserRecordDisplayName(userRecord);

                    if (auth0Id && displayName) {
                        lookup[auth0Id] = displayName;
                    }

                    return lookup;
                }, {});

                if (Object.keys(resolvedNames).length > 0) {
                    setSmartDispatchProfileNameByAuth0Id(previous => ({
                        ...previous,
                        ...resolvedNames,
                    }));
                }
            })
            .catch(() => {});

        return () => {
            cancelled = true;
        };
    }, [showSmartDispatchSummary, smartDispatchSummaryPayload, smartDispatchDriverNameByAuth0Id, smartDispatchProfileNameByAuth0Id]);
    const mergingRouteRefreshKey = useMemo(() => {
        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes) ? effectiveRouteSubscriptionData.Routes : [];

        return routeRecords
            .filter(routeRecord => routeRecord && ['route_ready', 'route_temp_claimed', 'route_temp_claimed_dispatch'].includes(routeRecord.status))
            .map(routeRecord => `${routeRecord.route_id}:${routeRecord.status}:${routeRecord.updated_at || routeRecord.updatedAt || ''}`)
            .sort()
            .join('|');
    }, [effectiveRouteSubscriptionData]);
    const pendingDispatchActionsRef = useRef(new Set());

    const runDispatchActionOnce = useCallback(async (actionKey, action) => {
        if (pendingDispatchActionsRef.current.has(actionKey)) {
            return null;
        }

        pendingDispatchActionsRef.current.add(actionKey);

        try {
            return await action();
        } finally {
            pendingDispatchActionsRef.current.delete(actionKey);
        }
    }, []);

    const refreshLocalDispatchData = useCallback(() => {
        if (!isLocalDashboardEnvironment) {
            return Promise.resolve();
        }

        if (!isMountedRef.current) {
            return Promise.resolve();
        }

        setLocalDispatchShipmentsLoading(true);
        setLocalDispatchRoutesLoading(true);

        const localDispatchShipmentsUrl = shipment_urls.adminDispatchShipments;
        const hostedDispatchShipmentsUrl = shipment_urls.toHostedShipmentUrl(localDispatchShipmentsUrl);
        const localDispatchRoutesUrl = shipment_urls.adminDispatchRoutes;
        const hostedDispatchRoutesUrl = shipment_urls.toHostedShipmentUrl(localDispatchRoutesUrl);

        const dispatchRequestParams = {
            market_ids: effectiveMarketScopeIds.length > 0 ? effectiveMarketScopeIds.join(',') : undefined,
        };

        const shipmentsRequest = axios({
            method: 'get',
            timeout: getDispatchBootstrapRequestTimeout(localDispatchShipmentsUrl),
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: localDispatchShipmentsUrl,
            params: dispatchRequestParams,
        })
            .then(response => {
                if (!isMountedRef.current) {
                    return;
                }

                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                setLocalDispatchShipments(payload);
            })
            .catch(fetchError => {
                if (
                    !isMountedRef.current ||
                    useHostedLocalDispatchShipmentsFallback ||
                    hostedDispatchShipmentsUrl === localDispatchShipmentsUrl ||
                    !shouldAttemptHostedDispatchFallback(localDispatchShipmentsUrl) ||
                    !isLocalShipmentNetworkFailure(fetchError)
                ) {
                    return;
                }

                setUseHostedLocalDispatchShipmentsFallback(true);

                return axios({
                    method: 'get',
                    timeout: getDispatchBootstrapRequestTimeout(hostedDispatchShipmentsUrl),
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: hostedDispatchShipmentsUrl,
                    params: dispatchRequestParams,
                }).then(response => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                    setLocalDispatchShipments(payload);
                }).catch(() => {});
            })
            .finally(() => {
                if (!isMountedRef.current) {
                    return;
                }

                setLocalDispatchShipmentsLoaded(true);
                setLocalDispatchShipmentsLoading(false);
            });

        const routesRequest = axios({
            method: 'get',
            timeout: getDispatchBootstrapRequestTimeout(localDispatchRoutesUrl),
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: localDispatchRoutesUrl,
            params: dispatchRequestParams,
        })
            .then(response => {
                if (!isMountedRef.current) {
                    return;
                }

                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                setLocalDispatchRoutes(payload);
            })
            .catch(fetchError => {
                if (
                    !isMountedRef.current ||
                    useHostedLocalDispatchRoutesFallback ||
                    hostedDispatchRoutesUrl === localDispatchRoutesUrl ||
                    !shouldAttemptHostedDispatchFallback(localDispatchRoutesUrl) ||
                    !isLocalShipmentNetworkFailure(fetchError)
                ) {
                    return;
                }

                setUseHostedLocalDispatchRoutesFallback(true);

                return axios({
                    method: 'get',
                    timeout: getDispatchBootstrapRequestTimeout(hostedDispatchRoutesUrl),
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: hostedDispatchRoutesUrl,
                    params: dispatchRequestParams,
                }).then(response => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                    setLocalDispatchRoutes(payload);
                }).catch(() => {});
            })
            .finally(() => {
                if (!isMountedRef.current) {
                    return;
                }

                setLocalDispatchRoutesLoaded(true);
                setLocalDispatchRoutesLoading(false);
            });

        return Promise.allSettled([shipmentsRequest, routesRequest]);
    }, [
        isLocalDashboardEnvironment,
        effectiveMarketScopeIds,
        useHostedLocalDispatchShipmentsFallback,
        useHostedLocalDispatchRoutesFallback,
    ]);

    const arrivalOverrideRequests = useMemo(() => {
        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes) ? effectiveRouteSubscriptionData.Routes : [];

        return extractArrivalOverrideRequests(routeRecords).sort((left, right) => {
            const priorityDelta = getArrivalOverrideRequestPriority(left, SUB) - getArrivalOverrideRequestPriority(right, SUB);

            if (priorityDelta !== 0) {
                return priorityDelta;
            }

            const leftCreatedAt = left && left.request && left.request.created_at ? new Date(left.request.created_at).getTime() : 0;
            const rightCreatedAt = right && right.request && right.request.created_at ? new Date(right.request.created_at).getTime() : 0;

            return leftCreatedAt - rightCreatedAt;
        });
    }, [SUB, effectiveRouteSubscriptionData]);
    const arrivalOverrideRequestByShipmentKey = useMemo(() => {
        return arrivalOverrideRequests.reduce((lookup, requestItem) => {
            if (!requestItem || !requestItem.shipmentId) {
                return lookup;
            }

            const shipmentKey = buildArrivalOverrideShipmentKey(requestItem.routeId, requestItem.shipmentId);

            if (!lookup[shipmentKey]) {
                lookup[shipmentKey] = requestItem;
            }

            return lookup;
        }, {});
    }, [arrivalOverrideRequests]);

    const getShipmentArrivalOverrideRequest = useCallback((routeRecord, shipmentRecord) => {
        if (!routeRecord || !shipmentRecord || !shipmentRecord.shipment_id) {
            return null;
        }

        return arrivalOverrideRequestByShipmentKey[buildArrivalOverrideShipmentKey(routeRecord.route_id, shipmentRecord.shipment_id)] || null;
    }, [arrivalOverrideRequestByShipmentKey]);

    const reopenArrivalOverrideRequest = useCallback(requestItem => {
        if (!requestItem || !requestItem.requestKey) {
            return;
        }

        const latestRequestItem = arrivalOverrideRequests.find(candidate => candidate && candidate.requestKey === requestItem.requestKey) || requestItem;

        if (!latestRequestItem || !latestRequestItem.request || !ARRIVAL_OVERRIDE_ACTIVE_STATUSES.has(latestRequestItem.request.status)) {
            props.notify('tc', 'This arrival override request is no longer available to reopen.', 'warning');
            return;
        }

        manuallyOpenedArrivalOverrideRequestKeysRef.current.add(latestRequestItem.requestKey);
        dismissedArrivalOverrideRequestKeysRef.current.delete(latestRequestItem.requestKey);
        setSelectedArrivalOverrideRequest(latestRequestItem);
        setArrivalOverrideModalOpen(true);
    }, [SUB, arrivalOverrideRequests, props]);

    useEffect(() => {
        const activeRequestKeys = new Set(arrivalOverrideRequests.map(requestItem => requestItem.requestKey));

        dismissedArrivalOverrideRequestKeysRef.current.forEach(requestKey => {
            if (!activeRequestKeys.has(requestKey)) {
                dismissedArrivalOverrideRequestKeysRef.current.delete(requestKey);
            }
        });

        const unseenPendingRequests = arrivalOverrideRequests.filter(requestItem =>
            requestItem
            && requestItem.request
            && requestItem.request.status === 'pending'
            && !seenArrivalOverrideRequestKeysRef.current.has(requestItem.requestKey)
        );

        unseenPendingRequests.forEach(requestItem => {
            seenArrivalOverrideRequestKeysRef.current.add(requestItem.requestKey);
            props.notify('tc', `Arrival override requested for route ${requestItem.routeFriendlyId || requestItem.routeId}.`, 'warning');
        });

        if (unseenPendingRequests.length > 0) {
            playNotificationSound();
        }

        const findNextOpenRequest = () =>
            arrivalOverrideRequests.find(requestItem => (
                !dismissedArrivalOverrideRequestKeysRef.current.has(requestItem.requestKey)
                && canSelectArrivalOverrideRequest(requestItem, SUB)
            )) || null;

        if (selectedArrivalOverrideRequest && selectedArrivalOverrideRequest.requestKey) {
            const refreshedSelection = arrivalOverrideRequests.find(requestItem => requestItem.requestKey === selectedArrivalOverrideRequest.requestKey) || null;

            if (refreshedSelection) {
                const mergedSelection = mergeArrivalOverrideSelection(selectedArrivalOverrideRequest, refreshedSelection, SUB);

                setSelectedArrivalOverrideRequest(previousSelection => (
                    areArrivalOverrideSelectionsEquivalent(mergedSelection, previousSelection)
                        ? previousSelection
                        : mergedSelection
                ));

                if (
                    mergedSelection.request
                    && mergedSelection.request.status === 'claimed_by_admin'
                    && mergedSelection.request.claimed_by
                    && mergedSelection.request.claimed_by !== SUB
                ) {
                    if (manuallyOpenedArrivalOverrideRequestKeysRef.current.has(mergedSelection.requestKey)) {
                        setArrivalOverrideModalOpen(true);
                        return;
                    }

                    const nextRequest = findNextOpenRequest();

                    if (!nextRequest || nextRequest.requestKey === mergedSelection.requestKey) {
                        setSelectedArrivalOverrideRequest(null);
                        setArrivalOverrideModalOpen(false);
                    } else {
                        setSelectedArrivalOverrideRequest(nextRequest);
                        setArrivalOverrideModalOpen(true);
                    }
                }

                return;
            }
        }

        const nextRequest = findNextOpenRequest();

        if (nextRequest) {
            setSelectedArrivalOverrideRequest(previousSelection => (
                areArrivalOverrideSelectionsEquivalent(nextRequest, previousSelection)
                    ? previousSelection
                    : nextRequest
            ));
            setArrivalOverrideModalOpen(true);
            return;
        }

        if (arrivalOverrideModalOpen) {
            setArrivalOverrideModalOpen(false);
        }

        if (selectedArrivalOverrideRequest) {
            setSelectedArrivalOverrideRequest(null);
        }
    }, [SUB, arrivalOverrideModalOpen, arrivalOverrideRequests, props.notify, selectedArrivalOverrideRequest]);

    const fetchGoPilotReviews = useCallback(() => {
        if (!gopilotReviewsSupported) {
            if (isMountedRef.current) {
                setGoPilotReviews([]);
                setGoPilotReviewsLoading(false);
            }
            return Promise.resolve([]);
        }

        if (!Array.isArray(marketIdArray) || marketIdArray.length === 0) {
            if (isMountedRef.current) {
                setGoPilotReviews([]);
            }
            return Promise.resolve([]);
        }

        if (!isMountedRef.current) {
            return Promise.resolve([]);
        }

        setGoPilotReviewsLoading(true);

        const localReviewUrl = shipment_urls.adminGoPilotReviews;
        const hostedReviewUrl = shipment_urls.toHostedShipmentUrl(localReviewUrl);
        const reviewUrl = useHostedLocalDispatchReviewsFallback ? hostedReviewUrl : localReviewUrl;

        return axios({
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: reviewUrl,
            params: {
                market_ids: effectiveMarketScopeIds.length > 0 ? effectiveMarketScopeIds.join(',') : undefined,
            }
        })
            .then(response => {
                if (!isMountedRef.current) {
                    return [];
                }

                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                setGoPilotReviews(payload);
                return payload;
            })
            .catch(fetchError => {
                if (!isMountedRef.current) {
                    return [];
                }

                if (isMissingOptionalDispatchEndpoint(fetchError)) {
                    cacheMissingOptionalDispatchEndpoint(reviewUrl);
                    setGoPilotReviewsSupported(false);
                    setGoPilotReviews([]);
                    return [];
                }

                if (
                    !useHostedLocalDispatchReviewsFallback &&
                    hostedReviewUrl !== localReviewUrl &&
                    shouldAttemptHostedDispatchFallback(localReviewUrl) &&
                    isLocalShipmentNetworkFailure(fetchError)
                ) {
                    setUseHostedLocalDispatchReviewsFallback(true);

                    return axios({
                        method: 'get',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                            'content-type': 'application/json'
                        },
                        url: hostedReviewUrl,
                        params: {
                            market_ids: effectiveMarketScopeIds.length > 0 ? effectiveMarketScopeIds.join(',') : undefined,
                        }
                    })
                        .then(response => {
                            if (!isMountedRef.current) {
                                return [];
                            }

                            const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                            setGoPilotReviews(payload);
                            return payload;
                        })
                        .catch(() => {
                            if (isMountedRef.current) {
                                setGoPilotReviews([]);
                            }
                            return [];
                        });
                }

                if (isMountedRef.current) {
                    setGoPilotReviews([]);
                }
                return [];
            })
            .finally(() => {
                if (isMountedRef.current) {
                    setGoPilotReviewsLoading(false);
                }
            });
    }, [gopilotReviewsSupported, marketIdArray, useHostedLocalDispatchReviewsFallback]);

    useEffect(() => {
        setUseHostedLocalDispatchShipmentsFallback(false);
        setUseHostedLocalDispatchRoutesFallback(false);
        setUseHostedLocalDispatchReviewsFallback(false);

        clearMissingOptionalDispatchEndpointCache(shipment_urls.adminGoPilotReviews);
        clearMissingOptionalDispatchEndpointCache(claimedOrderChatSummariesEndpoint);
        clearMissingOptionalDispatchEndpointCache(preClaimOrderChatSummariesEndpoint);

        setGoPilotReviewsSupported(!isOptionalDispatchEndpointCachedMissing(shipment_urls.adminGoPilotReviews));
        setClaimedOrderChatSummariesSupported(!isOptionalDispatchEndpointCachedMissing(claimedOrderChatSummariesEndpoint));
        setPreClaimOrderChatSummariesSupported(!isOptionalDispatchEndpointCachedMissing(preClaimOrderChatSummariesEndpoint));
    }, [isHostedDevelopmentDashboard, isLocalDashboardEnvironment]);

    useEffect(() => {
        let intervalId = null;
        void fetchGoPilotReviews();
        intervalId = window.setInterval(() => {
            void fetchGoPilotReviews();
        }, GOPILOT_REVIEW_POLL_MS);

        return () => {
            if (intervalId) {
                window.clearInterval(intervalId);
            }
        };
    }, [fetchGoPilotReviews]);

    useEffect(() => {
        if (!selectedGoPilotReviewId) {
            if (gopilotReviews.length > 0) {
                setSelectedGoPilotReviewId(gopilotReviews[0].shipment_id);
            }
            return;
        }

        if (!gopilotReviews.some(review => review && review.shipment_id === selectedGoPilotReviewId)) {
            setSelectedGoPilotReviewId(gopilotReviews.length > 0 ? gopilotReviews[0].shipment_id : null);
        }
    }, [gopilotReviews, selectedGoPilotReviewId]);

    useEffect(() => {
        if (gopilotReviews.length === 0) {
            return;
        }

        const firstNewReview = gopilotReviews.find(review => review && !seenGoPilotReviewIdsRef.current.has(review.shipment_id));
        gopilotReviews.forEach(review => {
            if (review && review.shipment_id) {
                seenGoPilotReviewIdsRef.current.add(review.shipment_id);
            }
        });

        if (firstNewReview) {
            setSelectedGoPilotReviewId(firstNewReview.shipment_id);
            setGoPilotReviewModalOpen(true);
            const reviewStageLabel = firstNewReview && firstNewReview.gopilot_review_stage === 'pickup' ? 'pickup' : 'delivery';
            const reviewMessage = firstNewReview && firstNewReview.gopilot_review_type === 'stage_override_request'
                ? `GoPilot ${reviewStageLabel} admin review required for shipment ${firstNewReview.shipment_friendly_id}.`
                : `GoPilot delivery completion review required for shipment ${firstNewReview.shipment_friendly_id}.`;
            props.notify('tc', reviewMessage, 'warning');
        }
    }, [gopilotReviews, props]);

    useEffect(() => {
        if (!gopilotReviewModalOpen || !selectedGoPilotReviewId) {
            setSelectedGoPilotReviewSummary(null);
            return;
        }

        let cancelled = false;
        setSelectedGoPilotReviewLoading(true);

        axios({
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: `${shipment_urls.shipmentEndpoint}${selectedGoPilotReviewId}/gopilot`,
        })
            .then(response => {
                if (!cancelled) {
                    setSelectedGoPilotReviewSummary(response && response.data ? response.data.payload : null);
                }
            })
            .catch(error => {
                if (!cancelled) {
                    const responseData = error && error.response ? error.response.data : null;
                    const message = responseData && responseData.message ? responseData.message : 'Failed to load GoPilot review details.';
                    props.notify('tc', message, 'danger');
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setSelectedGoPilotReviewLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [gopilotReviewModalOpen, props, selectedGoPilotReviewId]);

    const closeGoPilotReviewModal = () => {
        setGoPilotReviewModalOpen(false);
        setGoPilotReviewApprovalReason('');
    };

    const approveSelectedGoPilotReview = () => {
        if (!selectedGoPilotReview) {
            return;
        }

        setGoPilotReviewActionShipmentId(selectedGoPilotReview.shipment_id);

        const reviewApprovalUrl = selectedGoPilotReviewType === 'stage_override_request'
            ? `${shipment_urls.adminShipment}${selectedGoPilotReview.shipment_id}/gopilot/${selectedGoPilotReviewStage}/review-request/approve`
            : `${shipment_urls.adminShipment}${selectedGoPilotReview.shipment_id}/gopilot/review/approve`;

        const finalizeApprovedReview = () => {
            const approvedStageLabel = selectedGoPilotReviewStage === 'pickup' ? 'pickup' : 'delivery';
            const approvedMessage = selectedGoPilotReviewType === 'stage_override_request'
                ? `Shipment ${selectedGoPilotReview.shipment_friendly_id} ${approvedStageLabel} review approved.`
                : `Shipment ${selectedGoPilotReview.shipment_friendly_id} approved for completion.`;
            props.notify('tc', approvedMessage);
            setGoPilotReviewApprovalReason('');
            if (isLocalDashboardEnvironment) {
                void refreshLocalDispatchData();
            }
            void fetchGoPilotReviews().then(payload => {
                if (!payload || payload.length === 0) {
                    setGoPilotReviewModalOpen(false);
                    setSelectedGoPilotReviewId(null);
                    setSelectedGoPilotReviewSummary(null);
                    return;
                }

                const nextReview = payload.find(review => review.shipment_id !== selectedGoPilotReview.shipment_id) || payload[0];
                setSelectedGoPilotReviewId(nextReview.shipment_id);
            });
        };

        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: reviewApprovalUrl,
            data: {
                reason: gopilotReviewApprovalReason,
            },
        })
            .then(() => {
                finalizeApprovedReview();
            })
            .catch(error => {
                const statusCode = error && error.response ? Number(error.response.status) : null;
                const responseData = error && error.response ? error.response.data : null;
                const isCompletionReview = selectedGoPilotReviewType !== 'stage_override_request';

                if (isCompletionReview && statusCode === 409) {
                    props.notify('tc', `Shipment ${selectedGoPilotReview.shipment_friendly_id} approval is already in progress. Refreshing queue.`);
                    finalizeApprovedReview();
                    return;
                }

                const message = responseData && responseData.message ? responseData.message : 'Failed to approve GoPilot review.';
                props.notify('tc', message, 'danger');
            })
            .finally(() => {
                setGoPilotReviewActionShipmentId('');
            });
    };

    const denySelectedGoPilotReview = () => {
        if (!selectedGoPilotReview || selectedGoPilotReviewType !== 'stage_override_request') {
            return;
        }

        setGoPilotReviewActionShipmentId(selectedGoPilotReview.shipment_id);

        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: `${shipment_urls.adminShipment}${selectedGoPilotReview.shipment_id}/gopilot/${selectedGoPilotReviewStage}/review-request/deny`,
            data: {
                reason: gopilotReviewApprovalReason,
            },
        })
            .then(() => {
                props.notify('tc', `Shipment ${selectedGoPilotReview.shipment_friendly_id} ${selectedGoPilotReviewStage} review denied.`);
                setGoPilotReviewApprovalReason('');
                void fetchGoPilotReviews().then(payload => {
                    if (!payload || payload.length === 0) {
                        setGoPilotReviewModalOpen(false);
                        setSelectedGoPilotReviewId(null);
                        setSelectedGoPilotReviewSummary(null);
                        return;
                    }

                    const nextReview = payload.find(review => review.shipment_id !== selectedGoPilotReview.shipment_id) || payload[0];
                    setSelectedGoPilotReviewId(nextReview.shipment_id);
                });
            })
            .catch(error => {
                const responseData = error && error.response ? error.response.data : null;
                const message = responseData && responseData.message ? responseData.message : 'Failed to deny GoPilot review.';
                props.notify('tc', message, 'danger');
            })
            .finally(() => {
                setGoPilotReviewActionShipmentId('');
            });
    };

    // Reorder
    const [showReorderWaypoints, setShowReorderWaypoints] = useState(false);
    const [routeWaypoints, setRouteWaypoints] = useState([]);
    const [reorderError, setReorderError] = useState('');
    const [isReorderError, setIsReorderError] = useState(false);

    // Gas Price
    const [gasPrice, setGasPrice] = useState(0.0);
    const [dieselPrice, setDieselPrice] = useState(0.0);
    const [showGasPrice, setShowGasPrice] = useState(false);
    const [showGasPriceRegion, setShowGasPriceRegion] = useState(false);
    const [gasPriceError, setGasPriceError] = useState(false);
    const [dieselPriceError, setDieselPriceError] = useState(false);
    const [gasPriceUpdate, setGasPriceUpdate] = useState('');
    const [dieselPriceUpdate, setDieselPriceUpdate] = useState('');
    const [priceUpdateTime, setPriceUpdateTime] = useState('');
    const [marketName, setMarketName] = useState('');
    const [region, setRegion] = useState('');

    // Market Note
    const [showMarketNote, setShowMarketNote] = useState(false);
    const [showMarketNoteRegion, setShowMarketNoteRegion] = useState(false);
    const [marketNote, setMarketNote] = useState('');
    const [marketNoteUpdate, setMarketNoteUpdate] = useState('');
    const [regionNote, setRegionNote] = useState('');

    const [play] = useSound(Sound, { volume: 1, interrupt: true });
    const [playChatNotification] = useSound(IncomingTextSound, { volume: 1, interrupt: true });
    const hasUserInteractedRef = useRef(false);
    const notificationAudioRef = useRef(null);
    const chatNotificationAudioRef = useRef(null);
    const enrouteDriverFetchTokenRef = useRef(0);
    const hasWarnedUsersHasuraRef = useRef(false);
    const localDispatchDriversRetryAtRef = useRef(0);
    const dispatchDriversRequestIdRef = useRef(0);
    const dispatchSessionRecoveryPromiseRef = useRef(null);

    const [marketAndRegionOptions, setMarketAndRegionOptions] = useState([]);
    const [regionDefinitions, setRegionDefinitions] = useState([]);
    const [marketLookup, setMarketLookup] = useState({});
    const [regionCounts, setRegionCounts] = useState({ [ENTIRE_US_LABEL]: 0 });
    const [, setDispatchDriversDebug] = useState(null);
    const [cityStateQuery, setCityStateQuery] = useState('');

    // Twilio Driver Message
    const [showDriverMessageForm, setShowDriverMessageForm] = useState(false);
    const [driverMessage, setDriverMessage] = useState('');
    const [driverMessageAttachment, setDriverMessageAttachment] = useState(null);
    const [driverMessageAttachmentError, setDriverMessageAttachmentError] = useState('');
    const [driverMessageRetrieved, setDriverMessageRetrieved] = useState([]);
    const [messageRecipientInfo, setMessageRecipientInfo] = useState({});
    const [focusedDriverOnMap, setFocusedDriverOnMap] = useState(null);
    const [claimedOrderChatSummariesByShipmentId, setClaimedOrderChatSummariesByShipmentId] = useState({});
    const [claimedOrderChatSeenByShipmentId, setClaimedOrderChatSeenByShipmentId] = useState(() => readClaimedOrderChatSeenMap(SUB));
    const [claimedOrderChatUnreadCountsByShipmentId, setClaimedOrderChatUnreadCountsByShipmentId] = useState({});
    const [preClaimOrderChatSummariesByThreadId, setPreClaimOrderChatSummariesByThreadId] = useState({});
    const [preClaimOrderChatSeenByThreadId, setPreClaimOrderChatSeenByThreadId] = useState(() => readPreClaimOrderChatSeenMap(SUB));
    const [preClaimOrderChatUnreadCountsByThreadId, setPreClaimOrderChatUnreadCountsByThreadId] = useState({});
    const [currentAdminDisplayName, setCurrentAdminDisplayName] = useState(() => getAuthProfileDisplayName(CURRENT_USER_AUTH) || 'Dispatch');

    useEffect(() => {
        const summaries = Object.values(claimedOrderChatSummariesByShipmentId || {});

        if (summaries.length === 0) {
            previousClaimedOrderChatMessageIdsRef.current = {};
            previousClaimedOrderChatUnreadCountsRef.current = {};
            return;
        }

        const nextMessageIdsByThreadId = {};
        const previousUnreadCountsByThreadId = previousClaimedOrderChatUnreadCountsRef.current || {};
        const nextUnreadCountsByThreadId = {};
        let firstNewUnreadSummary = null;

        summaries.forEach(summary => {
            const thread = summary && summary.thread ? summary.thread : null;
            const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
            const shipmentId = thread && thread.shipment_id ? thread.shipment_id : '';
            const threadKey = buildClaimedOrderThreadKey(thread);
            const latestMessageId = latestMessage && latestMessage.message_id ? latestMessage.message_id : '';
            const isIncomingMessage = latestMessage
                ? latestMessage.direction
                    ? latestMessage.direction === 'received'
                    : latestMessage.sender_role === 'driver'
                : false;

            if (!latestMessageId || !threadKey) {
                return;
            }

            nextMessageIdsByThreadId[threadKey] = latestMessageId;
            nextUnreadCountsByThreadId[threadKey] = Number(claimedOrderChatUnreadCountsByShipmentId[threadKey]) || 0;

            const threadRouteStatus = thread && thread.route_status ? String(thread.route_status) : '';
            const threadShipmentStatus = thread && thread.shipment_status ? String(thread.shipment_status) : '';
            // Don't surface chat pop-ups for completed/cancelled orders.
            const isCompletedOrCancelledThread = ['route_completed', 'route_cancelled'].includes(threadRouteStatus)
                || ['shipment_completed', 'shipment_cancelled', 'shipment_declined'].includes(threadShipmentStatus);

            if (!hasHydratedClaimedOrderChatSummariesRef.current || !isIncomingMessage || !shipmentId || isCompletedOrCancelledThread) {
                return;
            }

            if (claimedOrderChatSeenByShipmentId[threadKey] === latestMessageId) {
                return;
            }

            const previousUnreadCount = Number(previousUnreadCountsByThreadId[threadKey]) || 0;
            const nextUnreadCount = nextUnreadCountsByThreadId[threadKey];

            if (nextUnreadCount <= previousUnreadCount) {
                return;
            }

            if (
                showDriverMessageForm
                && messageRecipientInfo
                && messageRecipientInfo.chatMode === 'order-thread'
                && (messageRecipientInfo.chatThreadId || buildClaimedOrderThreadKey({
                    shipment_id: messageRecipientInfo.chatShipmentId,
                    thread_type: messageRecipientInfo.chatThreadType,
                    participant_auth0_id: messageRecipientInfo.chatParticipantAuth0Id,
                })) === threadKey
            ) {
                return;
            }

            if (!firstNewUnreadSummary) {
                firstNewUnreadSummary = summary;
            }
        });

        previousClaimedOrderChatMessageIdsRef.current = nextMessageIdsByThreadId;
        previousClaimedOrderChatUnreadCountsRef.current = nextUnreadCountsByThreadId;

        if (!hasHydratedClaimedOrderChatSummariesRef.current) {
            hasHydratedClaimedOrderChatSummariesRef.current = true;
            return;
        }

        if (!firstNewUnreadSummary || !firstNewUnreadSummary.thread) {
            return;
        }

        const thread = firstNewUnreadSummary.thread;
        const threadKey = buildClaimedOrderThreadKey(thread);
        const isCustomerDriverThread = thread && thread.thread_type === 'customer_driver';
        const isCustomerDispatchThread = thread && thread.thread_type === 'customer_dispatch';
        const customerDriverThreadMetadata = isCustomerDriverThread
            ? resolveCustomerDriverThreadMetadata({ shipmentId: thread.shipment_id, participantAuth0Id: thread.participant_auth0_id || '' })
            : null;
        const nextRecipientInfo = {
            chatMode: 'order-thread',
            chatDisplayName: isCustomerDriverThread
                ? customerDriverThreadMetadata.chatDisplayName
                : (isCustomerDispatchThread ? 'Customer / Dispatch' : 'Driver and Dispatch'),
            chatRole: isCustomerDriverThread ? 'Customer Driver' : (isCustomerDispatchThread ? 'Customer Dispatch' : 'Claimed Order'),
            chatShipmentId: thread.shipment_id,
            chatShipmentFriendlyId: thread.shipment_friendly_id || '',
            chatThreadType: thread.thread_type || 'claimed_order',
            chatThreadId: threadKey,
            chatParticipantAuth0Id: isCustomerDriverThread
                ? customerDriverThreadMetadata.chatParticipantAuth0Id
                : (thread.participant_auth0_id || ''),
            chatReadOnly: isCustomerDriverThread,
            chatAdminDisplayName: getDispatchAdminDisplayName(),
            chatCustomerDisplayName: isCustomerDriverThread ? customerDriverThreadMetadata.chatCustomerDisplayName : '',
            chatDriverDisplayName: isCustomerDriverThread
                ? customerDriverThreadMetadata.chatDriverDisplayName
                : (isCustomerDispatchThread ? 'Customer / Dispatch' : resolveThreadDriverDisplayName({ shipmentId: thread.shipment_id })),
            chatAutoOpenedUnread: true,
        };

        setMessageRecipientInfo(nextRecipientInfo);
        setShowDriverMessageForm(true);
        retrieveMessage(nextRecipientInfo);
        props.notify('tc', `${isCustomerDriverThread ? 'New driver to customer message' : (isCustomerDispatchThread ? 'New customer to dispatch message' : 'New driver message')} for shipment ${thread.shipment_friendly_id || thread.shipment_id}.`, 'warning');
    }, [
        claimedOrderChatUnreadCountsByShipmentId,
        claimedOrderChatSeenByShipmentId,
        claimedOrderChatSummariesByShipmentId,
        messageRecipientInfo,
        props,
        showDriverMessageForm,
    ]);

    useEffect(() => {
        // Don't auto-open pre-claim driver chats while on the Completed tab — reviewing historical
        // orders shouldn't pop up every past driver question.
        if (selected === 'completed') {
            return;
        }

        const summaries = Object.values(preClaimOrderChatSummariesByThreadId || {});

        if (summaries.length === 0) {
            previousPreClaimOrderChatUnreadCountsRef.current = {};
            return;
        }

        const nextUnreadCountsByThreadId = {};
        const previousUnreadCountsByThreadId = previousPreClaimOrderChatUnreadCountsRef.current || {};
        let firstNewUnreadSummary = null;

        summaries.forEach(summary => {
            const thread = summary && summary.thread ? summary.thread : null;
            const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
            const threadKey = buildPreClaimOrderThreadKey(thread);
            const latestMessageId = latestMessage && latestMessage.message_id ? latestMessage.message_id : '';
            const isIncomingMessage = latestMessage
                ? latestMessage.direction
                    ? latestMessage.direction === 'received'
                    : latestMessage.sender_role === 'driver'
                : false;

            if (!threadKey || !latestMessageId) {
                return;
            }

            nextUnreadCountsByThreadId[threadKey] = Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0;

            if (!hasHydratedPreClaimOrderChatSummariesRef.current || !isIncomingMessage) {
                return;
            }

            if (preClaimOrderChatSeenByThreadId[threadKey] === latestMessageId) {
                return;
            }

            const previousUnreadCount = Number(previousUnreadCountsByThreadId[threadKey]) || 0;
            const nextUnreadCount = nextUnreadCountsByThreadId[threadKey];

            if (nextUnreadCount <= previousUnreadCount) {
                return;
            }

            if (
                showDriverMessageForm
                && messageRecipientInfo
                && messageRecipientInfo.chatMode === 'preclaim-order-thread'
                && messageRecipientInfo.chatThreadId === threadKey
            ) {
                return;
            }

            if (!firstNewUnreadSummary) {
                firstNewUnreadSummary = summary;
            }
        });

        previousPreClaimOrderChatUnreadCountsRef.current = nextUnreadCountsByThreadId;

        if (!hasHydratedPreClaimOrderChatSummariesRef.current) {
            hasHydratedPreClaimOrderChatSummariesRef.current = true;
            return;
        }

        if (!firstNewUnreadSummary || !firstNewUnreadSummary.thread) {
            return;
        }

        const thread = firstNewUnreadSummary.thread;
        const nextRecipientInfo = {
            chatMode: 'preclaim-order-thread',
            chatDisplayName: 'Driver Question',
            chatRole: 'Pre-Claim Order',
            chatShipmentId: thread.shipment_id,
            chatShipmentFriendlyId: thread.shipment_friendly_id || '',
            chatDriverAuth0Id: thread.driver_auth0_id,
            chatThreadId: buildPreClaimOrderThreadKey(thread),
            chatAdminDisplayName: getDispatchAdminDisplayName(),
            chatDriverDisplayName: resolveThreadDriverDisplayName({ shipmentId: thread.shipment_id, driverAuth0Id: thread.driver_auth0_id }),
            chatAutoOpenedUnread: true,
        };

        setMessageRecipientInfo(nextRecipientInfo);
        setShowDriverMessageForm(true);
        retrieveMessage(nextRecipientInfo);
        props.notify('tc', `New driver question for shipment ${thread.shipment_friendly_id || thread.shipment_id}.`, 'warning');
    }, [
        messageRecipientInfo,
        preClaimOrderChatSeenByThreadId,
        preClaimOrderChatSummariesByThreadId,
        preClaimOrderChatUnreadCountsByThreadId,
        props,
        selected,
        showDriverMessageForm,
    ]);

    useEffect(() => {
        if (selected === 'driverList' && enrouteClickDriver) {
            setEnrouteClickDriver('');
        }

        if (selected === 'driverList') {
            setRouteClick('');
        }
    }, [selected, focusedDriverOnMap]);
    const [totalUnreadDriverMessages, setTotalUnreadDriverMessages] = useState(0);
    const [driverNameSMS, setDriverNameSMS] = useState('');
    const [driversToSMSFiltered, setDriversToSMSFiltered] = useState([]);
    const [statusFilter, setStatusFilter] = useState([]);
    const [vehicleTypeFilter, setVehicleTypeFilter] = useState([]);
    const marketIdArrayRef = useRef(marketIdArray);
    const applyAllFiltersRef = useRef(null);

    const hasLoadedDispatchDriversRef = useRef(false);
    const dispatchDriverSnapshotRef = useRef([]);

    const isDirectUsersHasuraUnavailableLocally =
        isDashboardLocalDebugMode() &&
        typeof dispatchUsersHost === 'string' &&
        isLocalLikeHost(dispatchUsersHost) &&
        typeof user_urls.dispatchUsersHasuraHost === 'string' &&
        user_urls.dispatchUsersHasuraHost.includes('hasura.gophr.app');

    const isHostedUsersHasuraUnavailableFromBrowser =
        typeof window !== 'undefined' &&
        !isProductionStage() &&
        typeof user_urls.dispatchUsersHasuraHost === 'string' &&
        user_urls.dispatchUsersHasuraHost.includes('hasura.gophr.app');

    const shouldAvoidBrowserUsersHasuraForDispatchDrivers =
        typeof window !== 'undefined' &&
        !isLocalDashboardEnvironment &&
        typeof user_urls.dispatchUsersHasuraHost === 'string' &&
        user_urls.dispatchUsersHasuraHost.includes('hasura.gophr.app');

    const isHostedShipmentsHasuraUnavailableFromBrowser =
        typeof window !== 'undefined' &&
        !isProductionStage() &&
        typeof shipment_urls.hasuraHost === 'string' &&
        shipment_urls.hasuraHost.includes('hasura.gophr.app');

    const shouldAvoidBrowserShipmentsHasuraForMerging =
        typeof window !== 'undefined' &&
        !isLocalDashboardEnvironment &&
        typeof shipment_urls.hasuraHost === 'string' &&
        shipment_urls.hasuraHost.includes('hasura.gophr.app');

    const shouldPreserveLoadedDriversDuringLocalRetry = () => {
        const hasVisibleDriverSnapshot =
            driversToDisplay.length > 0 ||
            availableDriversCopy.length > 0 ||
            enrouteDriversCopy.length > 0 ||
            offlineDriversCopy.length > 0;

        return isLocalDashboardEnvironment && (
            (localDispatchDriversRetryAtRef.current > Date.now() && hasLoadedDispatchDriversRef.current) ||
            hasVisibleDriverSnapshot
        );
    };

    const authoritativeActiveRouteRecords = isLocalDashboardEnvironment
        ? (localDispatchRoutesLoaded ? localDispatchRoutes : null)
        : (routeListData && Array.isArray(routeListData.Routes)
            ? routeListData.Routes
            : (dataRoute && Array.isArray(dataRoute.Routes) ? dataRoute.Routes : null));
    const hasAuthoritativeActiveRouteSnapshot = Array.isArray(authoritativeActiveRouteRecords);
    const activeRouteDriverIdentifiers = getActiveRouteDriverIdentifiers(authoritativeActiveRouteRecords);
    const activeRouteDriverSignature = Array.from(activeRouteDriverIdentifiers).sort().join('|');

    const reconcileDriverAvailability = driverList => {
        return (Array.isArray(driverList) ? driverList : []).map(driver => {
            if (!hasAuthoritativeActiveRouteSnapshot || !normalizeDriverStatusFlag(driver && driver.is_online)) {
                return driver;
            }

            const driverIdentifiers = [
                driver && driver.driver_id,
                driver && driver.auth0_id,
                driver && driver.user_id,
                driver && driver.User && driver.User.auth0_id,
                driver && driver.User && driver.User.user_id,
            ].filter(Boolean).map(String);
            const hasActiveRoute = driverIdentifiers.some(identifier => activeRouteDriverIdentifiers.has(identifier));

            return normalizeDriverStatusFlag(driver && driver.is_available) === !hasActiveRoute
                ? driver
                : { ...driver, is_available: !hasActiveRoute };
        });
    };

    const applyDispatchDriverLists = (driverList, { preserveTableLists = false } = {}) => {
        const normalizedDriverList = reconcileDriverAvailability(driverList);
        const availableDriverList = normalizedDriverList.filter(driver => normalizeDriverStatusFlag(driver && driver.is_online) && normalizeDriverStatusFlag(driver && driver.is_available));
        const unavailableDriverList = normalizedDriverList.filter(driver => normalizeDriverStatusFlag(driver && driver.is_online) && !normalizeDriverStatusFlag(driver && driver.is_available));
        const offlineDriverList = normalizedDriverList.filter(driver => !normalizeDriverStatusFlag(driver && driver.is_online));
        const unreadMessageCount = normalizedDriverList.reduce((sum, driver) => sum + (Number(driver && driver.unread_message_count) || 0), 0);

        setDrivers(normalizedDriverList);
        setDriversToDisplay(normalizedDriverList);
        if (!preserveTableLists) {
            setDriversForAssign(normalizedDriverList);
            setDriversToSMS(normalizedDriverList);
            if (applyAllFiltersRef.current) {
                applyAllFiltersRef.current(undefined, undefined, undefined, undefined, normalizedDriverList);
            } else {
                setDriversToSMSFiltered(normalizedDriverList);
            }
            setTotalUnreadDriverMessages(unreadMessageCount);
        }
        setAvailableDriversCopy(availableDriverList);
        setEnrouteDriversCopy(unavailableDriverList);
        setOfflineDriversCopy(offlineDriverList);
        setDispatchDriversDebug(previous => ({
            ...(previous || {}),
            finalTotal: normalizedDriverList.length,
            finalAvailable: availableDriverList.length,
            finalEnroute: unavailableDriverList.length,
            finalOffline: offlineDriverList.length,
            finalUpdatedAt: new Date().toISOString(),
        }));
        dispatchDriverSnapshotRef.current = normalizedDriverList;
        hasLoadedDispatchDriversRef.current = normalizedDriverList.length > 0;
    };

    useEffect(() => {
        if (!hasAuthoritativeActiveRouteSnapshot || !hasLoadedDispatchDriversRef.current) {
            return;
        }

        applyDispatchDriverLists(dispatchDriverSnapshotRef.current);
    }, [activeRouteDriverSignature, hasAuthoritativeActiveRouteSnapshot]);

    const clearDispatchDriverLists = () => {
        setDrivers([]);
        setDriversToDisplay([]);
        setDriversForAssign([]);
        setDriversToSMS([]);
        setDriversToSMSFiltered([]);
        setTotalUnreadDriverMessages(0);
        setAvailableDriversCopy([]);
        setEnrouteDriversCopy([]);
        setOfflineDriversCopy([]);
        dispatchDriverSnapshotRef.current = [];
        hasLoadedDispatchDriversRef.current = false;
    };

    const warnUsersHasuraUnavailable = context => {
        if (hasWarnedUsersHasuraRef.current) {
            return;
        }

        hasWarnedUsersHasuraRef.current = true;
        void context;
    };

    const isUnauthorizedDispatchError = error => {
        if (!error) {
            return false;
        }

        if (error.response && error.response.status === 401) {
            return true;
        }

        const graphqlErrors = Array.isArray(error.graphqlErrors) ? error.graphqlErrors : [];
        const responseErrors = Array.isArray(error.response && error.response.data && error.response.data.errors)
            ? error.response.data.errors
            : [];
        const allErrors = [...graphqlErrors, ...responseErrors];

        return allErrors.some(entry => {
            const message = String(entry && entry.message ? entry.message : '').toLowerCase();
            const code = String(entry && entry.extensions && entry.extensions.code ? entry.extensions.code : '').toLowerCase();
            return (
                message.includes('malformed authorization header') ||
                message.includes('invalid-jwt') ||
                message.includes('jwt') ||
                code === 'invalid-jwt' ||
                code === 'access-denied'
            );
        });
    };

    const handleDispatchUnauthorizedError = error => {
        if (!isUnauthorizedDispatchError(error)) {
            return false;
        }

        if (!hasStoredSessionTokens()) {
            notifySessionExpired({ reason: 'dispatch_unauthorized' });
            return true;
        }

        if (!dispatchSessionRecoveryPromiseRef.current) {
            dispatchSessionRecoveryPromiseRef.current = renewSessionSilently()
                .catch(() => {
                    if (!hasStoredSessionTokens()) {
                        notifySessionExpired({ reason: 'dispatch_unauthorized' });
                    }
                })
                .finally(() => {
                    dispatchSessionRecoveryPromiseRef.current = null;
                });
        }

        return true;
    };

    const hasDispatchUnauthorizedPayloadError = response => {
        const errors = Array.isArray(response && response.data && response.data.errors)
            ? response.data.errors
            : [];

        if (errors.length === 0) {
            return false;
        }

        return errors.some(entry => {
            const message = String(entry && entry.message ? entry.message : '').toLowerCase();
            const code = String(entry && entry.extensions && entry.extensions.code ? entry.extensions.code : '').toLowerCase();

            return (
                message.includes('malformed authorization header') ||
                message.includes('invalid-jwt') ||
                message.includes('jwt') ||
                code === 'invalid-jwt' ||
                code === 'access-denied'
            );
        });
    };

    function playNotificationSound() {
        if (hasUserInteractedRef.current) {
            play();

            if (notificationAudioRef.current) {
                notificationAudioRef.current.currentTime = 0;
                notificationAudioRef.current.play().catch(() => {});
            }
        }
    }

    function playChatNotificationSound() {
        if (hasUserInteractedRef.current) {
            playChatNotification();

            if (chatNotificationAudioRef.current) {
                chatNotificationAudioRef.current.currentTime = 0;
                chatNotificationAudioRef.current.play().catch(() => {});
            }
        }
    }

    useEffect(() => {
        notificationAudioRef.current = new Audio(Sound);
        notificationAudioRef.current.preload = 'auto';
        notificationAudioRef.current.volume = 1;

        chatNotificationAudioRef.current = new Audio(IncomingTextSound);
        chatNotificationAudioRef.current.preload = 'auto';
        chatNotificationAudioRef.current.volume = 1;

        const enableSound = () => {
            if (!hasUserInteractedRef.current) {
                [notificationAudioRef.current, chatNotificationAudioRef.current].forEach(audio => {
                    if (!audio) {
                        return;
                    }

                    audio.muted = true;
                    audio.play()
                        .then(() => {
                            audio.pause();
                            audio.currentTime = 0;
                            audio.muted = false;
                        })
                        .catch(() => {
                            audio.muted = false;
                        });
                });
            }

            hasUserInteractedRef.current = true;
        };

        window.addEventListener('pointerdown', enableSound, { passive: true });
        window.addEventListener('keydown', enableSound, { passive: true });

        return () => {
            window.removeEventListener('pointerdown', enableSound);
            window.removeEventListener('keydown', enableSound);
            notificationAudioRef.current = null;
            chatNotificationAudioRef.current = null;
        };
    }, []);
    const [permitFilter, setPermitFilter] = useState([]);
    const driverFilterSelectStyles = useMemo(() => ({
        control: provided => ({
            ...provided,
            minHeight: '36px',
            backgroundColor: isDarkMode ? '#27293d' : '#ffffff',
            borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : '#ccc',
            color: isDarkMode ? '#ffffff' : '#212529',
            boxShadow: 'none'
        }),
        valueContainer: provided => ({
            ...provided,
            padding: '2px 8px'
        }),
        multiValue: provided => ({
            ...provided,
            backgroundColor: isDarkMode ? 'rgba(241, 90, 41, 0.18)' : '#f1f3f5'
        }),
        multiValueLabel: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        }),
        multiValueRemove: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        }),
        input: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        }),
        placeholder: provided => ({
            ...provided,
            color: isDarkMode ? 'rgba(255, 255, 255, 0.65)' : '#6c757d'
        }),
        singleValue: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        }),
        menu: provided => ({
            ...provided,
            backgroundColor: isDarkMode ? '#27293d' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#212529',
            zIndex: 1000
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#f15a29' : (state.isFocused ? (isDarkMode ? '#1d2033' : '#f1f3f5') : (isDarkMode ? '#27293d' : '#ffffff')),
            color: state.isSelected ? '#ffffff' : (isDarkMode ? '#ffffff' : '#212529')
        }),
        indicatorSeparator: provided => ({
            ...provided,
            backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#ccc'
        }),
        dropdownIndicator: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        }),
        clearIndicator: provided => ({
            ...provided,
            color: isDarkMode ? '#ffffff' : '#212529'
        })
    }), [isDarkMode]);

    useEffect(() => {
        marketIdArrayRef.current = effectiveMarketScopeIds;
    }, [effectiveMarketScopeIds]);

    // Update Driver Info and PO# in RouteDriver for displaying
    const [showDriverInfoAndPO, setShowDriverInfoAndPO] = useState(false);
    const [routeDriverFirstName, setRouteDriverFirstName] = useState('');
    const [routeDriverLastName, setRouteDriverLastName] = useState('');
    const [routeDriverPhone, setRouteDriverPhone] = useState('');
    const [routeDriverPONumber, setRouteDriverPONumber] = useState('');
    const [routeDriverRouteId, setRouteDriverRouteId] = useState('');

    //Update order info
    const [showUpdateOrderInfo, setShowUpdateOrderInfo] = useState(false);
    const [updateOrderInfo, setUpdateOrderInfo] = useState({ first_name: '', last_name: '', phone: '', business_name: '', instruction: '' });
    const [orderType, setOrderType] = useState('Pickup');
    const [orderId, setOrderId] = useState('');

    //! Display or hide the map
    const [showDispatchMap, setShowDispatchMap] = useState(true);
    const [dispatchMapVisibleBounds, setDispatchMapVisibleBounds] = useState(null);
    const [dispatchMapOfflineFetchEnabled, setDispatchMapOfflineFetchEnabled] = useState(false);

    //! Floating Live Chat / SMS Messages windows on the dispatch page
    const [openChatWindows, setOpenChatWindows] = useState([]);
    const toggleChatWindow = channel =>
        setOpenChatWindows(prev => (prev.includes(channel) ? prev.filter(c => c !== channel) : [...prev, channel]));
    const closeChatWindow = channel => setOpenChatWindows(prev => prev.filter(c => c !== channel));
    // Unread / needs-a-human counts per channel (backend counts needs_agent escalations + unread agent messages).
    const [chatUnreadCounts, setChatUnreadCounts] = useState({ website: 0, sms: 0, voice: 0, email: 0 });
    useEffect(() => {
        let active = true;
        const fetchUnread = () => {
            Promise.all([
                crmClient.chatUnread('website').catch(() => null),
                crmClient.chatUnread('sms').catch(() => null),
                crmClient.chatUnread('email').catch(() => null)
            ]).then(([web, sms, email]) => {
                if (!active) return;
                setChatUnreadCounts({
                    website: (web && web.unread) || 0,
                    sms: (sms && sms.unread) || 0,
                    email: (email && email.unread) || 0
                });
            });
        };
        fetchUnread();
        const timer = setInterval(fetchUnread, 20000);
        return () => {
            active = false;
            clearInterval(timer);
        };
    }, []);

    //! Fedex Label
    const [showFedexLabel, setShowFedexLabel] = useState(false);
    const [showTracking, setShowTracking] = useState(false);

    const handleDispatchMapVisibleBoundsChange = useCallback(nextBounds => {
        const nextIncludeOffline = Boolean(nextBounds && nextBounds.includeOffline);
        setDispatchMapOfflineFetchEnabled(currentValue => (currentValue === nextIncludeOffline ? currentValue : nextIncludeOffline));

        if (!nextBounds || !Number.isFinite(Number(nextBounds.south)) || !Number.isFinite(Number(nextBounds.north)) || !Number.isFinite(Number(nextBounds.west)) || !Number.isFinite(Number(nextBounds.east))) {
            setDispatchMapVisibleBounds(currentBounds => (currentBounds ? null : currentBounds));
            return;
        }

        const normalizedBounds = {
            minLat: Number(nextBounds.south),
            maxLat: Number(nextBounds.north),
            minLng: Number(nextBounds.west),
            maxLng: Number(nextBounds.east),
        };

        if (!Object.values(normalizedBounds).every(Number.isFinite)) {
            return;
        }

        setDispatchMapVisibleBounds(currentBounds => {
            if (
                currentBounds &&
                Math.abs(currentBounds.minLat - normalizedBounds.minLat) < 0.000001 &&
                Math.abs(currentBounds.maxLat - normalizedBounds.maxLat) < 0.000001 &&
                Math.abs(currentBounds.minLng - normalizedBounds.minLng) < 0.000001 &&
                Math.abs(currentBounds.maxLng - normalizedBounds.maxLng) < 0.000001
            ) {
                return currentBounds;
            }

            return normalizedBounds;
        });
    }, []);

    const openCompleteOrderModal = ({ shipmentId, orderId, actionType = null, stopLabel = null }) => {
        setCompleteOrderModal({ isOpen: true, shipmentId, orderId, actionType, stopLabel });
    };

    const closeCompleteOrderModal = () => {
        setCompleteOrderModal(prevState => ({ ...prevState, isOpen: false }));
    };

    const closeArrivalOverrideModal = () => {
        if (selectedArrivalOverrideRequest && selectedArrivalOverrideRequest.requestKey) {
            manuallyOpenedArrivalOverrideRequestKeysRef.current.delete(selectedArrivalOverrideRequest.requestKey);
            dismissedArrivalOverrideRequestKeysRef.current.add(selectedArrivalOverrideRequest.requestKey);
        }

        setArrivalOverrideModalOpen(false);
        setSelectedArrivalOverrideRequest(null);
    };

    const [selectedShipmentId, setSelectedShipmentId] = useState(null);

    const normalizeComparableValue = value => {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }

        return '';
    };

    const buildComparableOrderSignature = order => {
        if (!order || typeof order !== 'object') {
            return '';
        }

        return [
            normalizeComparableValue(order.order_id),
            normalizeComparableValue(order.order_friendly_id),
            normalizeComparableValue(order.status),
            normalizeComparableValue(order.actual_action),
            normalizeComparableValue(order.updated_at),
            normalizeComparableValue(order.updatedAt),
            normalizeComparableValue(order.completed_at),
            normalizeComparableValue(order.arrived_at),
        ].join('|');
    };

    const buildComparableShipmentSignature = shipment => {
        if (!shipment || typeof shipment !== 'object') {
            return '';
        }

        const orderSignature = Array.isArray(shipment.Orders)
            ? shipment.Orders.map(buildComparableOrderSignature).join('||')
            : '';

        return [
            normalizeComparableValue(shipment.shipment_id),
            normalizeComparableValue(shipment.shipment_friendly_id),
            normalizeComparableValue(shipment.status),
            normalizeComparableValue(shipment.updated_at),
            normalizeComparableValue(shipment.updatedAt),
            normalizeComparableValue(shipment.completed_at),
            orderSignature,
        ].join('|');
    };

    const buildComparableRouteSignature = route => {
        if (!route || typeof route !== 'object') {
            return '';
        }

        const shipmentSignature = Array.isArray(route.Shipments)
            ? route.Shipments.map(buildComparableShipmentSignature).join('|||')
            : '';
        const pathSignature = Array.isArray(route.path)
            ? route.path
                  .map((waypoint, index) => [
                      index,
                      normalizeComparableValue(waypoint && waypoint.order_id),
                      normalizeComparableValue(waypoint && waypoint.shipment_id),
                      normalizeComparableValue(waypoint && waypoint.waypoint_active),
                      normalizeComparableValue(waypoint && waypoint.is_waypoint_completed),
                      normalizeComparableValue(waypoint && waypoint.arrived_at),
                      normalizeComparableValue(waypoint && waypoint.completed_at),
                      normalizeComparableValue(waypoint && waypoint.arrival_override_request ? JSON.stringify(waypoint.arrival_override_request) : ''),
                  ].join('|'))
                  .join('||')
            : '';

        return [
            normalizeComparableValue(route.route_id),
            normalizeComparableValue(route.route_friendly_id),
            normalizeComparableValue(route.status),
            normalizeComparableValue(route.updated_at),
            normalizeComparableValue(route.updatedAt),
            normalizeComparableValue(route.completed_at),
            shipmentSignature,
            pathSignature,
        ].join('|');
    };

    const buildComparableDispatchRecordSignature = record => {
        if (!record || typeof record !== 'object') {
            return '';
        }

        if (record.route_id) {
            return buildComparableRouteSignature(record);
        }

        if (record.shipment_id) {
            return buildComparableShipmentSignature(record);
        }

        return [
            normalizeComparableValue(record.id),
            normalizeComparableValue(record.status),
            normalizeComparableValue(record.updated_at),
            normalizeComparableValue(record.updatedAt),
        ].join('|');
    };

    // Reset currentRecordId and currentRecord when 'selected' changes
    useEffect(() => {
        if (selected !== prevSelectedRef.current) {
            // Reset the currentRecordId and currentRecord when tab is changed
            setCurrentRecordId(null);
            setCurrentRecord(null);
            shipmentCurrentRecordMissCountRef.current = 0;
            routeCurrentRecordMissCountRef.current = 0;
            // Call the resetExpand function to collapse rows when tab is changed
            resetExpand({ force: true });
        }

        // Update the ref value whenever 'selected' changes
        prevSelectedRef.current = selected;
    }, [selected]);

    // useEffect for handling 'saved' or 'pending' tabs (Shipments data)
    useEffect(() => {
        if (!effectiveShipmentSubscriptionData) {
            return;
        }

        if (isDispatchRealtimeInteractionActive()) {
            pendingShipmentSubscriptionDataRef.current = effectiveShipmentSubscriptionData;
            return;
        }

        pendingShipmentSubscriptionDataRef.current = null;
        setShipmentsData(effectiveShipmentSubscriptionData);

        if (!currentRecordId || !currentRecord || (selected !== 'saved' && selected !== 'pending')) {
            shipmentCurrentRecordMissCountRef.current = 0;
            return;
        }

        const updatedRecord = effectiveShipmentSubscriptionData.Shipments.find(record => record.shipment_id === currentRecordId) || null;

        if (!updatedRecord) {
            shipmentCurrentRecordMissCountRef.current += 1;
            const hasExpandedRowsForSelectedTab = hasExpandedDispatchRows(expandedItems[selected]);

            if (
                shipmentCurrentRecordMissCountRef.current >= DISPATCH_CURRENT_RECORD_MISS_THRESHOLD
                && !hasExpandedRowsForSelectedTab
                && !isDispatchRealtimeInteractionActive()
            ) {
                setCurrentRecord(null);
            }
            return;
        }

        shipmentCurrentRecordMissCountRef.current = 0;

        if (buildComparableDispatchRecordSignature(updatedRecord) !== buildComparableDispatchRecordSignature(currentRecord)) {
            setCurrentRecord(updatedRecord);
        }
    }, [effectiveShipmentSubscriptionData, selected, currentRecordId, currentRecord, expandedItems]);

    // useEffect for handling 'ready', 'progressing', or 'completed' tabs (Routes data)
    useEffect(() => {
        if (!effectiveRouteSubscriptionData) {
            return;
        }

        if (isDispatchRealtimeInteractionActive()) {
            pendingRouteSubscriptionDataRef.current = effectiveRouteSubscriptionData;
            return;
        }

        pendingRouteSubscriptionDataRef.current = null;
        setRoutesData(effectiveRouteSubscriptionData);

        if (!currentRecordId || !currentRecord || (selected !== 'ready' && selected !== 'progressing' && selected !== 'completed')) {
            routeCurrentRecordMissCountRef.current = 0;
            return;
        }

        const updatedRecord = effectiveRouteSubscriptionData.Routes.find(record => record.route_id === currentRecordId) || null;

        if (!updatedRecord) {
            routeCurrentRecordMissCountRef.current += 1;
            const hasExpandedRowsForSelectedTab = hasExpandedDispatchRows(expandedItems[selected]);

            if (
                routeCurrentRecordMissCountRef.current >= DISPATCH_CURRENT_RECORD_MISS_THRESHOLD
                && !hasExpandedRowsForSelectedTab
                && !isDispatchRealtimeInteractionActive()
            ) {
                setCurrentRecord(null);
                setRouteClick('');
                setRouteClickTwice('');
                setEnrouteClickDriver('');
            }
            return;
        }

        routeCurrentRecordMissCountRef.current = 0;

        if (selected === 'completed') {
            return;
        }

        if (buildComparableDispatchRecordSignature(updatedRecord) !== buildComparableDispatchRecordSignature(currentRecord)) {
            setCurrentRecord(updatedRecord);
        }

    }, [effectiveRouteSubscriptionData, selected, currentRecordId, currentRecord, expandedItems, setEnrouteClickDriver, setRouteClick, setRouteClickTwice]);

    // Flush subscription updates that were deferred during a realtime interaction
    // as soon as the interaction ends, so a saved edit appears without a hard refresh.
    useEffect(() => {
        if (isLocalDashboardEnvironment) {
            return undefined;
        }

        const flushIntervalId = window.setInterval(() => {
            if (isDispatchRealtimeInteractionActive()) {
                return;
            }

            if (pendingShipmentSubscriptionDataRef.current) {
                setShipmentsData(pendingShipmentSubscriptionDataRef.current);
                pendingShipmentSubscriptionDataRef.current = null;
            }

            if (pendingRouteSubscriptionDataRef.current) {
                setRoutesData(pendingRouteSubscriptionDataRef.current);
                pendingRouteSubscriptionDataRef.current = null;
            }
        }, 600);

        return () => window.clearInterval(flushIntervalId);
    }, [isLocalDashboardEnvironment]);

    // Web socket for new incoming SMS notification
    useEffect(() => {
        const transportPolicy = getRealtimeTransportPolicy(dispatchUsersHost);

        const socket = io(dispatchUsersHost, {
            reconnectionAttempts: transportPolicy.reconnectionAttempts,
            transports: transportPolicy.shouldUsePollingOnly ? ['polling'] : ['websocket', 'polling'],
            upgrade: !transportPolicy.shouldUsePollingOnly,
        });

        socket.on('newMessage', data => {
            if (Array.isArray(marketIdArrayRef.current) && marketIdArrayRef.current.length > 0 && !marketIdArrayRef.current.includes(data.market_id)) {
                return;
            }

            let messageCount = 1;

            setDriversToSMS(prevDrivers => {
                const updates = prevDrivers.map(driver => {
                    messageCount += driver.unread_message_count;
                    return driver.phone === data.driver_phone ? { ...driver, unread_message_count: driver.unread_message_count + 1 } : driver;
                });

                if (applyAllFiltersRef.current) {
                    applyAllFiltersRef.current(undefined, undefined, undefined, undefined, updates);
                } else {
                    setDriversToSMSFiltered(updates);
                }

                return updates;
            });

            setTotalUnreadDriverMessages(messageCount);
            playChatNotificationSound();
            props.notify('tc', 'New driver message received.', 'warning');
        });

        return () => {
            socket.disconnect();
        };
    }, [setMarketIdArray]);

    const usePrevious = value => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    };

    const previousAmountReady = usePrevious(amountReady);
    const previousAmountPending = usePrevious(amountPending);

    const getPrimaryShipmentFromRoute = route => {
        return getRouteShipments(route)[0] || null;
    };

    const getRoutePayDisplay = route => {
        const primaryShipment = getPrimaryShipmentFromRoute(route);
        if (isFedexShipment(primaryShipment)) {
            return primaryShipment && primaryShipment.fedex_data && primaryShipment.fedex_data.fedex_selection
                ? primaryShipment.fedex_data.fedex_selection.price
                : '';
        }

        return RouteTotalDriverPays(route && Array.isArray(route.Shipments) ? route.Shipments : []);
    };

    const fetchEnrouteAndDriver = async route => {
        const requestToken = enrouteDriverFetchTokenRef.current + 1;
        enrouteDriverFetchTokenRef.current = requestToken;
        const isRequestActive = () => isMountedRef.current && requestToken === enrouteDriverFetchTokenRef.current;

        if (isFedexShipment(getPrimaryShipmentFromRoute(route))) {
            return;
        }
        const info = getCurrentRouteDriver(route);
        if (!info || !info.driver_blob) {
            if (isRequestActive()) {
                setEnrouteClickDriver(null);
            }
            return;
        }

        const vehicle = info.vehicle_blob || {};
        const vehicleLabel = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
        const user = {
            first_name: info.driver_blob.first_name,
            last_name: info.driver_blob.last_name,
            phone: info.driver_blob.phone,
            vehicle_info: vehicleLabel ? (vehicle.color ? vehicleLabel + ' (' + vehicle.color + ')' : vehicleLabel) : 'N/A'
        };
        const routeVehicleFallback = vehicle && Object.keys(vehicle).length > 0 ? vehicle : null;
        const routeAssignedVehicleId = info && info.vehicle_id ? String(info.vehicle_id) : null;
        const cachedFocusedDriver = resolveFocusedDriverRecord({
            driver_id: info.driver_id,
            driver_blob: info.driver_blob,
            phone: info.driver_blob.phone,
            User: {
                phone: info.driver_blob.phone,
                firstname: info.driver_blob.first_name,
                lastname: info.driver_blob.last_name,
            }
        });

        const buildFocusedDriverPayload = (driverRecord, driverInfo) => {
            const liveDriver = driverRecord || null;
            const liveVehicles = Array.isArray(liveDriver && liveDriver.Vehicles) ? liveDriver.Vehicles : [];
            const activeVehicle = resolveDriverVehicle(liveDriver, routeAssignedVehicleId) || resolveDriverActiveVehicle(liveDriver) || routeVehicleFallback || null;
            const resolvedDriverImageUrl =
                (liveDriver && liveDriver.image_url) ||
                (liveDriver && liveDriver.active_vehicle_details && liveDriver.active_vehicle_details.image_url) ||
                '';
            const activeVehicleDetails = activeVehicle
                ? {
                      ...activeVehicle,
                      render_image_url: getVehicleRenderUrl(activeVehicle) || activeVehicle.render_image_url || '',
                      image_url: getVehicleRenderUrl(activeVehicle) || activeVehicle.image_url || activeVehicle.render_image_url || resolvedDriverImageUrl || ''
                  }
                : null;

            return {
                LastDriverActions: driverInfo || (liveDriver && liveDriver.LastDriverActions) || null,
                driver_id: info.driver_id || (liveDriver && liveDriver.driver_id) || null,
                User: user,
                active_vehicle: routeAssignedVehicleId || (liveDriver && liveDriver.active_vehicle) || getVehicleIdentity(activeVehicleDetails) || null,
                active_vehicle_details: activeVehicleDetails,
                Vehicles: liveVehicles,
                vehicle_blob: activeVehicleDetails || routeVehicleFallback,
                can_deliver_alcohol: liveDriver && typeof liveDriver.can_deliver_alcohol === 'boolean' ? liveDriver.can_deliver_alcohol : !!info.can_deliver_alcohol,
                restricted_area_credentials: Array.isArray(liveDriver && liveDriver.restricted_area_credentials)
                    ? liveDriver.restricted_area_credentials
                    : (Array.isArray(info.restricted_area_credentials) ? info.restricted_area_credentials : []),
                employment_type: (liveDriver && liveDriver.employment_type) || info.employment_type || null,
                render_image_url: (activeVehicleDetails && activeVehicleDetails.render_image_url) || '',
                vehicle_image_url: (activeVehicleDetails && (activeVehicleDetails.vehicle_image_url || activeVehicleDetails.image_url || activeVehicleDetails.render_image_url)) || '',
                image_url: (activeVehicleDetails && activeVehicleDetails.image_url) || resolvedDriverImageUrl || (routeVehicleFallback && routeVehicleFallback.image_url) || '',
                tracking_blob: info.tracking_blob || null,
            };
        };

        const applyDriverFallbacks = driverRecord => {
            const restrictedCredentials = Array.isArray(driverRecord && driverRecord.restricted_area_credentials)
                ? driverRecord.restricted_area_credentials
                : Array.isArray(info.restricted_area_credentials)
                ? info.restricted_area_credentials
                : [];
            const canDeliverAlcohol = driverRecord && typeof driverRecord.can_deliver_alcohol === 'boolean'
                ? driverRecord.can_deliver_alcohol
                : !!info.can_deliver_alcohol;
            const permits = [];

            if (canDeliverAlcohol) {
                permits.push('Alcohol');
            }
            restrictedCredentials.forEach(credential => {
                permits.push(credential);
            });

            user.profile_photo_url = (driverRecord && driverRecord.profile_photo_url) || info.driver_blob.profile_photo_url || '';
            user.permit = permits.length > 0 ? permits.join(', ') : 'N/A';
            user.employment_type = (driverRecord && driverRecord.employment_type) || info.employment_type || 'N/A';
        };

        try {
            if (isDirectUsersHasuraUnavailableLocally) {
                warnUsersHasuraUnavailable('driver fallback details');
                applyDriverFallbacks(cachedFocusedDriver);
                if (isRequestActive()) {
                    setEnrouteClickDriver(buildFocusedDriverPayload(cachedFocusedDriver, null));
                }
                return;
            }

            const driver = await axios({
                method: 'post',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: user_urls.dispatchUsersHasuraHost,
                data: {
                    query: ` query LastDriverActions ($driverID: uuid!) {LastDriverActions (where: {driver_id: {_eq: $driverID}}) {
                  driver_id
                  location_blob
                    Driver {
                                        active_vehicle
                    profile_photo_url
                    restricted_area_credentials
                    can_deliver_alcohol
                    employment_type
                                        Vehicles {
                                            vehicle_id
                                            type
                                            make
                                            model
                                            color
                                            year
                                            plate_state
                                            plate_value
                                            render_image_url
                                            vehicle_image_url
                                            image_url
                                            VehicleDocuments(where: {doc_type: {_eq: "vehicle_render"}}, order_by: {updated_at: desc}) {
                                                signed_url
                                                url
                                                path_id
                                                file_name
                                                ocr_text
                                                updated_at
                                            }
                                        }
                  }
                  }
                }`,
                    variables: { driverID: info.driver_id }
                }
            });

            const lastDriverActions =
                driver && driver.data && driver.data.data && Array.isArray(driver.data.data.LastDriverActions) ? driver.data.data.LastDriverActions : [];
            const driverInfo = lastDriverActions.length > 0 ? lastDriverActions[0] : null;
            const liveDriver = driverInfo && driverInfo.Driver ? driverInfo.Driver : null;

            if (!isRequestActive()) {
                return;
            }

            const resolvedDriver = resolveFocusedDriverRecord({
                ...(liveDriver || {}),
                driver_id: (liveDriver && liveDriver.driver_id) || info.driver_id,
                driver_blob: info.driver_blob,
                phone: (liveDriver && liveDriver.phone) || info.driver_blob.phone,
                User: {
                    ...((liveDriver && liveDriver.User) || {}),
                    phone: ((liveDriver && liveDriver.User && liveDriver.User.phone) || (liveDriver && liveDriver.phone) || info.driver_blob.phone || ''),
                    firstname: ((liveDriver && liveDriver.User && liveDriver.User.firstname) || info.driver_blob.first_name || ''),
                    lastname: ((liveDriver && liveDriver.User && liveDriver.User.lastname) || info.driver_blob.last_name || ''),
                }
            });

            applyDriverFallbacks(resolvedDriver);
            if (isRequestActive()) {
                setEnrouteClickDriver(buildFocusedDriverPayload(resolvedDriver, driverInfo));
            }
        } catch (fetchError) {
            applyDriverFallbacks(cachedFocusedDriver);
            if (isRequestActive()) {
                setEnrouteClickDriver(buildFocusedDriverPayload(cachedFocusedDriver, null));
            }
        }
    };

    const updateTQLTracking = async route => {
        const primaryShipment = getPrimaryShipmentFromRoute(route);
        if (!primaryShipment || isFedexShipment(primaryShipment)) {
            return;
        }

        const routeDriver = getCurrentRouteDriver(route);
        const trackingBlob = routeDriver && routeDriver.tracking_blob ? routeDriver.tracking_blob : null;

        if (!trackingBlob || !Object.prototype.hasOwnProperty.call(trackingBlob, 'po_number')) {
            return;
        }

        const shipId = primaryShipment.shipment_id;
        const po_number = trackingBlob.po_number;

        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/shipments/direct/' + shipId + '/tql_ftl_tracking',
            data: { po_number }
        })
            .then(response => response)
            .catch(() => null);
    };

    const normalizePhoneForChat = phoneNumber => {
        if (!phoneNumber) {
            return '';
        }

        const rawPhone = String(phoneNumber).trim();
        if (rawPhone === '') {
            return '';
        }

        if (rawPhone.startsWith('+')) {
            const digitsWithPlus = '+' + rawPhone.slice(1).replace(/\D/g, '');
            return digitsWithPlus.length > 1 ? digitsWithPlus : '';
        }

        const digits = rawPhone.replace(/\D/g, '');

        if (digits.length === 10) {
            return `+1${digits}`;
        }

        if (digits.length === 11 && digits.startsWith('1')) {
            return `+${digits}`;
        }

        return '';
    };

    const getOrderChatScopeKey = contactInfo => {
        if (!contactInfo || !contactInfo.chatShipmentFriendlyId) {
            return '';
        }

        const normalizedPhone = normalizePhoneForChat(contactInfo.phone);

        if (!normalizedPhone) {
            return '';
        }

        const role = contactInfo.chatRole || 'Chat';

        return ['dispatch-order-chat', contactInfo.chatShipmentFriendlyId, role, normalizedPhone].join(':');
    };

    const readOrderChatSessionStart = contactInfo => {
        const scopeKey = getOrderChatScopeKey(contactInfo);

        if (!scopeKey) {
            return null;
        }

        try {
            const storedValue = localStorage.getItem(scopeKey);

            if (!storedValue) {
                return null;
            }

            const startedAt = new Date(storedValue);

            return Number.isNaN(startedAt.getTime()) ? null : startedAt.toISOString();
        } catch (error) {
            return null;
        }
    };

    const ensureOrderChatSessionStart = (contactInfo, fallbackDate = new Date()) => {
        const scopeKey = getOrderChatScopeKey(contactInfo);

        if (!scopeKey) {
            return null;
        }

        const existingStart = readOrderChatSessionStart(contactInfo);

        if (existingStart) {
            return existingStart;
        }

        const nextStart = fallbackDate instanceof Date ? fallbackDate.toISOString() : new Date(fallbackDate).toISOString();

        try {
            localStorage.setItem(scopeKey, nextStart);
        } catch (error) {
            return nextStart;
        }

        return nextStart;
    };

    const filterLogsForOrderChat = (logs, contactInfo) => {
        const normalizedLogs = Array.isArray(logs) ? logs : [];
        const startedAt = readOrderChatSessionStart(contactInfo);

        if (!contactInfo || !contactInfo.chatShipmentFriendlyId) {
            return normalizedLogs;
        }

        if (!startedAt) {
            return normalizedLogs;
        }

        const startedAtMs = new Date(startedAt).getTime();
        const filteredLogs = normalizedLogs.filter(log => {
            const logTimeMs = new Date(log.time).getTime();

            if (Number.isNaN(logTimeMs)) {
                // Keep entries with missing timestamps so the thread is never blank.
                return true;
            }

            return logTimeMs >= startedAtMs;
        });

        return filteredLogs.length > 0 ? filteredLogs : normalizedLogs;
    };

    const getResponseStatusValue = responseData => {
        if (!responseData || typeof responseData !== 'object') {
            return '';
        }

        if (responseData.status !== undefined && responseData.status !== null) {
            return responseData.status;
        }

        if (responseData.status_code !== undefined && responseData.status_code !== null) {
            return responseData.status_code;
        }

        return responseData.code || '';
    };

    const isSuccessfulResponse = responseData => {
        const responseStatus = getResponseStatusValue(responseData);

        return responseStatus === 'successful'
            || responseStatus === 'success'
            || responseStatus === 200
            || responseStatus === '200';
    };

    const getDriverMessageLogsFromResponse = responseData => {
        if (!responseData || typeof responseData !== 'object') {
            return [];
        }

        const payload = responseData.payload;

        if (Array.isArray(payload)) {
            return payload;
        }

        if (payload && typeof payload === 'object') {
            if (Array.isArray(payload.messages)) {
                return payload.messages;
            }

            if (Array.isArray(payload.logs)) {
                return payload.logs;
            }

            if (Array.isArray(payload.payload)) {
                return payload.payload;
            }
        }

        return [];
    };

    const resetDriverMessageComposer = () => {
        setDriverMessage('');
        setDriverMessageAttachment(null);
        setDriverMessageAttachmentError('');
        setMessageRecipientInfo({});
    };

    const resolveDriverMessageAttachmentDocType = file => {
        if (!file || !file.name) {
            return null;
        }

        const mimeType = String(file.type || '').toLowerCase();
        const extension = file.name.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
        const allowedDocumentExtensions = ['pdf', 'doc', 'docx', 'odt'];

        if (mimeType.startsWith('image/')) {
            return 'admin_message_attachment';
        }

        if (allowedDocumentExtensions.includes(extension)) {
            return 'admin_message_attachment';
        }

        return null;
    };

    const uploadDriverMessageAttachment = async file => {
        const docType = resolveDriverMessageAttachmentDocType(file);

        if (!docType) {
            throw new Error('Only image, PDF, DOC, DOCX, and ODT files are supported.');
        }

        const safeBaseName = String(file.name || 'attachment')
            .replace(/[^a-zA-Z0-9._-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '') || 'attachment';
        const pathId = `admin-driver-messages/${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        const formData = new FormData();
        formData.append('document', file, safeBaseName);

        const uploadResponse = await axios({
            method: 'post',
            url: `${apiFilesHost}/documents/upload?path_id=${encodeURIComponent(pathId)}&doc_type=${encodeURIComponent(docType)}&client_env=${encodeURIComponent(clientEnv)}`,
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
            },
            data: formData,
        });

        const signedUrl = uploadResponse && uploadResponse.data ? uploadResponse.data.url : '';

        if (!signedUrl) {
            throw new Error('Attachment upload did not return a signed URL.');
        }

        return signedUrl;
    };

    const handleDriverMessageAttachmentChange = event => {
        const file = event && event.target && event.target.files && event.target.files[0] ? event.target.files[0] : null;

        if (!file) {
            setDriverMessageAttachment(null);
            setDriverMessageAttachmentError('');
            return;
        }

        const docType = resolveDriverMessageAttachmentDocType(file);

        if (!docType) {
            setDriverMessageAttachment(null);
            setDriverMessageAttachmentError('Only image, PDF, DOC, DOCX, and ODT files are supported.');
            return;
        }

        setDriverMessageAttachment(file);
        setDriverMessageAttachmentError('');
    };

    const removeDriverMessageAttachment = () => {
        setDriverMessageAttachment(null);
        setDriverMessageAttachmentError('');
    };

    const resolvePreClaimRecipientInfo = recipientInfo => {
        if (!(recipientInfo && recipientInfo.chatMode === 'preclaim-order-thread')) {
            return recipientInfo;
        }

        if (recipientInfo.chatShipmentId && recipientInfo.chatDriverAuth0Id && recipientInfo.chatThreadId) {
            return recipientInfo;
        }

        const latestSummary = recipientInfo.chatShipmentId
            ? getLatestPreClaimOrderChatSummaryForShipment(recipientInfo.chatShipmentId)
            : null;
        const thread = latestSummary && latestSummary.thread ? latestSummary.thread : null;

        if (!thread || !thread.shipment_id || !thread.driver_auth0_id) {
            return recipientInfo;
        }

        return {
            ...recipientInfo,
            chatShipmentId: recipientInfo.chatShipmentId || thread.shipment_id,
            chatShipmentFriendlyId: recipientInfo.chatShipmentFriendlyId || thread.shipment_friendly_id || '',
            chatDriverAuth0Id: recipientInfo.chatDriverAuth0Id || thread.driver_auth0_id,
            chatThreadId: recipientInfo.chatThreadId || buildPreClaimOrderThreadKey(thread),
            chatDriverDisplayName: recipientInfo.chatDriverDisplayName && recipientInfo.chatDriverDisplayName !== 'Driver'
                ? recipientInfo.chatDriverDisplayName
                : resolveThreadDriverDisplayName({
                    shipmentId: recipientInfo.chatShipmentId || thread.shipment_id,
                    driverAuth0Id: recipientInfo.chatDriverAuth0Id || thread.driver_auth0_id,
                }),
        };
    };

    const sendMessage = (driverMessage, recipientInfo) => {
        const trimmedMessage = String(driverMessage || '').trim();

        if (recipientInfo && recipientInfo.chatMode === 'preclaim-order-thread') {
            const resolvedRecipientInfo = resolvePreClaimRecipientInfo(recipientInfo);

            if (!trimmedMessage) {
                props.notify('tc', 'Message is required');
                return;
            }

            if (!resolvedRecipientInfo.chatShipmentId || !resolvedRecipientInfo.chatDriverAuth0Id) {
                props.notify('tc', 'Failed to load driver order chat thread.', 'danger');
                return;
            }

            if (resolvedRecipientInfo !== recipientInfo) {
                setMessageRecipientInfo(resolvedRecipientInfo);
            }

            axios({
                method: 'post',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: preClaimOrderChatEndpoint,
                data: {
                    shipment_id: resolvedRecipientInfo.chatShipmentId,
                    driver_auth0_id: resolvedRecipientInfo.chatDriverAuth0Id,
                    body: trimmedMessage,
                }
            })
                .then(response => {
                    const createdMessage = response && response.data && response.data.payload ? response.data.payload : null;

                    if (!createdMessage) {
                        props.notify('tc', 'Failed to send the message');
                        return;
                    }

                    setDriverMessageRetrieved(currentMessages => [...currentMessages, createdMessage]);
                    markPreClaimOrderChatSeen(resolvedRecipientInfo.chatThreadId, createdMessage.message_id);
                    setDriverMessage('');
                })
                .catch(error => {
                    const errorMessage =
                        (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
                        (error && error.message) ||
                        'Failed to send the message';
                    props.notify('tc', errorMessage);
                });

            return;
        }

        if (recipientInfo && recipientInfo.chatMode === 'order-thread') {
            if (recipientInfo.chatReadOnly) {
                props.notify('tc', 'This shipment chat is view only from dispatch.');
                return;
            }

            if (!trimmedMessage) {
                props.notify('tc', 'Message is required');
                return;
            }

            axios({
                method: 'post',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: claimedOrderChatEndpoint,
                data: {
                    shipment_id: recipientInfo.chatShipmentId,
                    ...(getClaimedOrderChatThreadTypeParam(recipientInfo.chatThreadType) ? { thread_type: getClaimedOrderChatThreadTypeParam(recipientInfo.chatThreadType) } : {}),
                    ...(recipientInfo.chatParticipantAuth0Id ? { participant_auth0_id: recipientInfo.chatParticipantAuth0Id } : {}),
                    body: trimmedMessage,
                }
            })
                .then(response => {
                    const createdMessage = response && response.data && response.data.payload ? response.data.payload : null;

                    if (!createdMessage) {
                        props.notify('tc', 'Failed to send the message');
                        return;
                    }

                    setDriverMessageRetrieved(currentMessages => [...currentMessages, createdMessage]);
                    markClaimedOrderChatSeen(
                        recipientInfo.chatThreadId || buildClaimedOrderThreadKey({
                            shipment_id: recipientInfo.chatShipmentId,
                            thread_type: recipientInfo.chatThreadType,
                            participant_auth0_id: recipientInfo.chatParticipantAuth0Id,
                        }),
                        createdMessage.message_id
                    );
                    setDriverMessage('');
                })
                .catch(error => {
                    const errorMessage =
                        (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
                        (error && error.message) ||
                        'Failed to send the message';
                    props.notify('tc', errorMessage);
                });

            return;
        }

        const normalizedRecipient = normalizePhoneForChat(recipientInfo && recipientInfo.phone);

        if (!trimmedMessage && !driverMessageAttachment) {
            props.notify('tc', 'Message or attachment is required');
            return;
        }

        if (!normalizedRecipient) {
            props.notify('tc', 'Recipient phone number is invalid');
            return;
        }

        const startedAt = ensureOrderChatSessionStart(recipientInfo, new Date(Date.now() - 1000));
        const nextRecipientInfo = startedAt ? { ...recipientInfo, chatStartedAt: startedAt } : recipientInfo;

        Promise.resolve(driverMessageAttachment ? uploadDriverMessageAttachment(driverMessageAttachment) : null)
            .then(signedUrl => {
                let data = {
                    message: trimmedMessage,
                    recipient: normalizedRecipient,
                    mediaUrls: signedUrl ? [signedUrl] : [],
                };

                return axios({
                    method: 'post',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: dispatchUsersHost + '/driver/send-message',
                    data: data
                });
            })
            .then(response => {
                if (response.data.status === 'successful') {
                    if (nextRecipientInfo && nextRecipientInfo.chatShipmentFriendlyId) {
                        setMessageRecipientInfo(nextRecipientInfo);
                    }
                    toggleDriverMessageForm();
                    props.notify('tc', 'Successfully sent the message');
                    setDriverMessage('');
                    setDriverMessageAttachment(null);
                    setDriverMessageAttachmentError('');
                    setMessageRecipientInfo({});
                } else {
                    props.notify('tc', response.data.message || 'Failed to send the message');
                }
            })
            .catch(error => {
                const errorMessage =
                    (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
                    (error && error.message) ||
                    'Failed to send the message';
                props.notify('tc', errorMessage);
            });
    };

    // Per-order scoping for the dispatch↔customer (Order Placer) SMS chat: the customer's Twilio
    // history spans all their orders, so we filter it to the window that bounds just this order.
    const orderPlacerChatWindowCacheRef = useRef({});

    const filterOrderPlacerMessagesToWindow = (messages, orderWindow) => {
        if (!orderWindow || (!orderWindow.window_start && !orderWindow.window_end)) {
            return messages;
        }
        const startMs = orderWindow.window_start ? new Date(orderWindow.window_start).getTime() : -Infinity;
        const endMs = orderWindow.window_end ? new Date(orderWindow.window_end).getTime() : Infinity;
        return (messages || []).filter(message => {
            const stamp = new Date(message && (message.time || message.created_at || message.dateCreated)).getTime();
            if (!Number.isFinite(stamp)) {
                return true;
            }
            return stamp > startMs && stamp < endMs;
        });
    };

    const getOrderPlacerChatWindow = shipmentId => {
        if (!shipmentId) {
            return Promise.resolve(null);
        }
        const cache = orderPlacerChatWindowCacheRef.current;
        if (!cache[shipmentId]) {
            cache[shipmentId] = axios({
                method: 'get',
                headers: { Authorization: buildAuthorizationHeader(), 'content-type': 'application/json' },
                url: `${shipment_urls.shipmentHost}/dispatch/chat/order-placer?shipment_id=${encodeURIComponent(shipmentId)}`,
            })
                .then(response => (response && response.data && response.data.payload) || { window_start: null, window_end: null })
                .catch(() => ({ window_start: null, window_end: null }));
        }
        return cache[shipmentId];
    };

    const retrieveMessage = recipientInfoOrPhone => {
        const recipientInfo = typeof recipientInfoOrPhone === 'object' && recipientInfoOrPhone !== null
            ? recipientInfoOrPhone
            : { phone: recipientInfoOrPhone };

        if (recipientInfo && recipientInfo.chatMode === 'preclaim-order-thread') {
            const resolvedRecipientInfo = resolvePreClaimRecipientInfo(recipientInfo);

            if (!resolvedRecipientInfo.chatShipmentId || !resolvedRecipientInfo.chatDriverAuth0Id) {
                setDriverMessageRetrieved([]);
                return;
            }

            if (resolvedRecipientInfo !== recipientInfo) {
                setMessageRecipientInfo(resolvedRecipientInfo);
            }

            axios({
                method: 'get',
                headers: {
                    Authorization: buildAuthorizationHeader(),
                    'content-type': 'application/json'
                },
                url: `${preClaimOrderChatEndpoint}?shipment_id=${encodeURIComponent(resolvedRecipientInfo.chatShipmentId)}&driver_auth0_id=${encodeURIComponent(resolvedRecipientInfo.chatDriverAuth0Id)}`
            })
                .then(response => {
                    if (response.data.status === 'successful') {
                        const payload = response.data.payload || {};
                        const messages = Array.isArray(payload.messages) ? payload.messages : [];
                        const latestMessage = messages.length > 0 ? messages[messages.length - 1] : null;

                        setDriverMessageRetrieved(currentMessages => (
                            buildChatThreadSignature(currentMessages) === buildChatThreadSignature(messages)
                                ? currentMessages
                                : messages
                        ));

                        if (latestMessage && latestMessage.message_id && !resolvedRecipientInfo.chatAutoOpenedUnread) {
                            markPreClaimOrderChatSeen(resolvedRecipientInfo.chatThreadId, latestMessage.message_id);
                        }
                    } else {
                        setDriverMessageRetrieved([]);
                    }
                })
                .catch(() => {
                    setDriverMessageRetrieved([]);
                });

            return;
        }

        if (recipientInfo && recipientInfo.chatMode === 'order-thread') {
            if (!recipientInfo.chatShipmentId) {
                setDriverMessageRetrieved([]);
                return;
            }

            axios({
                method: 'get',
                headers: {
                    Authorization: buildAuthorizationHeader(),
                    'content-type': 'application/json'
                },
                url: `${claimedOrderChatEndpoint}?shipment_id=${encodeURIComponent(recipientInfo.chatShipmentId)}${getClaimedOrderChatThreadTypeParam(recipientInfo.chatThreadType) ? `&thread_type=${encodeURIComponent(getClaimedOrderChatThreadTypeParam(recipientInfo.chatThreadType))}` : ''}${recipientInfo.chatParticipantAuth0Id ? `&participant_auth0_id=${encodeURIComponent(recipientInfo.chatParticipantAuth0Id)}` : ''}`
            })
                .then(response => {
                    if (response.data.status === 'successful') {
                        const payload = response.data.payload || {};
                        const messages = Array.isArray(payload.messages) ? payload.messages : [];
                        const latestMessage = messages.length > 0 ? messages[messages.length - 1] : null;

                        setDriverMessageRetrieved(currentMessages => (
                            buildChatThreadSignature(currentMessages) === buildChatThreadSignature(messages)
                                ? currentMessages
                                : messages
                        ));

                        if (latestMessage && latestMessage.message_id && !recipientInfo.chatAutoOpenedUnread) {
                            markClaimedOrderChatSeen(
                                recipientInfo.chatThreadId || buildClaimedOrderThreadKey({
                                    shipment_id: recipientInfo.chatShipmentId,
                                    thread_type: recipientInfo.chatThreadType,
                                    participant_auth0_id: recipientInfo.chatParticipantAuth0Id,
                                }),
                                latestMessage.message_id
                            );
                        }
                    } else {
                        setDriverMessageRetrieved([]);
                    }
                })
                .catch(() => {
                    setDriverMessageRetrieved([]);
                });

            return;
        }

        const normalizedRecipient = normalizePhoneForChat(recipientInfo.phone);

        if (!normalizedRecipient) {
            setDriverMessageRetrieved([]);
            return;
        }

        // Scope the dispatch↔customer chat to only this order's messages (not the whole phone history).
        const scopeToOrder = recipientInfo.chatRole === 'Order Placer' && recipientInfo.chatShipmentId;
        const windowPromise = scopeToOrder ? getOrderPlacerChatWindow(recipientInfo.chatShipmentId) : Promise.resolve(null);

        windowPromise.then(orderWindow => {
            axios({
                method: 'get',
                headers: {
                    Authorization: buildAuthorizationHeader(),
                    'content-type': 'application/json'
                },
                url: dispatchUsersHost + `/driver/fetch-messages?phoneNumber=${encodeURIComponent(normalizedRecipient)}`
            })
                .then(response => {
                    if (isSuccessfulResponse(response.data)) {
                        let nextMessages = filterLogsForOrderChat(getDriverMessageLogsFromResponse(response.data), recipientInfo);
                        if (orderWindow) {
                            nextMessages = filterOrderPlacerMessagesToWindow(nextMessages, orderWindow);
                        }
                        setDriverMessageRetrieved(currentMessages => (
                            buildChatThreadSignature(currentMessages) === buildChatThreadSignature(nextMessages)
                                ? currentMessages
                                : nextMessages
                        ));
                    } else {
                        setDriverMessageRetrieved([]);
                    }
                })
                .catch(() => {
                    setDriverMessageRetrieved([]);
                });
        });
    };

    useEffect(() => {
        if (!showDriverMessageForm || !messageRecipientInfo || (!messageRecipientInfo.chatShipmentId && !messageRecipientInfo.phone)) {
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            retrieveMessage(messageRecipientInfo);
        }, OPEN_CHAT_THREAD_POLL_INTERVAL_MS);

        return () => window.clearInterval(intervalId);
    }, [showDriverMessageForm, messageRecipientInfo]);

    const formatPhoneNumber = phoneNumber => {
        if (!phoneNumber) {
            return '';
        }

        const digits = phoneNumber.toString().replace(/\D/g, '');

        if (digits.length === 10) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        }

        if (digits.length === 11 && digits.startsWith('1')) {
            return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
        }

        return phoneNumber;
    };

    const splitDisplayName = displayName => {
        const safeName = (displayName || '').trim();

        if (!safeName) {
            return { firstname: '', lastname: '' };
        }

        const nameParts = safeName.split(/\s+/);

        return {
            firstname: nameParts.shift() || '',
            lastname: nameParts.join(' ')
        };
    };

    const getNestedContactValue = (sources = [], keys = []) => {
        for (let sourceIndex = 0; sourceIndex < sources.length; sourceIndex += 1) {
            const source = sources[sourceIndex] || {};

            for (let keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
                const key = keys[keyIndex];
                const value = source[key];

                if (value !== undefined && value !== null && value !== '') {
                    return value;
                }
            }
        }

        return '';
    };

    const isLikelyUserIdentifier = value => {
        if (!value || typeof value !== 'string') {
            return false;
        }

        return value.includes('|') || /^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(value);
    };

    const normalizeAuth0Candidate = value => {
        if (!value || typeof value !== 'string') {
            return '';
        }

        const trimmedValue = value.trim();
        const strippedValue = trimmedValue.replace(/\(behalf\)$/i, '').trim();

        return isLikelyUserIdentifier(strippedValue) ? strippedValue : '';
    };

    const getOrderPlacerContact = shipment => {
        const shipInfo = (shipment && shipment.shipping_fee_blob && shipment.shipping_fee_blob.shipment) || {};
        const customerBlob = (shipment && shipment.customer_blob) || {};
        const invoiceTo = (shipment && shipment.invoice_to) || {};
        const orderPlacerName = getNestedContactValue(
            [
                shipment,
                shipInfo,
                customerBlob,
                invoiceTo
            ],
            [
                'placed_by_name',
                'order_placer_name',
                'created_by_name',
                'merchant_name',
                'contact_name',
                'name',
                'store_name'
            ]
        ) || (!isLikelyUserIdentifier(shipment && shipment.placed_by) ? shipment.placed_by : '');
        const customerBlobName = [customerBlob.first_name, customerBlob.last_name].filter(Boolean).join(' ');
        const orderPlacerPhone = getNestedContactValue(
            [
                shipment,
                shipInfo,
                customerBlob,
                invoiceTo
            ],
            [
            'placed_by_phone',
            'order_placer_phone',
            'created_by_phone',
            'placed_by_phone_number',
            'order_placer_phone_number',
            'created_by_phone_number',
            'contact_phone',
            'phone_number',
                'phone'
            ]
        );
        const orderPlacerEmail = getNestedContactValue(
            [
                shipment,
                shipInfo,
                customerBlob,
                invoiceTo
            ],
            ['placed_by_email', 'order_placer_email', 'created_by_email', 'contact_email', 'email']
        );
        const resolvedOrderPlacerName = orderPlacerName || customerBlobName;
        const orderPlacerNameParts = splitDisplayName(resolvedOrderPlacerName);

        return {
            key: 'order-placer',
            label: 'Order Placer',
            firstname: orderPlacerNameParts.firstname,
            lastname: orderPlacerNameParts.lastname,
            displayName: resolvedOrderPlacerName || 'Unknown order placer',
            phone: orderPlacerPhone,
            email: orderPlacerEmail,
            accentColor: '#57c7ff'
        };
    };

    const buildLocationChatContact = (order, fallbackLabel) => {
        const locationBlob = order && order.location_blob ? order.location_blob : {};
        const locationNameParts = splitDisplayName(locationBlob.name || '');

        return {
            firstname: locationNameParts.firstname,
            lastname: locationNameParts.lastname,
            displayName: locationBlob.name || fallbackLabel,
            phone: locationBlob.phone || '',
            email: locationBlob.email || '',
            label: fallbackLabel
        };
    };

    const getDispatchAdminDisplayName = () => {
        return String(currentAdminDisplayName || getAuthProfileDisplayName(CURRENT_USER_AUTH) || 'Dispatch').trim() || 'Dispatch';
    };

    const findKnownShipmentById = shipmentId => {
        if (!shipmentId) {
            return null;
        }

        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes)
            ? effectiveRouteSubscriptionData.Routes
            : [];

        for (let index = 0; index < routeRecords.length; index += 1) {
            const matchedRouteShipment = getRouteShipments(routeRecords[index]).find(candidate => candidate && candidate.shipment_id === shipmentId);

            if (matchedRouteShipment) {
                return matchedRouteShipment;
            }
        }

        const shipmentRecords = effectiveShipmentSubscriptionData && Array.isArray(effectiveShipmentSubscriptionData.Shipments)
            ? effectiveShipmentSubscriptionData.Shipments
            : [];

        return shipmentRecords.find(candidate => candidate && candidate.shipment_id === shipmentId) || null;
    };

    const resolveClaimedOrderDriverDisplayName = (shipment, contact) => {
        const contactDisplayName = String((contact && contact.displayName) || '').trim();
        if (contact && contact.label === 'Driver' && contactDisplayName) {
            return contactDisplayName;
        }

        const routeDrivers =
            (shipment && Array.isArray(shipment.RouteDrivers) && shipment.RouteDrivers) ||
            (shipment && shipment.Route && Array.isArray(shipment.Route.RouteDrivers) && shipment.Route.RouteDrivers) ||
            [];
        const currentDriver = routeDrivers.find(driver => driver && driver.status !== 'unassigned') || routeDrivers[0] || null;

        if (currentDriver && currentDriver.driver_blob) {
            const driverName = `${currentDriver.driver_blob.first_name || ''} ${currentDriver.driver_blob.last_name || ''}`.trim();
            if (driverName) {
                return driverName;
            }
        }

        const shipmentDriverName = `${shipment && shipment.driver_blob && shipment.driver_blob.first_name ? shipment.driver_blob.first_name : ''} ${shipment && shipment.driver_blob && shipment.driver_blob.last_name ? shipment.driver_blob.last_name : ''}`.trim();
        return shipmentDriverName || 'Driver';
    };

    const resolveThreadDriverDisplayName = ({ shipmentId = '', driverAuth0Id = '', fallbackName = 'Driver' } = {}) => {
        const shipment = findKnownShipmentById(shipmentId);

        if (!shipment) {
            return fallbackName;
        }

        if (driverAuth0Id) {
            const routeDrivers =
                (shipment && Array.isArray(shipment.RouteDrivers) && shipment.RouteDrivers) ||
                (shipment && shipment.Route && Array.isArray(shipment.Route.RouteDrivers) && shipment.Route.RouteDrivers) ||
                [];
            const matchedDriver = routeDrivers.find(driver => driver && (driver.driver_auth0_id === driverAuth0Id || driver.auth0_id === driverAuth0Id)) || null;

            if (matchedDriver && matchedDriver.driver_blob) {
                const matchedDriverName = `${matchedDriver.driver_blob.first_name || ''} ${matchedDriver.driver_blob.last_name || ''}`.trim();

                if (matchedDriverName) {
                    return matchedDriverName;
                }
            }
        }

        return resolveClaimedOrderDriverDisplayName(shipment, null) || fallbackName;
    };

    const getShipmentDriverReference = useCallback(
        shipment => {
            const routeDrivers =
                (shipment && Array.isArray(shipment.RouteDrivers) && shipment.RouteDrivers) ||
                (shipment && shipment.Route && Array.isArray(shipment.Route.RouteDrivers) && shipment.Route.RouteDrivers) ||
                [];
            const currentDriver = routeDrivers.find(driver => driver && driver.status !== 'unassigned') || routeDrivers[0] || null;

            return {
                driverId:
                    (currentDriver && currentDriver.driver_id) ||
                    (shipment && shipment.driver_id) ||
                    '',
                phone:
                    (currentDriver && currentDriver.driver_blob && currentDriver.driver_blob.phone) ||
                    (shipment && shipment.driver_blob && shipment.driver_blob.phone) ||
                    '',
            };
        },
        []
    );

    const getDriverContactReference = (contact, shipment) => {
        if (!(contact && contact.label === 'Driver')) {
            return { driverId: '', phone: contact && contact.phone ? contact.phone : '' };
        }

        const shipmentDriverReference = getShipmentDriverReference(shipment);

        return {
            driverId: (contact && contact.driverId) || shipmentDriverReference.driverId || '',
            phone: (contact && contact.phone) || shipmentDriverReference.phone || '',
        };
    };

    const shouldUseClaimedOrderThread = (contact, shipment) => {
        if (!(shipment && shipment.shipment_id)) {
            return false;
        }

        if (!contact) {
            return true;
        }

        if (contact.label === 'Claimed Order') {
            return true;
        }

        if (contact.label === 'Customer Driver') {
            return true;
        }

        if (contact.label === 'Customer Dispatch') {
            return true;
        }

        if (contact.label !== 'Driver') {
            return false;
        }

        if (!contact.phone) {
            return true;
        }

        return selected === 'progressing' || selected === 'completed';
    };

    const resolveShipmentCustomerParticipantAuth0Id = shipment => {
        if (!shipment || typeof shipment !== 'object') {
            return '';
        }

        const customerBlob = shipment.customer_blob && typeof shipment.customer_blob === 'object'
            ? shipment.customer_blob
            : {};

        return normalizeAuth0Candidate(shipment.cust_auth0_id)
            || normalizeAuth0Candidate(shipment.created_by)
            || normalizeAuth0Candidate(shipment.placed_by)
            || normalizeAuth0Candidate(customerBlob.auth0_id)
            || '';
    };

    const resolveCustomerDriverThreadMetadata = ({ shipment = null, shipmentId = '', participantAuth0Id = '' } = {}) => {
        const resolvedShipment = shipment || findKnownShipmentById(shipmentId);
        const resolvedShipmentId = shipmentId || (resolvedShipment && resolvedShipment.shipment_id) || '';
        const customerDriverSummaries = Object.values(claimedOrderChatSummariesByShipmentId || {});
        const matchedSummary = customerDriverSummaries.find(summary => {
            const thread = summary && summary.thread ? summary.thread : null;

            if (!(thread && thread.shipment_id === resolvedShipmentId && thread.thread_type === 'customer_driver')) {
                return false;
            }

            if (!participantAuth0Id) {
                return true;
            }

            return (thread.participant_auth0_id || '') === participantAuth0Id;
        }) || null;
        const summaryThread = matchedSummary && matchedSummary.thread ? matchedSummary.thread : null;
        const orderPlacerContact = resolvedShipment ? getOrderPlacerContact(resolvedShipment) : null;
        const customerDisplayName = getShipmentCustomerName(resolvedShipment)
            || (orderPlacerContact && orderPlacerContact.displayName)
            || 'Customer';
        const driverDisplayName = resolvedShipment
            ? resolveClaimedOrderDriverDisplayName(resolvedShipment, null)
            : resolveThreadDriverDisplayName({ shipmentId: resolvedShipmentId });
        const summaryHasParticipantField = Boolean(summaryThread) && Object.prototype.hasOwnProperty.call(summaryThread, 'participant_auth0_id');
        const effectiveParticipantAuth0Id = participantAuth0Id
            || (summaryHasParticipantField ? summaryThread.participant_auth0_id : undefined)
            || (!summaryHasParticipantField ? resolveShipmentCustomerParticipantAuth0Id(resolvedShipment) : null);

        return {
            chatDisplayName: `${customerDisplayName} / ${driverDisplayName || 'Driver'}`,
            chatCustomerDisplayName: customerDisplayName,
            chatDriverDisplayName: driverDisplayName || 'Driver',
            chatParticipantAuth0Id: effectiveParticipantAuth0Id,
        };
    };

    const openOrderContactChat = (contact, shipment) => {
        if ((!contact || !contact.phone) && !(shipment && shipment.shipment_id)) {
            return;
        }

        if (shouldUseClaimedOrderThread(contact, shipment)) {
            const chatThreadType = contact && contact.chatThreadType ? contact.chatThreadType : 'claimed_order';
            const customerDriverThreadMetadata = chatThreadType === 'customer_driver'
                ? resolveCustomerDriverThreadMetadata({ shipment })
                : null;
            const chatParticipantAuth0Id = customerDriverThreadMetadata
                ? customerDriverThreadMetadata.chatParticipantAuth0Id
                : (chatThreadType === 'customer_dispatch' ? resolveShipmentCustomerParticipantAuth0Id(shipment) : '');
            const nextRecipientInfo = {
                chatMode: 'order-thread',
                chatDisplayName: customerDriverThreadMetadata
                    ? customerDriverThreadMetadata.chatDisplayName
                    : (chatThreadType === 'customer_dispatch' ? 'Customer / Dispatch' : 'Driver and Dispatch'),
                chatRole: chatThreadType === 'customer_driver' ? 'Customer Driver' : (chatThreadType === 'customer_dispatch' ? 'Customer Dispatch' : 'Claimed Order'),
                chatShipmentId: shipment.shipment_id,
                chatShipmentFriendlyId: shipment && shipment.shipment_friendly_id ? shipment.shipment_friendly_id : '',
                chatThreadType,
                chatThreadId: buildClaimedOrderThreadKey({
                    shipment_id: shipment.shipment_id,
                    thread_type: chatThreadType,
                    participant_auth0_id: chatParticipantAuth0Id,
                }),
                chatParticipantAuth0Id,
                chatReadOnly: chatThreadType === 'customer_driver',
                chatAdminDisplayName: getDispatchAdminDisplayName(),
                chatCustomerDisplayName: customerDriverThreadMetadata ? customerDriverThreadMetadata.chatCustomerDisplayName : '',
                chatDriverDisplayName: customerDriverThreadMetadata ? customerDriverThreadMetadata.chatDriverDisplayName : resolveClaimedOrderDriverDisplayName(shipment, contact),
            };

            setMessageRecipientInfo(nextRecipientInfo);
            setShowDriverMessageForm(true);
            retrieveMessage(nextRecipientInfo);
            return;
        }

        const nextRecipientInfo = {
            firstname: contact.firstname || contact.displayName || '',
            lastname: contact.lastname || '',
            phone: contact.phone,
            email: contact.email || '',
            chatDisplayName: contact.displayName,
            chatRole: contact.label,
            chatShipmentId: shipment && shipment.shipment_id ? shipment.shipment_id : '',
            chatShipmentFriendlyId: shipment && shipment.shipment_friendly_id ? shipment.shipment_friendly_id : '',
            driverId: getDriverContactReference(contact, shipment).driverId,
        };

        const startedAt = readOrderChatSessionStart(nextRecipientInfo);

        setMessageRecipientInfo(startedAt ? { ...nextRecipientInfo, chatStartedAt: startedAt } : nextRecipientInfo);
        setShowDriverMessageForm(true);
        retrieveMessage(nextRecipientInfo);

        if (nextRecipientInfo.driverId) {
            const smsUnreadCount = getSmsUnreadCountForDriver(getDriverContactReference(contact, shipment));

            if (smsUnreadCount > 0) {
                markDriverMessageRead(nextRecipientInfo.driverId, smsUnreadCount);
            }
        }
    };

    const openPreClaimOrderChat = shipment => {
        if (!(shipment && shipment.shipment_id)) {
            return;
        }

        const latestSummary = getLatestPreClaimOrderChatSummaryForShipment(shipment.shipment_id);
        const thread = latestSummary && latestSummary.thread ? latestSummary.thread : null;

        if (!thread || !thread.driver_auth0_id) {
            return;
        }

        const nextRecipientInfo = {
            chatMode: 'preclaim-order-thread',
            chatDisplayName: 'Driver Question',
            chatRole: 'Pre-Claim Order',
            chatShipmentId: thread.shipment_id,
            chatShipmentFriendlyId: thread.shipment_friendly_id || '',
            chatDriverAuth0Id: thread.driver_auth0_id,
            chatThreadId: buildPreClaimOrderThreadKey(thread),
            chatAdminDisplayName: getDispatchAdminDisplayName(),
            chatDriverDisplayName: resolveThreadDriverDisplayName({ shipmentId: thread.shipment_id, driverAuth0Id: thread.driver_auth0_id }),
        };

        // Clear the alert immediately using the SAME message id the poll compares against
        // (summary.latest_message), so reopening a read thread doesn't re-raise the badge.
        const openedLatestMessageId = latestSummary && latestSummary.latest_message && latestSummary.latest_message.message_id
            ? latestSummary.latest_message.message_id
            : '';

        setMessageRecipientInfo(nextRecipientInfo);
        setShowDriverMessageForm(true);
        if (openedLatestMessageId) {
            markPreClaimOrderChatSeen(nextRecipientInfo.chatThreadId, openedLatestMessageId);
        }
        retrieveMessage(nextRecipientInfo);
    };

    const openPreClaimOrderChatSummary = summary => {
        const thread = summary && summary.thread ? summary.thread : null;

        if (!thread || !thread.shipment_id || !thread.driver_auth0_id) {
            return;
        }

        const nextRecipientInfo = {
            chatMode: 'preclaim-order-thread',
            chatDisplayName: 'Driver Question',
            chatRole: 'Pre-Claim Order',
            chatShipmentId: thread.shipment_id,
            chatShipmentFriendlyId: thread.shipment_friendly_id || '',
            chatDriverAuth0Id: thread.driver_auth0_id,
            chatThreadId: buildPreClaimOrderThreadKey(thread),
            chatAdminDisplayName: getDispatchAdminDisplayName(),
            chatDriverDisplayName: resolveThreadDriverDisplayName({ shipmentId: thread.shipment_id, driverAuth0Id: thread.driver_auth0_id }),
        };

        // Clear the alert immediately using the SAME message id the poll compares against
        // (summary.latest_message), so reopening a read thread doesn't re-raise the badge.
        const openedLatestMessageId = summary && summary.latest_message && summary.latest_message.message_id
            ? summary.latest_message.message_id
            : '';

        setMessageRecipientInfo(nextRecipientInfo);
        setShowDriverMessageForm(true);
        if (openedLatestMessageId) {
            markPreClaimOrderChatSeen(nextRecipientInfo.chatThreadId, openedLatestMessageId);
        }
        retrieveMessage(nextRecipientInfo);
    };

    const PreClaimOrderChatEntry = ({ shipment }) => {
        if (!(shipment && shipment.shipment_id)) {
            return null;
        }

        const latestSummary = getLatestPreClaimOrderChatSummaryForShipment(shipment.shipment_id);
        const unreadCount = getPreClaimOrderChatUnreadCountForShipment(shipment.shipment_id);

        if (!latestSummary) {
            return null;
        }

        return (
            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <strong>Driver Questions</strong>
                <button
                    type="button"
                    onClick={() => openPreClaimOrderChat(shipment)}
                    title="Open pre-claim driver question"
                    aria-label="Open pre-claim driver question"
                    style={{
                        alignItems: 'center',
                        background: 'transparent',
                        border: 'none',
                        color: '#f7941d',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        gap: '6px',
                        justifyContent: 'center',
                        lineHeight: 1,
                        padding: 0,
                        position: 'relative'
                    }}
                >
                    {unreadCount > 0 ? (
                        <span style={{ position: 'absolute', right: '-10px', top: '-10px' }}>
                            {renderClaimedOrderUnreadBadge(unreadCount, { backgroundColor: '#D62828', borderColor: '#FFFFFF' })}
                        </span>
                    ) : null}
                    <FontAwesomeIcon icon={faComment} style={{ fontSize: '1.1em' }} />
                    <span style={{ fontSize: '13px', fontWeight: 600 }}>Open Thread</span>
                </button>
            </div>
        );
    };

    const ReadyRoutePreClaimQuestions = ({ route }) => {
        const routeShipments = getRouteShipments(route).filter(
            shipment => shipment && trackedPreClaimOrderChatShipmentIds.includes(shipment.shipment_id)
        );
        const summaries = Object.values(preClaimOrderChatSummariesByThreadId || {})
            .filter(summary => {
                const thread = summary && summary.thread ? summary.thread : null;
                return thread && routeShipments.some(shipment => shipment && shipment.shipment_id === thread.shipment_id);
            })
            .sort((left, right) => {
                const rightTime = new Date(right && right.latest_message && right.latest_message.created_at ? right.latest_message.created_at : 0).getTime();
                const leftTime = new Date(left && left.latest_message && left.latest_message.created_at ? left.latest_message.created_at : 0).getTime();
                return rightTime - leftTime;
            });

        if (summaries.length === 0) {
            return null;
        }

        // Only render as a yellow alert while a driver question is unread; once opened/seen the
        // thread stays viewable but drops the alert styling and badge so it no longer nags.
        const totalUnreadCount = summaries.reduce((count, summary) => {
            const threadKey = buildPreClaimOrderThreadKey(summary && summary.thread ? summary.thread : null);
            return count + (Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0);
        }, 0);
        const hasUnreadQuestions = totalUnreadCount > 0;

        return (
            <div
                style={{
                    margin: '0 20px 16px',
                    padding: '14px 16px',
                    border: hasUnreadQuestions
                        ? '1px solid rgba(245, 197, 66, 0.55)'
                        : `1px solid ${isDarkMode ? 'rgba(255, 255, 255, 0.12)' : '#e3e3e3'}`,
                    borderRadius: '8px',
                    backgroundColor: hasUnreadQuestions
                        ? (isDarkMode ? 'rgba(245, 197, 66, 0.08)' : '#FFF7DB')
                        : (isDarkMode ? 'rgba(255, 255, 255, 0.03)' : '#f7f7f8')
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                    <strong style={{ color: hasUnreadQuestions ? (isDarkMode ? '#F5C542' : '#7A5900') : (isDarkMode ? '#d1d1d1' : '#555') }}>Driver Questions</strong>
                    {renderClaimedOrderUnreadBadge(
                        totalUnreadCount,
                        { backgroundColor: '#D62828', borderColor: '#FFFFFF' }
                    )}
                </div>
                {summaries.map(summary => {
                    const thread = summary && summary.thread ? summary.thread : null;
                    const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
                    const threadKey = buildPreClaimOrderThreadKey(thread);
                    const unreadCount = Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0;

                    return (
                        <div
                            key={threadKey}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: '12px',
                                padding: '10px 0',
                                borderTop: '1px solid rgba(122, 89, 0, 0.12)'
                            }}
                        >
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                    <strong>
                                        Shipment {thread && (thread.shipment_friendly_id || thread.shipment_id)}
                                    </strong>
                                    {unreadCount > 0 ? renderClaimedOrderUnreadBadge(unreadCount, { backgroundColor: '#D62828', borderColor: '#FFFFFF' }) : null}
                                </div>
                                <div style={{ marginTop: '4px', fontSize: '13px', opacity: 0.85 }}>
                                    {latestMessage && latestMessage.body ? latestMessage.body : 'Open thread'}
                                </div>
                            </div>
                            <Button
                                size="sm"
                                className="btn btn-warning"
                                style={{ padding: '5px 10px', margin: 0, whiteSpace: 'nowrap' }}
                                onClick={() => openPreClaimOrderChatSummary(summary)}
                            >
                                Open Thread
                            </Button>
                        </div>
                    );
                })}
            </div>
        );
    };

    const InlinePhoneWithChat = ({ phone, contact, shipment = null, style = {}, useFormattedPhone = true }) => {
        if (!phone && !(shipment && shipment.shipment_id)) {
            return null;
        }

        const usesClaimedOrderThread = shouldUseClaimedOrderThread(contact, shipment);
        const claimedOrderThreadType = contact && contact.chatThreadType ? contact.chatThreadType : 'claimed_order';
        const claimedOrderParticipantAuth0Id = claimedOrderThreadType === 'customer_driver'
            ? resolveCustomerDriverThreadMetadata({ shipment }).chatParticipantAuth0Id
            : (claimedOrderThreadType === 'customer_dispatch' ? resolveShipmentCustomerParticipantAuth0Id(shipment) : '');
        const claimedOrderUnreadCount = usesClaimedOrderThread && shipment && shipment.shipment_id
            ? getClaimedOrderChatUnreadCountForThread({
                shipmentId: shipment.shipment_id,
                threadType: claimedOrderThreadType,
                participantAuth0Id: claimedOrderParticipantAuth0Id,
            })
            : 0;
        const smsUnreadCount = !usesClaimedOrderThread && contact && contact.label === 'Driver'
            ? getSmsUnreadCountForDriver(getDriverContactReference(contact, shipment))
            : 0;
        const unreadCount = claimedOrderUnreadCount + smsUnreadCount;
        const unreadBadgeOptions = smsUnreadCount > 0 && claimedOrderUnreadCount === 0
            ? { backgroundColor: '#D62828', borderColor: '#FFFFFF' }
            : undefined;

        return (
            <p
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: '8px',
                    marginBottom: 0,
                    ...style
                }}
            >
                <span>{phone ? (useFormattedPhone ? formatPhoneNumber(phone) : phone) : 'Claimed order chat'}</span>
                {(shipment && shipment.shipment_id) || (contact && contact.phone) ? (
                    <button
                        type="button"
                        onClick={() => openOrderContactChat(contact, shipment)}
                        title="Open chat"
                        aria-label="Open chat"
                        style={{
                            alignItems: 'center',
                            background: 'transparent',
                            border: 'none',
                            color: '#f7941d',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            justifyContent: 'center',
                            lineHeight: 1,
                            padding: 0,
                            position: 'relative'
                        }}
                    >
                        {unreadCount > 0 ? (
                            <span style={{ position: 'absolute', right: '-10px', top: '-10px' }}>
                                {renderClaimedOrderUnreadBadge(unreadCount, unreadBadgeOptions)}
                            </span>
                        ) : null}
                        <FontAwesomeIcon icon={faComment} style={{ fontSize: '1.3em' }} />
                    </button>
                ) : null}
            </p>
        );
    };

    const getChatDisplayName = contactInfo => {
        if (!contactInfo) {
            return 'Unknown Contact';
        }

        if (contactInfo.chatDisplayName) {
            return contactInfo.chatDisplayName;
        }

        const fallbackName = `${contactInfo.firstname || ''} ${contactInfo.lastname || ''}`.trim();
        return fallbackName || 'Unknown Contact';
    };

    const getChatNameInitials = displayName => String(displayName || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(namePart => namePart.charAt(0).toUpperCase())
        .join('') || 'C';

    const getChatTitle = contactInfo => {
        const role = contactInfo && contactInfo.chatRole ? contactInfo.chatRole : '';

        if (role === 'Order Placer') {
            return 'Order Placed By Chat';
        }

        if (role === 'Pickup') {
            return 'Pickup Location Chat';
        }

        if (role === 'Dropoff') {
            return 'Dropoff Location Chat';
        }

        if (role === 'Driver') {
            return 'Driver Chat';
        }

        if (role === 'Claimed Order') {
            return 'Claimed Order Chat';
        }

        if (role === 'Customer Driver') {
            return 'Customer / Driver Chat';
        }

        if (role === 'Pre-Claim Order') {
            return 'Pre-Claim Order Chat';
        }

        return 'Chat';
    };

    function parseDriverCoordinate(value) {
        if (typeof value === 'number' && Number.isFinite(value)) {
            return value;
        }

        if (typeof value === 'string' && value.trim() !== '') {
            const parsedValue = parseFloat(value);

            if (Number.isFinite(parsedValue)) {
                return parsedValue;
            }
        }

        return null;
    }

    function isValidDriverCoordinate(lat, lng) {
        return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
    }

    function normalizeDriverLocationBlob(locationBlob) {
        if (!locationBlob) {
            return null;
        }

        let normalizedBlob = locationBlob;

        if (typeof normalizedBlob === 'string') {
            try {
                normalizedBlob = JSON.parse(normalizedBlob);
            } catch (error) {
                return null;
            }
        }

        if (!normalizedBlob || typeof normalizedBlob !== 'object') {
            return null;
        }

        // Support GeoJSON-like payloads where coordinates are [lng, lat].
        if ((normalizedBlob.lat === undefined && normalizedBlob.latitude === undefined) && Array.isArray(normalizedBlob.coordinates) && normalizedBlob.coordinates.length >= 2) {
            normalizedBlob = {
                ...normalizedBlob,
                lng: normalizedBlob.coordinates[0],
                lat: normalizedBlob.coordinates[1]
            };
        }

        const nestedLocationBlob = normalizedBlob.location_blob || normalizedBlob.location;
        if ((normalizedBlob.lat === undefined && normalizedBlob.latitude === undefined) && nestedLocationBlob && typeof nestedLocationBlob === 'object') {
            normalizedBlob = {
                ...normalizedBlob,
                ...nestedLocationBlob
            };
        }

        const lat = parseDriverCoordinate(normalizedBlob.lat !== undefined ? normalizedBlob.lat : normalizedBlob.latitude);
        const lng = parseDriverCoordinate(normalizedBlob.lng !== undefined ? normalizedBlob.lng : normalizedBlob.longitude);

        if (lat === null || lng === null || !isValidDriverCoordinate(lat, lng)) {
            return null;
        }

        return {
            ...normalizedBlob,
            lat,
            lng,
            latitude: lat,
            longitude: lng
        };
    }

    const getDriverAddressLocation = driver => {
        const addresses = driver && driver.User && Array.isArray(driver.User.Addresses)
            ? driver.User.Addresses
            : [];

        const addressWithCoordinates = addresses.find(address => {
            const lat = parseDriverCoordinate(address && address.latitude);
            const lng = parseDriverCoordinate(address && address.longitude);

            return lat !== null && lng !== null && isValidDriverCoordinate(lat, lng);
        });

        if (!addressWithCoordinates) {
            return null;
        }

        const lat = parseDriverCoordinate(addressWithCoordinates.latitude);
        const lng = parseDriverCoordinate(addressWithCoordinates.longitude);

        if (lat === null || lng === null || !isValidDriverCoordinate(lat, lng)) {
            return null;
        }

        return {
            lat,
            lng,
            latitude: lat,
            longitude: lng,
            city: addressWithCoordinates.city,
            state: addressWithCoordinates.state,
            address_1: addressWithCoordinates.address_1,
            zip: addressWithCoordinates.zip
        };
    };

    const getPrimaryVehicleType = driver => {
        const selectedVehicle = resolveDriverActiveVehicle(driver);

        return selectedVehicle && selectedVehicle.type ? selectedVehicle.type : '';
    };

    const getDriverStatusValue = useCallback(driver => {
        if (normalizeDriverStatusFlag(driver && driver.is_online) && normalizeDriverStatusFlag(driver && driver.is_available)) {
            return 'available';
        }

        if (normalizeDriverStatusFlag(driver && driver.is_online) && !normalizeDriverStatusFlag(driver && driver.is_available)) {
            return 'enroute';
        }

        return 'unavailable';
    }, []);

    const driverMatchesFilters = useCallback((driver, {
        searchText = '',
        statusFilters = [],
        vehicleFilters = [],
        permitFilters = []
    } = {}) => {
        const normalizedSearchText = String(searchText || '').toLowerCase().trim();
        const normalizedStatusFilters = Array.isArray(statusFilters) ? statusFilters : [];
        const normalizedVehicleFilters = Array.isArray(vehicleFilters) ? vehicleFilters : [];
        const normalizedPermitFilters = Array.isArray(permitFilters) ? permitFilters : [];

        if (normalizedSearchText !== '') {
            const rawUser = driver.User || {};
            const firstName = (rawUser.firstname || rawUser.first_name || driver.firstname || driver.first_name || '').toLowerCase();
            const lastName = (rawUser.lastname || rawUser.last_name || driver.lastname || driver.last_name || '').toLowerCase();
            const fullName = `${firstName} ${lastName}`.trim();
            const phone = (rawUser.phone || driver.phone || '').toLowerCase();
            const normalizedPhone = phone.replace(/\D/g, '');
            const normalizedSearchKeyword = normalizedSearchText.replace(/\D/g, '');
            const driverStatus = getDriverStatusValue(driver);
            const vehicleType = String(getPrimaryVehicleType(driver) || '').toLowerCase();
            const permitValue = String(driver && driver.permit ? driver.permit : '').toLowerCase();
            let textMatch = false;

            if (firstName.includes(normalizedSearchText) || lastName.includes(normalizedSearchText) || fullName.includes(normalizedSearchText)) {
                textMatch = true;
            }

            if (phone.includes(normalizedSearchText)) {
                textMatch = true;
            }

            if (normalizedSearchKeyword !== '' && normalizedPhone.includes(normalizedSearchKeyword)) {
                textMatch = true;
            }

            if (driverStatus.includes(normalizedSearchText) || vehicleType.includes(normalizedSearchText) || permitValue.includes(normalizedSearchText)) {
                textMatch = true;
            }

            if (driver.User.Addresses && driver.User.Addresses.length > 0) {
                const address = driver.User.Addresses[0];
                const market = `${address.city || ''}, ${address.state || ''}`.toLowerCase();
                if (market.includes(normalizedSearchText)) {
                    textMatch = true;
                }
            }

            if (!textMatch) {
                return false;
            }
        }

        if (normalizedStatusFilters.length > 0 && !normalizedStatusFilters.includes(getDriverStatusValue(driver))) {
            return false;
        }

        if (normalizedVehicleFilters.length > 0) {
            const driverVehicleType = String(getPrimaryVehicleType(driver) || '').toLowerCase();
            if (!normalizedVehicleFilters.includes(driverVehicleType)) {
                return false;
            }
        }

        if (normalizedPermitFilters.length > 0) {
            const permitValue = String(driver && driver.permit ? driver.permit : '').toLowerCase();
            if (!normalizedPermitFilters.some(filterValue => permitValue.includes(String(filterValue).toLowerCase()))) {
                return false;
            }
        }

        return true;
    }, [getDriverStatusValue]);

    const getSelectedVehicleForDriver = driver => {
        return resolveDriverActiveVehicle(driver);
    };

    const getDispatchDriverBadgeStatus = driver => {
        if (!driver) {
            return null;
        }

        if (driver.compliance_status) {
            return driver.compliance_status;
        }

        if (driver.banned_by_branch || driver.status === 'inactive') {
            return 'restricted';
        }

        return null;
    };

    const buildAssignedDriverPayload = ({ driver, status: assignmentStatus, distance }) => {
        const selectedVehicle = getSelectedVehicleForDriver(driver);

        if (!selectedVehicle) {
            return null;
        }

        return {
            driver_id: driver.driver_id,
            status: assignmentStatus,
            distance,
            employment_type: driver.employment_type,
            route_id: route.route_id,
            driver_auth0_id: driver.auth0_id,
            driver_blob: {
                first_name: driver.User.firstname,
                last_name: driver.User.lastname,
                user_name: driver.User.username,
                email: driver.User.email,
                phone: driver.User.phone,
                carry_capacity: parseInt(driver.carrying_capacity)
            },
            vehicle_id: selectedVehicle.vehicle_id || driver.active_vehicle || null,
            vehicle_blob: {
                type: selectedVehicle.type,
                make: selectedVehicle.make,
                model: selectedVehicle.model,
                color: selectedVehicle.color,
                year: parseInt(selectedVehicle.year),
                plate_state: selectedVehicle.plate_state,
                plate_value: selectedVehicle.plate_value,
                render_image_url: selectedVehicle.render_image_url || getVehicleRenderUrl(selectedVehicle) || null,
                vehicle_image_url: selectedVehicle.vehicle_image_url || null,
                image_url: getVehicleRenderUrl(selectedVehicle) || null
            }
        };
    };

    const driverHasMapLocation = driver => {
        const lastDriverActions = driver && driver.LastDriverActions;
        const actionList = Array.isArray(lastDriverActions) ? lastDriverActions : (lastDriverActions ? [lastDriverActions] : []);
        const latestActionWithLocation = actionList
            .slice()
            .sort((left, right) => new Date(right && right.timestamp ? right.timestamp : 0) - new Date(left && left.timestamp ? left.timestamp : 0))
            .find(action => normalizeDriverLocationBlob(action && action.location_blob));
        const normalizedLocationBlob = normalizeDriverLocationBlob(latestActionWithLocation && latestActionWithLocation.location_blob);
        const addressLocation = getDriverAddressLocation(driver);

        return Boolean(
            driver && (
                (latestActionWithLocation && normalizedLocationBlob) ||
                addressLocation
            )
        );
    };

    const resolveFocusedDriverRecord = driver => {
        if (!driver) {
            return null;
        }

        const driverUser = driver.User || {};
        const driverBlob = driver.driver_blob || {};
        const candidateValues = [
            driver.driver_id,
            driver.auth0_id,
            driver.user_id,
            driverUser.auth0_id,
            driverUser.user_id,
            driverBlob.driver_id,
            driverBlob.auth0_id,
            driverBlob.user_id,
            driverBlob.phone,
            driver.phone,
            driverUser.phone
        ].filter(Boolean);

        const loadedDrivers = [].concat(availableDriversCopy || [], enrouteDriversCopy || [], offlineDriversCopy || []);

        const matchedDriver = loadedDrivers.find(loadedDriver => {
            const loadedUser = loadedDriver && loadedDriver.User ? loadedDriver.User : {};
            const loadedValues = [
                loadedDriver && loadedDriver.driver_id,
                loadedDriver && loadedDriver.auth0_id,
                loadedDriver && loadedDriver.user_id,
                loadedUser.auth0_id,
                loadedUser.user_id,
                loadedDriver && loadedDriver.phone,
                loadedUser.phone
            ].filter(Boolean);

            return loadedValues.some(value => candidateValues.includes(value));
        });

        if (!matchedDriver) {
            return synchronizeDriverVehicleState(driver);
        }

        if (driverHasMapLocation(matchedDriver) || !driverHasMapLocation(driver)) {
            return synchronizeDriverVehicleState({
                ...driver,
                ...matchedDriver,
                User: matchedDriver && matchedDriver.User ? matchedDriver.User : driver.User,
                Vehicles: matchedDriver && Array.isArray(matchedDriver.Vehicles) && matchedDriver.Vehicles.length > 0 ? matchedDriver.Vehicles : driver.Vehicles,
                LastDriverActions: matchedDriver && matchedDriver.LastDriverActions ? matchedDriver.LastDriverActions : driver.LastDriverActions,
                active_vehicle_details: matchedDriver && matchedDriver.active_vehicle_details ? matchedDriver.active_vehicle_details : driver.active_vehicle_details,
                vehicle_blob: matchedDriver && matchedDriver.vehicle_blob ? matchedDriver.vehicle_blob : driver.vehicle_blob,
                image_url: (matchedDriver && matchedDriver.image_url) || driver.image_url || '',
            });
        }

        return synchronizeDriverVehicleState({
            ...matchedDriver,
            ...driver,
            User: driver.User || matchedDriver.User,
            Vehicles: Array.isArray(driver.Vehicles) && driver.Vehicles.length > 0 ? driver.Vehicles : matchedDriver.Vehicles,
            LastDriverActions: driver.LastDriverActions || matchedDriver.LastDriverActions,
            active_vehicle_details: driver.active_vehicle_details || matchedDriver.active_vehicle_details,
            vehicle_blob: driver.vehicle_blob || matchedDriver.vehicle_blob,
            image_url: driver.image_url || (matchedDriver && matchedDriver.image_url) || '',
        });
    };

    const openDriverChat = driver => {
        if (!driver) {
            return;
        }

        const resolvedDriver = resolveFocusedDriverRecord(driver);

        setRouteClick('');
        setEnrouteClickDriver('');
        setFocusedDriverOnMap(resolvedDriver);

        const rawUser = resolvedDriver && resolvedDriver.User ? resolvedDriver.User : driver.User || {};
        const firstname = rawUser.firstname || rawUser.first_name || driver.firstname || driver.first_name || '';
        const lastname = rawUser.lastname || rawUser.last_name || driver.lastname || driver.last_name || '';
        const phone = rawUser.phone || (resolvedDriver && resolvedDriver.phone) || driver.phone || (driver.driver_blob && driver.driver_blob.phone) || '';

        if (!phone) {
            return;
        }

        const nextRecipientInfo = {
            ...rawUser,
            firstname,
            lastname,
            phone,
            chatDisplayName: `${firstname} ${lastname}`.trim(),
            chatRole: 'Driver',
            chatShipmentFriendlyId: '',
        };
        const startedAt = readOrderChatSessionStart(nextRecipientInfo);

        setMessageRecipientInfo(startedAt ? { ...nextRecipientInfo, chatStartedAt: startedAt } : nextRecipientInfo);
        setShowDriverMessageForm(true);
        retrieveMessage(nextRecipientInfo);

        if (driver.driver_id && driver.unread_message_count > 0) {
            markDriverMessageRead(driver.driver_id, driver.unread_message_count);
        }
    };

    const fetchGasPrice = () => {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query:
                    `{
        Markets (where: {market_id: {_eq: "` +
                    marketIdArray[0] +
                    `"}}) {
          fuel_prices 
          market_name
          market_id
          updated_at
        }
      }`
            }
        })
            .then(response => {
                if (response.data.data) {
                    setGasPrice(response.data.data.Markets[0].fuel_prices.gas_price);
                    setDieselPrice(response.data.data.Markets[0].fuel_prices.diesel_price);
                    setPriceUpdateTime(response.data.data.Markets[0].updated_at);
                    setMarketName(response.data.data.Markets[0].market_name);
                } else if (response.data.errors) {
                    setGasPrice('');
                    setDieselPrice('');
                }
            })
            .catch(() => {
                setGasPrice('');
                setDieselPrice('');
            });
    };

    useEffect(() => {
        if (isSingleMarket) {
            fetchGasPrice();
        }
    }, [marketIdArray, isSingleMarket]);

    const getActiveTabLabel = selectedTab => {
        if (selectedTab === 'pending') {
            return 'Pending';
        }
        if (selectedTab === 'saved') {
            return 'Scheduled';
        }
        if (selectedTab === 'ready') {
            return 'Ready';
        }
        if (selectedTab === 'progressing') {
            return 'In Progress';
        }
        if (selectedTab === 'completed') {
            return 'Completed';
        }

        return '';
    };

    const fetchRegionCountsForActiveTab = () => {
        const allMarketIds = Array.from(new Set(regionDefinitions.flatMap(regionDefinition => regionDefinition.marketIds)));

        const defaultCounts = REGION_ORDER.reduce(
            (counts, regionName) => ({ ...counts, [regionName]: 0 }),
            { [ENTIRE_US_LABEL]: 0 }
        );

        if (allMarketIds.length === 0) {
            setRegionCounts(defaultCounts);
            return;
        }

        const marketIdArrayString = allMarketIds.map(id => `"${id}"`).join(',');
        const baseHeaders = {
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
            'content-type': 'application/json'
        };

        if (isLocalDashboardEnvironment) {
            const nextCounts = { ...defaultCounts };

            if (selected === 'pending' || selected === 'saved') {
                const statuses = selected === 'pending' ? PENDING_SHIPMENT_STATUSES : SCHEDULED_SHIPMENT_STATUSES;
                const sourceShipments = (effectiveShipmentSubscriptionData && effectiveShipmentSubscriptionData.Shipments) || [];

                sourceShipments.forEach(shipmentRecord => {
                    if (!statuses.includes(shipmentRecord.status) || !isDispatchVisibleShipment(shipmentRecord)) {
                        return;
                    }

                    const marketMetadata = marketLookup[shipmentRecord.market_id];
                    if (!marketMetadata || !nextCounts.hasOwnProperty(marketMetadata.regionName)) {
                        return;
                    }

                    nextCounts[marketMetadata.regionName] += 1;
                    nextCounts[ENTIRE_US_LABEL] += 1;
                });

                setRegionCounts(nextCounts);
                return;
            }

            if (selected === 'ready' || selected === 'progressing' || selected === 'completed') {
                const statuses = selected === 'ready' ? READY_ROUTE_STATUSES : selected === 'progressing' ? PROGRESSING_ROUTE_STATUSES : COMPLETED_ROUTE_STATUSES;
                const sourceRoutes = (effectiveRouteSubscriptionData && effectiveRouteSubscriptionData.Routes) || [];

                sourceRoutes.forEach(routeRecord => {
                    if (!statuses.includes(routeRecord.status) || !isDispatchVisibleRoute(routeRecord)) {
                        return;
                    }

                    const marketMetadata = marketLookup[routeRecord.market_id];
                    if (!marketMetadata || !nextCounts.hasOwnProperty(marketMetadata.regionName)) {
                        return;
                    }

                    nextCounts[marketMetadata.regionName] += 1;
                    nextCounts[ENTIRE_US_LABEL] += 1;
                });

                setRegionCounts(nextCounts);

                if (selected === 'ready') {
                    setTotalAmountReady(nextCounts[ENTIRE_US_LABEL]);
                }

                if (selected === 'progressing') {
                    setTotalAmountDelivering(nextCounts[ENTIRE_US_LABEL]);
                }

                return;
            }

            setRegionCounts(nextCounts);
            return;
        }

        if (selected === 'pending' || selected === 'saved') {
            const statuses = selected === 'pending' ? PENDING_SHIPMENT_STATUSES : SCHEDULED_SHIPMENT_STATUSES;
            const statusList = statuses.map(status => `"${status}"`).join(',');

            axios({
                method: 'post',
                headers: baseHeaders,
                url: shipment_urls.hasuraHost,
                data: {
                    query: `{
                        Shipments(where: {
                            _and: [
                                { market_id: { _in: [${marketIdArrayString}] } }
                                { deleted_at: { _is_null: true } }
                                { status: { _in: [${statusList}] } }
                            ]
                        }) {
                            shipment_id
                            market_id
                            shipping_fee_blob
                        }
                    }`
                }
            })
                .then(response => {
                    if (!(response && response.data && response.data.data)) {
                        return;
                    }

                    const nextCounts = { ...defaultCounts };
                    response.data.data.Shipments.forEach(shipmentRecord => {
                        if (!isDispatchVisibleShipment(shipmentRecord)) {
                            return;
                        }

                        const marketMetadata = marketLookup[shipmentRecord.market_id];

                        if (!marketMetadata || !nextCounts.hasOwnProperty(marketMetadata.regionName)) {
                            return;
                        }

                        nextCounts[marketMetadata.regionName] += 1;
                        nextCounts[ENTIRE_US_LABEL] += 1;
                    });

                    setRegionCounts(nextCounts);
                })
                .catch(() => {
                    setRegionCounts(defaultCounts);
                });

            return;
        }

        if (selected === 'completed') {
            const nextCounts = { ...defaultCounts };
            const sourceRoutes = (effectiveRouteSubscriptionData && effectiveRouteSubscriptionData.Routes) || [];

            sourceRoutes.forEach(routeRecord => {
                if (!COMPLETED_ROUTE_STATUSES.includes(routeRecord.status) || !isDispatchVisibleRoute(routeRecord)) {
                    return;
                }

                const marketMetadata = marketLookup[routeRecord.market_id];
                if (!marketMetadata || !nextCounts.hasOwnProperty(marketMetadata.regionName)) {
                    return;
                }

                nextCounts[marketMetadata.regionName] += 1;
                nextCounts[ENTIRE_US_LABEL] += 1;
            });

            setRegionCounts(nextCounts);
            return;
        }

        if (selected === 'ready' || selected === 'progressing') {
            const statuses = selected === 'ready' ? READY_ROUTE_STATUSES : selected === 'progressing' ? PROGRESSING_ROUTE_STATUSES : COMPLETED_ROUTE_STATUSES;
            const statusList = statuses.map(status => `"${status}"`).join(',');
            const completedFilter = `{ status: { _in: [${statusList}] } }`;

            axios({
                method: 'post',
                headers: baseHeaders,
                url: shipment_urls.hasuraHost,
                data: {
                    query: `{
                        Routes(where: {
                            _and: [
                                { market_id: { _in: [${marketIdArrayString}] } }
                                { deleted_at: { _is_null: true } }
                                ${completedFilter}
                            ]
                        }) {
                            route_id
                            market_id
                            status
                            Shipments {
                                status
                                shipping_fee_blob
                                Orders {
                                    status
                                }
                            }
                        }
                    }`
                }
            })
                .then(response => {
                    if (!(response && response.data && response.data.data)) {
                        return;
                    }

                    const nextCounts = { ...defaultCounts };
                    response.data.data.Routes.forEach(routeRecord => {
                        if (!isDispatchVisibleRoute(routeRecord)) {
                            return;
                        }

                        const marketMetadata = marketLookup[routeRecord.market_id];

                        if (!marketMetadata || !nextCounts.hasOwnProperty(marketMetadata.regionName)) {
                            return;
                        }

                        nextCounts[marketMetadata.regionName] += 1;
                        nextCounts[ENTIRE_US_LABEL] += 1;
                    });

                    setRegionCounts(nextCounts);

                    if (selected === 'ready') {
                        setTotalAmountReady(nextCounts[ENTIRE_US_LABEL]);
                    }

                    if (selected === 'progressing') {
                        setTotalAmountDelivering(nextCounts[ENTIRE_US_LABEL]);
                    }
                })
                .catch(() => {
                    setRegionCounts(defaultCounts);
                });

            return;
        }

        setRegionCounts(defaultCounts);
    };

    useEffect(() => {
        fetchRegionCountsForActiveTab();
        const interval = setInterval(fetchRegionCountsForActiveTab, 30000);
        return () => clearInterval(interval);
    }, [selected, regionDefinitions, marketLookup, isLocalDashboardEnvironment, effectiveShipmentSubscriptionData, effectiveRouteSubscriptionData]);

    const fetchNationalRouteTotals = () => {
        if (isLocalDashboardEnvironment) {
            const sourceRoutes = (effectiveRouteSubscriptionData && effectiveRouteSubscriptionData.Routes) || [];
            let nextReadyCount = 0;
            let nextDeliveringCount = 0;

            sourceRoutes.forEach(routeRecord => {
                if (!isDispatchVisibleRoute(routeRecord)) {
                    return;
                }

                if (READY_ROUTE_STATUSES.includes(routeRecord.status)) {
                    nextReadyCount += 1;
                }

                if (PROGRESSING_ROUTE_STATUSES.includes(routeRecord.status)) {
                    nextDeliveringCount += 1;
                }
            });

            setTotalAmountReady(nextReadyCount);
            setTotalAmountDelivering(nextDeliveringCount);
            return;
        }

        const allMarketIds = Array.from(new Set(regionDefinitions.flatMap(regionDefinition => regionDefinition.marketIds)));

        if (allMarketIds.length === 0) {
            return;
        }

        const marketIdArrayString = allMarketIds.map(id => `"${id}"`).join(',');

        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query: `{
                    Routes(where: {
                        _and: [
                            { market_id: { _in: [${marketIdArrayString}] } }
                            { deleted_at: { _is_null: true } }
                            { status: { _in: ["route_ready", "route_temp_claimed", "route_claimed", "route_assigned", "route_enroute"] } }
                        ]
                    }) {
                        route_id
                        status
                        Shipments {
                            status
                            shipping_fee_blob
                            Orders {
                                status
                            }
                        }
                    }
                }`
            }
        })
            .then(response => {
                if (!(response && response.data && response.data.data)) {
                    return;
                }

                let nextReadyCount = 0;
                let nextDeliveringCount = 0;

                response.data.data.Routes.forEach(routeRecord => {
                    if (!isDispatchVisibleRoute(routeRecord)) {
                        return;
                    }

                    if (READY_ROUTE_STATUSES.includes(routeRecord.status)) {
                        nextReadyCount += 1;
                    }

                    if (PROGRESSING_ROUTE_STATUSES.includes(routeRecord.status)) {
                        nextDeliveringCount += 1;
                    }
                });

                setTotalAmountReady(nextReadyCount);
                setTotalAmountDelivering(nextDeliveringCount);
            })
            .catch(() => {
                setTotalAmountReady(0);
                setTotalAmountDelivering(0);
            });
    };

    useEffect(() => {
        fetchNationalRouteTotals();
        const interval = setInterval(fetchNationalRouteTotals, 30000);
        return () => clearInterval(interval);
    }, [regionDefinitions, isLocalDashboardEnvironment, effectiveRouteSubscriptionData]);

    const fetchRegionAndMarketGasPrice = () => {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query:
                    `{
            Regions (where: {region_id: {_eq: "` +
                    regionId +
                    `"}}) {
            region_name
            gas_price
            diesel_price
            updated_at
            Markets {
              fuel_prices 
              market_name
              market_id
              updated_at
            }
         }
      }`
            }
        })
            .then(response => {
                if (response.data.data) {
                    setRegion(response.data.data.Regions[0]);
                } else if (response.data.errors) {
                    setRegion(null);
                }
            })
            .catch(() => {
                setRegion(null);
            });
    };

    // Load the region-level fuel price whenever a region (not a single city) is selected,
    // so the inline fuel display can show it — the price is uniform across the region's cities.
    useEffect(() => {
        if (!isSingleMarket && regionId) {
            fetchRegionAndMarketGasPrice();
        }
    }, [regionId, isSingleMarket]);

    const fetchMarketNote = () => {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query:
                    `{
        Markets (where: {market_id: {_eq: "` +
                    marketIdArray[0] +
                    `"}}) {
          market_name
          note
        }
      }`
            }
        })
            .then(response => {
                if (response.data.data) {
                    setMarketNote(response.data.data.Markets[0]);
                } else if (response.data.errors) {
                    setMarketNote(null);
                }
            })
            .catch(() => {
                setMarketNote(null);
            });
    };

    const fetchRegionAndMarketNote = () => {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query:
                    `{
            Regions (where: {region_id: {_eq: "` +
                    regionId +
                    `"}}) {
            region_name
            Markets {
              market_name
              note
            }
         }
      }`
            }
        })
            .then(response => {
                if (response.data.data) {
                    setRegionNote(response.data.data.Regions[0]);
                } else if (response.data.errors) {
                    setRegionNote(null);
                }
            })
            .catch(error => {
                void error;
                setRegionNote(null);
            });
    };

    const buildFlatMarketOptions = markets => {
        return (markets || []).map(market => ({
            value: {
                id: market.market_id,
                coordinates: {
                    latitude: Array.isArray(market.center) ? market.center[0] : 30.23119,
                    longitude: Array.isArray(market.center) ? market.center[1] : -93.21163,
                },
                scopeType: 'market',
                depth: 1,
            },
            label: market.market_name,
        }));
    };

    const buildRegionHierarchy = superRegions => {
        const regionsByName = {};
        const nextMarketLookup = {};

        (superRegions || []).forEach(superRegion => {
            (superRegion.Regions || []).forEach(region => {
                const canonicalRegionName = canonicalizeRegionName(region.region_name);

                if (!REGION_ORDER.includes(canonicalRegionName)) {
                    return;
                }

                if (!regionsByName[canonicalRegionName]) {
                    regionsByName[canonicalRegionName] = {
                        id: region.region_id,
                        name: canonicalRegionName,
                        marketIds: [],
                        markets: [],
                        latitudeTotal: 0,
                        longitudeTotal: 0
                    };
                }

                (region.Markets || []).forEach(market => {
                    if (!market || !market.market_id) {
                        return;
                    }

                    const latitude = Array.isArray(market.center) ? market.center[0] : DEFAULT_COUNTRY_COORDINATES.latitude;
                    const longitude = Array.isArray(market.center) ? market.center[1] : DEFAULT_COUNTRY_COORDINATES.longitude;

                    regionsByName[canonicalRegionName].marketIds.push(market.market_id);
                    regionsByName[canonicalRegionName].markets.push({
                        id: market.market_id,
                        name: market.market_name,
                        coordinates: { latitude, longitude }
                    });
                    regionsByName[canonicalRegionName].latitudeTotal += latitude;
                    regionsByName[canonicalRegionName].longitudeTotal += longitude;
                    nextMarketLookup[market.market_id] = {
                        marketName: market.market_name,
                        regionName: canonicalRegionName,
                        coordinates: { latitude, longitude }
                    };
                });
            });
        });

        const nextRegionDefinitions = REGION_ORDER.map(regionName => regionsByName[regionName])
            .filter(Boolean)
            .map(region => ({
                id: region.id,
                name: region.name,
                marketIds: Array.from(new Set(region.marketIds)),
                markets: region.markets.sort((left, right) => left.name.localeCompare(right.name)),
                coordinates: region.marketIds.length
                    ? {
                          latitude: region.latitudeTotal / region.marketIds.length,
                          longitude: region.longitudeTotal / region.marketIds.length
                      }
                    : DEFAULT_COUNTRY_COORDINATES
            }));

        const allMarketIds = Array.from(new Set(nextRegionDefinitions.flatMap(region => region.marketIds)));
        const nextOptions = [
            {
                value: {
                    id: 'entire-us',
                    idArray: allMarketIds,
                    coordinates: DEFAULT_COUNTRY_COORDINATES,
                    scopeType: 'country',
                    depth: 0,
                    regionName: ENTIRE_US_LABEL
                },
                label: ENTIRE_US_LABEL
            }
        ];

        nextRegionDefinitions.forEach(region => {
            nextOptions.push({
                value: {
                    id: region.id,
                    idArray: region.marketIds,
                    coordinates: region.coordinates,
                    scopeType: 'region',
                    depth: 1,
                    regionName: region.name
                },
                label: region.name
            });

            region.markets.forEach(market => {
                nextOptions.push({
                    value: {
                        id: market.id,
                        coordinates: market.coordinates,
                        scopeType: 'market',
                        depth: 2,
                        regionName: region.name
                    },
                    label: market.name
                });
            });
        });

        return { options: nextOptions, regions: nextRegionDefinitions, marketLookup: nextMarketLookup };
    };

    const fetchFlatMarkets = () => {
        return axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query: `{
                    Markets(where: {deleted_at: {_is_null: true}}, order_by: {market_name: asc}) {
                        market_name
                        center
                        market_id
                    }
                }`
            }
        }).then(res => {
            const markets = res && res.data && res.data.data && Array.isArray(res.data.data.Markets)
                ? res.data.data.Markets
                : [];

            setMarketAndRegionOptions(buildFlatMarketOptions(markets));
        });
    };

    function fetchMarketAndRegions() {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query: `{
          SuperRegions(order_by: {super_region_name: asc}) {
            super_region_name
            super_region_id
            Regions (order_by: {region_name: asc}){
              region_name
              region_id
              Markets (order_by: {market_name: asc}){
                market_name
                center       
                market_id
              }
            }
          }
        }`
            }
        })
            .then(res => {
                //! need to think region and superRegion center could be set in db, right now just average from markets for region, and set center hard code for US
                const superRegions = res && res.data && res.data.data && Array.isArray(res.data.data.SuperRegions)
                    ? res.data.data.SuperRegions
                    : [];

                if (superRegions.length === 0) {
                    return fetchFlatMarkets();
                }

                const { options: finalOptions, regions: nextRegionDefinitions, marketLookup: nextMarketLookup } = buildRegionHierarchy(superRegions);
                if (finalOptions.length === 0) {
                    return fetchFlatMarkets();
                }

                setRegionDefinitions(nextRegionDefinitions);
                setMarketLookup(nextMarketLookup);
                setMarketAndRegionOptions(finalOptions);
            })
            .catch(error => {
                handleDispatchUnauthorizedError(error);
                setDispatchDriversDebug(previous => ({
                    ...(previous || {}),
                    lastMarketsError: String((error && (error.code || (error.response && error.response.status) || error.message)) || 'unknown'),
                }));
                void error;
                fetchFlatMarkets().catch(flatMarketsError => {
                    handleDispatchUnauthorizedError(flatMarketsError);
                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        lastMarketsError: String((flatMarketsError && (flatMarketsError.code || (flatMarketsError.response && flatMarketsError.response.status) || flatMarketsError.message)) || 'unknown'),
                    }));
                    void flatMarketsError;
                });
            });
    }
    useEffect(() => {
        fetchMarketAndRegions();
    }, []);

    const memoizedOptions = useMemo(() => marketAndRegionOptions, [marketAndRegionOptions]);
    const activeTabLabel = getActiveTabLabel(selected);

    const getShipmentOriginLabel = shipmentRecord => {
        return getLocationDisplay(getShipmentOriginLocation(shipmentRecord));
    };

    const getRouteOriginLabel = routeRecord => {
        return getLocationDisplay(getRouteOriginLocation(routeRecord));
    };

    const filteredShipmentsToDisplay = useMemo(() => {
        const sourceShipments = effectiveShipmentSubscriptionData && Array.isArray(effectiveShipmentSubscriptionData.Shipments)
            ? effectiveShipmentSubscriptionData.Shipments
            : [];
        const selectedStatuses = selected === 'saved'
            ? SCHEDULED_SHIPMENT_STATUSES
            : selected === 'pending'
            ? PENDING_SHIPMENT_STATUSES
            : null;
        const shipmentRows = selectedStatuses
            ? sourceShipments.filter(shipmentRecord =>
                shipmentRecord && selectedStatuses.includes(shipmentRecord.status) && isDispatchVisibleShipment(shipmentRecord)
            )
            : shipmentsToDisplay;

        if (!cityStateQuery) {
            return shipmentRows;
        }

        return shipmentRows.filter(shipmentRecord =>
            matchesCityStateQuery(extractShipmentLocations(shipmentRecord), cityStateQuery, [getShipmentOriginLabel(shipmentRecord)])
        );
    }, [effectiveShipmentSubscriptionData, shipmentsToDisplay, selected, cityStateQuery, marketLookup]);

    const scheduledShipmentsVisibleCount = useMemo(() => {
        const scheduledBadgeData = adminDispatchShipmentFallbackData || effectiveShipmentSubscriptionData;
        const sourceShipments = scheduledBadgeData && Array.isArray(scheduledBadgeData.Shipments)
            ? scheduledBadgeData.Shipments
            : [];

        return sourceShipments.filter(shipmentRecord => {
            if (!shipmentRecord || !SCHEDULED_SHIPMENT_STATUSES.includes(shipmentRecord.status) || !isDispatchVisibleShipment(shipmentRecord)) {
                return false;
            }

            if (!cityStateQuery) {
                return true;
            }

            return matchesCityStateQuery(extractShipmentLocations(shipmentRecord), cityStateQuery, [getShipmentOriginLabel(shipmentRecord)]);
        }).length;
    }, [adminDispatchShipmentFallbackData, cityStateQuery, effectiveShipmentSubscriptionData, marketLookup]);

    const filteredRoutesToDisplay = useMemo(() => {
        const sourceRoutes = routeListSourceData && Array.isArray(routeListSourceData.Routes)
            ? routeListSourceData.Routes
            : [];
        const selectedStatuses = selected === 'ready'
            ? READY_ROUTE_STATUSES
            : selected === 'progressing'
            ? PROGRESSING_ROUTE_STATUSES
            : null;
        const routeRows = selectedStatuses
            ? sourceRoutes.filter(routeRecord =>
                routeRecord && selectedStatuses.includes(routeRecord.status) && isDispatchVisibleRoute(routeRecord)
            )
            : routesToDisplay;

        if (!cityStateQuery) {
            return routeRows;
        }

        return routeRows.filter(routeRecord =>
            matchesCityStateQuery(extractRouteLocations(routeRecord), cityStateQuery, [getRouteOriginLabel(routeRecord)])
        );
    }, [routeListSourceData, routesToDisplay, selected, cityStateQuery, marketLookup]);

    const deliveringClaimedOrderChatShipmentIds = useMemo(() => {
        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes)
            ? effectiveRouteSubscriptionData.Routes
            : [];
        const nextShipmentIds = new Set();

        routeRecords.forEach(routeRecord => {
            if (!routeRecord || !PROGRESSING_ROUTE_STATUSES.includes(routeRecord.status) || !isDispatchVisibleRoute(routeRecord)) {
                return;
            }

            getRouteShipments(routeRecord).forEach(shipmentRecord => {
                if (shipmentRecord && shipmentRecord.shipment_id) {
                    nextShipmentIds.add(shipmentRecord.shipment_id);
                }
            });
        });

        return Array.from(nextShipmentIds);
    }, [effectiveRouteSubscriptionData]);

    const trackedClaimedOrderChatShipmentIds = useMemo(() => {
        const nextShipmentIds = new Set();

        deliveringClaimedOrderChatShipmentIds.forEach(shipmentId => {
            if (shipmentId) {
                nextShipmentIds.add(shipmentId);
            }
        });

        if (selected === 'ready' || selected === 'progressing' || selected === 'completed') {
            filteredRoutesToDisplay.forEach(routeRecord => {
                getRouteShipments(routeRecord).forEach(shipmentRecord => {
                    if (shipmentRecord && shipmentRecord.shipment_id) {
                        nextShipmentIds.add(shipmentRecord.shipment_id);
                    }
                });
            });
        }

        filteredShipmentsToDisplay.forEach(shipmentRecord => {
            if (shipmentRecord && shipmentRecord.shipment_id) {
                nextShipmentIds.add(shipmentRecord.shipment_id);
            }
        });

        if (messageRecipientInfo && messageRecipientInfo.chatMode === 'order-thread' && messageRecipientInfo.chatShipmentId) {
            nextShipmentIds.add(messageRecipientInfo.chatShipmentId);
        }

        return Array.from(nextShipmentIds);
    }, [deliveringClaimedOrderChatShipmentIds, filteredRoutesToDisplay, filteredShipmentsToDisplay, messageRecipientInfo, selected]);

    const readyPreClaimOrderChatShipmentIds = useMemo(() => {
        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes)
            ? effectiveRouteSubscriptionData.Routes
            : [];
        const nextShipmentIds = new Set();

        routeRecords.forEach(routeRecord => {
            // Keep pre-claim driver chats visible/answerable through the route's active life
            // (ready AND assigned/claimed/enroute), so a pre-claim question doesn't vanish once the
            // load is assigned.
            const isTrackablePreClaimStatus = routeRecord
                && (READY_ROUTE_STATUSES.includes(routeRecord.status) || PROGRESSING_ROUTE_STATUSES.includes(routeRecord.status));
            if (!isTrackablePreClaimStatus || !isDispatchVisibleRoute(routeRecord)) {
                return;
            }

            getRouteShipments(routeRecord).forEach(shipmentRecord => {
                if (isPreClaimChatTrackedShipment(shipmentRecord)) {
                    nextShipmentIds.add(shipmentRecord.shipment_id);
                }
            });
        });

        return Array.from(nextShipmentIds);
    }, [effectiveRouteSubscriptionData]);

    const readyOnlyPreClaimOrderChatShipmentIds = useMemo(() => {
        const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes)
            ? effectiveRouteSubscriptionData.Routes
            : [];
        const nextShipmentIds = new Set();

        routeRecords.forEach(routeRecord => {
            // Ready-TAB badge must reflect ONLY ready routes; once a load is assigned/enroute it
            // belongs to Delivering, so its pre-claim unread shouldn't light up the Ready tab.
            if (!routeRecord || !READY_ROUTE_STATUSES.includes(routeRecord.status) || !isDispatchVisibleRoute(routeRecord)) {
                return;
            }

            getRouteShipments(routeRecord).forEach(shipmentRecord => {
                if (isPreClaimChatTrackedShipment(shipmentRecord)) {
                    nextShipmentIds.add(shipmentRecord.shipment_id);
                }
            });
        });

        return Array.from(nextShipmentIds);
    }, [effectiveRouteSubscriptionData]);

    const savedPreClaimOrderChatShipmentIds = useMemo(() => {
        const shipmentRecords = effectiveShipmentSubscriptionData && Array.isArray(effectiveShipmentSubscriptionData.Shipments)
            ? effectiveShipmentSubscriptionData.Shipments
            : [];

        return Array.from(new Set(
            shipmentRecords
                .filter(shipmentRecord => (
                    shipmentRecord &&
                    shipmentRecord.shipment_id &&
                    isDispatchVisibleShipment(shipmentRecord) &&
                    SCHEDULED_SHIPMENT_STATUSES.includes(shipmentRecord.status)
                ))
                .map(shipmentRecord => shipmentRecord.shipment_id)
        ));
    }, [effectiveShipmentSubscriptionData]);

    const trackedPreClaimOrderChatShipmentIds = useMemo(() => {
        const nextShipmentIds = new Set();

        readyPreClaimOrderChatShipmentIds.forEach(shipmentId => {
            if (shipmentId) {
                nextShipmentIds.add(shipmentId);
            }
        });

        savedPreClaimOrderChatShipmentIds.forEach(shipmentId => {
            if (shipmentId) {
                nextShipmentIds.add(shipmentId);
            }
        });

        // Track pre-claim driver chats for every route currently displayed (any tab: ready,
        // progressing, or completed) so the questions stay visible, not only on the ready board.
        filteredRoutesToDisplay.forEach(routeRecord => {
            getRouteShipments(routeRecord).forEach(shipmentRecord => {
                if (isPreClaimChatTrackedShipment(shipmentRecord)) {
                    nextShipmentIds.add(shipmentRecord.shipment_id);
                }
            });
        });

        if (selected === 'saved') {
            filteredShipmentsToDisplay.forEach(shipmentRecord => {
                if (
                    shipmentRecord &&
                    shipmentRecord.shipment_id &&
                    SCHEDULED_SHIPMENT_STATUSES.includes(shipmentRecord.status)
                ) {
                    nextShipmentIds.add(shipmentRecord.shipment_id);
                }
            });
        }

        if (messageRecipientInfo && messageRecipientInfo.chatMode === 'preclaim-order-thread' && messageRecipientInfo.chatShipmentId) {
            nextShipmentIds.add(messageRecipientInfo.chatShipmentId);
        }

        return Array.from(nextShipmentIds);
    }, [filteredRoutesToDisplay, filteredShipmentsToDisplay, messageRecipientInfo, readyPreClaimOrderChatShipmentIds, savedPreClaimOrderChatShipmentIds, selected]);

    const deliveringTabUnreadCount = useMemo(
        () => Object.values(claimedOrderChatSummariesByShipmentId || {}).reduce((count, summary) => {
            const thread = summary && summary.thread ? summary.thread : null;
            const threadKey = buildClaimedOrderThreadKey(thread);

            if (!thread || !threadKey || !deliveringClaimedOrderChatShipmentIds.includes(thread.shipment_id)) {
                return count;
            }

            return count + (Number(claimedOrderChatUnreadCountsByShipmentId[threadKey]) || 0);
        }, 0),
        [claimedOrderChatSummariesByShipmentId, claimedOrderChatUnreadCountsByShipmentId, deliveringClaimedOrderChatShipmentIds]
    );

    const readyTabUnreadCount = useMemo(
        () => Object.values(preClaimOrderChatSummariesByThreadId || {}).reduce((count, summary) => {
            const thread = summary && summary.thread ? summary.thread : null;
            const threadKey = buildPreClaimOrderThreadKey(thread);

            if (!thread || !readyOnlyPreClaimOrderChatShipmentIds.includes(thread.shipment_id)) {
                return count;
            }

            return count + (Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0);
        }, 0),
        [preClaimOrderChatSummariesByThreadId, preClaimOrderChatUnreadCountsByThreadId, readyOnlyPreClaimOrderChatShipmentIds]
    );

    const savedTabUnreadCount = useMemo(
        () => Object.values(preClaimOrderChatSummariesByThreadId || {}).reduce((count, summary) => {
            const thread = summary && summary.thread ? summary.thread : null;
            const threadKey = buildPreClaimOrderThreadKey(thread);

            if (!thread || !savedPreClaimOrderChatShipmentIds.includes(thread.shipment_id)) {
                return count;
            }

            return count + (Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0);
        }, 0),
        [preClaimOrderChatSummariesByThreadId, preClaimOrderChatUnreadCountsByThreadId, savedPreClaimOrderChatShipmentIds]
    );

    useEffect(() => {
        const previousUnreadCount = Number(previousDeliveringTabUnreadCountRef.current) || 0;

        if (deliveringTabUnreadCount > previousUnreadCount) {
            playChatNotificationSound();
        }

        previousDeliveringTabUnreadCountRef.current = deliveringTabUnreadCount;
    }, [deliveringTabUnreadCount]);

    useEffect(() => {
        const previousUnreadCount = Number(previousReadyTabUnreadCountRef.current) || 0;

        if (readyTabUnreadCount > previousUnreadCount) {
            playChatNotificationSound();
        }

        previousReadyTabUnreadCountRef.current = readyTabUnreadCount;
    }, [readyTabUnreadCount]);

    useEffect(() => {
        setClaimedOrderChatSeenByShipmentId(readClaimedOrderChatSeenMap(SUB));
    }, [SUB]);

    useEffect(() => {
        setPreClaimOrderChatSeenByThreadId(readPreClaimOrderChatSeenMap(SUB));
    }, [SUB]);

    useEffect(() => {
        const fallbackAdminDisplayName = getAuthProfileDisplayName(CURRENT_USER_AUTH) || 'Dispatch';

        if (!SUB) {
            setCurrentAdminDisplayName(fallbackAdminDisplayName);
            return undefined;
        }

        let cancelled = false;

        axios({
            method: 'post',
            url: user_urls.hasuraHost,
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            data: {
                query: `query LoadCurrentDispatchUser($identifier: String!, $email: String!) {
                    Users(
                        where: {
                            _or: [
                                { auth0_id: { _eq: $identifier } }
                                { email: { _eq: $email } }
                            ]
                        }
                        limit: 1
                    ) {
                        firstname
                        lastname
                        username
                        email
                    }
                }`,
                variables: {
                    identifier: SUB,
                    email: CURRENT_USER_AUTH.email || ''
                }
            }
        })
            .then(response => {
                if (cancelled) {
                    return;
                }

                const users = response && response.data && response.data.data && Array.isArray(response.data.data.Users)
                    ? response.data.data.Users
                    : [];
                const resolvedName = getUserRecordDisplayName(users[0]) || fallbackAdminDisplayName;
                setCurrentAdminDisplayName(resolvedName || 'Dispatch');
            })
            .catch(() => {
                if (!cancelled) {
                    setCurrentAdminDisplayName(fallbackAdminDisplayName);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [SUB, CURRENT_USER_AUTH.email, CURRENT_USER_AUTH.name, CURRENT_USER_AUTH.given_name, CURRENT_USER_AUTH.family_name, CURRENT_USER_AUTH.nickname]);

    const getLatestPreClaimOrderChatSummaryForShipment = useCallback(
        shipmentId => {
            if (!shipmentId) {
                return null;
            }

            return Object.values(preClaimOrderChatSummariesByThreadId || {}).reduce((latestSummary, summary) => {
                const thread = summary && summary.thread ? summary.thread : null;
                const latestMessage = summary && summary.latest_message ? summary.latest_message : null;

                if (!thread || thread.shipment_id !== shipmentId || !thread.driver_auth0_id) {
                    return latestSummary;
                }

                if (!latestSummary) {
                    return summary;
                }

                const latestSummaryTimestamp = new Date(latestSummary.latest_message && latestSummary.latest_message.created_at ? latestSummary.latest_message.created_at : 0).getTime();
                const summaryTimestamp = new Date(latestMessage && latestMessage.created_at ? latestMessage.created_at : 0).getTime();

                return summaryTimestamp > latestSummaryTimestamp ? summary : latestSummary;
            }, null);
        },
        [preClaimOrderChatSummariesByThreadId]
    );

    const getPreClaimOrderChatUnreadCountForShipment = useCallback(
        shipmentId => Object.values(preClaimOrderChatSummariesByThreadId || {}).reduce((count, summary) => {
            const thread = summary && summary.thread ? summary.thread : null;

            if (!thread || thread.shipment_id !== shipmentId) {
                return count;
            }

            const threadKey = buildPreClaimOrderThreadKey(thread);
            return count + (Number(preClaimOrderChatUnreadCountsByThreadId[threadKey]) || 0);
        }, 0),
        [preClaimOrderChatSummariesByThreadId, preClaimOrderChatUnreadCountsByThreadId]
    );

    const markPreClaimOrderChatSeen = useCallback(
        (threadKey, messageId) => {
            if (!threadKey || !messageId) {
                return;
            }

            setPreClaimOrderChatUnreadCountsByThreadId(currentValue => {
                if (!currentValue[threadKey]) {
                    return currentValue;
                }

                return {
                    ...currentValue,
                    [threadKey]: 0,
                };
            });

            setPreClaimOrderChatSeenByThreadId(currentValue => {
                if (currentValue[threadKey] === messageId) {
                    return currentValue;
                }

                const nextValue = {
                    ...currentValue,
                    [threadKey]: messageId,
                };

                persistPreClaimOrderChatSeenMap(SUB, nextValue);
                return nextValue;
            });
        },
        [SUB]
    );

    useEffect(() => {
        if (!currentAdminDisplayName) {
            return;
        }

        setMessageRecipientInfo(currentValue => {
            if (!(currentValue && (currentValue.chatMode === 'order-thread' || currentValue.chatMode === 'preclaim-order-thread'))) {
                return currentValue;
            }

            if (currentValue.chatAdminDisplayName === currentAdminDisplayName) {
                return currentValue;
            }

            return {
                ...currentValue,
                chatAdminDisplayName: currentAdminDisplayName
            };
        });
    }, [currentAdminDisplayName]);

    const markClaimedOrderChatSeen = useCallback(
        (threadKey, messageId) => {
            if (!threadKey || !messageId) {
                return;
            }

            setClaimedOrderChatUnreadCountsByShipmentId(currentValue => {
                if (!currentValue[threadKey]) {
                    return currentValue;
                }

                return {
                    ...currentValue,
                    [threadKey]: 0,
                };
            });

            setClaimedOrderChatSeenByShipmentId(currentValue => {
                if (currentValue[threadKey] === messageId) {
                    return currentValue;
                }

                const nextValue = {
                    ...currentValue,
                    [threadKey]: messageId
                };

                persistClaimedOrderChatSeenMap(SUB, nextValue);
                return nextValue;
            });
        },
        [SUB]
    );

    const driverSmsUnreadLookup = useMemo(() => {
        return (Array.isArray(driversToSMS) ? driversToSMS : []).reduce(
            (lookup, driverRecord) => {
                const unreadCount = Number(driverRecord && driverRecord.unread_message_count) || 0;

                if (unreadCount <= 0) {
                    return lookup;
                }

                if (driverRecord && driverRecord.driver_id) {
                    lookup.byDriverId[driverRecord.driver_id] = unreadCount;
                }

                const normalizedPhone = normalizePhoneForChat(
                    (driverRecord && driverRecord.phone) ||
                    (driverRecord && driverRecord.User && driverRecord.User.phone) ||
                    ''
                );

                if (normalizedPhone) {
                    lookup.byPhone[normalizedPhone] = Math.max(lookup.byPhone[normalizedPhone] || 0, unreadCount);
                }

                return lookup;
            },
            { byDriverId: {}, byPhone: {} }
        );
    }, [driversToSMS]);

    useEffect(() => {
        if (!claimedOrderChatSummariesSupported) {
            setClaimedOrderChatSummariesByShipmentId({});
            return undefined;
        }

        if (trackedClaimedOrderChatShipmentIds.length === 0) {
            setClaimedOrderChatSummariesByShipmentId({});
            return undefined;
        }

        let cancelled = false;

        const syncClaimedOrderChatSummaries = () => {
            if (dispatchSessionRecoveryPromiseRef.current) {
                return;
            }

            const shipmentIdBatches = [];

            for (let index = 0; index < trackedClaimedOrderChatShipmentIds.length; index += CLAIMED_ORDER_CHAT_SUMMARY_BATCH_SIZE) {
                shipmentIdBatches.push(trackedClaimedOrderChatShipmentIds.slice(index, index + CLAIMED_ORDER_CHAT_SUMMARY_BATCH_SIZE));
            }

            Promise.all(
                shipmentIdBatches.flatMap(shipmentIds => CLAIMED_ORDER_CHAT_SUMMARY_THREAD_TYPES.map(threadType => axios({
                    method: 'get',
                    headers: {
                        Authorization: buildAuthorizationHeader(),
                        'content-type': 'application/json'
                    },
                    url: `${claimedOrderChatSummariesEndpoint}?shipment_ids=${encodeURIComponent(shipmentIds.join(','))}${getClaimedOrderChatThreadTypeParam(threadType) ? `&thread_type=${encodeURIComponent(getClaimedOrderChatThreadTypeParam(threadType))}` : ''}`
                })))
            )
                .then(responses => {
                    if (cancelled) {
                        return;
                    }

                    if (!responses.every(response => response && response.data && response.data.status === 'successful')) {
                        setClaimedOrderChatSummariesByShipmentId({});
                        return;
                    }

                    const summaries = responses.flatMap((response, responseIndex) => {
                        const responseSummaries = response && response.data && response.data.payload && Array.isArray(response.data.payload.summaries)
                            ? response.data.payload.summaries
                            : [];
                        const requestedThreadType = CLAIMED_ORDER_CHAT_SUMMARY_THREAD_TYPES[
                            responseIndex % CLAIMED_ORDER_CHAT_SUMMARY_THREAD_TYPES.length
                        ];

                        return responseSummaries
                            .map(summary => normalizeClaimedOrderChatSummary(summary, requestedThreadType))
                            .filter(Boolean);
                    });

                    const nextSummariesByShipmentId = summaries.reduce((lookup, summary) => {
                        const threadKey = buildClaimedOrderThreadKey(summary && summary.thread ? summary.thread : null);

                        if (threadKey) {
                            lookup[threadKey] = summary;
                        }

                        return lookup;
                    }, {});

                    setClaimedOrderChatSummariesByShipmentId(nextSummariesByShipmentId);
                    setClaimedOrderChatUnreadCountsByShipmentId(currentValue => {
                        const nextUnreadCountsByShipmentId = {};
                        const previousMessageIdsByShipmentId = previousClaimedOrderChatMessageIdsRef.current || {};
                        const countedMessageIdsByShipmentId = countedClaimedOrderChatMessageIdsRef.current || {};
                        const nextCountedMessageIdsByShipmentId = { ...countedMessageIdsByShipmentId };

                        summaries.forEach(summary => {
                            const thread = summary && summary.thread ? summary.thread : null;
                            const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
                            const shipmentId = thread && thread.shipment_id ? thread.shipment_id : '';
                            const threadKey = buildClaimedOrderThreadKey(thread);
                            const latestMessageId = latestMessage && latestMessage.message_id ? latestMessage.message_id : '';
                            const previousMessageId = threadKey ? previousMessageIdsByShipmentId[threadKey] : '';
                            const seenMessageId = threadKey ? claimedOrderChatSeenByShipmentId[threadKey] : '';
                            const isIncomingMessage = latestMessage
                                ? latestMessage.direction
                                    ? latestMessage.direction === 'received'
                                    : latestMessage.sender_role === 'driver'
                                : false;

                            if (!shipmentId || !threadKey || !latestMessageId || !isIncomingMessage || seenMessageId === latestMessageId) {
                                if (threadKey) {
                                    nextUnreadCountsByShipmentId[threadKey] = 0;
                                    nextCountedMessageIdsByShipmentId[threadKey] = seenMessageId || latestMessageId || '';
                                }
                                return;
                            }

                            const currentUnreadCount = Number(currentValue[threadKey]) || 0;
                            const countedMessageId = threadKey ? countedMessageIdsByShipmentId[threadKey] : '';
                            const hasObservedNewLatestMessage = Boolean(previousMessageId) && previousMessageId !== latestMessageId;

                            if (hasObservedNewLatestMessage && countedMessageId !== latestMessageId) {
                                nextUnreadCountsByShipmentId[threadKey] = currentUnreadCount + 1;
                                nextCountedMessageIdsByShipmentId[threadKey] = latestMessageId;
                                return;
                            }

                            nextUnreadCountsByShipmentId[threadKey] = currentUnreadCount > 0 ? currentUnreadCount : 1;
                            nextCountedMessageIdsByShipmentId[threadKey] = countedMessageId || latestMessageId;
                        });

                        countedClaimedOrderChatMessageIdsRef.current = nextCountedMessageIdsByShipmentId;

                        return nextUnreadCountsByShipmentId;
                    });
                })
                .catch(fetchError => {
                    if (!cancelled) {
                        if (handleDispatchUnauthorizedError(fetchError)) {
                            return;
                        }

                        if (isUnavailableOptionalDispatchEndpoint(fetchError)) {
                            cacheMissingOptionalDispatchEndpoint(claimedOrderChatSummariesEndpoint);
                            setClaimedOrderChatSummariesSupported(false);
                        }
                        setClaimedOrderChatSummariesByShipmentId({});
                        setClaimedOrderChatUnreadCountsByShipmentId({});
                    }
                });
        };

        syncClaimedOrderChatSummaries();
        const intervalId = window.setInterval(syncClaimedOrderChatSummaries, CLAIMED_ORDER_CHAT_POLL_INTERVAL_MS);

        return () => {
            cancelled = true;
            window.clearInterval(intervalId);
        };
    }, [claimedOrderChatSummariesSupported, trackedClaimedOrderChatShipmentIds]);

    useEffect(() => {
        if (!preClaimOrderChatSummariesSupported) {
            setPreClaimOrderChatSummariesByThreadId({});
            setPreClaimOrderChatUnreadCountsByThreadId({});
            previousPreClaimOrderChatMessageIdsRef.current = {};
            countedPreClaimOrderChatMessageIdsRef.current = {};
            return undefined;
        }

        if (trackedPreClaimOrderChatShipmentIds.length === 0) {
            setPreClaimOrderChatSummariesByThreadId({});
            setPreClaimOrderChatUnreadCountsByThreadId({});
            previousPreClaimOrderChatMessageIdsRef.current = {};
            countedPreClaimOrderChatMessageIdsRef.current = {};
            return undefined;
        }

        let cancelled = false;

        const syncPreClaimOrderChatSummaries = () => {
            if (dispatchSessionRecoveryPromiseRef.current) {
                return;
            }

            const shipmentIdBatches = [];

            for (let index = 0; index < trackedPreClaimOrderChatShipmentIds.length; index += CLAIMED_ORDER_CHAT_SUMMARY_BATCH_SIZE) {
                shipmentIdBatches.push(trackedPreClaimOrderChatShipmentIds.slice(index, index + CLAIMED_ORDER_CHAT_SUMMARY_BATCH_SIZE));
            }

            Promise.all(
                shipmentIdBatches.map(shipmentIds => axios({
                    method: 'get',
                    headers: {
                        Authorization: buildAuthorizationHeader(),
                        'content-type': 'application/json'
                    },
                    url: `${preClaimOrderChatSummariesEndpoint}?shipment_ids=${encodeURIComponent(shipmentIds.join(','))}`
                }))
            )
                .then(responses => {
                    if (cancelled) {
                        return;
                    }

                    if (!responses.every(response => response && response.data && response.data.status === 'successful')) {
                        setPreClaimOrderChatSummariesByThreadId({});
                        return;
                    }

                    const summaries = responses
                        .flatMap(response => (
                            response && response.data && response.data.payload && Array.isArray(response.data.payload.summaries)
                                ? response.data.payload.summaries
                                : []
                        ))
                        .map(normalizePreClaimOrderChatSummary)
                        .filter(Boolean);

                    const nextSummariesByThreadId = summaries.reduce((lookup, summary) => {
                        const thread = summary && summary.thread ? summary.thread : null;
                        const threadKey = buildPreClaimOrderThreadKey(thread);

                        if (threadKey) {
                            lookup[threadKey] = summary;
                        }

                        return lookup;
                    }, {});

                    setPreClaimOrderChatSummariesByThreadId(nextSummariesByThreadId);
                    setPreClaimOrderChatUnreadCountsByThreadId(currentValue => {
                        const nextUnreadCountsByThreadId = {};
                        const previousMessageIdsByThreadId = previousPreClaimOrderChatMessageIdsRef.current || {};
                        const countedMessageIdsByThreadId = countedPreClaimOrderChatMessageIdsRef.current || {};
                        const nextCountedMessageIdsByThreadId = { ...countedMessageIdsByThreadId };

                        summaries.forEach(summary => {
                            const thread = summary && summary.thread ? summary.thread : null;
                            const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
                            const threadKey = buildPreClaimOrderThreadKey(thread);
                            const latestMessageId = latestMessage && latestMessage.message_id ? latestMessage.message_id : '';
                            const previousMessageId = threadKey ? previousMessageIdsByThreadId[threadKey] : '';
                            const seenMessageId = threadKey ? preClaimOrderChatSeenByThreadId[threadKey] : '';
                            const isIncomingMessage = latestMessage
                                ? latestMessage.direction
                                    ? latestMessage.direction === 'received'
                                    : latestMessage.sender_role === 'driver'
                                : false;

                            if (!threadKey || !latestMessageId || !isIncomingMessage || seenMessageId === latestMessageId) {
                                if (threadKey) {
                                    nextUnreadCountsByThreadId[threadKey] = 0;
                                    nextCountedMessageIdsByThreadId[threadKey] = seenMessageId || latestMessageId || '';
                                }
                                return;
                            }

                            const currentUnreadCount = Number(currentValue[threadKey]) || 0;
                            const countedMessageId = countedMessageIdsByThreadId[threadKey] || '';
                            const hasObservedNewLatestMessage = Boolean(previousMessageId) && previousMessageId !== latestMessageId;

                            if (hasObservedNewLatestMessage && countedMessageId !== latestMessageId) {
                                nextUnreadCountsByThreadId[threadKey] = currentUnreadCount + 1;
                                nextCountedMessageIdsByThreadId[threadKey] = latestMessageId;
                                return;
                            }

                            nextUnreadCountsByThreadId[threadKey] = currentUnreadCount > 0 ? currentUnreadCount : 1;
                            nextCountedMessageIdsByThreadId[threadKey] = countedMessageId || latestMessageId;
                        });

                        previousPreClaimOrderChatMessageIdsRef.current = summaries.reduce((lookup, summary) => {
                            const thread = summary && summary.thread ? summary.thread : null;
                            const latestMessage = summary && summary.latest_message ? summary.latest_message : null;
                            const threadKey = buildPreClaimOrderThreadKey(thread);

                            if (threadKey && latestMessage && latestMessage.message_id) {
                                lookup[threadKey] = latestMessage.message_id;
                            }

                            return lookup;
                        }, {});
                        countedPreClaimOrderChatMessageIdsRef.current = nextCountedMessageIdsByThreadId;

                        return nextUnreadCountsByThreadId;
                    });
                })
                .catch(error => {
                    if (!cancelled) {
                        if (handleDispatchUnauthorizedError(error)) {
                            return;
                        }

                        if (isUnavailableOptionalDispatchEndpoint(error)) {
                            cacheMissingOptionalDispatchEndpoint(preClaimOrderChatSummariesEndpoint);
                            setPreClaimOrderChatSummariesSupported(false);
                            setPreClaimOrderChatSummariesByThreadId({});
                            setPreClaimOrderChatUnreadCountsByThreadId({});
                            return;
                        }

                        setPreClaimOrderChatSummariesByThreadId({});
                        setPreClaimOrderChatUnreadCountsByThreadId({});
                    }
                });
        };

        syncPreClaimOrderChatSummaries();
        const intervalId = window.setInterval(syncPreClaimOrderChatSummaries, CLAIMED_ORDER_CHAT_POLL_INTERVAL_MS);

        return () => {
            cancelled = true;
            window.clearInterval(intervalId);
        };
    }, [preClaimOrderChatSeenByThreadId, preClaimOrderChatSummariesSupported, trackedPreClaimOrderChatShipmentIds]);

    const getClaimedOrderChatUnreadCountForShipment = useCallback(
        shipmentId => {
            if (!shipmentId) {
                return 0;
            }

            return Object.values(claimedOrderChatSummariesByShipmentId || {}).reduce((count, summary) => {
                const thread = summary && summary.thread ? summary.thread : null;
                const threadKey = buildClaimedOrderThreadKey(thread);

                if (!thread || thread.shipment_id !== shipmentId || !threadKey) {
                    return count;
                }

                return count + (Number(claimedOrderChatUnreadCountsByShipmentId[threadKey]) || 0);
            }, 0);
        },
        [claimedOrderChatSummariesByShipmentId, claimedOrderChatUnreadCountsByShipmentId]
    );

    const getClaimedOrderChatUnreadCountForThread = useCallback(
        ({ shipmentId = '', threadType = 'claimed_order', participantAuth0Id = '' } = {}) => {
            const threadKey = buildClaimedOrderThreadKey({
                shipment_id: shipmentId,
                thread_type: threadType,
                participant_auth0_id: participantAuth0Id,
            });

            if (!threadKey) {
                return 0;
            }

            return Number(claimedOrderChatUnreadCountsByShipmentId[threadKey]) || 0;
        },
        [claimedOrderChatUnreadCountsByShipmentId]
    );

    const getSmsUnreadCountForDriver = useCallback(
        ({ driverId = '', phone = '' } = {}) => {
            const normalizedPhone = normalizePhoneForChat(phone);

            if (driverId && driverSmsUnreadLookup.byDriverId[driverId]) {
                return driverSmsUnreadLookup.byDriverId[driverId];
            }

            if (normalizedPhone && driverSmsUnreadLookup.byPhone[normalizedPhone]) {
                return driverSmsUnreadLookup.byPhone[normalizedPhone];
            }

            return 0;
        },
        [driverSmsUnreadLookup]
    );

    const getSmsUnreadCountForShipment = useCallback(
        shipment => getSmsUnreadCountForDriver(getShipmentDriverReference(shipment)),
        [getShipmentDriverReference, getSmsUnreadCountForDriver]
    );

    const getTotalChatUnreadCountForShipment = useCallback(
        shipment => {
            if (!shipment) {
                return 0;
            }

            const claimedOrderUnreadCount = getClaimedOrderChatUnreadCountForShipment(shipment.shipment_id || '');
            const smsUnreadCount = getSmsUnreadCountForShipment(shipment);

            return claimedOrderUnreadCount + smsUnreadCount;
        },
        [getClaimedOrderChatUnreadCountForShipment, getSmsUnreadCountForShipment]
    );

    const getClaimedOrderChatUnreadCountForRoute = useCallback(
        route => getRouteShipments(route).reduce((count, shipmentRecord) => {
            const shipmentId = shipmentRecord && shipmentRecord.shipment_id ? shipmentRecord.shipment_id : '';
            return count + getClaimedOrderChatUnreadCountForShipment(shipmentId);
        }, 0),
        [getClaimedOrderChatUnreadCountForShipment]
    );

    const getSmsUnreadCountForRoute = useCallback(
        route => {
            const seenDriverKeys = new Set();

            return getRouteShipments(route).reduce((count, shipmentRecord) => {
                const driverReference = getShipmentDriverReference(shipmentRecord);
                const driverKey = driverReference.driverId || normalizePhoneForChat(driverReference.phone);

                if (!driverKey || seenDriverKeys.has(driverKey)) {
                    return count;
                }

                seenDriverKeys.add(driverKey);
                return count + getSmsUnreadCountForDriver(driverReference);
            }, 0);
        },
        [getShipmentDriverReference, getSmsUnreadCountForDriver]
    );

    const renderClaimedOrderUnreadBadge = (unreadCount, options = {}) => {
        if (!unreadCount) {
            return null;
        }

        const {
            backgroundColor = '#12233D',
            borderColor = '#FFF',
        } = options;

        return (
            <span
                style={{
                    alignItems: 'center',
                    backgroundColor,
                    border: `2px solid ${borderColor}`,
                    borderRadius: '999px',
                    color: '#FFF',
                    display: 'inline-flex',
                    fontSize: '11px',
                    fontWeight: 700,
                    height: '20px',
                    justifyContent: 'center',
                    minWidth: '20px',
                    padding: '0 6px'
                }}
            >
                {unreadCount > 9 ? '9+' : unreadCount}
            </span>
        );
    };

    const renderClaimedOrderRouteLabel = routeRecord => {
        const preClaimUnreadCount = getRouteShipments(routeRecord).reduce(
            (count, shipmentRecord) => count + getPreClaimOrderChatUnreadCountForShipment(shipmentRecord && shipmentRecord.shipment_id),
            0
        );
        const unreadCount = getClaimedOrderChatUnreadCountForRoute(routeRecord) + getSmsUnreadCountForRoute(routeRecord) + preClaimUnreadCount;

        return (
            <div style={{ alignItems: 'center', display: 'inline-flex', flexWrap: 'wrap', gap: '8px', textAlign: 'left' }}>
                <span>
                    {routeRecord.route_friendly_id}--
                    {routeRecord.Shipments.map((ship, index) => {
                        return index !== 0 ? `/${ship.shipment_friendly_id}` : ship.shipment_friendly_id;
                    })}
                </span>
                {renderClaimedOrderUnreadBadge(unreadCount, { backgroundColor: '#D62828', borderColor: '#FFFFFF' })}
            </div>
        );
    };

    const allDispatchMarketIds = useMemo(() => Array.from(new Set(regionDefinitions.flatMap(regionDefinition => regionDefinition.marketIds))), [regionDefinitions]);
    const dispatchDriverMarketScopeIds = useMemo(() => {
        if (Array.isArray(marketIdArray) && marketIdArray.length > 0) {
            return marketIdArray;
        }

        if (Array.isArray(allDispatchMarketIds) && allDispatchMarketIds.length > 0) {
            return allDispatchMarketIds;
        }

        return [];
    }, [marketIdArray, allDispatchMarketIds]);

    // A scheduled shipment leaving the saved tab (e.g. force-ready) shows up as a
    // route change, not always in the shipment subscription, so refetch the saved
    // REST fallback when routes change too.
    const routeSubscriptionSignature = useMemo(() => {
        if (!dataRoute || !Array.isArray(dataRoute.Routes)) {
            return '';
        }
        return dataRoute.Routes
            .map(routeRecord => `${routeRecord && routeRecord.route_id}:${routeRecord && routeRecord.status}`)
            .sort()
            .join('|');
    }, [dataRoute]);

    useEffect(() => {
        if (
            isLocalDashboardEnvironment ||
            !liveSubscriptionsEnabled ||
            dispatchDriverMarketScopeIds.length === 0
        ) {
            setAdminDispatchShipmentFallbackData(null);
            return undefined;
        }

        let cancelled = false;

        axios({
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminDispatchShipments,
            params: {
                market_ids: dispatchDriverMarketScopeIds.join(','),
            },
        })
            .then(response => {
                if (cancelled) {
                    return;
                }

                const payload = response && response.data && Array.isArray(response.data.payload)
                    ? response.data.payload
                    : [];
                // REST (Sequelize underscored) serializes auto-timestamps as camelCase;
                // alias to snake_case so date display/sort/staleness match the GraphQL shape.
                const normalizedPayload = payload.map(shipment => (shipment && typeof shipment === 'object'
                    ? {
                        ...shipment,
                        created_at: shipment.created_at || shipment.createdAt || null,
                        updated_at: shipment.updated_at || shipment.updatedAt || null,
                    }
                    : shipment));
                setAdminDispatchShipmentFallbackData({ Shipments: normalizedPayload });
            })
            .catch(fetchError => {
                if (!cancelled) {
                    console.error('Unable to load the admin Dispatch shipment fallback', fetchError);
                    setAdminDispatchShipmentFallbackData(null);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [dispatchDriverMarketScopeIds, isLocalDashboardEnvironment, liveSubscriptionsEnabled, shipmentSubscriptionSignature, routeSubscriptionSignature]);

    const isEntireUsSelection = useMemo(() => {
        if (!Array.isArray(marketIdArray) || marketIdArray.length === 0) {
            return false;
        }

        if (allDispatchMarketIds.length === 0 || marketIdArray.length !== allDispatchMarketIds.length) {
            return false;
        }

        const selectedIds = new Set(marketIdArray);
        return allDispatchMarketIds.every(marketIdValue => selectedIds.has(marketIdValue));
    }, [allDispatchMarketIds, marketIdArray]);

    const filteredMergingRoutes = useMemo(() => {
        const normalizedSelectedMarketIds = new Set(Array.isArray(marketIdArray) ? marketIdArray : []);
        const baseRoutes = cityStateQuery
            ? mergingRoutes.filter(routeRecord =>
                  matchesCityStateQuery(extractRouteLocations(routeRecord), cityStateQuery, [getRouteOriginLabel(routeRecord)])
              )
            : isEntireUsSelection
            ? mergingRoutes
            : mergingRoutes.filter(routeRecord => {
                  if (normalizedSelectedMarketIds.size === 0) {
                      return false;
                  }

                  if (routeRecord && routeRecord.market_id && normalizedSelectedMarketIds.has(routeRecord.market_id)) {
                      return true;
                  }

                  return getRouteShipments(routeRecord).some(shipmentRecord => shipmentRecord && normalizedSelectedMarketIds.has(shipmentRecord.market_id));
              });

        if (!cityStateQuery) {
            return baseRoutes;
        }

        return baseRoutes;
    }, [mergingRoutes, cityStateQuery, marketLookup, marketIdArray, isEntireUsSelection]);

    const deriveMergingRoutesFromRouteRecords = useCallback(
        routeRecords => (Array.isArray(routeRecords) ? routeRecords.filter(routeRecord => routeRecord && routeRecord.status === 'route_temp_claimed_dispatch') : []),
        []
    );

    const resetGasPricesInput = () => {
        setGasPriceUpdate('');
        setDieselPriceUpdate('');
    };

    const handleGasPriceUpdate = (gasPrice, dieselPrice) => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/admins/markets/' + marketId + '/fuel_prices/update',
            data: { gas_price: gasPrice, diesel_price: dieselPrice }
        })
            .then(response => {
                props.notify('tc', 'Fuel Prices Successfully Updated');
                fetchGasPrice();
                toggleGasPrice();
                resetGasPricesInput();
            })
            .catch(() => {
                props.notify('tc', 'Failed to update fuel prices', 'danger');
            });
    };

    const handleGasPriceUpdateThroughRegion = (gasPrice, dieselPrice) => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/admins/regions/' + regionId + '/fuel_prices/update',
            data: { gas_price: gasPrice, diesel_price: dieselPrice }
        })
            .then(response => {
                props.notify('tc', 'Fuel Prices Successfully Updated');
                // fetchGasPrice();
                toggleGasPriceRegion();
                resetGasPricesInput();
            })
            .catch(() => {
                props.notify('tc', 'Failed to update regional fuel prices', 'danger');
            });
    };

    const handleMarketNoteUpdate = note => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/admins/markets/' + marketId + '/note/update',
            data: { note }
        })
            .then(response => {
                props.notify('tc', 'Market Note Successfully Updated');
                toggleMarketNote();
                setMarketNoteUpdate('');
            })
            .catch(() => {
                props.notify('tc', 'Failed to update market note', 'danger');
            });
    };

    const handleMarketNoteUpdateThroughRegion = note => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/admins/regions/' + regionId + '/note/update',
            data: { note }
        })
            .then(response => {
                props.notify('tc', 'Market Notes Successfully Updated');
                toggleMarketNoteRegion();
                setMarketNoteUpdate('');
            })
            .catch(() => {
                props.notify('tc', 'Failed to update regional market note', 'danger');
            });
    };

    const handleOrderETAUpdate = (order, eta) => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/admins/shipments/' + order.shipment_id + '/orders/' + order.order_id + '/eta-update',
            data: { estimated_arrival_time: eta }
        })
            .then(response => {
                props.notify('tc', 'Order ETA Successfully Updated');
            })
            .catch(() => {
                props.notify('tc', 'Failed to update order ETA', 'danger');
            });
    };

    const DriverList = ({ driver }) => {
        const user = driver && driver.User ? driver.User : {};
        const vehicles = driver && Array.isArray(driver.Vehicles) ? driver.Vehicles : [];
        const primaryVehicle = vehicles.length === 0
            ? null
            : vehicles.find(vehicle => vehicle.vehicle_id === driver.active_vehicle) || vehicles[0];
        const vehicleLabel = primaryVehicle && primaryVehicle.type ? capitalize(primaryVehicle.type.replace(/_/, ' ')) : 'Unknown';
        const driverPlatform = driver && driver.User && Array.isArray(driver.User.FCMTokens) && driver.User.FCMTokens.length > 0
            ? String(driver.User.FCMTokens[0].platform || '').toLowerCase()
            : null;
        const platformIcon = driverPlatform === 'ios' ? '🍎' : driverPlatform === 'android' ? '🤖' : null;

        return (
            <p>
                {' '}
                {user.firstname || ''} {user.lastname || ''} {'  -  '} {vehicleLabel}{' '}
                {platformIcon && <span style={{ fontSize: 10 }}>{platformIcon}</span>}
                <span style={{ float: 'right', fontSize: 8 }}>{driver.is_online && driver.is_available ? '🟢 ' : driver.is_online && !driver.is_available ? '🟠 ' : '⚪️'}</span>
            </p>
        );
    };
    const toggle = () => {
        setModal(!modal);
        setPrimaryDriver('');
        setDriverSelected(false);
        setPassenger1('');
        setPassenger1Selected(false);
        setPassenger2('');
        setPassenger2Selected(false);
    };

    const toggleReassign = () => {
        setModalReassign(!modalReassign);
        setDriverReassign('');
        setDriverReassignSelected(false);
    };

    const toggleAssignPassengerOnly = () => {
        setModalAssignPassengerOnly(!modalAssignPassengerOnly);
        setPassenger1OnlyAssigned('');
        setPassenger1OnlyAssignedSelected(false);
        setPassenger2OnlyAssigned('');
        setPassenger2OnlyAssignedSelected(false);
    };

    const DeliveryDescription = ({ shipment }) => {
        return (
            <>
                <strong>Delivery Description</strong>
                {shipment.description.includes('{') &&
                shipment.description.includes('[') &&
                shipment.description.includes(':') &&
                shipment.description.includes('quantity') &&
                shipment.description.includes('detail') ? (
                    JSON.parse(shipment.description).map((de, index) => {
                        return (
                            <React.Fragment key={de.id || `${de.detail || 'detail'}-${de.quantity || 0}-${index}`}>
                                <p style={{ wordSpacing: '2px' }}>
                                    {de.quantity} -- {de.detail}
                                </p>
                                <div style={{ marginLeft: '5px' }}>
                                    {/* Check if the properties exist before rendering */}
                                    {de.weight && <p>Weight: {de.weight}</p>}
                                    {de.height && <p>Height: {de.height}</p>}
                                    {de.width && <p>Width: {de.width}</p>}
                                    {de.length && <p>Length: {de.length}</p>}
                                    {de.stackable !== undefined && <p>Stackable: {de.stackable ? 'Yes' : 'No'}</p>}
                                    {de.nmfc && <p>NMFC: {de.nmfc}</p>}
                                </div>
                            </React.Fragment>
                        );
                    })
                ) : (
                    <p> {shipment.description}</p>
                )}

                {isFedexShipment(shipment) && (
                    <>
                        <p>
                            Tracking Number:{' '}
                            <a
                                href={`https://www.fedex.com/fedextrack/?trknbr=${shipment.fedex_data.output.transactionShipments[0].pieceResponses[0].trackingNumber}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'white', textDecoration: 'underline' }}
                            >
                                {shipment.fedex_data.output.transactionShipments[0].pieceResponses[0].trackingNumber}
                            </a>
                        </p>
                        <div>
                            <Button
                                color="info"
                                onClick={() => {
                                    setSelectedShipmentId(shipment.shipment_id);
                                    setShowFedexLabel(true);
                                }}
                                style={{ marginTop: '10px' }}
                            >
                                <i className="fas fa-print me-3"></i>
                                &nbsp;Print FedEx Label
                            </Button>
                        </div>
                        <div>
                            <Button
                                color="success"
                                onClick={() => {
                                    setSelectedShipmentId(shipment.shipment_id);
                                    setShowTracking(true);
                                }}
                                style={{ marginTop: '10px' }}
                            >
                                <i className="fas fa-truck me-2"></i>
                                &nbsp;Track Package
                            </Button>
                        </div>
                    </>
                )}
            </>
        );
    };

    const AIRecommendation = ({ shipment }) => {
        if (!shipment.ai_recommendation) {
            return null;
        }

        return (
            <>
                <Col className="col-3" style={{ textAlign: 'left' }}>
                    <strong>AI Recommendation</strong>
                    <p>{shipment.ai_recommendation.recommendation}</p>
                    {shipment.ai_recommendation.recommended_weight !== shipment.ai_recommendation.selected_weight && (
                        <p>
                            <i className="fas fa-flag text-danger"></i> Recommended Weight: {shipment.ai_recommendation.recommended_weight}
                        </p>
                    )}
                    {shipment.ai_recommendation.recommended_vehicle_type !== shipment.ai_recommendation.selected_vehicle_type && (
                        <p>
                            <i className="fas fa-flag text-danger"></i> Recommended Vehicle: {shipment.ai_recommendation.recommended_vehicle_type}
                        </p>
                    )}
                </Col>
            </>
        );
    };

    const getCustomerQuoteRange = shipment => {
        const feeBlob = shipment && shipment.shipping_fee_blob && typeof shipment.shipping_fee_blob === 'object'
            ? shipment.shipping_fee_blob
            : {};
        const calculatedBlob = feeBlob.calculated && typeof feeBlob.calculated === 'object'
            ? feeBlob.calculated
            : {};
        const quoteBlob = feeBlob.quote_blob && typeof feeBlob.quote_blob === 'object'
            ? feeBlob.quote_blob
            : {};
        const nestedQuote = feeBlob.quote && typeof feeBlob.quote === 'object'
            ? feeBlob.quote
            : {};
        const nestedQuoteCalculated = nestedQuote.calculated && typeof nestedQuote.calculated === 'object'
            ? nestedQuote.calculated
            : {};
        const quoteBlobCalculated = quoteBlob.calculated && typeof quoteBlob.calculated === 'object'
            ? quoteBlob.calculated
            : {};

        const rangeCandidates = [
            calculatedBlob.shipping_fee_range,
            calculatedBlob.shipping_fee_range_standard,
            calculatedBlob.shipping_fee_range_expedited,
            calculatedBlob.shipping_fee_range_super_expedited,
            nestedQuote.shipping_fee_range,
            nestedQuoteCalculated.shipping_fee_range,
            nestedQuoteCalculated.shipping_fee_range_standard,
            quoteBlob.shipping_fee_range,
            quoteBlobCalculated.shipping_fee_range,
            quoteBlobCalculated.shipping_fee_range_standard,
            feeBlob.shipping_fee_range,
            shipment && shipment.shipping_fee_range,
        ];

        const normalizedRange = rangeCandidates.reduce((matchedRange, range) => {
            if (matchedRange) {
                return matchedRange;
            }

            if (!range) {
                return null;
            }

            const min = Number(range.min);
            const max = Number(range.max);

            if (!Number.isFinite(min) || !Number.isFinite(max)) {
                return null;
            }

            return { min, max };
        }, null);

        return normalizedRange;
    };

    const formatQuoteRange = range => {
        if (!range) {
            return '';
        }

        const min = Number(range.min);
        const max = Number(range.max);

        if (!Number.isFinite(min) || !Number.isFinite(max)) {
            return '';
        }

        return `$${min.toFixed(2)}--$${max.toFixed(2)}`;
    };

    const LoadDetails = ({ shipment, route = null }) => {
        const resolvedRoute = useMemo(() => {
            if (!route || !route.route_id || !routesData || !Array.isArray(routesData.Routes)) {
                return route;
            }

            return routesData.Routes.find(candidate => candidate && candidate.route_id === route.route_id) || route;
        }, [route, routesData]);
        const resolvedShipment = useMemo(() => {
            if (resolvedRoute && Array.isArray(resolvedRoute.Shipments)) {
                const matchedRouteShipment = resolvedRoute.Shipments.find(candidate => candidate && candidate.shipment_id === shipment.shipment_id);

                if (matchedRouteShipment) {
                    return matchedRouteShipment;
                }
            }

            if (shipmentsData && Array.isArray(shipmentsData.Shipments)) {
                const matchedShipment = shipmentsData.Shipments.find(candidate => candidate && candidate.shipment_id === shipment.shipment_id);

                if (matchedShipment) {
                    return matchedShipment;
                }
            }

            return shipment;
        }, [resolvedRoute, shipment, shipmentsData]);
        const detailShipment = resolvedShipment || shipment;
        const blob = getShipmentFeeBlob(detailShipment);
        const shipInfo = blob && blob.shipment && typeof blob.shipment === 'object' ? blob.shipment : {};
        const demurrage = detailShipment.billing_details && detailShipment.billing_details.demurrage ? detailShipment.billing_details.demurrage : null;
        const liveDemurrageClockContext = useMemo(
            () => getLiveDemurrageClockContext(detailShipment, resolvedRoute, demurrage, shipInfo),
            [detailShipment, resolvedRoute, demurrage, shipInfo]
        );
        const [liveDemurrageNowMs, setLiveDemurrageNowMs] = useState(() => Date.now());
        const demurrageApplication = demurrage && demurrage.application ? demurrage.application : null;
        useEffect(() => {
            if (!liveDemurrageClockContext) {
                return undefined;
            }

            setLiveDemurrageNowMs(Date.now());
            const intervalId = window.setInterval(() => {
                setLiveDemurrageNowMs(Date.now());
            }, 30000);

            return () => {
                window.clearInterval(intervalId);
            };
        }, [liveDemurrageClockContext]);
        const hasPendingDemurrageReviewForShipment = hasPendingDemurrageReview(detailShipment);
        const demurrageReviewPromptKey = useMemo(() => buildDemurrageReviewPromptKey(detailShipment), [detailShipment]);

        useEffect(() => {
            if (!detailShipment || !detailShipment.shipment_id) {
                return;
            }

            if (!hasPendingDemurrageReviewForShipment) {
                clearDemurrageReviewPromptKeysForShipment(autoPromptedDemurrageReviewKeysRef.current, detailShipment.shipment_id);
                return;
            }

            if (!demurrageReviewPromptKey || autoPromptedDemurrageReviewKeysRef.current.has(demurrageReviewPromptKey)) {
                return;
            }

            autoPromptedDemurrageReviewKeysRef.current.add(demurrageReviewPromptKey);
            setShipment(detailShipment);
            setDemurrageDecisionNotes('');
            setShowDemurrageReviewModal(true);
        }, [detailShipment, demurrageReviewPromptKey, hasPendingDemurrageReviewForShipment]);
        const liveWaitMinutes = useMemo(() => {
            const arrivalTimestamp = liveDemurrageClockContext && liveDemurrageClockContext.arrivalAt
                ? parseLiveDemurrageTimestamp(liveDemurrageClockContext.arrivalAt)
                : null;

            if (!arrivalTimestamp) {
                return null;
            }

            return Math.max(0, Math.floor((liveDemurrageNowMs - arrivalTimestamp.getTime()) / 60000));
        }, [liveDemurrageClockContext, liveDemurrageNowMs]);
        const demurrageStops = useMemo(() => (demurrage && Array.isArray(demurrage.stops) ? demurrage.stops : []), [demurrage]);
        const displayedDemurrageStops = useMemo(() => {
            if (demurrageStops.length === 0) {
                return [];
            }

            return demurrageStops.map(stop => {
                const isActiveStop = Boolean(
                    stop
                    && liveDemurrageClockContext
                    && liveWaitMinutes != null
                    && stop.stop_id
                    && stop.stop_id === liveDemurrageClockContext.stopId
                );

                if (!isActiveStop) {
                    return stop;
                }

                return {
                    ...stop,
                    wait_minutes: Math.max(Number(stop.wait_minutes || 0), liveWaitMinutes),
                    free_minutes: Math.max(Number(stop.free_minutes || 0), Number(liveDemurrageClockContext.freeMinutes || 0)),
                    billable_minutes: Math.floor(
                        Math.max(
                            0,
                            Math.max(Number(stop.wait_minutes || 0), liveWaitMinutes)
                            - Math.max(Number(stop.free_minutes || 0), Number(liveDemurrageClockContext.freeMinutes || 0))
                        ) / normalizeDemurrageIncrementMinutes(demurrage && demurrage.policy && demurrage.policy.increment_minutes)
                    ) * normalizeDemurrageIncrementMinutes(demurrage && demurrage.policy && demurrage.policy.increment_minutes),
                    amount: getDemurrageAmountFromTiming({
                        hourlyRate: stop.hourly_rate || (demurrage && demurrage.hourly_rate),
                        waitMinutes: Math.max(Number(stop.wait_minutes || 0), liveWaitMinutes),
                        freeMinutes: Math.max(Number(stop.free_minutes || 0), Number(liveDemurrageClockContext.freeMinutes || 0)),
                        incrementMinutes: demurrage && demurrage.policy && demurrage.policy.increment_minutes,
                    }),
                };
            });
        }, [demurrageStops, liveDemurrageClockContext, liveWaitMinutes]);
        const displayedWaitMinutes = displayedDemurrageStops.length > 0
            ? displayedDemurrageStops.reduce((sum, stop) => sum + Number((stop && stop.wait_minutes) || 0), 0)
            : liveWaitMinutes == null
            ? Number(demurrage && demurrage.total_wait_minutes ? demurrage.total_wait_minutes : 0)
            : Math.max(Number(demurrage && demurrage.total_wait_minutes ? demurrage.total_wait_minutes : 0), liveWaitMinutes);
        const displayedFreeMinutes = displayedDemurrageStops.length > 0
            ? displayedDemurrageStops.reduce((sum, stop) => sum + Number((stop && stop.free_minutes) || 0), 0)
            : liveDemurrageClockContext
            ? Math.max(Number(demurrage && demurrage.total_free_minutes ? demurrage.total_free_minutes : 0), Number(liveDemurrageClockContext.freeMinutes || 0))
            : Number(demurrage && demurrage.total_free_minutes ? demurrage.total_free_minutes : 0);
        const appliedDemurrageAmount = Number((demurrageApplication && demurrageApplication.applied_amount) || blob.demurrage_fee || 0);
        const currentDemurrageDisplayAmount = getDemurrageDisplayAmount(demurrage, demurrageApplication, blob);
        const liveDemurrageDisplayAmount = Math.max(
            currentDemurrageDisplayAmount,
            roundDemurrageCurrency(displayedDemurrageStops.reduce((sum, stop) => sum + Number((stop && stop.amount) || 0), 0)),
            getDemurrageAmountFromTiming({
                hourlyRate: demurrage && demurrage.hourly_rate,
                waitMinutes: displayedWaitMinutes,
                freeMinutes: displayedFreeMinutes,
                incrementMinutes: demurrage && demurrage.policy && demurrage.policy.increment_minutes,
            })
        );
        const totalShippingAmount = Number(detailShipment.shipping_fee || 0);
        const originalQuoteAmount = Math.max(
            0,
            Number((totalShippingAmount - appliedDemurrageAmount).toFixed(2))
        );
        const demurrageReviewReasons = demurrage && Array.isArray(demurrage.stops)
            ? Array.from(new Set(demurrage.stops.flatMap(stop => (stop.review_reasons || []))))
            : [];
        const formatDurationMinutes = minutes => {
            const safeMinutes = Math.max(0, Number(minutes || 0));
            const hours = Math.floor(safeMinutes / 60);
            const remainingMinutes = safeMinutes % 60;

            if (hours > 0) {
                return `${hours}h ${remainingMinutes}m`;
            }

            return `${remainingMinutes}m`;
        };
        const formatCurrency = value => `$${Number(value || 0).toFixed(2)}`;
        const shippingFeeRange = getCustomerQuoteRange(detailShipment);
        const customerQuoteRangeDisplay = formatQuoteRange(shippingFeeRange);
        const hasShippingFeeRange = Boolean(customerQuoteRangeDisplay);
        const shouldShowQuoteRangeAsOriginalQuote =
            QUOTE_EDITABLE_PENDING_STATUSES.includes(detailShipment.status) &&
            Number(originalQuoteAmount || 0) === 0 &&
            hasShippingFeeRange;
        const originalQuoteDisplay = shouldShowQuoteRangeAsOriginalQuote
            ? customerQuoteRangeDisplay
            : formatCurrency(originalQuoteAmount);
        const totalShippingDisplay = detailShipment.shipping_fee === 0 && detailShipment.shipment_type !== 'school_lunch' && hasShippingFeeRange
            ? customerQuoteRangeDisplay
            : formatCurrency(detailShipment.shipping_fee);
        const demurrageStatusLabel = demurrage
            ? demurrage.status === 'review_required'
                ? 'Review Required'
                : demurrage.status === 'accruing'
                ? 'Accruing'
                : demurrage.total_billable_minutes > 0
                ? 'Calculated'
                : 'Within Free Time'
            : null;

        return (
            <>
                {shipInfo.hasOwnProperty('is_ltl') && shipInfo.is_ltl ? (
                    <p>
                        <strong>LTL Freight </strong>
                    </p>
                ) : null}
                <p>
                    {getVehicleTypeLabel(detailShipment.vehicle_type)}
                </p>
                <p>{detailShipment.weight} lbs</p>
                <p>{detailShipment.num_of_gophrs} Gophrs Needed</p>
                <p>{Number(detailShipment.distance || 0).toFixed(2) + ' miles'}</p>
                {/* <p>{'$' + shipment.shipping_fee.toFixed(2)}</p> */}
                {detailShipment.merchant_order_id ? (
                    <p>
                        Store Order ID: <strong>{'  ' + detailShipment.merchant_order_id} </strong>{' '}
                    </p>
                ) : null}
                {detailShipment.scheduled_for ? (
                    <p>
                        Schedule: <strong>{'  ' + formatTimestamp(detailShipment.scheduled_for)}</strong>{' '}
                    </p>
                ) : null}
                {blob.hasOwnProperty('calculated') && (
                    <>
                        <p>{blob.shipment.is_personal_protective_equipment && 'PPE required'}</p>
                        <p>{blob.calculated.hasOwnProperty('hand_load_fee') && blob.calculated.hand_load_fee >= 0 && 'Hand Load: $' + blob.calculated.hand_load_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('dolly_fee') && 'Dolly: $' + blob.calculated.dolly_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('pallet_jack_fee') && 'Pallet Jack: $' + blob.calculated.pallet_jack_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('twic_card_fee') && 'TWIC Card: $' + blob.calculated.twic_card_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('liftgate_fee') && 'Liftgate: $' + blob.calculated.liftgate_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('hazmat_fee') && 'Hazmat: $' + blob.calculated.hazmat_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('weather_protection_fee') && 'Weather Protection: $' + blob.calculated.weather_protection_fee.toFixed(2)}</p>
                        <p>{blob.calculated.hasOwnProperty('medical_fee') && 'Medical: $' + blob.calculated.medical_fee.toFixed(2)}</p>
                    </>
                )}
                {appliedDemurrageAmount > 0 ? <p>Demurrage Cost: {formatCurrency(appliedDemurrageAmount)}</p> : null}
                {QUOTE_EDITABLE_PENDING_STATUSES.includes(detailShipment.status) && customerQuoteRangeDisplay ? (
                    <p>Customer Quote Range:{'  ' + customerQuoteRangeDisplay}</p>
                ) : null}
                <p>Original Quote:{'  ' + originalQuoteDisplay}</p>
                <p>
                    Total Shipping:{' ' + totalShippingDisplay}
                </p>
                {demurrage ? (
                    <>
                        <p>
                            Demurrage Status: <strong>{demurrageStatusLabel}</strong>
                        </p>
                        <p>Wait Time: {formatDurationMinutes(displayedWaitMinutes)}/{formatDurationMinutes(displayedFreeMinutes)} free</p>
                        <p>Demurrage Price: {formatCurrency(liveDemurrageDisplayAmount)}</p>
                        {displayedDemurrageStops.map((stop, index) => {
                            if (!stop) {
                                return null;
                            }

                            const stopLabel = stop.stop_type ? String(stop.stop_type) : `Stop ${index + 1}`;
                            return (
                                <p key={`${stop.stop_id || stopLabel}-${index}`}>
                                    {stopLabel}: {formatDurationMinutes(stop.wait_minutes)} / {formatDurationMinutes(stop.free_minutes)} free
                                </p>
                            );
                        })}
                        {demurrage.total_billable_minutes > 0 ? (
                            <p>
                                Demurrage: {formatDurationMinutes(demurrage.total_billable_minutes)} {formatCurrency(demurrage.total_amount)}
                            </p>
                        ) : null}
                        {hasPendingDemurrageReviewForShipment ? (
                            <p style={{ color: '#ffb347' }}>
                                Needs Review: {formatDurationMinutes(demurrage.review_billable_minutes)} {formatCurrency(demurrage.review_amount)}
                            </p>
                        ) : null}
                        {demurrage.preview_billable_minutes > 0 ? (
                            <p style={{ color: '#57c7ff' }}>
                                Preview: {formatDurationMinutes(demurrage.preview_billable_minutes)} {formatCurrency(demurrage.preview_amount)}
                            </p>
                        ) : null}
                        {demurrageReviewReasons.length > 0 ? <p>Review Flags: {demurrageReviewReasons.join(', ')}</p> : null}
                        {hasPendingDemurrageReviewForShipment ? <ReviewDemurrage shipment={detailShipment} style={{ marginTop: '4px' }} /> : null}
                    </>
                ) : null}
                {(detailShipment.shipment_type === 'direct' || detailShipment.shipment_type === 'connect') && <UpdateShippingFee shipment={detailShipment} />}
                {(detailShipment.shipment_type === 'routed_direct' || detailShipment.shipment_type === 'multidrop_direct') && <UpdateShippingFee shipment={detailShipment} />}
            </>
        );
    };

    const DeliveryStatus = ({ shipment }) => {
        return (
            <p style={{ marginBottom: '15px' }}>
                {shipment.status === 'shipment_ready_for_driver'
                    ? 'Ready for Driver'
                    : shipment.status === 'shipment_assigned'
                    ? 'Assigned to Driver'
                    : shipment.status === 'shipment_enroute'
                    ? 'En Route'
                    : shipment.status === 'shipment_completed'
                    ? 'Completed✅'
                    : shipment.status === 'shipment_scheduled'
                    ? 'Scheduled'
                    : null}
            </p>
        );
    };

    const hasOwn = (value, key) => Boolean(value && Object.prototype.hasOwnProperty.call(value, key));

    const getOrderStatusForDisplay = order => {
        if (!order || typeof order.status !== 'string') {
            return '';
        }

        return order.status;
    };

    const getPickupActionInstruction = order => {
        if (!order || !hasOwn(order, 'actions') || !order.actions || !hasOwn(order.actions, 'pick_up')) {
            return '';
        }

        const pickupAction = order.actions.pick_up;

        if (Array.isArray(pickupAction) && typeof pickupAction[0] === 'string') {
            return pickupAction[0];
        }

        if (typeof pickupAction === 'string') {
            return pickupAction;
        }

        return '';
    };

    const isPickupOrderForDisplay = order => {
        if (!order || typeof order !== 'object') {
            return false;
        }

        if (order.actual_action === 'pickup') {
            return true;
        }

        const pickupInstruction = getPickupActionInstruction(order);

        return hasOwn(order, 'actions') && hasOwn(order.actions, 'pick_up') && !pickupInstruction.includes('(drop)');
    };

    const isOrderCompletedForDisplay = order => {
        if (!order || typeof order !== 'object') {
            return false;
        }

        const orderStatus = getOrderStatusForDisplay(order);

        if (isPickupOrderForDisplay(order)) {
            return orderStatus === 'order_enroute' || orderStatus === 'order_completed';
        }

        return orderStatus === 'order_completed';
    };

    const getRouteWaypointForOrderDisplay = (route, order) => {
        if (!route || !Array.isArray(route.path) || !order || typeof order !== 'object') {
            return null;
        }

        return route.path.find(waypoint => {
            if (!waypoint || typeof waypoint !== 'object') {
                return false;
            }

            if (order.order_id && (waypoint.order_id === order.order_id || waypoint.waypoint_id === order.order_id)) {
                return true;
            }

            return false;
        }) || null;
    };

    const getOrderCompletionTimestampForDisplay = (order, route = null) => {
        if (!order || typeof order !== 'object') {
            return null;
        }

        if (isPickupOrderForDisplay(order)) {
            const matchedWaypoint = getRouteWaypointForOrderDisplay(route, order);
            return typeof order.arrived_at === 'string'
                ? order.arrived_at
                : order.arrival_validation && typeof order.arrival_validation.timestamp === 'string'
                ? order.arrival_validation.timestamp
                : matchedWaypoint && typeof matchedWaypoint.arrived_at === 'string'
                ? matchedWaypoint.arrived_at
                : matchedWaypoint && matchedWaypoint.arrival_validation && typeof matchedWaypoint.arrival_validation.timestamp === 'string'
                ? matchedWaypoint.arrival_validation.timestamp
                : typeof order.completed_at === 'string'
                ? order.completed_at
                : null;
        }

        return typeof order.completed_at === 'string' ? order.completed_at : null;
    };

    const formatOrderCompletionForDisplay = (order, route = null) => {
        const completionTimestamp = getOrderCompletionTimestampForDisplay(order, route);
        return completionTimestamp ? formatTimestamp(completionTimestamp) + '✅' : 'completed✅';
    };

    const DeliveringRouteActions = ({ route }) => {
        if (!route || (route.status !== 'route_assigned' && route.status !== 'route_claimed')) {
            return null;
        }

        const primaryShipment = route.Shipments && route.Shipments[0];
        if (!primaryShipment) {
            return null;
        }

        if (isFedexShipment(primaryShipment)) {
            return null;
        }

        return (
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'nowrap', justifyContent: 'flex-start', marginLeft: '4px' }}>
                <Button
                    size="sm"
                    className="btn btn-secondary"
                    style={{ padding: `4px 8px`, margin: 0, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flexShrink: 0 }}
                    onClick={e => {
                        e.stopPropagation();
                        openSmartDispatchSummary(route);
                    }}
                >
                    Dispatch Status
                </Button>
                <Button
                    size="sm"
                    className="btn btn-info"
                    style={{ padding: `4px 8px`, margin: 0, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flexShrink: 0 }}
                    onClick={e => {
                        e.stopPropagation();
                        setRoute(route);
                        setRouteWaypoints(route.path);
                        setShowReorderWaypoints(true);
                    }}
                >
                    Reorder
                </Button>
                <Button
                    size="sm"
                    className="btn btn-default"
                    style={{ padding: `4px 8px`, margin: 0, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flexShrink: 0 }}
                    onClick={e => {
                        e.stopPropagation();
                        handleReassign(route);
                    }}
                >
                    Reassign
                </Button>
                <Button
                    size="sm"
                    className="btn btn-secondary"
                    style={{ padding: `4px 8px`, margin: 0, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flexShrink: 0 }}
                    onClick={e => {
                        e.stopPropagation();
                        handleAssignPassengerOnly(route);
                    }}
                >
                    Passenger
                </Button>
                <Button
                    size="sm"
                    className="btn btn-success"
                    style={{ padding: `4px 8px`, margin: 0, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', flexShrink: 0 }}
                    onClick={e => {
                        e.stopPropagation();
                        setRoute(route);
                        setShowAlertUnassignRoute(true);
                    }}
                >
                    Unassign
                </Button>
            </div>
        );
    };

    const ExpandedDeliveryStatusColumn = ({ shipment, route = null, children = null, fileViewerProps = null, showFileUpload = false, className = 'col-2', style = {} }) => {
        return (
            <Col className={className} style={{ textAlign: 'left', ...style }}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '8px', flexWrap: 'nowrap' }}>
                    <div>
                        <strong>Delivery Status</strong>
                        <DeliveryStatus shipment={shipment} />
                    </div>
                    <DeliveringRouteActions route={route} />
                </div>
                {children}
                {fileViewerProps ? <FileViewer {...fileViewerProps} /> : null}
            </Col>
        );
    };

    const HeaderFileUploadColumn = ({ shipment, className = 'col-2', style = {} }) => {
        return (
            <Col className={className} style={{ textAlign: 'left', ...style }}>
                <strong>Files</strong>
                <FileUpload shipmentId={shipment.shipment_id} shipmentFriendlyId={shipment.shipment_friendly_id} />
            </Col>
        );
    };

    const EtaStopAdminActions = ({ shipmentId, order, stopLabel, route = null }) => {
        if (!order) {
            return null;
        }

        const canActOnBehalf = canDispatchAdminOverrideRouteOrder(order, route);

        if (!canActOnBehalf) {
            return null;
        }

        return (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
                <CompleteOrderButton
                    shipmentId={shipmentId}
                    orderId={order.order_id}
                    label="Mark Arrived"
                    colorClass="btn btn-warning"
                    actionType="arrival_override"
                    stopLabel={stopLabel}
                    onOpen={openCompleteOrderModal}
                />
                <CompleteOrderButton
                    shipmentId={shipmentId}
                    orderId={order.order_id}
                    label="Mark Completed"
                    colorClass="btn btn-success"
                    actionType="complete"
                    stopLabel={stopLabel}
                    onOpen={openCompleteOrderModal}
                />
            </div>
        );
    };

    const CompactEtaStatusBlock = ({ shipment, route = null }) => {
        const shipmentOrders = shipment && Array.isArray(shipment.Orders) ? shipment.Orders.filter(Boolean) : [];
        const pickupOrder = shipmentOrders.find(order => order.actions && order.actions.hasOwnProperty('pick_up') && (!Array.isArray(order.actions.pick_up) || !order.actions.pick_up[0] || !order.actions.pick_up[0].includes('(drop)'))) || shipmentOrders[0];
        const dropoffOrder = shipmentOrders.find(order => order.actions && (order.actions.hasOwnProperty('drop_off') || order.actual_action === 'dropoff')) || shipmentOrders[1];
        const isPickupCompleted = isOrderCompletedForDisplay(pickupOrder);
        const isDropoffCompleted = isOrderCompletedForDisplay(dropoffOrder);

        return (
            <div style={{ display: 'flex', gap: '18px', alignItems: 'flex-start', flexWrap: 'wrap', marginBottom: '10px' }}>
                <div style={{ minWidth: '160px' }}>
                    <p style={{ marginBottom: '6px' }}>
                        Pick up:{' '}
                        {isPickupCompleted ? formatOrderCompletionForDisplay(pickupOrder, route) : 'approaching'}
                    </p>
                    {pickupOrder && !isPickupCompleted && <ETAUpdate handleOrderETAUpdate={handleOrderETAUpdate} order={pickupOrder} />}
                    {pickupOrder && !isPickupCompleted ? <EtaStopAdminActions shipmentId={shipment.shipment_id} order={pickupOrder} stopLabel="Pickup" route={route} /> : null}
                </div>
                <div style={{ minWidth: '160px' }}>
                    <p style={{ marginBottom: '6px' }}>
                        Drop off:{' '}
                        {isPickupCompleted && isDropoffCompleted
                            ? formatTimestamp(dropoffOrder.completed_at) + '✅'
                            : isPickupCompleted && !isDropoffCompleted
                            ? 'delivering'
                            : 'waiting'}
                    </p>
                    {dropoffOrder && !isDropoffCompleted && <ETAUpdate handleOrderETAUpdate={handleOrderETAUpdate} order={dropoffOrder} />}
                    {dropoffOrder && !isDropoffCompleted ? <EtaStopAdminActions shipmentId={shipment.shipment_id} order={dropoffOrder} stopLabel="Dropoff" route={route} /> : null}
                </div>
            </div>
        );
    };

    const getDirectShipmentOrders = shipment => {
        const shipmentOrders = shipment && Array.isArray(shipment.Orders) ? shipment.Orders.filter(Boolean) : [];
        const pickupOrder = shipmentOrders.find(
            order =>
                order &&
                order.actions &&
                order.actions.hasOwnProperty('pick_up') &&
                (!Array.isArray(order.actions.pick_up) || !order.actions.pick_up[0] || !order.actions.pick_up[0].includes('(drop)'))
        ) || shipmentOrders[0] || null;
        const dropoffOrder = shipmentOrders.find(
            order => order && order.actions && (order.actions.hasOwnProperty('drop_off') || order.actual_action === 'dropoff')
        ) || shipmentOrders.find(order => order && order !== pickupOrder) || null;

        return {
            pickupOrder,
            dropoffOrder,
        };
    };

    const BasicInfo = ({ order }) => {
        const locationContact = buildLocationChatContact(order, order && order.actions && order.actions.hasOwnProperty('drop_off') ? 'Dropoff' : 'Pickup');

        return (
            <>
                <p>{order.location_blob.name}</p>
                <InlinePhoneWithChat phone={order.location_blob.phone} contact={locationContact} shipment={order && order.shipment_id ? { shipment_id: order.shipment_id } : null} />
                {order.location_blob.business_name && <p> Business Name: {order.location_blob.business_name}</p>}
                <p>{order.location_blob.address_1}</p>
                <p>
                    {order.location_blob.city}, {order.location_blob.state}, {order.location_blob.zip}
                </p>
            </>
        );
    };

    const BasicInfoDirectPick = ({ shipment, route = null }) => {
        const { pickupOrder: order } = getDirectShipmentOrders(shipment);

        if (!order || !order.location_blob) {
            return null;
        }

        const pickupContact = buildLocationChatContact(order, 'Pickup');
        const canUpdateLocation = !isFedexShipment(shipment);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div>
                    <strong>Pickup Information</strong>

                    <p>{order.location_blob.name}</p>
                    <InlinePhoneWithChat phone={order.location_blob.phone} contact={pickupContact} shipment={shipment} />
                    <p>{order.location_blob.email}</p>
                    {order.location_blob.business_name && <p> Business Name: {order.location_blob.business_name}</p>}
                    <p>{order.location_blob.address_1}</p>
                    <p>
                        {order.location_blob.city}, {order.location_blob.state}, {order.location_blob.zip}
                    </p>
                    {isOrderCompletedForDisplay(order) && <p>{formatOrderCompletionForDisplay(order, route).replace('✅', ' ✅')}</p>}
                    <PhotoGallery photos={order.photos} buttonText="📷 View Photos" />
                </div>
                {canUpdateLocation ? (
                    <div style={{ marginTop: 'auto', paddingTop: '8px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        {canUpdateLocation ? (
                            <Button
                                size="sm"
                                className="btn btn-success"
                                style={{ padding: `5px 10px`, display: `flex`, flexDirection: `column` }}
                                onClick={() => {
                                    setOrderId(order.order_id);
                                    setOrderType('Pickup');
                                    setShowUpdateOrderInfo(true);
                                }}
                            >
                                Update
                            </Button>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    };

    const BasicInfoDirectDrop = ({ shipment }) => {
        const { dropoffOrder: order } = getDirectShipmentOrders(shipment);

        if (!order || !order.location_blob) {
            return null;
        }

        const dropoffContact = buildLocationChatContact(order, 'Dropoff');
        const canUpdateLocation = !isFedexShipment(shipment);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div>
                    <strong>Dropoff Information</strong>

                    <p>{order.location_blob.name}</p>
                    <InlinePhoneWithChat phone={order.location_blob.phone} contact={dropoffContact} shipment={shipment} />
                    <p>{order.location_blob.email}</p>
                    {order.location_blob.business_name && <p> Business Name: {order.location_blob.business_name}</p>}
                    <p>{order.location_blob.address_1}</p>
                    <p>
                        {order.location_blob.city}, {order.location_blob.state}, {order.location_blob.zip}
                    </p>
                    {order.status === 'order_completed' && <p>{formatTimestamp(order.completed_at) + ' ✅'}</p>}
                    <PhotoGallery photos={order.photos} buttonText="📷 View Photos" />
                </div>
                {canUpdateLocation ? (
                    <div style={{ marginTop: 'auto', paddingTop: '8px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                        {canUpdateLocation ? (
                            <Button
                                size="sm"
                                className="btn btn-success"
                                style={{ padding: `5px 10px`, display: `flex`, flexDirection: `column` }}
                                onClick={() => {
                                    setOrderId(order.order_id);
                                    setOrderType('Dropoff');
                                    setShowUpdateOrderInfo(true);
                                }}
                            >
                                Update
                            </Button>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    };

    const BasicInfoMultidropWaypoint = ({ orders, display }) => {
        const orderedStops = Array.isArray(orders)
            ? orders.filter(order => Boolean(order && typeof order === 'object' && order.location_blob && order.actions && typeof order.actions === 'object'))
            : [];

        if (orderedStops.length === 0) {
            return null;
        }

        const primaryPickupOrder = orderedStops.find(order => {
            const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
            if (normalizedAction === 'pickup' || normalizedAction === 'pick_up') {
                return true;
            }

            const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : null;
            if (!actions || !Object.prototype.hasOwnProperty.call(actions, 'pick_up')) {
                return false;
            }

            const pickupInstruction = Array.isArray(actions.pick_up)
                ? String(actions.pick_up[0] || '')
                : String(actions.pick_up || '');

            return !pickupInstruction.includes('(drop)');
        }) || orderedStops[0];

        let pickupStopIndex = 0;
        let dropoffStopIndex = 0;

        return (
            <>
                {orderedStops.map((order, index) => {
                    if (!order || !order.location_blob) {
                        return null;
                    }

                    const normalizedAction = String(order && order.actual_action ? order.actual_action : '').trim().toLowerCase();
                    const actions = order && order.actions && typeof order.actions === 'object' ? order.actions : {};
                    const hasPickupAction = Object.prototype.hasOwnProperty.call(actions, 'pick_up');
                    const hasDropoffAction = normalizedAction === 'dropoff'
                        || normalizedAction === 'drop_off'
                        || Object.prototype.hasOwnProperty.call(actions, 'drop_off');
                    const isDropoffStop = hasDropoffAction;
                    const pickupActionItems = hasPickupAction
                        ? (Array.isArray(actions.pick_up) ? actions.pick_up : [actions.pick_up])
                        : [];
                    const isDisguisedDropoff = !Object.prototype.hasOwnProperty.call(actions, 'drop_off')
                        && pickupActionItems.some(item => String(item || '').includes('(drop)'));

                    if (isDropoffStop) {
                        dropoffStopIndex += 1;
                    } else {
                        pickupStopIndex += 1;
                    }

                    const stopHeading = isDropoffStop
                        ? `Dropoff Stop ${dropoffStopIndex}`
                        : `Pickup Stop ${pickupStopIndex}`;

                    return (
                        <Col key={getWaypointColumnKey({ type: isDropoffStop ? 'dropoff' : 'pickup', order }, index)} className="col-2.5">
                            <strong>{stopHeading}</strong>
                            <BasicInfo order={order} />

                            {isDropoffStop
                                ? (isDisguisedDropoff ? <RoutedDirectItemListTwist order={order} /> : <RoutedDirectItemList order={order} />)
                                : <RoutedDirectItemList order={order} />}
                            {isDropoffStop
                                ? (isDisguisedDropoff ? <PickOrDropInstructionsTwist order={order} /> : <PickOrDropInstructions order={order} />)
                                : <PickOrDropInstructions order={order} />}

                            {(canShowDispatchDriverProgressOrder(order) || isOrderCompletedForDisplay(order)) && display && (
                                <WaypointStatus pickOrder={primaryPickupOrder} currentOrder={order} />
                            )}
                            {canDispatchAdminOverrideOrder(order) && display && (
                                <div>
                                    {!isOrderCompletedForDisplay(order) ? <ETAUpdate handleOrderETAUpdate={handleOrderETAUpdate} order={order} /> : null}
                                    <CompleteOrderButton shipmentId={order.shipment_id} orderId={order.order_id} onOpen={openCompleteOrderModal} />
                                </div>
                            )}
                        </Col>
                    );
                })}
            </>
        );
    };

    const MultiDropDocuments = ({ shipment }) => {
        const shipmentHandshakes = Array.isArray(shipment && shipment.ShipmentHandshakes)
            ? shipment.ShipmentHandshakes
            : [];

        const fileViewerProps = {
            shipmentId: shipment.shipment_id,
            showGenerateBolButton: true,
            deadDropPhotos:
                shipment.status === 'shipment_completed' && shipmentHandshakes.length > 0 && shipmentHandshakes[0].type === 'dead_drop'
                    ? [shipmentHandshakes[0].url]
                    : [],
            shipFriendId: shipment.shipment_friendly_id,
        };

        return (
            <Col className="col-3" style={{ textAlign: 'left' }}>
                <strong>Documents</strong>
                <FileViewer {...fileViewerProps} />
                <FileUpload shipmentId={shipment.shipment_id} shipmentFriendlyId={shipment.shipment_friendly_id} />
            </Col>
        );
    };

    const BasicInfoRoutedWaypoint = ({ orders, display }) => {
        let pickOrders = [];
        let firstPickOrder;
        let middlePickOrder;
        let middleDropOrder;
        let finalDropOrder;
        let hasMiddleDrop = false;

        orders.forEach(order => {
            if (order.actions.hasOwnProperty('drop_off')) {
                finalDropOrder = order;
            } else if (order.actions.hasOwnProperty('pick_up')) {
                if (order.actions['pick_up'][0].includes('drop')) {
                    middleDropOrder = order;
                    hasMiddleDrop = true;
                } else {
                    pickOrders.push(order);
                }
            }
        });

        if (orders.length === 4) {
            pickOrders.forEach(po => {
                if (po.location_blob.address === middleDropOrder.location_blob.address) {
                    middlePickOrder = po;
                } else {
                    firstPickOrder = po;
                }
            });
        } else if (orders.length === 3) {
            if (hasMiddleDrop) {
                firstPickOrder = pickOrders[0];
            } else {
                firstPickOrder = pickOrders[0];
                middlePickOrder = pickOrders[1];
            }
        }

        return (
            <>
                <Col className="col-2.5">
                    <strong>Pickup Info</strong>
                    <BasicInfo order={firstPickOrder} />
                    <RoutedDirectItemList order={firstPickOrder} />
                    <PickOrDropInstructions order={firstPickOrder} />
                    {(canShowDispatchDriverProgressOrder(firstPickOrder) || isOrderCompletedForDisplay(firstPickOrder)) && display && (
                        <p>
                            <strong>Status:</strong> {isOrderCompletedForDisplay(firstPickOrder) ? formatOrderCompletionForDisplay(firstPickOrder) : 'approaching'}
                        </p>
                    )}
                    {canDispatchAdminOverrideOrder(firstPickOrder) && (
                        <div>
                            <ETAUpdate handleOrderETAUpdate={handleOrderETAUpdate} order={firstPickOrder} />
                            <CompleteOrderButton shipmentId={firstPickOrder.shipment_id} orderId={firstPickOrder.order_id} onOpen={openCompleteOrderModal} />
                        </div>
                    )}
                </Col>
                <Col className="col-2.5">
                    <strong>Pickup/Dropoff Info</strong>
                    <BasicInfo order={middlePickOrder ? middlePickOrder : middleDropOrder} />
                    {orders.length === 3 ? (
                        <>
                            {!hasMiddleDrop ? (
                                <>
                                    <RoutedDirectItemList order={middlePickOrder} />
                                    <PickOrDropInstructionsTwist order={middlePickOrder} />
                                    {(canShowDispatchDriverProgressOrder(middlePickOrder) ||
                                        isOrderCompletedForDisplay(middlePickOrder)) &&
                                        display && <WaypointStatus pickOrder={firstPickOrder} currentOrder={middlePickOrder} />}
                                    {canDispatchAdminOverrideOrder(middlePickOrder) && display && (
                                        <CompleteOrderButton shipmentId={middlePickOrder.shipment_id} orderId={middlePickOrder.order_id} onOpen={openCompleteOrderModal} />
                                    )}
                                </>
                            ) : (
                                <>
                                    <RoutedDirectItemListTwist order={middleDropOrder} />
                                    <PickOrDropInstructionsTwist order={middleDropOrder} />
                                    {(canShowDispatchDriverProgressOrder(middleDropOrder) ||
                                        middleDropOrder.status === 'order_completed') &&
                                        display && <WaypointStatus pickOrder={firstPickOrder} currentOrder={middleDropOrder} />}
                                    {canDispatchAdminOverrideOrder(middleDropOrder) && display && (
                                        <CompleteOrderButton shipmentId={middleDropOrder.shipment_id} orderId={middleDropOrder.order_id} onOpen={openCompleteOrderModal} />
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <div>
                            <RoutedDirectItemList order={middlePickOrder} />
                            <PickOrDropInstructions order={middlePickOrder} />
                            {(canShowDispatchDriverProgressOrder(middlePickOrder) || isOrderCompletedForDisplay(middlePickOrder)) &&
                                display && <WaypointStatus pickOrder={firstPickOrder} currentOrder={middlePickOrder} />}
                            {canDispatchAdminOverrideOrder(middlePickOrder) && display && (
                                <CompleteOrderButton shipmentId={middlePickOrder.shipment_id} orderId={middlePickOrder.order_id} onOpen={openCompleteOrderModal} />
                            )}
                            <RoutedDirectItemListTwist order={middleDropOrder} />
                            <PickOrDropInstructionsTwist order={middleDropOrder} />

                            {(canShowDispatchDriverProgressOrder(middleDropOrder) || middleDropOrder.status === 'order_completed') &&
                                display && <WaypointStatus pickOrder={firstPickOrder} currentOrder={middleDropOrder} />}
                            {canDispatchAdminOverrideOrder(middleDropOrder) && display && (
                                <CompleteOrderButton shipmentId={middleDropOrder.shipment_id} orderId={middleDropOrder.order_id} onOpen={openCompleteOrderModal} />
                            )}
                        </div>
                    )}
                </Col>
                <Col className="col-2.5">
                    <strong>Dropoff Info</strong>
                    <BasicInfo order={finalDropOrder} />
                    <RoutedDirectItemList order={finalDropOrder} />
                    <PickOrDropInstructions order={finalDropOrder} />
                    {(canShowDispatchDriverProgressOrder(finalDropOrder) || finalDropOrder.status === 'order_completed') && display && (
                        <WaypointStatus pickOrder={firstPickOrder} currentOrder={finalDropOrder} />
                    )}
                </Col>
            </>
        );
    };

    const RoutedDirectItemList = ({ order }) => {
        return order.actions.hasOwnProperty('pick_up')
            ? order.actions['pick_up'].map((item, index) => {
                  return index === 0 ? (
                      <p key={`pick-${index}-${item}`}>Pick: {item}</p>
                  ) : (
                      <p key={`pick-${index}-${item}`} style={{ textIndent: '30px' }}>
                          {item}
                      </p>
                  );
              })
            : order.actions['drop_off'].map((item, index) => {
                  return index === 0 ? (
                      <p key={`drop-${index}-${item}`}>Drop: {item}</p>
                  ) : (
                      <p key={`drop-${index}-${item}`} style={{ textIndent: '35px' }}>
                          {item}
                      </p>
                  );
              });
    };

    const RoutedDirectItemListTwist = ({ order }) => {
        // Handle both pick_up (disguised dropoffs) and drop_off actions
        let items = [];
        if (order.actions.hasOwnProperty('pick_up')) {
            items = order.actions['pick_up'];
        } else if (order.actions.hasOwnProperty('drop_off')) {
            items = order.actions['drop_off'];
        }

        return items.map((item, index) => {
            if (item.includes('(drop)')) {
                return index === 0 ? (
                    <p key={`twist-drop-${index}-${item}`}>Drop: {item.replace('(drop)', '')}</p>
                ) : (
                    <p key={`twist-drop-${index}-${item}`} style={{ textIndent: '30px' }}>
                        {item.replace('(drop)', '')}
                    </p>
                );
            } else {
                return index === 0 ? (
                    <p key={`twist-passthrough-${index}-${item}`}>Drop: {item}</p>
                ) : (
                    <p key={`twist-passthrough-${index}-${item}`} style={{ textIndent: '30px' }}>
                        {item}
                    </p>
                );
            }
        });
    };

    const PickOrDropInstructions = ({ order }) => {
        if (order.actions.hasOwnProperty('pick_up')) {
            return order.pick_up_instructions ? (
                <>
                    <p style={{ textIndent: '10px' }}> Instructions: </p>
                    <p style={{ textIndent: '30px' }}>{order.pick_up_instructions}</p>
                </>
            ) : null;
        } else if (order.actions.hasOwnProperty('drop_off')) {
            return order.drop_off_instructions ? (
                <>
                    <p style={{ textIndent: '10px' }}> Instructions: </p>
                    <p style={{ textIndent: '30px' }}>{order.drop_off_instructions}</p>
                </>
            ) : null;
        }
    };

    const PickOrDropInstructionsTwist = ({ order }) => {
        let isDrop = false;
        order.actions['pick_up'].forEach(item => {
            if (item.includes('(drop)')) {
                isDrop = true;
            }
        });
        return isDrop ? (
            <>
                {order.drop_off_instructions ? (
                    <>
                        <p style={{ textIndent: '10px' }}> Instructions: </p>
                        <p style={{ textIndent: '30px' }}>{order.drop_off_instructions}</p>
                    </>
                ) : null}
            </>
        ) : (
            <>
                {order.pick_up_instructions ? (
                    <>
                        <p style={{ textIndent: '10px' }}> Instructions: </p>
                        <p style={{ textIndent: '30px' }}>{order.pick_up_instructions}</p>
                    </>
                ) : null}
            </>
        );
    };

    const WaypointStatus = ({ pickOrder, currentOrder }) => {
        const isPickupCompleted = isOrderCompletedForDisplay(pickOrder);
        const isCurrentOrderCompleted = isOrderCompletedForDisplay(currentOrder);

        return (
            <>
                <p>
                    <strong>Status:</strong>
                    {isPickupCompleted && isCurrentOrderCompleted
                        ? formatOrderCompletionForDisplay(currentOrder)
                        : isPickupCompleted && !isCurrentOrderCompleted
                        ? ' delivering'
                        : ' waiting'}
                </p>
                {(currentOrder.status === 'driver_assigned' || currentOrder.status === 'driver_claimed') && (
                    <ETAUpdate handleOrderETAUpdate={handleOrderETAUpdate} order={currentOrder} />
                )}
            </>
        );
    };

    const RegularPickAndDropInstructions = ({ shipment, pickupClassName = undefined, dropoffClassName = undefined, pickupStyle = {}, dropoffStyle = {} }) => {
        return (
            <>
                <Col className={pickupClassName} style={{ textAlign: 'left', ...pickupStyle }}>
                    <strong>Pickup Instructions</strong>
                    <p>{shipment.pick_up_instructions}</p>
                </Col>

                <Col className={dropoffClassName} style={{ textAlign: 'left', ...dropoffStyle }}>
                    <strong>Dropoff Instructions</strong>
                    <p>{shipment.drop_off_instructions}</p>
                </Col>
            </>
        );
    };

    const ShipmentType = ({ shipment, type, fileViewerProps = null }) => {
        const orderPlacerContact = getOrderPlacerContact(shipment);
        const hasOrderPlacerDetails = orderPlacerContact.displayName || orderPlacerContact.phone || orderPlacerContact.email;
        const unreadCount = getTotalChatUnreadCountForShipment(shipment);

        return (
            <div style={{ color: '#cdcaca' }}>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ alignItems: 'center', display: 'inline-flex', flexWrap: 'wrap', gap: '8px' }}>
                        <strong>Type: {type} &nbsp;&nbsp; -- &nbsp;&nbsp; Ship_ID : {shipment.shipment_friendly_id}</strong>
                        {renderClaimedOrderUnreadBadge(unreadCount, { backgroundColor: '#D62828', borderColor: '#FFFFFF' })}
                        {canDispatchEditActiveShipment(shipment) ? (
                            <Button
                                size="sm"
                                className="btn btn-info"
                                style={{ padding: '4px 10px', margin: 0 }}
                                onClick={() => openActiveOrderEditor(shipment)}
                            >
                                Edit order
                            </Button>
                        ) : null}
                    </div>
                    {isMobileClientType(shipment.client_type) ? (
                        <img src={mobile} alt="mobile" style={{ marginLeft: '2px', width: '40px', height: 'auto' }} />
                    ) : (
                        <img src={laptop} alt="laptop" style={{ marginLeft: '2px', width: '40px', height: 'auto' }} />
                    )}
                    {shipment.is_expedited ? <span style={{ color: '#f7941d', marginLeft: '6px', fontWeight: 600 }}>Expedited Delivery</span> : null}
                </div>
                {fileViewerProps ? (
                    <div style={{ marginTop: '8px' }}>
                        <FileViewer {...fileViewerProps} />
                    </div>
                ) : null}
                {hasOrderPlacerDetails ? (
                    <div style={{ marginTop: '8px', lineHeight: 1.4 }}>
                        <div>
                            <strong>Ordered By:</strong> {orderPlacerContact.displayName}
                        </div>
                        {orderPlacerContact.phone ? (
                            <InlinePhoneWithChat
                                phone={orderPlacerContact.phone}
                                contact={orderPlacerContact}
                                shipment={shipment}
                                style={{ marginTop: '2px' }}
                            />
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    };

    const getRouteDriverIdentity = driver => {
        if (!driver) {
            return '';
        }

        const driverBlob = getDriverDisplayBlob(driver);
        const driverName = `${driverBlob.first_name || ''} ${driverBlob.last_name || ''}`.trim();

        return String(
            driver.driver_id ||
                driver.auth0_id ||
                (driver.driver_blob && driver.driver_blob.phone) ||
                driverName
        ).trim();
    };

    const buildShipmentFallbackRouteDriver = shipment => {
        if (!(shipment && shipment.driver_blob)) {
            return null;
        }

        return {
            driver_id: shipment.driver_id || '',
            driver_blob: shipment.driver_blob,
            vehicle_blob: shipment.vehicle_blob || {},
            tracking_blob: shipment.tracking_blob || null,
            employment_type: shipment.employment_type || null,
            status: 'driver',
        };
    };

    const mergeRouteDriverRecords = (currentDriver, nextDriver) => {
        if (!currentDriver) {
            return nextDriver;
        }

        if (!nextDriver) {
            return currentDriver;
        }

        return {
            ...nextDriver,
            ...currentDriver,
            driver_id: currentDriver.driver_id || nextDriver.driver_id || '',
            driver_blob: currentDriver.driver_blob || nextDriver.driver_blob || null,
            vehicle_blob: currentDriver.vehicle_blob || nextDriver.vehicle_blob || {},
            tracking_blob: currentDriver.tracking_blob || nextDriver.tracking_blob || null,
            employment_type: currentDriver.employment_type || nextDriver.employment_type || null,
            status: currentDriver.status || nextDriver.status || 'driver',
        };
    };

    const getRouteDriversForDisplay = (route, shipment = null) => {
        const routeShipments = route && Array.isArray(route.Shipments) ? route.Shipments : [];
        const driverCandidates = [
            ...((route && Array.isArray(route.RouteDrivers) && route.RouteDrivers) || []),
            ...((shipment && Array.isArray(shipment.RouteDrivers) && shipment.RouteDrivers) || []),
            ...((shipment && shipment.Route && Array.isArray(shipment.Route.RouteDrivers) && shipment.Route.RouteDrivers) || []),
            ...(shipment ? [buildShipmentFallbackRouteDriver(shipment)] : []),
            ...routeShipments.map(buildShipmentFallbackRouteDriver),
        ].filter(Boolean);

        return driverCandidates.reduce((drivers, candidateDriver) => {
            const driverIdentity = getRouteDriverIdentity(candidateDriver);

            if (!driverIdentity) {
                drivers.push(candidateDriver);
                return drivers;
            }

            const existingDriverIndex = drivers.findIndex(driver => getRouteDriverIdentity(driver) === driverIdentity);

            if (existingDriverIndex === -1) {
                drivers.push(candidateDriver);
                return drivers;
            }

            drivers[existingDriverIndex] = mergeRouteDriverRecords(drivers[existingDriverIndex], candidateDriver);
            return drivers;
        }, []);
    };

    const getCurrentRouteDriver = (route, shipment = null) => {
        const routeDrivers = getRouteDriversForDisplay(route, shipment);

        if (routeDrivers.length === 0) {
            return null;
        }

        return routeDrivers.find(driver => driver && driver.status !== 'unassigned') || routeDrivers[0];
    };

    const getSelectedRouteDriverForDisplay = (route, shipment = null) => {
        const currentDriver = getCurrentRouteDriver(route, shipment);

        if (!currentDriver) {
            return null;
        }

        const routeId = route && route.route_id ? route.route_id : '';
        const selectedRouteId = currentRecordId || '';
        const canUseFocusedDriver = Boolean(
            routeId &&
            selectedRouteId &&
            routeId === selectedRouteId &&
            enrouteClickDriver &&
            (!getRouteDriverIdentity(currentDriver) || getRouteDriverIdentity(enrouteClickDriver) === getRouteDriverIdentity(currentDriver))
        );

        return resolveFocusedDriverRecord(canUseFocusedDriver ? enrouteClickDriver : currentDriver);
    };

    const DirectRouteDriverInfo = ({ route, shipment, showWebTracking = false, className = 'col-3', style = {} }) => {
        const currentDriver = getSelectedRouteDriverForDisplay(route, shipment);

        if (!currentDriver) {
            return null;
        }

        return (
            <Col className={className} style={{ textAlign: 'left', ...style }}>
                <strong>Driver Information</strong>
                <DriverPay route={route} shipment={shipment} driver={currentDriver} driverStatus="driver" />
                {showWebTracking ? <WebTrackingLink route={route} /> : null}
            </Col>
        );
    };

    const DriverPay = ({ route, shipment, driver, driverStatus }) => {
        const driverBlob = getDriverDisplayBlob(driver);
        const activeArrivalOverrideRequest = driverStatus === 'driver'
            ? getShipmentArrivalOverrideRequest(route, shipment)
            : null;
        const permitDisplay = (() => {
            if (!driver) {
                return 'N/A';
            }

            const directPermit = (driver.User && driver.User.permit) || driver.permit || '';
            if (typeof directPermit === 'string' && directPermit.trim()) {
                return directPermit.trim();
            }

            const permits = [];
            if (driver.can_deliver_alcohol) {
                permits.push('Alcohol');
            }
            if (Array.isArray(driver.restricted_area_credentials)) {
                driver.restricted_area_credentials.forEach(credential => {
                    if (credential) {
                        permits.push(credential);
                    }
                });
            }

            return permits.length > 0 ? permits.join(', ') : 'N/A';
        })();
        const vehicleDetails = driver && driver.active_vehicle_details ? driver.active_vehicle_details : driver && driver.vehicle_blob ? driver.vehicle_blob : {};

        return (
            <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                    <Button
                        size="sm"
                        className="btn btn-warning"
                        style={{ padding: `5px 12px`, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', margin: 0, whiteSpace: 'nowrap', minWidth: '64px', flexShrink: 0 }}
                        onClick={() => {
                            fetchDriverPay(shipment.shipment_id, driver.driver_id, driverStatus);
                            setShowDriverPay(true);
                        }}
                    >
                        Pay
                    </Button>
                    {driverStatus === 'driver' && driver && (
                        <Button
                            size="sm"
                            className="btn btn-info"
                            style={{ padding: `5px 12px`, display: `inline-flex`, alignItems: 'center', justifyContent: 'center', margin: 0, whiteSpace: 'nowrap', minWidth: '98px', flexShrink: 0 }}
                            onClick={() => {
                                setRouteDriverRouteId(shipment.route_id);
                                setShowDriverInfoAndPO(true);
                            }}
                        >
                            Driver Info
                        </Button>
                    )}
                </div>
                {driver && (
                    <p style={{ margin: '0 0 5px 0', whiteSpace: 'normal' }}>
                        {driverBlob.first_name} {driverBlob.last_name} {driverStatus === 'driver' ? '🚚' : driverStatus === 'passenger' ? '🏋️‍♀️' : null}
                    </p>
                )}
                {driver && driverStatus === 'driver' && driver.tracking_blob && driver.tracking_blob.hasOwnProperty('po_number') && (
                    <p style={{ margin: 5 }}> ELD #: {driver.tracking_blob.po_number}</p>
                )}
                {driver && (
                    <InlinePhoneWithChat
                        phone={driverBlob.phone}
                        shipment={shipment}
                        contact={{
                            firstname: driverBlob.first_name || '',
                            lastname: driverBlob.last_name || '',
                            driverId: driver.driver_id || '',
                            displayName: `${driverBlob.first_name || ''} ${driverBlob.last_name || ''}`.trim() || 'Assigned driver',
                            phone: driverBlob.phone || '',
                            email: driverBlob.email || '',
                            label: 'Driver'
                        }}
                        style={{ margin: 5 }}
                    />
                )}
                {driver && resolveShipmentCustomerParticipantAuth0Id(shipment) ? (
                    <InlinePhoneWithChat
                        phone="Customer / Driver chat"
                        shipment={shipment}
                        contact={{
                            displayName: 'Customer / Driver',
                            label: 'Customer Driver',
                            chatThreadType: 'customer_driver'
                        }}
                        style={{ margin: 5 }}
                        useFormattedPhone={false}
                    />
                ) : null}
                {resolveShipmentCustomerParticipantAuth0Id(shipment) ? (
                    <InlinePhoneWithChat
                        phone="Customer / Dispatch chat"
                        shipment={shipment}
                        contact={{
                            displayName: 'Customer / Dispatch',
                            label: 'Customer Dispatch',
                            chatThreadType: 'customer_dispatch'
                        }}
                        style={{ margin: 5 }}
                        useFormattedPhone={false}
                    />
                ) : null}
                {driverStatus === 'driver' && driver && formatEmploymentTypeLabel(driver.employment_type) ? (
                    <p style={{ margin: 5 }}>{formatEmploymentTypeLabel(driver.employment_type)}</p>
                ) : null}
                {driverStatus === 'driver' && driver && (
                    <p style={{ margin: 5 }}>
                        {[vehicleDetails.year, vehicleDetails.make, vehicleDetails.model].filter(Boolean).join(' ') + (vehicleDetails.color ? ` (${vehicleDetails.color})` : '')}
                    </p>
                )}
                {driverStatus === 'driver' && driver && <p style={{ margin: 5 }}>Permit: {permitDisplay}</p>}
                {activeArrivalOverrideRequest ? (
                    <div style={{ margin: '10px 5px 0 5px' }}>
                        <Button
                            size="sm"
                            color="warning"
                            onClick={event => {
                                event.preventDefault();
                                event.stopPropagation();
                                reopenArrivalOverrideRequest(activeArrivalOverrideRequest);
                            }}
                        >
                            Reopen Arrival Override Request
                        </Button>
                    </div>
                ) : null}
            </>
        );
    };

    const DriverCounts = ({ count }) => {
        return (
            <strong>
                {count > 1 ? 'Drivers' : 'Driver'}({count})
            </strong>
        );
    };

    const WebTrackingLink = ({ route }) => {
        if (!route.short_code) {
            return null;
        }

        const trackingUrl = config.config.web_tracking.host + '/' + route.short_code;

        // Primary shipment on this route, used to text the customer their recipient tracking link.
        const trackingShipment = Array.isArray(route.Shipments) && route.Shipments.length > 0 ? route.Shipments[0] : null;

        const copyTrackingLink = async event => {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(trackingUrl);
                } else {
                    const textArea = document.createElement('textarea');
                    textArea.value = trackingUrl;
                    textArea.setAttribute('readonly', 'readonly');
                    textArea.style.position = 'fixed';
                    textArea.style.opacity = '0';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                }

                props.notify('tc', 'Tracking link copied to clipboard.');
            } catch (error) {
                props.notify('tc', 'Unable to copy the tracking link. Please copy it manually.', 'warning');
            }
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <p style={{ marginBottom: 0 }}>{trackingUrl}</p>
                <Button size="sm" color="info" style={{ padding: '4px 10px' }} onClick={copyTrackingLink}>
                    <FontAwesomeIcon icon={faCopy} style={{ marginRight: '6px' }} />
                    Copy
                </Button>
                {trackingShipment ? (
                    <Button
                        size="sm"
                        color="default"
                        style={{ padding: '4px 10px' }}
                        onClick={e => {
                            e.stopPropagation();
                            sendRecipientTrackingLinkToNumber(trackingShipment);
                        }}
                    >
                        Text to #
                    </Button>
                ) : null}
            </div>
        );
    };

    const UpdateShippingFee = ({ shipment, style = {} }) => {
        return (
            <Button
                className="btn btn-success"
                style={{ padding: `5px 10px`, marginTop: '8px', display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', ...style }}
                onClick={() => {
                    setShipment(shipment);
                    setShowUpdateShippingFee(true);
                }}
            >
                Shipping Fee
            </Button>
        );
    };

    const PendingQuoteOverrideButton = ({ shipment }) => {
        if (!shipment || !QUOTE_EDITABLE_SHIPMENT_TYPES.includes(shipment.shipment_type)) {
            return null;
        }

        return (
            <Button
                className={shipment.shipping_fee > 0 ? 'btn btn-warning' : 'btn btn-info'}
                style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                onClick={e => {
                    e.stopPropagation();
                    setShipment(shipment);
                    setShowUpdateShippingFee(true);
                }}
            >
                <i className="fas fa-dollar-sign"></i>
                {shipment.shipping_fee > 0 ? 'Update Quote' : 'Input Quote'}
            </Button>
        );
    };

    const ReviewDemurrage = ({ shipment, style = {} }) => {
        return (
            <Button
                className="btn btn-warning"
                style={{ padding: `5px 10px`, marginTop: '8px', display: `inline-flex`, alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', ...style }}
                onClick={() => {
                    setShipment(shipment);
                    setDemurrageDecisionNotes('');
                    setShowDemurrageReviewModal(true);
                }}
            >
                Review Demurrage
            </Button>
        );
    };

    const DispatchShipmentReview = ({ shipment }) => {
        const sid = shipment && shipment.shipment_id ? String(shipment.shipment_id) : '';
        const [review, setReview] = React.useState(null);

        React.useEffect(() => {
            if (!sid) return;
            let active = true;
            axios({
                method: 'get',
                headers: { Authorization: buildAuthorizationHeader(), 'content-type': 'application/json' },
                url: shipment_urls.adminCustomerDriverReviewByShipment(sid),
            }).then(response => {
                if (!active) return;
                const payload = response && response.data ? response.data.payload : null;
                if (!payload || !payload.rating) return;
                const rating = Number(payload.rating || 0);
                setReview({
                    rating,
                    reviewText: typeof payload.review_text === 'string' ? payload.review_text.trim() : '',
                    submittedAt: payload.submitted_at || null,
                });
            }).catch(() => {});
            return () => { active = false; };
        }, [sid]);

        if (!review) return null;

        const filled = '★'.repeat(Math.max(0, Math.min(5, review.rating)));
        const empty = '☆'.repeat(Math.max(0, 5 - Math.max(0, Math.min(5, review.rating))));

        return (
            <div style={{ marginTop: '16px', marginLeft: '20px', marginRight: '20px', padding: '14px 16px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.14)', backgroundColor: 'rgba(255,255,255,0.06)', textAlign: 'left' }}>
                <strong style={{ display: 'block', marginBottom: '8px' }}>Customer Driver Review</strong>
                <p style={{ marginBottom: '6px', fontSize: '18px', letterSpacing: '0.08em', color: '#f4b400' }}>{filled}{empty}</p>
                {review.submittedAt ? <p style={{ marginBottom: review.reviewText ? '6px' : 0, fontSize: '13px', color: '#cdcaca' }}><strong>Submitted:</strong> {formatTimestamp(review.submittedAt)}</p> : null}
                {review.reviewText ? <p style={{ marginBottom: 0 }}><strong>Review:</strong> {review.reviewText}</p> : null}
            </div>
        );
    };

    const UpdateDriverPayBeforeClaim = ({ shipment }) => {
        return isFedexShipment(shipment) ? null : (
            <Col className="col-2" style={{ textAlign: 'left' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <Button
                        size="sm"
                        className="btn btn-warning"
                        style={{ padding: `5px 10px`, display: `flex`, flexDirection: `column` }}
                        onClick={() => {
                            setShipment(shipment);
                            setShowUpdateDriverPayBeforeClaim(true);
                        }}
                    >
                        Driver Pay
                    </Button>
                    {shipment && shipment.route_id && (
                        <Button
                            size="sm"
                            className="btn btn-secondary"
                            style={{ padding: `5px 10px`, display: `flex`, flexDirection: `column` }}
                            onClick={() => {
                                openSmartDispatchSummary(shipment);
                            }}
                        >
                            Dispatch Status
                        </Button>
                    )}
                </div>
            </Col>
        );
    };

    const SchoolLunchInfo = ({ order, shipment }) => {
        return (
            <>
                <div style={{ paddingTop: '10px', paddingBottom: '10px', marginLeft: '20px', marginRight: '20px', textAlign: 'left' }}>
                    <Row>
                        <Col className="col-1.5">
                            <strong>Dining Period</strong>
                            <p>{order.actions.pick_up[0].slice(15).slice(0, -3)}</p>
                        </Col>

                        <Col className="col-3">
                            <strong>Quantity & Meal Type</strong>
                            {order.actions.pick_up.map((meal, index) => {
                                if (index > 0) {
                                    return <p>{meal}</p>;
                                }
                                return null;
                            })}
                        </Col>

                        <Col className="col-1.5">
                            <strong>Total Price</strong>
                            <p>${order.total.toFixed(2)}</p>
                        </Col>
                        <Col className="col-3">
                            <strong>Pickup Instructions</strong>
                            <p>{shipment.pick_up_instructions}</p>
                        </Col>
                        <Col className="col-3">
                            <strong>Dropoff Instructions</strong>
                            <p>{shipment.drop_off_instructions}</p>
                        </Col>
                    </Row>
                </div>
            </>
        );
    };

    const QuoteShippingFeeButton = ({ shipment }) => {
        const customerQuoteRangeDisplay = formatQuoteRange(getCustomerQuoteRange(shipment));

        return (
            <>
                <Row>
                    <ButtonGroup>
                        {shipment.shipping_fee === 0 ? (
                            <Button style={{ width: `100%`, textAlign: 'center' }} color="info" name="waitingApproval" className={'btn btn-simple'} disabled>
                                Waiting Quote
                            </Button>
                        ) : (
                            <Button style={{ width: `100%`, textAlign: 'center' }} color="success" name="quoteApproved" className={'btn btn-simple'} disabled>
                                Quote Submitted
                            </Button>
                        )}
                    </ButtonGroup>
                </Row>
                <Row>
                    <Button
                        className={shipment.shipping_fee > 0 ? 'btn btn-warning' : 'btn btn-info'}
                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                        onClick={() => {
                            setShipment(shipment);
                            setShowUpdateShippingFee(true);
                        }}
                    >
                        {shipment.shipping_fee > 0 ? 'Update Quote' : 'Input Quote'}
                    </Button>
                </Row>
                {customerQuoteRangeDisplay ? (
                    <Row style={{ marginTop: '8px' }}>
                        <div style={{ fontSize: '12px', color: '#cdcaca', textAlign: 'left' }}>
                            Customer Quote Range: {customerQuoteRangeDisplay}
                        </div>
                    </Row>
                ) : null}
            </>
        );
    };

    // reorder function
    const handleReorder = (routeId, path) => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/routes/' + routeId + '/reorder-waypoints',
            data: { path: path }
        })
            .then(response => {
                props.notify('tc', 'Routes Successfully Reordered');
                toggleReorderWaypoints();
            })
            .catch(error => {
                if (error.response) {
                    setIsReorderError(true);
                    setReorderError(error.response.data.message);
                } else {
                    setIsReorderError(true);
                    setReorderError('Unable to reorder route waypoints.');
                }
            });
    };

    // route builder functions
    const handleMergingCheckbox = position => {
        const updatedCheckedState = mergingCheckState.map((item, index) => (index === position ? !item : item));
        setMergingCheckedState(updatedCheckedState);

        const allChecked = updatedCheckedState.every(item => item);
        setMergingCheckStateAllChecked(allChecked);
    };

    const handleMergingCheckboxClick = (position, event) => {
        if (event) {
            event.stopPropagation();
        }

        handleMergingCheckbox(position);
    };

    const handleSelectAllMergingCheckbox = () => {
        const allChecked = !mergingCheckStateAllChecked;
        const updatedCheckedState = mergingCheckState.map(() => allChecked);
        setMergingCheckedState(updatedCheckedState);
        setMergingCheckStateAllChecked(allChecked);
    };

    const currentUserHasMergingRecords = filteredMergingRoutes.length > 0;

    useEffect(() => {
        let selectedIdArray = [];
        let selectedRoutesArray = [];
        let waypointsCount = 0;
        mergingCheckState.forEach((state, index) => {
            if (state === true) {
                selectedIdArray.push(filteredMergingRoutes[index].route_id);
                selectedRoutesArray.push(filteredMergingRoutes[index]);
                waypointsCount += filteredMergingRoutes[index].waypoints_number;
            }
        });
        setMergeRoutesList(selectedIdArray);
        setMergeRouteWaypointsSelected(waypointsCount);
        setSelectedMergingRoutes(selectedRoutesArray);
    }, [mergingCheckState, filteredMergingRoutes]);

    useEffect(() => {
        setMergingCheckStateAllChecked(false);
        setMergingCheckedState(new Array(filteredMergingRoutes.length).fill(false));
        setAmountMerging(filteredMergingRoutes.length);
        syncOpenedMergingRoutes(expandedItems.merging);
    }, [filteredMergingRoutes]);

    useEffect(() => {
        if (selected !== 'merging') {
            if (openedMergingRoutes.length > 0) {
                setOpenedMergingRoutes([]);
            }

            if (showMergingRoutesMap) {
                setShowMergingRoutesMap(false);
            }

            return;
        }

        const shouldShowMergingRoutesMap = selectedMergingRoutes.length > 0 || openedMergingRoutes.length > 0;

        if (showMergingRoutesMap !== shouldShowMergingRoutesMap) {
            setShowMergingRoutesMap(shouldShowMergingRoutesMap);
        }
    }, [selected, selectedMergingRoutes, openedMergingRoutes, showMergingRoutesMap]);

    useEffect(() => {
        if (mergeRoutesList.length >= 2) {
            setIsRouteBuilderAccessible(true);
        } else {
            setIsRouteBuilderAccessible(false);
        }
    }, [mergeRoutesList]);

    useEffect(() => {
        if (mergeRouteWaypointsSelected >= mergeRouteWaypointsWarning) {
            setTimeout(() => {
                alert(
                    `Warning: You have selected ${mergeRouteWaypointsSelected}, which has reached the route waypoints limit ${mergeRouteWaypointsWarning}, but you can continue add and merge`
                );
            }, 500);
        }
    }, [mergeRouteWaypointsSelected]);

    const buildRoutes = mergeRoutesList => {
        const actionKey = `merge-routes:${mergeRoutesList.slice().sort().join(',')}`;

        void runDispatchActionOnce(actionKey, async () => {
            try {
                const response = await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentHost + '/routes/route-builder/merge',
                    data: { route_ids: mergeRoutesList }
                });

                props.notify('tc', 'Routes Successfully Merged');
                void refreshLocalDispatchData().finally(() => {
                    fetchMergingRoutes();
                });
                setTimeout(() => {
                    alert(`The Route_ID of new generated route is ${response.data.payload.route_friendly_id}`);
                }, 1000);
            } catch (error) {
                void error;
                props.notify('tc', 'Failed to merge routes', 'danger');
            }
        });
    };

    const tempClaimRoutes = routeId => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/routes/temp_claim/' + routeId + '/dispatch'
        })
            .then(response => {})
            .catch(() => {
                props.notify('tc', 'Failed to temp claim route', 'danger');
            });
    };

    const CancelTempClaimRoutes = routeId => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.shipmentHost + '/routes/cancel_temp_claim/' + routeId + '/dispatch'
        })
            .then(response => {})
            .catch(() => {
                props.notify('tc', 'Failed to cancel temp claim', 'danger');
            });
    };

    const resolveSmartDispatchSummaryContext = routeReference => {
        if (!routeReference) {
            return null;
        }

        if (typeof routeReference === 'string') {
            return {
                routeId: routeReference,
                routeFriendlyId: '',
                shipmentId: '',
                shipmentFriendlyId: '',
            };
        }

        const firstShipment = Array.isArray(routeReference.Shipments) ? routeReference.Shipments[0] : null;

        return {
            routeId: routeReference.route_id || routeReference.routeId || '',
            routeFriendlyId: routeReference.route_friendly_id || routeReference.routeFriendlyId || '',
            shipmentId: routeReference.shipment_id || routeReference.shipmentId || (firstShipment && firstShipment.shipment_id) || '',
            shipmentFriendlyId: routeReference.shipment_friendly_id || routeReference.shipmentFriendlyId || (firstShipment && firstShipment.shipment_friendly_id) || '',
        };
    };

    const normalizeSmartDispatchDriverAction = action => {
        const normalizedAction = String(action || '').trim().toLowerCase();
        if (normalizedAction === 'accepted' || normalizedAction === 'claimed') {
            return 'accepted';
        }

        if (normalizedAction === 'pass' || normalizedAction === 'passed') {
            return 'passed';
        }

        if (normalizedAction === 'viewed' || normalizedAction === 'view') {
            return 'viewed';
        }

        return 'not viewed';
    };

    const resolveSmartDispatchNotificationName = notification => {
        const snapshot = notification && notification.candidate_snapshot ? notification.candidate_snapshot : {};
        const preferredName = String(notification && notification.name ? notification.name : snapshot.driver_name || snapshot.display_name || '').trim();
        const isUnknownName = preferredName.toLowerCase() === 'unknown driver';
        if (preferredName && !isUnknownName && !isAuth0LikeIdentifier(preferredName)) {
            return preferredName;
        }

        const auth0Id = String(notification && notification.driver_auth0_id ? notification.driver_auth0_id : snapshot.auth0_id || preferredName || '').trim();
        if (auth0Id && smartDispatchDriverNameByAuth0Id[auth0Id]) {
            return smartDispatchDriverNameByAuth0Id[auth0Id];
        }

        if (auth0Id && smartDispatchProfileNameByAuth0Id[auth0Id]) {
            return smartDispatchProfileNameByAuth0Id[auth0Id];
        }

        const firstName = String(snapshot.first_name || snapshot.firstName || '').trim();
        const lastName = String(snapshot.last_name || snapshot.lastName || '').trim();
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || 'Unknown Driver';
    };

    const resolveSmartDispatchNotificationLastAction = notification => {
        if (notification && notification.claimed_at) {
            return 'accepted';
        }

        if (notification && notification.passed_at) {
            return 'passed';
        }

        if (notification && notification.viewed_at) {
            return 'viewed';
        }

        return normalizeSmartDispatchDriverAction(notification && notification.status);
    };

    const deriveSmartDispatchNotifiedDrivers = workflowSummary => {
        if (!workflowSummary || typeof workflowSummary !== 'object') {
            return [];
        }

        const isModernSummary = Array.isArray(workflowSummary.notified_drivers);
        const list = isModernSummary
            ? workflowSummary.notified_drivers
            : (Array.isArray(workflowSummary.DriverDispatchNotifications) ? workflowSummary.DriverDispatchNotifications : []);

        const byDriverKey = {};
        list.forEach((entry, index) => {
            const notification = entry || {};
            const driverName = resolveSmartDispatchNotificationName(notification);
            const action = isModernSummary
                ? normalizeSmartDispatchDriverAction(notification.last_action || notification.lastAction || notification.status)
                : resolveSmartDispatchNotificationLastAction(notification);
            const driverKey = String(notification.driver_auth0_id || notification.driver_id || driverName || `unknown-${index}`);

            byDriverKey[driverKey] = {
                name: driverName,
                lastAction: action,
            };
        });

        return Object.values(byDriverKey);
    };

    const openSmartDispatchSummary = routeReference => {
        const context = resolveSmartDispatchSummaryContext(routeReference);
        const routeId = context && context.routeId ? context.routeId : '';

        if (!routeId) {
            return;
        }

        setShowSmartDispatchSummary(true);
        setSmartDispatchSummaryLoading(true);
        setSmartDispatchSummaryContext(context);
        setSmartDispatchSummaryRouteId(routeId);

        axios({
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.smartDispatchAdminRouteSummary + routeId + '/summary'
        })
            .then(response => {
                setSmartDispatchSummaryPayload(response.data && response.data.payload ? response.data.payload : null);
            })
            .catch(() => {
                setSmartDispatchSummaryPayload(null);
                props.notify('tc', 'Unable to load smart dispatch summary');
            })
            .finally(() => {
                setSmartDispatchSummaryLoading(false);
            });
    };

    const summarizeSmartDispatchSkipReasons = skipped => {
        if (!Array.isArray(skipped) || skipped.length === 0) {
            return '';
        }

        const labels = {
            already_notified: 'already notified',
            alcohol: 'alcohol clearance',
            asset: 'missing asset',
            compliance: 'compliance',
            credential: 'missing credential',
            disabled: 'disabled',
            distance: 'distance',
            offline_phase: 'offline',
            stale_location: 'stale location',
            unavailable: 'unavailable',
            vehicle: 'vehicle mismatch',
        };
        const counts = skipped.reduce((summary, entry) => {
            const reason = entry && entry.reason ? entry.reason : 'other';
            summary[reason] = (summary[reason] || 0) + 1;
            return summary;
        }, {});
        const topReasons = Object.entries(counts)
            .sort((left, right) => right[1] - left[1])
            .slice(0, 2)
            .map(([reason, count]) => `${labels[reason] || reason}: ${count}`);

        return topReasons.join(', ');
    };

    const summarizeSmartDispatchStartResult = workflowSummary => {
        if (!workflowSummary || typeof workflowSummary !== 'object') {
            return 'Smart dispatch started';
        }

        const attempts = Array.isArray(workflowSummary.DriverDispatchAttempts) ? workflowSummary.DriverDispatchAttempts : [];
        const notifications = Array.isArray(workflowSummary.DriverDispatchNotifications) ? workflowSummary.DriverDispatchNotifications : [];
        const latestAttempt = attempts.length > 0
            ? [...attempts].sort((left, right) => Number(right.wave_number || 0) - Number(left.wave_number || 0))[0]
            : null;
        const notifiedCount = latestAttempt && Number.isFinite(Number(latestAttempt.notified_count))
            ? Number(latestAttempt.notified_count)
            : notifications.length;
        const candidateCount = latestAttempt && Number.isFinite(Number(latestAttempt.candidate_count))
            ? Number(latestAttempt.candidate_count)
            : null;
        const skippedSummary = summarizeSmartDispatchSkipReasons(
            latestAttempt && latestAttempt.summary_blob ? latestAttempt.summary_blob.skipped : []
        );
        const workflowStatus = typeof workflowSummary.status === 'string' ? workflowSummary.status : '';
        const stopReason = typeof workflowSummary.stop_reason === 'string' ? workflowSummary.stop_reason : '';

        if (notifiedCount > 0) {
            return notifiedCount === 1
                ? 'Smart dispatch started and notified 1 driver'
                : `Smart dispatch started and notified ${notifiedCount} drivers`;
        }

        if (workflowStatus === 'escalated' || stopReason === 'no_candidates_remaining') {
            if (candidateCount > 0) {
                return `Smart dispatch found ${candidateCount} candidates but could not notify any drivers`;
            }

            if (skippedSummary) {
                return `Smart dispatch started, but no drivers were eligible to notify (${skippedSummary})`;
            }

            return 'Smart dispatch started, but no eligible drivers were available to notify';
        }

        if (candidateCount === 0) {
            if (skippedSummary) {
                return `Smart dispatch started, but no drivers were eligible to notify (${skippedSummary})`;
            }

            return 'Smart dispatch started, but there were no eligible drivers to notify';
        }

        return 'Smart dispatch started';
    };

    const startSmartDispatchRoute = route => {
        if (!route || !route.route_id) {
            return;
        }

        setSmartDispatchActionRouteId(route.route_id);

        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.smartDispatchStartRoute + route.route_id
        })
            .then(response => {
                const workflowSummary = response && response.data && response.data.payload ? response.data.payload : null;

                if (workflowSummary) {
                    const summaryContext = resolveSmartDispatchSummaryContext(route);
                    setShowSmartDispatchSummary(true);
                    setSmartDispatchSummaryLoading(false);
                    setSmartDispatchSummaryContext(summaryContext);
                    setSmartDispatchSummaryRouteId(summaryContext && summaryContext.routeId ? summaryContext.routeId : route.route_id);
                    setSmartDispatchSummaryPayload(workflowSummary);
                } else {
                    openSmartDispatchSummary(route);
                }

                props.notify('tc', summarizeSmartDispatchStartResult(workflowSummary));
            })
            .catch(error => {
                const responseData = error && error.response ? error.response.data : null;
                const responseMessage = responseData && responseData.message ? responseData.message : 'Unable to start smart dispatch';

                console.error('[smart-dispatch-start] request failed', JSON.stringify({
                    routeId: route.route_id,
                    status: error && error.response ? error.response.status : null,
                    data: responseData,
                }, null, 2));
                props.notify('tc', responseMessage);
            })
            .finally(() => {
                setSmartDispatchActionRouteId('');
            });
    };

    const toggleDriverMessageForm = () => {
        if (showDriverMessageForm) {
            if (messageRecipientInfo && messageRecipientInfo.chatMode === 'order-thread' && messageRecipientInfo.chatShipmentId) {
                const activeThreadKey = messageRecipientInfo.chatThreadId || buildClaimedOrderThreadKey({
                    shipment_id: messageRecipientInfo.chatShipmentId,
                    thread_type: messageRecipientInfo.chatThreadType,
                    participant_auth0_id: messageRecipientInfo.chatParticipantAuth0Id,
                });
                const activeSummary = claimedOrderChatSummariesByShipmentId[activeThreadKey];
                const latestMessage = activeSummary && activeSummary.latest_message ? activeSummary.latest_message : null;

                if (latestMessage && latestMessage.message_id) {
                    markClaimedOrderChatSeen(activeThreadKey, latestMessage.message_id);
                }
            }

            resetDriverMessageComposer();
            setFocusedDriverOnMap(null);
        }

        setShowDriverMessageForm(!showDriverMessageForm);
    };

    const toggleGasPrice = () => {
        setShowGasPrice(!showGasPrice);
    };

    const toggleGasPriceRegion = () => {
        setShowGasPriceRegion(!showGasPriceRegion);
    };

    const toggleMarketNote = () => {
        setShowMarketNote(!showMarketNote);
    };

    const toggleMarketNoteRegion = () => {
        setShowMarketNoteRegion(!showMarketNoteRegion);
    };

    const toggleReorderWaypoints = () => {
        setShowReorderWaypoints(!showReorderWaypoints);
        if (showReorderWaypoints) {
            setIsReorderError(false);
        }
    };

    const resolveShipmentStoreId = shipment => {
        if (!shipment) {
            return null;
        }

        return (
            (shipment.customer_blob && shipment.customer_blob.store_id) ||
            (shipment.shipping_fee_blob && shipment.shipping_fee_blob.shipment && shipment.shipping_fee_blob.shipment.store_id) ||
            (Array.isArray(shipment.Orders) &&
                shipment.Orders.find(order => order && order.store_id) &&
                shipment.Orders.find(order => order && order.store_id).store_id) ||
            null
        );
    };

    const canDispatchEditActiveShipment = shipment => {
        if (!shipment) {
            return false;
        }

        const shipmentType = shipment.shipment_type || 'direct';

        return (
            !DISPATCH_NON_EDITABLE_SHIPMENT_STATUSES.has(shipment.status) &&
            !shipment.completed_at &&
            DISPATCH_EDIT_ACTIVE_SHIPMENT_TYPES.has(shipmentType) &&
            !isFedexShipment(shipment)
        );
    };

    const openActiveOrderEditor = shipment => {
        if (!shipment || !props.history || typeof props.history.push !== 'function') {
            return;
        }

        const activeOrderEdit = {
            shipment,
            storeId: resolveShipmentStoreId(shipment),
        };

        props.history.push({
            pathname: ACTIVE_ORDER_EDIT_PATH,
            state: {
                activeOrderEdit,
            },
        });
    };

    const toggleShippingFee = () => {
        setShowUpdateShippingFee(!showUpdateShippingFee);
    };

    const toggleSetupFee = () => {
        setShowChargeSetupFee(!showChargeSetupFee);
    };

    const toggleDriverPay = () => {
        setShowDriverPay(!showDriverPay);
    };

    const toggleDemurrageReviewModal = () => {
        if (showDemurrageReviewModal) {
            setDemurrageDecisionNotes('');
            setIsSubmittingDemurrageDecision(false);
        }

        setShowDemurrageReviewModal(!showDemurrageReviewModal);
    };

    const toggleDriverInfoAndPO = () => {
        setShowDriverInfoAndPO(!showDriverInfoAndPO);
    };
    const toggleShowUpdateOrderInfo = () => {
        setShowUpdateOrderInfo(!showUpdateOrderInfo);
    };

    const toggleUpdateDriverPayBeforeClaim = () => {
        setShowUpdateDriverPayBeforeClaim(!showUpdateDriverPayBeforeClaim);
    };

    const resetShippingFee = () => {
        setShippingFee('');
    };

    const resetSetupFee = () => {
        setSetupDuration('');
    };

    const resetDriverBonus = () => {
        setDriverBonus('');
    };

    const resetBonusReason = () => {
        setBonusReason('');
    };

    const resetShippingFeeReason = () => {
        setShippingFeeReason('');
    };

    const resetRouteDriverInfoAndPO = () => {
        setRouteDriverFirstName('');
        setRouteDriverLastName('');
        setRouteDriverPhone('');
        setRouteDriverPONumber('');
        setRouteDriverRouteId('');
    };

    // useEffects
    useEffect(() => {
        if (error) {
            if (error.message === 'cannot start as connection_init failed with : Could not verify JWT: JWTExpired') {
                props.history.push('/');
            }
        }
    }, [error]);

    useEffect(() => {
        if (error) {
            if (error.message === 'cannot start as connection_init failed with : Could not verify JWT: JWTExpired') {
                props.history.push('/');
            }
        }
    }, [error]);

    useEffect(() => {
        if (shipmentsData && shipmentsData.Shipments) {
            const shownShipments = [];
            shipmentsData.Shipments.forEach(element => {
                if (filter.includes(element.status) && isDispatchVisibleShipment(element)) {
                    shownShipments.push(element);
                }
            });
            if (selected === 'saved') {
                shownShipments.sort((leftShipment, rightShipment) => {
                    const leftScheduledAt = leftShipment && leftShipment.scheduled_for ? new Date(leftShipment.scheduled_for).getTime() : 0;
                    const rightScheduledAt = rightShipment && rightShipment.scheduled_for ? new Date(rightShipment.scheduled_for).getTime() : 0;

                    return leftScheduledAt - rightScheduledAt;
                });
            }
            setShipmentsToDisplay(shownShipments);
        }
    }, [filter, shipmentsData, selected]);

    useEffect(() => {
        if (routeListSourceData && routeListSourceData.Routes) {
            let shownRoutes = [];

            routeListSourceData.Routes.forEach(element => {
                if (
                    (selected === 'completed' && routeMatchesCompletedTab(element))
                    || (selected !== 'completed' && filterRoutes.includes(element.status) && isDispatchVisibleRoute(element))
                ) {
                    shownRoutes.push(element);
                }
            });

            // Sort routes if `selected` is 'completed'
            if (selected === 'completed') {
                shownRoutes.sort((a, b) => {
                    return new Date(b.completed_at) - new Date(a.completed_at); // Descending order by completed_at
                });
            }

            setRoutesToDisplay(shownRoutes);
        }
    }, [filterRoutes, routeListSourceData, selected]); // Make sure to include `selected` as a dependency

    // Dispatch Map Filters
    useEffect(() => {
        if (!routesReadyCheck) {
            setReadyRoutes([]);
        } else {
            if (routesData) {
                let allDeliveringRoutes = [];
                routesData.Routes.forEach(route => {
                    if (
                        (route.status === 'route_ready' || route.status === 'route_temp_claimed' || route.status === 'route_temp_claimed_dispatch') &&
                        isDispatchVisibleRoute(route)
                    ) {
                        allDeliveringRoutes.push(route);
                    }
                });
                setReadyRoutes(allDeliveringRoutes);
                if (allDeliveringRoutes.length > 0) {
                    if (routesExpeditedCheck && !routesAlcoholCheck) {
                        let expeditedReadyRoutes = [];
                        allDeliveringRoutes.forEach(route => {
                            if (route.is_expedited) {
                                expeditedReadyRoutes.push(route);
                            }
                        });
                        setReadyRoutes(expeditedReadyRoutes);
                    }
                    if (routesAlcoholCheck && !routesExpeditedCheck) {
                        let alcoholReadyRoutes = [];
                        allDeliveringRoutes.forEach(route => {
                            if (route.contains_alcohol) {
                                alcoholReadyRoutes.push(route);
                            }
                        });
                        setReadyRoutes(alcoholReadyRoutes);
                    }
                    if (routesAlcoholCheck && routesExpeditedCheck) {
                        let expeditedAlcoholReadyRoutes = [];
                        allDeliveringRoutes.forEach(route => {
                            if (route.contains_alcohol && route.is_expedited) {
                                expeditedAlcoholReadyRoutes.push(route);
                            }
                        });
                        setReadyRoutes(expeditedAlcoholReadyRoutes);
                    }
                } else {
                    setReadyRoutes([]);
                }
            } else {
                setReadyRoutes([]);
            }
        }
    }, [routesData, routesReadyCheck, routesExpeditedCheck, routesAlcoholCheck]);

    useEffect(() => {
        if (!routesDeliveringCheck) {
            setDeliveringRoutes([]);
        } else {
            if (routesData) {
                let allReadyRoutes = [];
                routesData.Routes.forEach(route => {
                    if ((route.status === 'route_claimed' || route.status === 'route_assigned' || route.status === 'route_enroute') && isDispatchVisibleRoute(route)) {
                        allReadyRoutes.push(route);
                    }
                });
                setDeliveringRoutes(allReadyRoutes);
                if (allReadyRoutes.length > 0) {
                    if (routesExpeditedCheck && !routesAlcoholCheck) {
                        let expeditedReadyRoutes = [];
                        allReadyRoutes.forEach(route => {
                            if (route.is_expedited) {
                                expeditedReadyRoutes.push(route);
                            }
                        });
                        setDeliveringRoutes(expeditedReadyRoutes);
                    }
                    if (routesAlcoholCheck && !routesExpeditedCheck) {
                        let alcoholReadyRoutes = [];
                        allReadyRoutes.forEach(route => {
                            if (route.contains_alcohol) {
                                alcoholReadyRoutes.push(route);
                            }
                        });
                        setDeliveringRoutes(alcoholReadyRoutes);
                    }
                    if (routesAlcoholCheck && routesExpeditedCheck) {
                        let expeditedAlcoholReadyRoutes = [];
                        allReadyRoutes.forEach(route => {
                            if (route.contains_alcohol && route.is_expedited) {
                                expeditedAlcoholReadyRoutes.push(route);
                            }
                        });
                        setDeliveringRoutes(expeditedAlcoholReadyRoutes);
                    }
                } else {
                    setDeliveringRoutes([]);
                }
            } else {
                setDeliveringRoutes([]);
            }
        }
    }, [routesData, routesDeliveringCheck, routesExpeditedCheck, routesAlcoholCheck]);

    useEffect(() => {
        const activeFilters = {
            searchText: driverNameSMS,
            statusFilters: statusFilter,
            vehicleFilters: vehicleTypeFilter,
            permitFilters: permitFilter
        };

        const showOfflineDrivers = Array.isArray(statusFilter) && statusFilter.includes('unavailable');

        const filteredAvailable = (Array.isArray(availableDriversCopy) ? availableDriversCopy : []).filter(driver => driverMatchesFilters(driver, activeFilters));
        const filteredEnroute = (Array.isArray(enrouteDriversCopy) ? enrouteDriversCopy : []).filter(driver => driverMatchesFilters(driver, activeFilters));
        setAvailableDrivers(filteredAvailable);
        setEnrouteDrivers(filteredEnroute);

        // Defer offline driver filtering so the UI thread is not blocked when the checkbox is clicked.
        // Available/enroute are small sets; offline can be hundreds — always compute off the click frame.
        if (!showOfflineDrivers) {
            setOfflineDrivers([]);
            return undefined;
        }

        const offlineTimer = setTimeout(() => {
            const filteredOffline = (Array.isArray(offlineDriversCopy) ? offlineDriversCopy : []).filter(driver => driverMatchesFilters(driver, activeFilters));
            setOfflineDrivers(filteredOffline);
        }, 0);

        return () => clearTimeout(offlineTimer);
    }, [driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, availableDriversCopy, enrouteDriversCopy, offlineDriversCopy, driverMatchesFilters, setAvailableDrivers, setEnrouteDrivers, setOfflineDrivers]);

    // Functions
    const reset = () => {
        setPrimaryDriver('');
        setDriverSelected(false);
        setPassenger1('');
        setPassenger1Selected(false);
        setPassenger2('');
        setPassenger2Selected(false);
    };

    const resetReassign = () => {
        setDriverReassign('');
        setDriverReassignSelected(false);
    };

    const resetAssignPassengerOnly = () => {
        setPassenger1OnlyAssigned('');
        setPassenger1OnlyAssignedSelected(false);
        setPassenger2OnlyAssigned('');
        setPassenger2OnlyAssignedSelected(false);
    };

    const makeAlmostReady = order_friendly_id => {
        if (almostReady.includes(order_friendly_id)) {
            return <FaExclamationTriangle size="30" color="#fcb23a" />;
        } else {
            return <FaExclamationTriangle size="30" color="#fcb23a" />;
        }
    };

    const makeReady = order_friendly_id => {
        if (ready.includes(order_friendly_id)) {
            return <FaExclamationCircle size="30" color="#be1e2d" />;
        } else {
            return <FaExclamationCircle size="30" color="#be1e2d" />;
        }
    };

    const resetExpand = ({ force = false } = {}) => {
        if (!force && isDispatchRealtimeInteractionActive()) {
            return;
        }

        expandedItems[selected] = {};
        shipmentCurrentRecordMissCountRef.current = 0;
        routeCurrentRecordMissCountRef.current = 0;
        if (selected === 'merging') {
            setOpenedMergingRoutes([]);
        }
        if (selected === 'ready' || selected === 'progressing' || selected === 'completed' || selected === 'saved' || selected === 'pending') {
            setRouteClick('');
            setRouteClickTwice('');
            setEnrouteClickDriver('');
            setFocusedDriverOnMap(null);
            setCurrentRecordId(null);
            setCurrentRecord(null);
        }
        props.expand(expandedItems);
    };

    const syncOpenedMergingRoutes = expandedMergingState => {
        const nextExpandedState = expandedMergingState || {};
        const nextOpenedRoutes = filteredMergingRoutes.filter((routeRecord, index) => nextExpandedState[index]);
        setOpenedMergingRoutes(nextOpenedRoutes);
    };

    const hasExpandedRows = expandedState => {
        return hasExpandedDispatchRows(expandedState);
    };

    const clearRouteSelectionState = () => {
        enrouteDriverFetchTokenRef.current += 1;
        shipmentCurrentRecordMissCountRef.current = 0;
        routeCurrentRecordMissCountRef.current = 0;
        setRouteClick('');
        setRouteClickTwice('');
        setEnrouteClickDriver('');
        setFocusedDriverOnMap(null);
        setCurrentRecordId(null);
        setCurrentRecord(null);
    };

    const handleExpandedChange = nextExpandedState => {
        // The realtime interaction guard protects route/shipment tabs from collapsing
        // during live data updates, but the driver list has no such state — skip it.
        if (selected !== 'driverList' && isDispatchRealtimeInteractionActive()) {
            return;
        }

        if (!expandedItems[selected]) {
            expandedItems[selected] = {};
        }

        expandedItems[selected] = nextExpandedState || {};

        if (selected === 'ready' || selected === 'progressing' || selected === 'completed' || selected === 'saved') {
            const expandedIndexes = Object.keys(expandedItems[selected]).filter(key => Boolean(expandedItems[selected][key]));

            if (expandedIndexes.length > 0) {
                const expandedIndex = parseInt(expandedIndexes[0], 10);
                const routeRecord = selected === 'saved'
                    ? (filteredShipmentsToDisplay[expandedIndex] && filteredShipmentsToDisplay[expandedIndex].Route ? filteredShipmentsToDisplay[expandedIndex].Route : null)
                    : (routesToDisplay[expandedIndex] || null);

                if (routeRecord && routeRecord.route_id) {
                    setRouteClick(routeRecord);
                    setRouteClickTwice(routeRecord);
                    setCurrentRecordId(routeRecord.route_id);
                    setCurrentRecord(routeRecord);

                    if (selected === 'progressing') {
                        void fetchEnrouteAndDriver(routeRecord);
                    }
                }
            }
        }

        if (selected === 'merging') {
            syncOpenedMergingRoutes(expandedItems[selected]);
        }

        if (selected === 'driverList') {
            const expandedIndexes = Object.keys(expandedItems.driverList).filter(key => Boolean(expandedItems.driverList[key]));
            if (expandedIndexes.length > 0) {
                setExpandedDriverListSnapshot(currentSnapshot => currentSnapshot || driverListTableData);
                setFocusedDriverOnMap(null);
            } else {
                setExpandedDriverListSnapshot(null);
                setFocusedDriverOnMap(null);
            }
        }

        if (!hasExpandedRows(expandedItems[selected])) {
            clearRouteSelectionState();
        }

        props.expand(expandedItems);
    };

    async function handleRowClick(event, rowInfo, cell, element) {
        if (!expandedItems[selected]) {
            expandedItems[selected] = {};
        }

        const hydratedRouteRecord = (selected === 'ready' || selected === 'progressing' || selected === 'completed') && routesData && Array.isArray(routesData.Routes)
            ? routesData.Routes.find(routeRecord => routeRecord && routeRecord.route_id === event.original.route_id) || null
            : null;
        const activeRouteRecord = hydratedRouteRecord || event.original;

        // Set currentRecordId using the appropriate ID field based on the selected tab
        if (selected === 'ready' || selected === 'progressing' || selected === 'completed') {
            if (activeRouteRecord && activeRouteRecord.__dispatchPreview && !hydratedRouteRecord && !hasExpandableDispatchPreviewDetails(activeRouteRecord)) {
                props.notify('tc', 'Route details are still syncing. Try again in a moment.', 'warning');
                return;
            }

            setCurrentRecordId(activeRouteRecord.route_id);
            setCurrentRecord(activeRouteRecord);
        } else if (selected === 'saved' || selected === 'pending') {
            setCurrentRecordId(event.original.shipment_id);
            setCurrentRecord(event.original);
        }
        if (selected === 'ready') {
            if (
                element.target.toString().split(' ')[1] !== 'HTMLDivElement]' &&
                element.target.toString().split(' ')[1] !== 'SVGPathElement]' &&
                element.target.toString().split(' ')[1] !== 'SVGSVGElement]'
            ) {
                if (element.target.className.split(' ')[0] === 'btn' || element.target.className.split(' ')[0] === 'btn-simple') {
                    return;
                }
            }
            if (expandedItems.ready[event.viewIndex]) {
                expandedItems.ready[event.viewIndex] = !expandedItems.ready[event.viewIndex];
                clearRouteSelectionState();
            } else {
                expandedItems.ready[event.viewIndex] = true;
                setRouteClick(activeRouteRecord);
                setRouteClickTwice(activeRouteRecord);
            }
        } else if (selected === 'completed') {
            if (expandedItems.completed[event.viewIndex]) {
                expandedItems.completed[event.viewIndex] = !expandedItems.completed[event.viewIndex];
                clearRouteSelectionState();
            } else {
                expandedItems.completed[event.viewIndex] = true;
                setRouteClick(activeRouteRecord);
                setRouteClickTwice(activeRouteRecord);
            }
        } else if (selected === 'saved') {
            if (expandedItems.saved[event.viewIndex]) {
                expandedItems.saved[event.viewIndex] = !expandedItems.saved[event.viewIndex];
                //! convert shipment to route click
                clearRouteSelectionState();
            } else {
                expandedItems.saved[event.viewIndex] = true;
                setRouteClick(event.original.Route);
                setRouteClickTwice(event.original.Route);
            }
        } else if (selected === 'progressing') {
            if (expandedItems.progressing[event.viewIndex]) {
                expandedItems.progressing[event.viewIndex] = !expandedItems.progressing[event.viewIndex];
                clearRouteSelectionState();
            } else {
                expandedItems.progressing[event.viewIndex] = true;
                await updateTQLTracking(activeRouteRecord);
                setRouteClick(activeRouteRecord);
                fetchEnrouteAndDriver(activeRouteRecord);
                setRouteClickTwice(activeRouteRecord);
            }
        } else if (selected === 'pending') {
            if (expandedItems.pending[event.viewIndex]) {
                expandedItems.pending[event.viewIndex] = !expandedItems.pending[event.viewIndex];
                clearRouteSelectionState();
            } else {
                expandedItems.pending[event.viewIndex] = true;
            }
        } else if (selected === 'driverList') {
            toggleDriverListExpansion(event.original, event.viewIndex);
            return;
        } else if (selected === 'merging') {
            expandedItems.merging[event.viewIndex] = !expandedItems.merging[event.viewIndex];
            setFocusedDriverOnMap(null);
            setRouteClick('');
            syncOpenedMergingRoutes(expandedItems.merging);
        } else {
            setFocusedDriverOnMap(null);
        }

        props.expand(expandedItems);
    }

    const toggleDriverListExpansion = (driverRecord, viewIndex) => {
        if (typeof viewIndex !== 'number') {
            return;
        }

        if (!expandedItems.driverList) {
            expandedItems.driverList = {};
        }

        const shouldExpand = !expandedItems.driverList[viewIndex];

        expandedItems.driverList = shouldExpand ? { [viewIndex]: true } : {};
        setRouteClick('');
        setEnrouteClickDriver('');
        setExpandedDriverListSnapshot(currentSnapshot => shouldExpand ? (currentSnapshot || driverListTableData) : null);
        setFocusedDriverOnMap(null);
        props.expand(expandedItems);
    };

    function fetchAllDriversForAssign() {
        if (isLocalDashboardEnvironment) {
            setLoading(true);
            fetchDriversByMarketFallback(marketIdArray)
                .then(driverList => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversForAssign(driverList);
                    setLoading(false);
                })
                .catch(() => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversForAssign([]);
                    setLoading(false);
                });
            return;
        }

        if (isDirectUsersHasuraUnavailableLocally) {
            warnUsersHasuraUnavailable('driver assignment');
            setDriversForAssign([]);
            setLoading(false);
            return;
        }

        if (shouldAvoidBrowserUsersHasuraForDispatchDrivers || isHostedUsersHasuraUnavailableFromBrowser) {
            setLoading(true);
            fetchDriversByMarketFallback(marketIdArray)
                .then(driverList => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversForAssign(driverList);
                    setLoading(false);
                })
                .catch(() => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversForAssign([]);
                    setLoading(false);
                });
            return;
        }

        const marketIdArrayString = marketIdArray.map(id => `"${id}"`).join(',');
        setLoading(true);
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: user_urls.dispatchUsersHasuraHost,

            data: {
                query:
                    `{Drivers(order_by: [{ is_online: desc} , {is_available: desc}, {User: {firstname: asc}}, {User: {lastname: asc}}] where: {default_market_id: {_in:[` +
                    marketIdArrayString +
                    `]}}) { driver_id is_online is_available active_vehicle auth0_id updatedAt updated_by user_id carrying_capacity employment_type can_deliver_alcohol default_market_id restricted_area_credentials unread_message_count User { auth0_id username firstname lastname email phone FCMTokens(where:{application:{_eq:"driver"}}, order_by:{updatedAt:desc}, limit:1){platform} } Vehicles{vehicle_id type make model color year plate_state render_image_url vehicle_image_url image_url VehicleDocuments(where: {doc_type: {_eq: "vehicle_render"}}, order_by: {updated_at: desc}) { signed_url url path_id ocr_text updated_at }} LastDriverActions { market_id timestamp location_blob
          }}}`
            }
        })
            .then(response => {
                if (hasDispatchUnauthorizedPayloadError(response)) {
                    handleDispatchUnauthorizedError({
                        response: {
                            status: 401,
                            data: { errors: response.data.errors }
                        }
                    });
                }
                if (response.data.data) {
                    const drivers = Array.isArray(response.data.data.Drivers) ? response.data.data.Drivers : [];
                    if (drivers.length === 0) {
                        fetchDriversByMarketFallback(marketIdArray)
                            .then(fallbackDrivers => {
                                setDriversForAssign(fallbackDrivers);
                                setLoading(false);
                            })
                            .catch(() => {
                                setDriversForAssign([]);
                                setLoading(false);
                            });
                        return;
                    }

                    setDriversForAssign(drivers);
                    // console.log('drivers-for-assign ', driversForAssign);
                    setLoading(false);
                } else {
                    setDriversForAssign([]);
                    setLoading(false);
                }
            })
            .catch(() => {
                setDriversForAssign([]);
                setLoading(false);
            });
    }

    function fetchAllDriversForSMS() {
        if (isLocalDashboardEnvironment) {
            setLoading(true);
            fetchDriversByMarketFallback(marketIdArray)
                .then(driverList => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    const messageCount = driverList.reduce((sum, driver) => sum + (driver.unread_message_count || 0), 0);
                    setDriversToSMS(driverList);
                    applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverList);
                    setTotalUnreadDriverMessages(messageCount);
                    setLoading(false);
                })
                .catch(() => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversToSMS([]);
                    setDriversToSMSFiltered([]);
                    setTotalUnreadDriverMessages(0);
                    setLoading(false);
                });
            return;
        }

        if (isDirectUsersHasuraUnavailableLocally) {
            warnUsersHasuraUnavailable('driver messaging');
            setDriversToSMS([]);
            setDriversToSMSFiltered([]);
            setTotalUnreadDriverMessages(0);
            setLoading(false);
            return;
        }

        if (shouldAvoidBrowserUsersHasuraForDispatchDrivers || isHostedUsersHasuraUnavailableFromBrowser) {
            setLoading(true);
            fetchDriversByMarketFallback(marketIdArray)
                .then(driverList => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    const messageCount = driverList.reduce((sum, driver) => sum + (driver.unread_message_count || 0), 0);
                    setDriversToSMS(driverList);
                    applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverList);
                    setTotalUnreadDriverMessages(messageCount);
                    setLoading(false);
                })
                .catch(() => {
                    if (!isMountedRef.current) {
                        return;
                    }

                    setDriversToSMS([]);
                    setDriversToSMSFiltered([]);
                    setTotalUnreadDriverMessages(0);
                    setLoading(false);
                });
            return;
        }

        const marketIdArrayString = marketIdArray.map(id => `"${id}"`).join(',');
        setLoading(true);
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: user_urls.dispatchUsersHasuraHost,

            data: {
                query:
                    `{Drivers(order_by: [{ unread_message_count: desc} ,{ is_online: desc} , {is_available: desc}, {User: {firstname: asc}}, {User: {lastname: asc}}] where: {default_market_id: {_in:[` +
                    marketIdArrayString +
                    `]}}) { driver_id is_online is_available active_vehicle auth0_id updatedAt updated_by user_id carrying_capacity employment_type can_deliver_alcohol default_market_id restricted_area_credentials unread_message_count phone User { auth0_id username firstname lastname email phone Addresses { city state } FCMTokens(where:{application:{_eq:"driver"}}, order_by:{updatedAt:desc}, limit:1){platform} } Vehicles{vehicle_id type make model color year plate_state render_image_url vehicle_image_url image_url VehicleDocuments(where: {doc_type: {_eq: "vehicle_render"}}, order_by: {updated_at: desc}) { signed_url url path_id ocr_text updated_at }} LastDriverActions { market_id timestamp location_blob
          }}}`
            }
        })
            .then(response => {
                if (hasDispatchUnauthorizedPayloadError(response)) {
                    handleDispatchUnauthorizedError({
                        response: {
                            status: 401,
                            data: { errors: response.data.errors }
                        }
                    });
                }
                if (response.data.data) {
                    let driverData = response.data.data.Drivers;
                    if (!Array.isArray(driverData) || driverData.length === 0) {
                        fetchDriversByMarketFallback(marketIdArray)
                            .then(driverList => {
                                if (!isMountedRef.current) {
                                    return;
                                }

                                const messageCount = driverList.reduce((sum, driver) => sum + (driver.unread_message_count || 0), 0);
                                setDriversToSMS(driverList);
                                applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverList);
                                setTotalUnreadDriverMessages(messageCount);
                                setLoading(false);
                            })
                            .catch(() => {
                                if (!isMountedRef.current) {
                                    return;
                                }

                                setDriversToSMS([]);
                                setDriversToSMSFiltered([]);
                                setTotalUnreadDriverMessages(0);
                                setLoading(false);
                            });
                        return;
                    }

                    axios({
                        method: 'post',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                            'content-type': 'application/json'
                        },
                        url: shipment_urls.hasuraHost,
                        data: {
                            query: `{
                Markets (where: {deleted_at : {_is_null: true}}) {
                  market_name
                  market_id

                }
              }`
                        }
                    })
                        .then(response => {
                            if (response.data.data) {
                                let markets = response.data.data.Markets;
                                let driverList = [];
                                let messageCount = 0;
                                driverData.forEach(driver => {
                                    messageCount += driver.unread_message_count;
                                    let market_name;
                                    let permits = [];
                                    for (let i = 0; i < markets.length; i++) {
                                        if (driver.default_market_id === markets[i].market_id) {
                                            market_name = markets[i].market_name;
                                            break;
                                        }
                                    }
                                    if (driver.can_deliver_alcohol) {
                                        permits.push('Alcohol');
                                    }
                                    driver.restricted_area_credentials.forEach(credential => {
                                        permits.push(credential);
                                    });

                                    driver = {
                                        ...driver,
                                        market_name,
                                        permit: permits.map(permit => permit).join(', ')
                                    };
                                    driverList.push(driver);
                                });
                                setDriversToSMS(driverList);
                                applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverList);
                                setTotalUnreadDriverMessages(messageCount);
                                setLoading(false);
                            } else if (response.data.errors) {
                                setDriversToSMS([]);
                                setDriversToSMSFiltered([]);
                                setTotalUnreadDriverMessages(0);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            setDriversToSMS([]);
                            setDriversToSMSFiltered([]);
                            setTotalUnreadDriverMessages(0);
                            setLoading(false);
                        });
                    setLoading(false);
                } else {
                    setDriversToSMS([]);
                    setDriversToSMSFiltered([]);
                    setTotalUnreadDriverMessages(0);
                    setLoading(false);
                }
            })
            .catch(() => {
                setDriversToSMS([]);
                setDriversToSMSFiltered([]);
                setTotalUnreadDriverMessages(0);
                setLoading(false);
            });
    }

    function markDriverMessageRead(driverId, currentUnread) {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: user_urls.hasuraRest + '/driver/message/read',
            data: {
                driver_id: driverId
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setTotalUnreadDriverMessages(totalUnreadDriverMessages - currentUnread);
                    let updates = driversToSMS.map(driver => {
                        return driver.driver_id === driverId ? { ...driver, unread_message_count: 0 } : driver;
                    });
                    setDriversToSMS(updates);
                    applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, updates);
                } else {
                    props.notify('tc', 'Failed to mark driver messages as read', 'danger');
                }
            })
            .catch(() => {
                props.notify('tc', 'Failed to mark driver messages as read', 'danger');
            });
    }

        function fetchMergingRoutes() {
            const applyMergingRouteRecords = routeRecords => {
                const nextMergingRoutes = deriveMergingRoutesFromRouteRecords(routeRecords);

                setMergingRoutes(nextMergingRoutes);
                setMergingCheckStateAllChecked(false);
                setMergingCheckedState(new Array(nextMergingRoutes.length).fill(false));
                setAmountMerging(nextMergingRoutes.length);
            };

            const applySubscriptionMergingRoutes = () => {
                const routeRecords = effectiveRouteSubscriptionData && Array.isArray(effectiveRouteSubscriptionData.Routes)
                    ? effectiveRouteSubscriptionData.Routes
                    : [];

                applyMergingRouteRecords(routeRecords);
            };

            const marketIdsForMerging = allDispatchMarketIds.length > 0 ? allDispatchMarketIds : Array.isArray(marketIdArray) ? marketIdArray : [];

            if (marketIdsForMerging.length === 0) {
                        setMergingRoutes([]);
                        setMergingCheckStateAllChecked(false);
                        setMergingCheckedState([]);
                        setAmountMerging(0);
                        return;
                }

                    if (isHostedShipmentsHasuraUnavailableFromBrowser || shouldAvoidBrowserShipmentsHasuraForMerging) {
                        applySubscriptionMergingRoutes();
                        return;
                    }

                    if (isLocalDashboardEnvironment) {
                        axios({
                            method: 'get',
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: shipment_urls.adminDispatchRoutes,
                            params: {
                                market_ids: marketIdsForMerging.join(','),
                            }
                        })
                            .then(response => {
                                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                                applyMergingRouteRecords(payload);
                            })
                            .catch(error => {
                                void error;
                                setMergingRoutes([]);
                                setMergingCheckStateAllChecked(false);
                                setMergingCheckedState([]);
                                setAmountMerging(0);
                            });
                        return;
                    }

                const headers = {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                };

                const buildQuery = marketIdValue => `{
                        routes_temp_claimed_by_dispatch(args: {mkt_id: "${marketIdValue}"}) {
                            bounds
                            path
                            contains_alcohol
                            created_at
                            updated_at
                            updated_by
                            completed_at
                            market_id
                            num_of_gophrs
                            distance
                            route_id
                            route_friendly_id
                            status
                            waypoints_number
                            is_expedited
                            Shipments {
                                shipment_id
                                route_id
                                shipment_friendly_id
                                shipment_type
                                cust_auth0_id
                                cust_auth0_id
                                customer_blob
                                description
                                drop_off_instructions
                                status
                                distance
                                shipping_fee
                                shipping_fee_blob
                                weight
                                is_expedited
                                vehicle_type
                                num_of_gophrs
                                DriverPays {
                                    total_earning
                                    driver_status
                                    deleted_at
                                }
                                created_at
                                updated_at
                                pick_up_instructions
                                scheduled_for
                                contains_alcohol
                                merchant_order_id
                                ai_recommendation
                                client_type
                                Orders(order_by: { order_friendly_id: asc }) {
                                    location_blob
                                    contains_alcohol
                                    order_friendly_id
                                    status
                                    subtotal
                                    sum_tax
                                    total
                                    created_at
                                    updated_at
                                    pick_up_instructions
                                    description
                                    weight
                                    drop_off_instructions
                                    arrived_at
                                    actions
                                    Items {
                                        item_id
                                        product_blob
                                        quantity
                                        product_price
                                        status
                                        product_id
                                        ItemOptions {
                                            option_name
                                            option_price
                                            variant_name
                                            variant_blob
                                            option_blob
                                        }
                                    }
                                }
                            }
                            RouteDrivers(where: { deleted_at: { _is_null: true } }, order_by: { created_at: asc }) {
                                distance
                                driver_auth0_id
                                driver_blob
                                vehicle_id
                                vehicle_blob
                                status
                                driver_id
                            }
                        }
                    }`;

                Promise.all(
                    Array.from(new Set(marketIdsForMerging)).map(selectedMarketId =>
                                axios({
                                        method: 'post',
                                        headers,
                                        url: shipment_urls.hasuraHost,
                                        data: { query: buildQuery(selectedMarketId) }
                                })
                        )
                )
                        .then(responses => {
                                const routeMap = new Map();

                                responses.forEach(response => {
                                        if (response.data.errors && response.data.errors.length > 0) {
                                        if (hasDispatchUnauthorizedPayloadError(response)) {
                                            handleDispatchUnauthorizedError({
                                                response: {
                                                status: 401,
                                                data: { errors: response.data.errors }
                                                }
                                            });
                                        }
                                                return;
                                        }

                                        const fetchedRoutes = response.data.data && response.data.data.routes_temp_claimed_by_dispatch
                                                ? response.data.data.routes_temp_claimed_by_dispatch
                                                : [];

                                        fetchedRoutes.forEach(routeRecord => {
                                                if (!routeMap.has(routeRecord.route_id)) {
                                                        routeMap.set(routeRecord.route_id, routeRecord);
                                                }
                                        });
                                });

                                applyMergingRouteRecords(Array.from(routeMap.values()));
                        })
                        .catch(error => {
                                void error;
                                if (shouldAvoidBrowserShipmentsHasuraForMerging) {
                                    applySubscriptionMergingRoutes();
                                    return;
                                }
                                setMergingRoutes([]);
                                setMergingCheckStateAllChecked(false);
                                setMergingCheckedState([]);
                                setAmountMerging(0);
                        });
    }

    const filterDriver = e => {
        const keyword = e.target.value;

        if (keyword !== '') {
            const results = driversForAssign.filter(driver => {
                return driver.User.firstname.toLowerCase().startsWith(keyword.toLowerCase());
                // Use the toLowerCase() method to make it case-insensitive
            });

            setIsFilterDrivers(true);
            setFilterDriversForAssign(results);
        } else {
            setFilterDriversForAssign(driversForAssign);
            // If the text field is empty, show all users
        }

        setDriverName(keyword);
    };

    const applyAllFilters = useCallback((
        searchText = driverNameSMS,
        statusFilterValue = statusFilter,
        vehicleFilterValue = vehicleTypeFilter,
        permitFilterValue = permitFilter,
        sourceDrivers = driverListSourceData
    ) => {
        const results = (Array.isArray(sourceDrivers) ? sourceDrivers : []).filter(driver => driverMatchesFilters(driver, {
            searchText,
            statusFilters: statusFilterValue,
            vehicleFilters: vehicleFilterValue,
            permitFilters: permitFilterValue
        }));

        setDriversToSMSFiltered(sortDriverSmsList(results));
    }, [driverListSourceData, driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverMatchesFilters, sortDriverSmsList]);

    useEffect(() => {
        applyAllFiltersRef.current = applyAllFilters;
    }, [applyAllFilters]);

    useEffect(() => {
        applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter, driverListSourceData);
    }, [applyAllFilters, driverListSourceData, driverNameSMS, statusFilter, vehicleTypeFilter, permitFilter]);

    const filterDriverSMS = e => {
        const keyword = e.target.value;
        setDriverNameSMS(keyword);
        applyAllFilters(keyword, statusFilter, vehicleTypeFilter, permitFilter);
    };

    const handleStatusFilterChange = e => {
        const value = Array.isArray(e) ? e.map(option => option.value) : [];
        setStatusFilter(value);
        applyAllFilters(driverNameSMS, value, vehicleTypeFilter, permitFilter);
    };

    const handleVehicleTypeFilterChange = e => {
        const value = Array.isArray(e) ? e.map(option => option.value) : [];
        setVehicleTypeFilter(value);
        applyAllFilters(driverNameSMS, statusFilter, value, permitFilter);
    };

    const handlePermitFilterChange = e => {
        const value = Array.isArray(e) ? e.map(option => option.value) : [];
        setPermitFilter(value);
        applyAllFilters(driverNameSMS, statusFilter, vehicleTypeFilter, value);
    };

    const hasActiveDriverListFilters =
        driverNameSMS.trim() !== '' ||
        statusFilter.length > 0 ||
        vehicleTypeFilter.length > 0 ||
        permitFilter.length > 0;

    const liveDriverListTableData = hasActiveDriverListFilters ? driversToSMSFiltered : driverListSourceData;
    const driverListTableData = expandedDriverListSnapshot || liveDriverListTableData;

    useEffect(() => {
        if (!isLocalDashboardEnvironment) {
            setLocalDispatchShipments(current => (current.length === 0 ? current : []));
            setLocalDispatchShipmentsLoading(false);
            setLocalDispatchRoutes(current => (current.length === 0 ? current : []));
            setLocalDispatchRoutesLoading(false);
            return;
        }

        const activeLocalMarketScopeIds = Array.isArray(marketIdArray) && marketIdArray.length > 0
            ? marketIdArray
            : allDispatchMarketIds;

        let cancelled = false;
        let pollTimeoutId = null;
        let consecutiveFailures = 0;
        const localDispatchShipmentsUrl = shipment_urls.adminDispatchShipments;
        const hostedDispatchShipmentsUrl = shipment_urls.toHostedShipmentUrl(localDispatchShipmentsUrl);
        const localDispatchRoutesUrl = shipment_urls.adminDispatchRoutes;
        const hostedDispatchRoutesUrl = shipment_urls.toHostedShipmentUrl(localDispatchRoutesUrl);

        const fetchLocalDispatchShipments = () => {
            setLocalDispatchShipmentsLoading(true);

            const requestUrl = useHostedLocalDispatchShipmentsFallback ? hostedDispatchShipmentsUrl : localDispatchShipmentsUrl;

            return axios({
                method: 'get',
                timeout: getDispatchBootstrapRequestTimeout(requestUrl),
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: requestUrl,
                params: {
                    market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                }
            })
                .then(response => {
                    if (cancelled) {
                        return true;
                    }

                    const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];

                    if (
                        payload.length === 0 &&
                        !useHostedLocalDispatchShipmentsFallback &&
                        requestUrl === localDispatchShipmentsUrl &&
                        hostedDispatchShipmentsUrl !== localDispatchShipmentsUrl &&
                        shouldAttemptHostedDispatchFallback(localDispatchShipmentsUrl)
                    ) {
                        setUseHostedLocalDispatchShipmentsFallback(true);

                        return axios({
                            method: 'get',
                            timeout: getDispatchBootstrapRequestTimeout(hostedDispatchShipmentsUrl),
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: hostedDispatchShipmentsUrl,
                            params: {
                                market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                            }
                        })
                            .then(hostedResponse => {
                                if (cancelled) {
                                    return true;
                                }

                                const hostedPayload = hostedResponse && hostedResponse.data && Array.isArray(hostedResponse.data.payload)
                                    ? hostedResponse.data.payload
                                    : [];
                                setLocalDispatchShipments(hostedPayload);
                                return true;
                            })
                            .catch(() => {
                                if (!cancelled) {
                                    // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                                    setLocalDispatchShipments(current => current);
                                }

                                return false;
                            });
                    }

                    setLocalDispatchShipments(payload);
                    return true;
                })
                .catch(fetchError => {
                    if (
                        !cancelled &&
                        !useHostedLocalDispatchShipmentsFallback &&
                        hostedDispatchShipmentsUrl !== localDispatchShipmentsUrl &&
                        shouldAttemptHostedDispatchFallback(localDispatchShipmentsUrl) &&
                        isLocalShipmentNetworkFailure(fetchError)
                    ) {
                        setUseHostedLocalDispatchShipmentsFallback(true);

                        return axios({
                            method: 'get',
                            timeout: getDispatchBootstrapRequestTimeout(hostedDispatchShipmentsUrl),
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: hostedDispatchShipmentsUrl,
                            params: {
                                market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                            }
                        })
                            .then(response => {
                                if (cancelled) {
                                    return true;
                                }

                                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                                setLocalDispatchShipments(payload);
                                return true;
                            })
                            .catch(() => {
                                if (!cancelled) {
                                    // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                                    setLocalDispatchShipments(current => current);
                                }

                                return false;
                            });
                    }

                    if (!cancelled) {
                        void fetchError;
                        // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                        setLocalDispatchShipments(current => current);
                    }

                    return false;
                })
                .finally(() => {
                    if (!cancelled) {
                        setLocalDispatchShipmentsLoaded(true);
                        setLocalDispatchShipmentsLoading(false);
                    }
                });
        };

        const fetchLocalDispatchRoutes = () => {
            setLocalDispatchRoutesLoading(true);

            const requestUrl = useHostedLocalDispatchRoutesFallback ? hostedDispatchRoutesUrl : localDispatchRoutesUrl;

            return axios({
                method: 'get',
                timeout: getDispatchBootstrapRequestTimeout(requestUrl),
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: requestUrl,
                params: {
                    market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                }
            })
                .then(response => {
                    if (cancelled) {
                        return true;
                    }

                    const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];

                    if (
                        payload.length === 0 &&
                        !useHostedLocalDispatchRoutesFallback &&
                        requestUrl === localDispatchRoutesUrl &&
                        hostedDispatchRoutesUrl !== localDispatchRoutesUrl &&
                        shouldAttemptHostedDispatchFallback(localDispatchRoutesUrl)
                    ) {
                        setUseHostedLocalDispatchRoutesFallback(true);

                        return axios({
                            method: 'get',
                            timeout: getDispatchBootstrapRequestTimeout(hostedDispatchRoutesUrl),
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: hostedDispatchRoutesUrl,
                            params: {
                                market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                            }
                        })
                            .then(hostedResponse => {
                                if (cancelled) {
                                    return true;
                                }

                                const hostedPayload = hostedResponse && hostedResponse.data && Array.isArray(hostedResponse.data.payload)
                                    ? hostedResponse.data.payload
                                    : [];
                                setLocalDispatchRoutes(hostedPayload);
                                return true;
                            })
                            .catch(() => {
                                if (!cancelled) {
                                    // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                                    setLocalDispatchRoutes(current => current);
                                }

                                return false;
                            });
                    }

                    setLocalDispatchRoutes(payload);
                    return true;
                })
                .catch(fetchError => {
                    if (
                        !cancelled &&
                        !useHostedLocalDispatchRoutesFallback &&
                        hostedDispatchRoutesUrl !== localDispatchRoutesUrl &&
                        shouldAttemptHostedDispatchFallback(localDispatchRoutesUrl) &&
                        isLocalShipmentNetworkFailure(fetchError)
                    ) {
                        setUseHostedLocalDispatchRoutesFallback(true);

                        return axios({
                            method: 'get',
                            timeout: getDispatchBootstrapRequestTimeout(hostedDispatchRoutesUrl),
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: hostedDispatchRoutesUrl,
                            params: {
                                market_ids: activeLocalMarketScopeIds.length > 0 ? activeLocalMarketScopeIds.join(',') : undefined,
                            }
                        })
                            .then(response => {
                                if (cancelled) {
                                    return true;
                                }

                                const payload = response && response.data && Array.isArray(response.data.payload) ? response.data.payload : [];
                                setLocalDispatchRoutes(payload);
                                return true;
                            })
                            .catch(() => {
                                if (!cancelled) {
                                    // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                                    setLocalDispatchRoutes(current => current);
                                }

                                return false;
                            });
                    }

                    if (!cancelled) {
                        void fetchError;
                        // Keep the last successful snapshot to avoid visual resets during transient poll failures.
                        setLocalDispatchRoutes(current => current);
                    }

                    return false;
                })
                .finally(() => {
                    if (!cancelled) {
                        setLocalDispatchRoutesLoaded(true);
                        setLocalDispatchRoutesLoading(false);
                    }
                });
        };

        const getNextPollDelay = hasFailures => {
            if (!hasFailures) {
                return LOCAL_DISPATCH_POLL_SUCCESS_MS;
            }

            return Math.min(
                LOCAL_DISPATCH_POLL_FAILURE_BASE_MS * Math.pow(2, Math.max(consecutiveFailures - 1, 0)),
                LOCAL_DISPATCH_POLL_FAILURE_MAX_MS
            );
        };

        const scheduleNextPoll = hasFailures => {
            if (cancelled) {
                return;
            }

            pollTimeoutId = window.setTimeout(runPollCycle, getNextPollDelay(hasFailures));
        };

        const runPollCycle = () => {
            Promise.all([fetchLocalDispatchShipments(), fetchLocalDispatchRoutes()]).then(([shipmentsOk, routesOk]) => {
                if (cancelled) {
                    return;
                }

                const hasFailures = !shipmentsOk || !routesOk;
                consecutiveFailures = hasFailures ? consecutiveFailures + 1 : 0;
                scheduleNextPoll(hasFailures);
            });
        };

        runPollCycle();

        return () => {
            cancelled = true;
            if (pollTimeoutId) {
                window.clearTimeout(pollTimeoutId);
            }
        };
    }, [
        isLocalDashboardEnvironment,
        marketIdArray,
        allDispatchMarketIds,
        useHostedLocalDispatchShipmentsFallback,
        useHostedLocalDispatchRoutesFallback,
    ]);

    const getDriverDisplayBlob = driver => {
        const rawUser = driver && driver.User ? driver.User : {};
        const rawBlob = driver && driver.driver_blob ? driver.driver_blob : {};

        return {
            ...rawBlob,
            first_name: rawBlob.first_name || rawUser.firstname || rawUser.first_name || driver.firstname || driver.first_name || '',
            last_name: rawBlob.last_name || rawUser.lastname || rawUser.last_name || driver.lastname || driver.last_name || '',
            phone: rawBlob.phone || rawUser.phone || driver.phone || '',
            email: rawBlob.email || rawUser.email || driver.email || '',
        };
    };

    const normalizeDriverRecord = (driver, markets = []) => {
        const permits = [];
        const credentials = Array.isArray(driver.restricted_area_credentials) ? driver.restricted_area_credentials : [];
        const normalizedIsOnline = normalizeDriverStatusFlag(driver && driver.is_online);
        const normalizedIsAvailable = normalizeDriverStatusFlag(driver && driver.is_available);
        const driverBlob = getDriverDisplayBlob(driver);
        const normalizedVehicles = Array.isArray(driver.Vehicles)
            ? driver.Vehicles.map(vehicle => ({
                  ...vehicle,
                  render_image_url: getVehicleRenderUrl(vehicle) || vehicle.render_image_url || ''
              }))
            : [];
        const activeVehicleIdentity = driver && driver.active_vehicle ? String(driver.active_vehicle) : null;
        const normalizedActiveVehicleDetails = driver && driver.active_vehicle_details
            ? {
                  ...driver.active_vehicle_details,
                  render_image_url: getVehicleRenderUrl(driver.active_vehicle_details) || driver.active_vehicle_details.render_image_url || '',
                  image_url: getVehicleRenderUrl(driver.active_vehicle_details) || driver.active_vehicle_details.image_url || driver.active_vehicle_details.render_image_url || ''
              }
            : null;
        const activeVehicle =
            (activeVehicleIdentity && normalizedVehicles.find(vehicle => getVehicleIdentity(vehicle) === activeVehicleIdentity)) ||
            (normalizedActiveVehicleDetails && (!activeVehicleIdentity || getVehicleIdentity(normalizedActiveVehicleDetails) === activeVehicleIdentity)
                ? normalizedActiveVehicleDetails
                : null) ||
            normalizedVehicles[0] ||
            null;
        const lastDriverActions = Array.isArray(driver.LastDriverActions)
            ? driver.LastDriverActions.slice().sort((left, right) => new Date(right && right.timestamp ? right.timestamp : 0) - new Date(left && left.timestamp ? left.timestamp : 0))
            : [];
        const latestAction = lastDriverActions.find(action => normalizeDriverLocationBlob(action && action.location_blob)) || lastDriverActions[0] || null;
        const normalizedLatestAction = latestAction
            ? {
                  ...latestAction,
                  location_blob: normalizeDriverLocationBlob(latestAction.location_blob)
              }
            : null;
        const marketId = (latestAction && latestAction.market_id) || driver.default_market_id;
        const matchedMarket = markets.find(market => market.market_id === marketId);

        if (driver.can_deliver_alcohol) {
            permits.push('Alcohol');
        }

        credentials.forEach(credential => permits.push(credential));

        return {
            ...driver,
            is_online: normalizedIsOnline,
            is_available: normalizedIsAvailable,
            driver_blob: driverBlob,
            Vehicles: normalizedVehicles,
            LastDriverActions: normalizedLatestAction,
            market_name: matchedMarket ? matchedMarket.market_name : '',
            permit: permits.length > 0 ? permits.join(', ') : 'N/A',
            active_vehicle_details: activeVehicle,
            image_url: getVehicleRenderUrl(activeVehicle) || ''
        };
    };

    const getDriverRecordLookupKey = driver => {
        if (!driver) {
            return '';
        }

        return driver.driver_id ||
            driver.auth0_id ||
            driver.user_id ||
            (driver.User && (driver.User.auth0_id || driver.User.user_id)) ||
            '';
    };

    const getLatestDriverActionRecord = driver => {
        const lastDriverActions = Array.isArray(driver && driver.LastDriverActions)
            ? driver.LastDriverActions
            : (driver && driver.LastDriverActions ? [driver.LastDriverActions] : []);

        if (lastDriverActions.length === 0) {
            return null;
        }

        return lastDriverActions
            .slice()
            .sort((left, right) => new Date(right && right.timestamp ? right.timestamp : 0) - new Date(left && left.timestamp ? left.timestamp : 0))[0] || null;
    };

    const synchronizeDriverVehicleState = driver => {
        if (!driver) {
            return driver;
        }

        const vehicles = Array.isArray(driver.Vehicles) ? driver.Vehicles : [];
        const activeVehicleId = driver.active_vehicle ? String(driver.active_vehicle) : null;
        const resolvedActiveVehicle =
            resolveDriverVehicle(driver, activeVehicleId) ||
            (driver.active_vehicle_details && (!activeVehicleId || getVehicleIdentity(driver.active_vehicle_details) === activeVehicleId)
                ? driver.active_vehicle_details
                : null) ||
            vehicles[0] ||
            null;
        const resolvedImageUrl = getVehicleRenderUrl(resolvedActiveVehicle) || (resolvedActiveVehicle && (resolvedActiveVehicle.image_url || resolvedActiveVehicle.render_image_url)) || '';

        return {
            ...driver,
            active_vehicle: activeVehicleId || getVehicleIdentity(resolvedActiveVehicle) || null,
            active_vehicle_details: resolvedActiveVehicle
                ? {
                    ...resolvedActiveVehicle,
                    render_image_url: getVehicleRenderUrl(resolvedActiveVehicle) || resolvedActiveVehicle.render_image_url || '',
                    image_url: resolvedImageUrl,
                }
                : null,
            image_url: resolvedImageUrl,
        };
    };

    const mergeDriverRecords = (currentDriver, nextDriver) => {
        if (!currentDriver) {
            return synchronizeDriverVehicleState(nextDriver);
        }

        if (!nextDriver) {
            return synchronizeDriverVehicleState(currentDriver);
        }

        const currentHasLocation = driverHasMapLocation(currentDriver);
        const nextHasLocation = driverHasMapLocation(nextDriver);
        const currentLatestAction = getLatestDriverActionRecord(currentDriver);
        const nextLatestAction = getLatestDriverActionRecord(nextDriver);
        const currentLatestTimestamp = new Date(currentLatestAction && currentLatestAction.timestamp ? currentLatestAction.timestamp : 0).getTime();
        const nextLatestTimestamp = new Date(nextLatestAction && nextLatestAction.timestamp ? nextLatestAction.timestamp : 0).getTime();
        const currentUpdatedAtTimestamp = new Date(currentDriver && currentDriver.updatedAt ? currentDriver.updatedAt : 0).getTime();
        const nextUpdatedAtTimestamp = new Date(nextDriver && nextDriver.updatedAt ? nextDriver.updatedAt : 0).getTime();
        const shouldUseNextStatus = nextUpdatedAtTimestamp > currentUpdatedAtTimestamp;
        const shouldUseNextVehicle =
            nextUpdatedAtTimestamp >= currentUpdatedAtTimestamp ||
            nextDriver.active_vehicle !== currentDriver.active_vehicle ||
            nextDriver.image_url !== currentDriver.image_url;
        const nextActiveVehicleId = nextDriver.active_vehicle || null;
        const currentActiveVehicleId = currentDriver.active_vehicle || null;
        const nextActiveVehicleDetails = nextDriver.active_vehicle_details || null;
        const currentActiveVehicleDetails = currentDriver.active_vehicle_details || null;
        const nextActiveVehicleMatches = !nextActiveVehicleId || !nextActiveVehicleDetails || nextActiveVehicleDetails.vehicle_id === nextActiveVehicleId;
        const currentActiveVehicleMatches = !currentActiveVehicleId || !currentActiveVehicleDetails || currentActiveVehicleDetails.vehicle_id === currentActiveVehicleId;

        let preferredActions = currentDriver.LastDriverActions;
        if (nextHasLocation && (!currentHasLocation || nextLatestTimestamp >= currentLatestTimestamp)) {
            preferredActions = nextDriver.LastDriverActions;
        } else if (!currentHasLocation && nextDriver.LastDriverActions) {
            preferredActions = nextDriver.LastDriverActions;
        }

        const currentUser = currentDriver.User || null;
        const nextUser = nextDriver.User || null;
        const mergedUser = currentUser || nextUser
            ? {
                  ...(currentUser || {}),
                  ...(nextUser || {}),
                  auth0_id: (currentUser && currentUser.auth0_id) || (nextUser && nextUser.auth0_id) || null,
                  username: (currentUser && currentUser.username) || (nextUser && nextUser.username) || '',
                  firstname: (currentUser && currentUser.firstname) || (nextUser && nextUser.firstname) || '',
                  lastname: (currentUser && currentUser.lastname) || (nextUser && nextUser.lastname) || '',
                  email: (currentUser && currentUser.email) || (nextUser && nextUser.email) || '',
                  phone: (currentUser && currentUser.phone) || (nextUser && nextUser.phone) || '',
                  Addresses: nextUser && Array.isArray(nextUser.Addresses) && nextUser.Addresses.length > 0
                      ? nextUser.Addresses
                      : ((currentUser && Array.isArray(currentUser.Addresses)) ? currentUser.Addresses : []),
              }
            : null;

        return synchronizeDriverVehicleState({
            ...currentDriver,
            ...nextDriver,
            is_online: normalizeDriverStatusFlag(shouldUseNextStatus ? nextDriver.is_online : currentDriver.is_online),
            is_available: normalizeDriverStatusFlag(shouldUseNextStatus ? nextDriver.is_available : currentDriver.is_available),
            active_vehicle: shouldUseNextVehicle
                ? (nextDriver.active_vehicle || currentDriver.active_vehicle || null)
                : (currentDriver.active_vehicle || nextDriver.active_vehicle || null),
            default_market_id: currentDriver.default_market_id || nextDriver.default_market_id || null,
            carrying_capacity: currentDriver.carrying_capacity || nextDriver.carrying_capacity || null,
            employment_type: currentDriver.employment_type || nextDriver.employment_type || null,
            can_deliver_alcohol: Boolean(currentDriver.can_deliver_alcohol || nextDriver.can_deliver_alcohol),
            restricted_area_credentials: Array.isArray(currentDriver.restricted_area_credentials) && currentDriver.restricted_area_credentials.length > 0
                ? currentDriver.restricted_area_credentials
                : (Array.isArray(nextDriver.restricted_area_credentials) ? nextDriver.restricted_area_credentials : []),
            unread_message_count: Math.max(currentDriver.unread_message_count || 0, nextDriver.unread_message_count || 0),
            updatedAt: shouldUseNextStatus ? nextDriver.updatedAt : currentDriver.updatedAt,
            updated_by: shouldUseNextStatus ? nextDriver.updated_by : currentDriver.updated_by,
            phone: shouldUseNextStatus ? (nextDriver.phone || currentDriver.phone || '') : (currentDriver.phone || nextDriver.phone || ''),
            image_url: shouldUseNextVehicle
                ? (nextDriver.image_url || currentDriver.image_url || '')
                : (currentDriver.image_url || nextDriver.image_url || ''),
            active_vehicle_details: shouldUseNextVehicle
                ? (nextActiveVehicleMatches ? (nextActiveVehicleDetails || (currentActiveVehicleMatches ? currentActiveVehicleDetails : null) || null) : null)
                : (currentActiveVehicleMatches ? (currentActiveVehicleDetails || (nextActiveVehicleMatches ? nextActiveVehicleDetails : null) || null) : null),
            User: mergedUser,
            Vehicles: shouldUseNextVehicle && Array.isArray(nextDriver.Vehicles) && nextDriver.Vehicles.length > 0
                ? nextDriver.Vehicles
                : (Array.isArray(currentDriver.Vehicles) && currentDriver.Vehicles.length > 0
                    ? currentDriver.Vehicles
                    : (Array.isArray(nextDriver.Vehicles) ? nextDriver.Vehicles : [])),
            LastDriverActions: preferredActions,
        });
    };

    const mergeDriverRecordLists = (primaryDrivers = [], secondaryDrivers = []) => {
        const mergedDrivers = new Map();

        primaryDrivers.forEach(driver => {
            const lookupKey = getDriverRecordLookupKey(driver);
            if (lookupKey) {
                mergedDrivers.set(lookupKey, driver);
            }
        });

        secondaryDrivers.forEach(driver => {
            const lookupKey = getDriverRecordLookupKey(driver);
            if (!lookupKey) {
                return;
            }

            const existingDriver = mergedDrivers.get(lookupKey);
            mergedDrivers.set(lookupKey, mergeDriverRecords(existingDriver, driver));
        });

        return Array.from(mergedDrivers.values());
    };

    const enrichHostedDispatchDriversWithComplianceSummary = (requestId, currentDriverList = []) => {
        if (isLocalDashboardEnvironment) {
            return;
        }

        fetchDriversByMarketFallback(marketIdArray)
            .then(summaryDrivers => {
                if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                    return;
                }

                if (!Array.isArray(summaryDrivers) || summaryDrivers.length === 0) {
                    return;
                }

                const mergedDriverList = mergeDriverRecordLists(summaryDrivers, currentDriverList);
                applyDispatchDriverLists(mergedDriverList);
            })
            .catch(() => {});
    };

    const shouldUseLightweightDispatchDriverList = options => {
        if (!showDispatchMap) {
            return false;
        }

        if (!options || options.includeOffline !== true) {
            return false;
        }

        return Boolean(options.visibleBounds);
    };

    const fetchDriversFromUsersHasuraFallback = async (marketIds, hasuraHostOverride = null) => {
        const marketIdList = Array.isArray(marketIds) && marketIds.length > 0
            ? `[${marketIds.map(id => `"${id}"`).join(',')}]`
            : null;

        const driverWhereClause = marketIdList
            ? `where: { _or: [{ default_market_id: { _in: ${marketIdList} } }, { LastDriverActions: { market_id: { _in: ${marketIdList} } } }] },`
            : '';
        const lastDriverActionsArgs = marketIdList
            ? `(where: { market_id: { _in: ${marketIdList} } }, order_by: [{ timestamp: desc }])`
            : `(order_by: [{ timestamp: desc }])`;

        const driversResponse = await axios({
            method: 'post',
            timeout: HOSTED_DISPATCH_DRIVERS_TIMEOUT_MS,
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: hasuraHostOverride || user_urls.dispatchUsersHasuraHost,
            data: {
                query: `{
                    Drivers(${driverWhereClause} order_by: [{ is_online: desc }, { is_available: desc }, { User: { firstname: asc } }, { User: { lastname: asc } }]) {
                        driver_id
                        auth0_id
                        user_id
                        is_online
                        is_available
                        active_vehicle
                        carrying_capacity
                        employment_type
                        can_deliver_alcohol
                        default_market_id
                        restricted_area_credentials
                        unread_message_count
                        profile_photo_url
                        phone
                        User {
                            auth0_id
                            username
                            firstname
                            lastname
                            email
                            phone
                            FCMTokens(where:{application:{_eq:"driver"}}, order_by:{updatedAt:desc}, limit:1){platform}
                            Addresses {
                                city
                                state
                                latitude
                                longitude
                                address_1
                                zip
                            }
                        }
                        Vehicles {
                            vehicle_id
                            type
                            make
                            model
                            color
                            year
                            plate_state
                            render_image_url
                            vehicle_image_url
                            image_url
                            VehicleDocuments(where: {doc_type: {_eq: "vehicle_render"}}, order_by: {updated_at: desc}) {
                                signed_url
                                url
                                path_id
                                ocr_text
                                updated_at
                            }
                        }
                        LastDriverActions${lastDriverActionsArgs} {
                            market_id
                            timestamp
                            location_blob
                        }
                    }
                }`
            }
        });

        if (Array.isArray(driversResponse.data && driversResponse.data.errors) && driversResponse.data.errors.length > 0) {
            const fallbackError = new Error(driversResponse.data.errors[0].message || 'Users Hasura driver fallback query failed');
            fallbackError.graphqlErrors = driversResponse.data.errors;
            handleDispatchUnauthorizedError(fallbackError);
            throw fallbackError;
        }

        const drivers = (driversResponse.data && driversResponse.data.data && driversResponse.data.data.Drivers) || [];

        return drivers.map(driver => ({
            ...driver,
            LastDriverActions: Array.isArray(driver.LastDriverActions)
                ? driver.LastDriverActions.map(action => ({
                      ...action,
                      location_blob: normalizeDriverLocationBlob(action.location_blob),
                  }))
                : [],
        })).sort((left, right) => {
            if (left.is_online !== right.is_online) {
                return left.is_online ? -1 : 1;
            }

            if (left.is_available !== right.is_available) {
                return left.is_available ? -1 : 1;
            }

            const leftName = `${(left.User && left.User.firstname) || ''} ${(left.User && left.User.lastname) || ''}`.trim().toLowerCase();
            const rightName = `${(right.User && right.User.firstname) || ''} ${(right.User && right.User.lastname) || ''}`.trim().toLowerCase();
            return leftName.localeCompare(rightName);
        });
    };

    const fetchDriversFromLocalUsersHasuraProxy = async marketIds => {
        const LOCAL_PROXY_DRIVER_PAGE_SIZE = 1000;
        const LOCAL_PROXY_DRIVER_MAX_PAGES = 20;
        const fetchProxyDriverPage = async (offset, limit) => {
            const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutId = controller ? setTimeout(() => controller.abort(), LOCAL_PROXY_USERS_HASURA_TIMEOUT_MS) : null;
            const query = `{
                Drivers(limit: ${limit}, offset: ${offset}, order_by: [{ is_online: desc }, { is_available: desc }, { User: { firstname: asc } }, { User: { lastname: asc } }]) {
                    driver_id
                    auth0_id
                    user_id
                    profile_photo_url
                    is_online
                    is_available
                    active_vehicle
                    carrying_capacity
                    employment_type
                    can_deliver_alcohol
                    default_market_id
                    restricted_area_credentials
                    unread_message_count
                    phone
                    User {
                        auth0_id
                        username
                        firstname
                        lastname
                        email
                        phone
                        Addresses {
                            latitude
                            longitude
                        }
                    }
                    Vehicles {
                        vehicle_id
                        type
                        make
                        model
                        color
                        year
                        plate_state
                    }
                    LastDriverActions(limit: 1, order_by: [{ timestamp: desc }]) {
                        market_id
                        timestamp
                        location_blob
                    }
                }
            }`;

            let proxyJson = {};
            try {
                const response = await fetch('/__local/users-hasura', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ query }),
                    signal: controller ? controller.signal : undefined
                });

                const responseText = await response.text();
                try {
                    proxyJson = responseText ? JSON.parse(responseText) : {};
                } catch (error) {
                    throw new Error(`Local users hasura proxy returned non-JSON response (status ${response.status}): ${responseText.slice(0, 300)}`);
                }

                if (!response.ok) {
                    const proxyHttpError = new Error(
                        `Local users hasura proxy HTTP ${response.status}: ${String((proxyJson && proxyJson.errors && proxyJson.errors[0] && proxyJson.errors[0].message) || response.statusText || 'request failed')}`
                    );
                    proxyHttpError.status = response.status;
                    proxyHttpError.payload = proxyJson;
                    throw proxyHttpError;
                }
            } finally {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            }

            if (Array.isArray(proxyJson && proxyJson.errors) && proxyJson.errors.length > 0) {
                const proxyError = new Error(proxyJson.errors[0].message || 'Local users hasura proxy driver query failed');
                proxyError.graphqlErrors = proxyJson.errors;
                throw proxyError;
            }

            return (proxyJson && proxyJson.data && proxyJson.data.Drivers) || [];
        };

        const drivers = [];
        let pageCount = 0;
        let offset = 0;

        while (pageCount < LOCAL_PROXY_DRIVER_MAX_PAGES) {
            const pageDrivers = await fetchProxyDriverPage(offset, LOCAL_PROXY_DRIVER_PAGE_SIZE);

            if (!Array.isArray(pageDrivers) || pageDrivers.length === 0) {
                break;
            }

            drivers.push(...pageDrivers);
            pageCount += 1;

            if (pageDrivers.length < LOCAL_PROXY_DRIVER_PAGE_SIZE) {
                break;
            }

            offset += LOCAL_PROXY_DRIVER_PAGE_SIZE;
        }
        const normalizeMarketId = value => String(value || '').trim().toLowerCase();
        const selectedMarketIds = new Set((Array.isArray(marketIds) ? marketIds : []).map(normalizeMarketId).filter(Boolean));
        const scopedDrivers = selectedMarketIds.size > 0
            ? drivers.filter(driver => {
                const defaultMarketId = normalizeMarketId(driver && driver.default_market_id ? driver.default_market_id : '');
                if (defaultMarketId && selectedMarketIds.has(defaultMarketId)) {
                    return true;
                }

                const latestActionMarketId =
                    Array.isArray(driver && driver.LastDriverActions) && driver.LastDriverActions.length > 0 && driver.LastDriverActions[0] && driver.LastDriverActions[0].market_id
                        ? normalizeMarketId(driver.LastDriverActions[0].market_id)
                        : '';

                return latestActionMarketId ? selectedMarketIds.has(latestActionMarketId) : false;
            })
            : drivers;

        const shouldUseRawProxyDrivers = selectedMarketIds.size > 0 && scopedDrivers.length === 0 && drivers.length > 0;
        const filteredDrivers = shouldUseRawProxyDrivers ? drivers : scopedDrivers;

        setDispatchDriversDebug(previous => ({
            ...(previous || {}),
            proxyRawCount: Array.isArray(drivers) ? drivers.length : 0,
            proxyScopedCount: Array.isArray(scopedDrivers) ? scopedDrivers.length : 0,
            proxyUsedRawFallback: shouldUseRawProxyDrivers,
            proxyPageSize: LOCAL_PROXY_DRIVER_PAGE_SIZE,
            proxyPagesFetched: pageCount,
            proxyMaxPagesReached: pageCount >= LOCAL_PROXY_DRIVER_MAX_PAGES,
        }));

        return filteredDrivers.map(driver => ({
            ...driver,
            LastDriverActions: Array.isArray(driver.LastDriverActions)
                ? driver.LastDriverActions.map(action => ({
                      ...action,
                      location_blob: normalizeDriverLocationBlob(action.location_blob),
                  }))
                : [],
        }));
    };

    const fetchDriversByMarketFallback = async (marketIds, options = {}) => {
        setDispatchDriversDebug(previous => ({
            ...(previous || {}),
            mode: isLocalDashboardEnvironment ? 'local' : 'hosted',
            marketIdsCount: Array.isArray(marketIds) ? marketIds.length : 0,
            marketIdsSample: Array.isArray(marketIds) ? marketIds.slice(0, 10) : [],
        }));

        let markets = [];

        if (!isHostedShipmentsHasuraUnavailableFromBrowser) {
            try {
                const marketsResponse = await axios({
                    method: 'post',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.hasuraHost,
                    data: {
                        query: `{
                            Markets (where: {deleted_at : {_is_null: true}}) {
                                market_name
                                market_id
                            }
                        }`
                    }
                });

                markets = (marketsResponse.data && marketsResponse.data.data && marketsResponse.data.data.Markets) || [];
            } catch (error) {
                void error;
                markets = [];
            }
        }

        const buildDispatchDriversUrl = baseHost => {
            if (!baseHost) {
                return null;
            }

            const resolvedBaseHost =
                !isDashboardLocalDebugMode &&
                typeof window !== 'undefined' &&
                window.location &&
                !isLocalLikeHost(window.location.hostname)
                    ? 'https://api-users.gophr.app'
                    : baseHost;

            const searchParams = new URLSearchParams();

            if (Array.isArray(marketIds) && marketIds.length > 0) {
                searchParams.set('market_ids', marketIds.join(','));
            }

            if (options && options.visibleBounds) {
                const { minLat, maxLat, minLng, maxLng } = options.visibleBounds;
                if (Number.isFinite(minLat) && Number.isFinite(maxLat) && Number.isFinite(minLng) && Number.isFinite(maxLng)) {
                    searchParams.set('min_lat', String(minLat));
                    searchParams.set('max_lat', String(maxLat));
                    searchParams.set('min_lng', String(minLng));
                    searchParams.set('max_lng', String(maxLng));
                }
            }

            if (options && options.includeOffline === false) {
                searchParams.set('include_offline', 'false');
            }

            if (shouldUseLightweightDispatchDriverList(options)) {
                searchParams.set('lightweight', 'true');
            }

            const query = searchParams.toString();

            return `${resolvedBaseHost}/admin/dispatch/drivers${query ? `?${query}` : ''}`;
        };

        const driverMatchesMarketScope = (driverRecord, selectedMarketIds) => {
            if (!Array.isArray(selectedMarketIds) || selectedMarketIds.length === 0) {
                return true;
            }

            const selectedIds = new Set(selectedMarketIds.map(id => String(id)));
            const defaultMarketId = driverRecord && driverRecord.default_market_id ? String(driverRecord.default_market_id) : '';
            if (defaultMarketId && selectedIds.has(defaultMarketId)) {
                return true;
            }

            const actions = Array.isArray(driverRecord && driverRecord.LastDriverActions)
                ? driverRecord.LastDriverActions
                : [];

            return actions.some(action => action && action.market_id && selectedIds.has(String(action.market_id)));
        };

        const requestDispatchDrivers = async url => {
            if (!url) {
                return [];
            }

            const shouldBackOffLocalRequest =
                isLocalLikeHost(url) &&
                localDispatchDriversRetryAtRef.current > Date.now();

            if (shouldBackOffLocalRequest) {
                return [];
            }

            try {
                const requestTimeout = isLocalLikeHost(url)
                    ? LOCAL_DISPATCH_BOOTSTRAP_TIMEOUT_MS
                    : HOSTED_DISPATCH_DRIVERS_TIMEOUT_MS;
                const response = await axios({
                    method: 'get',
                    timeout: requestTimeout,
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url,
                });

                if (isLocalLikeHost(url)) {
                    localDispatchDriversRetryAtRef.current = 0;
                }

                if (Array.isArray(response.data && response.data.payload)) {
                    return response.data.payload;
                }

                if (Array.isArray(response.data && response.data.data)) {
                    return response.data.data;
                }

                if (Array.isArray(response.data && response.data.drivers)) {
                    return response.data.drivers;
                }

                if (Array.isArray(response.data)) {
                    return response.data;
                }

                return [];
            } catch (error) {
                handleDispatchUnauthorizedError(error);
                setDispatchDriversDebug(previous => ({
                    ...(previous || {}),
                    lastRestError: String((error && (error.code || (error.response && error.response.status) || error.message)) || 'unknown'),
                    lastRestErrorHost: typeof url === 'string' ? url : '',
                }));
                const isLocalNetworkFailure =
                    isLocalLikeHost(url) &&
                    (!error || !error.response) &&
                    (
                        error.code === 'ERR_NETWORK' ||
                        error.code === 'ECONNABORTED' ||
                        (typeof error.message === 'string' && (error.message.toLowerCase().includes('network error') || error.message.toLowerCase().includes('timeout')))
                    );

                if (isLocalNetworkFailure) {
                    localDispatchDriversRetryAtRef.current = Date.now() + LOCAL_DISPATCH_DRIVERS_RETRY_COOLDOWN_MS;
                }

                void error;
                return [];
            }
        };

        const browserLocalDispatchDriversUrl =
            typeof window !== 'undefined' &&
            isLocalLikeHost(window.location && window.location.hostname) &&
            !isLocalLikeHost(user_urls.dispatchDriversHost)
                ? buildDispatchDriversUrl(LOCAL_BROWSER_USERS_HOST)
                : null;
        const localDispatchDriversUrl = supportsDispatchDriversRestEndpoint(user_urls.dispatchDriversHost)
            ? user_urls.dispatchDriversList(marketIds, options)
            : browserLocalDispatchDriversUrl;
        const remoteDispatchDriversBaseHost = 'https://api-users.gophr.app';
        const alternateRemoteDispatchDriversBaseHost = null;
        const remoteDispatchDriversUrl = supportsDispatchDriversRestEndpoint(remoteDispatchDriversBaseHost)
            ? buildDispatchDriversUrl(remoteDispatchDriversBaseHost)
            : null;
        const alternateRemoteDispatchDriversUrl = supportsDispatchDriversRestEndpoint(alternateRemoteDispatchDriversBaseHost)
            ? buildDispatchDriversUrl(alternateRemoteDispatchDriversBaseHost)
            : null;
        const localDrivers = await requestDispatchDrivers(localDispatchDriversUrl);
        const shouldTryRemoteDispatchDrivers =
            localDrivers.length === 0 &&
            remoteDispatchDriversUrl !== localDispatchDriversUrl &&
            Boolean(remoteDispatchDriversUrl);
        const remoteApiDrivers = shouldTryRemoteDispatchDrivers
            ? await requestDispatchDrivers(remoteDispatchDriversUrl)
            : [];
        const shouldTryAlternateRemoteDispatchDrivers =
            localDrivers.length === 0 &&
            remoteApiDrivers.length === 0 &&
            alternateRemoteDispatchDriversUrl !== remoteDispatchDriversUrl &&
            Boolean(alternateRemoteDispatchDriversUrl);
        const alternateRemoteApiDrivers = shouldTryAlternateRemoteDispatchDrivers
            ? await requestDispatchDrivers(alternateRemoteDispatchDriversUrl)
            : [];

        let unscopedLocalDrivers = [];
        let unscopedRemoteDrivers = [];
        const shouldTryUnscopedRestFallback =
            Array.isArray(marketIds) &&
            marketIds.length > 0 &&
            localDrivers.length === 0 &&
            remoteApiDrivers.length === 0;

        if (shouldTryUnscopedRestFallback) {
            const localUnscopedUrl = supportsDispatchDriversRestEndpoint(user_urls.dispatchDriversHost)
                ? buildDispatchDriversUrl(user_urls.dispatchDriversHost)
                : (browserLocalDispatchDriversUrl ? buildDispatchDriversUrl(LOCAL_BROWSER_USERS_HOST) : null);
            const remoteUnscopedUrl = supportsDispatchDriversRestEndpoint(remoteDispatchDriversBaseHost)
                ? buildDispatchDriversUrl(remoteDispatchDriversBaseHost)
                : null;
            const alternateRemoteUnscopedUrl = supportsDispatchDriversRestEndpoint(alternateRemoteDispatchDriversBaseHost)
                ? buildDispatchDriversUrl(alternateRemoteDispatchDriversBaseHost)
                : null;

            unscopedLocalDrivers = await requestDispatchDrivers(localUnscopedUrl);
            if (remoteUnscopedUrl && remoteUnscopedUrl !== localUnscopedUrl) {
                unscopedRemoteDrivers = await requestDispatchDrivers(remoteUnscopedUrl);
            }

            if (unscopedRemoteDrivers.length === 0 && alternateRemoteUnscopedUrl && alternateRemoteUnscopedUrl !== remoteUnscopedUrl) {
                unscopedRemoteDrivers = await requestDispatchDrivers(alternateRemoteUnscopedUrl);
            }
        }

        const scopedFallbackLocalDrivers = (Array.isArray(unscopedLocalDrivers) ? unscopedLocalDrivers : []).filter(driver =>
            driverMatchesMarketScope(driver, marketIds)
        );
        const scopedFallbackRemoteDrivers = (Array.isArray(unscopedRemoteDrivers) ? unscopedRemoteDrivers : []).filter(driver =>
            driverMatchesMarketScope(driver, marketIds)
        );
        const recoveredRestDrivers = mergeDriverRecordLists(scopedFallbackLocalDrivers, scopedFallbackRemoteDrivers);
        const scopedLocalDrivers = mergeDriverRecordLists(localDrivers, recoveredRestDrivers);
        const scopedRemoteDrivers = mergeDriverRecordLists(remoteApiDrivers, alternateRemoteApiDrivers);

        if (isLocalDashboardEnvironment) {
            const localEnvironmentDrivers = mergeDriverRecordLists(scopedLocalDrivers, scopedRemoteDrivers);

            if (localEnvironmentDrivers.length > 0) {
                return localEnvironmentDrivers.map(driver => normalizeDriverRecord(driver, markets));
            }

            let localFallbackDrivers = [];
            let unscopedLocalFallbackDrivers = [];
            let scopedRecoveredHasuraFallbackDrivers = [];
            const alternateUsersHasuraHost = getAlternateUsersHasuraHost(user_urls.dispatchUsersHasuraHost);
            let alternateLocalFallbackDrivers = [];
            let alternateUnscopedLocalFallbackDrivers = [];
            let localProxyFallbackDrivers = [];
            let localProxyUnscopedFallbackDrivers = [];
            try {
                localProxyFallbackDrivers = await fetchDriversFromLocalUsersHasuraProxy(marketIds);
                localFallbackDrivers = localProxyFallbackDrivers;
            } catch (error) {
                handleDispatchUnauthorizedError(error);
                setDispatchDriversDebug(previous => ({
                    ...(previous || {}),
                    lastHasuraError: String((error && error.message) || 'unknown'),
                }));
            }

            if (localFallbackDrivers.length === 0) {
                try {
                    localFallbackDrivers = await fetchDriversFromUsersHasuraFallback(marketIds);
                } catch (error) {
                    handleDispatchUnauthorizedError(error);
                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        lastHasuraError: String((error && error.message) || 'unknown'),
                    }));
                }
            }

            if (localFallbackDrivers.length === 0 && alternateUsersHasuraHost) {
                try {
                    alternateLocalFallbackDrivers = await fetchDriversFromUsersHasuraFallback(marketIds, alternateUsersHasuraHost);
                    localFallbackDrivers = alternateLocalFallbackDrivers;
                } catch (error) {
                    handleDispatchUnauthorizedError(error);
                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        lastHasuraError: String((error && error.message) || 'unknown'),
                    }));
                }
            }

            if (Array.isArray(marketIds) && marketIds.length > 0 && localFallbackDrivers.length === 0) {
                try {
                    localProxyUnscopedFallbackDrivers = await fetchDriversFromLocalUsersHasuraProxy([]);
                    unscopedLocalFallbackDrivers = localProxyUnscopedFallbackDrivers;
                } catch (error) {
                    handleDispatchUnauthorizedError(error);
                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        lastHasuraError: String((error && error.message) || 'unknown'),
                    }));
                }

                if (unscopedLocalFallbackDrivers.length === 0) {
                    try {
                        unscopedLocalFallbackDrivers = await fetchDriversFromUsersHasuraFallback();
                    } catch (error) {
                        handleDispatchUnauthorizedError(error);
                        setDispatchDriversDebug(previous => ({
                            ...(previous || {}),
                            lastHasuraError: String((error && error.message) || 'unknown'),
                        }));
                    }
                }

                if (unscopedLocalFallbackDrivers.length === 0 && alternateUsersHasuraHost) {
                    try {
                        alternateUnscopedLocalFallbackDrivers = await fetchDriversFromUsersHasuraFallback([], alternateUsersHasuraHost);
                        unscopedLocalFallbackDrivers = alternateUnscopedLocalFallbackDrivers;
                    } catch (error) {
                        handleDispatchUnauthorizedError(error);
                        setDispatchDriversDebug(previous => ({
                            ...(previous || {}),
                            lastHasuraError: String((error && error.message) || 'unknown'),
                        }));
                    }
                }

                scopedRecoveredHasuraFallbackDrivers = unscopedLocalFallbackDrivers.filter(driver =>
                    driverMatchesMarketScope(driver, marketIds)
                );
                localFallbackDrivers = scopedRecoveredHasuraFallbackDrivers;
            }

            const mergedLocalFallbackDrivers = mergeDriverRecordLists(localEnvironmentDrivers, localFallbackDrivers);

            setDispatchDriversDebug(previous => ({
                ...(previous || {}),
                mode: 'local',
                marketIdsCount: Array.isArray(marketIds) ? marketIds.length : 0,
                marketIdsSample: Array.isArray(marketIds) ? marketIds.slice(0, 10) : [],
                localRestCount: Array.isArray(scopedLocalDrivers) ? scopedLocalDrivers.length : 0,
                remoteRestCount: Array.isArray(scopedRemoteDrivers) ? scopedRemoteDrivers.length : 0,
                localRestUnscopedCount: Array.isArray(unscopedLocalDrivers) ? unscopedLocalDrivers.length : 0,
                remoteRestUnscopedCount: Array.isArray(unscopedRemoteDrivers) ? unscopedRemoteDrivers.length : 0,
                remoteRestAltCount: Array.isArray(alternateRemoteApiDrivers) ? alternateRemoteApiDrivers.length : 0,
                hasuraFallbackCount: Array.isArray(localFallbackDrivers) ? localFallbackDrivers.length : 0,
                hasuraUnscopedCount: Array.isArray(unscopedLocalFallbackDrivers) ? unscopedLocalFallbackDrivers.length : 0,
                hasuraAltCount: Array.isArray(alternateLocalFallbackDrivers) ? alternateLocalFallbackDrivers.length : 0,
                hasuraLocalProxyCount: Array.isArray(localProxyFallbackDrivers) ? localProxyFallbackDrivers.length : 0,
                hasuraLocalProxyUnscopedCount: Array.isArray(localProxyUnscopedFallbackDrivers) ? localProxyUnscopedFallbackDrivers.length : 0,
                mergedCount: Array.isArray(mergedLocalFallbackDrivers) ? mergedLocalFallbackDrivers.length : 0,
                sourceUpdatedAt: new Date().toISOString(),
            }));

            return mergedLocalFallbackDrivers.map(driver => normalizeDriverRecord(driver, markets));
        }

        const hasRestDriverData =
            (Array.isArray(scopedLocalDrivers) && scopedLocalDrivers.length > 0)
            || (Array.isArray(scopedRemoteDrivers) && scopedRemoteDrivers.length > 0);

        const shouldSkipBrowserHasuraFallback =
            ((shouldAvoidBrowserUsersHasuraForDispatchDrivers || isHostedUsersHasuraUnavailableFromBrowser) && hasRestDriverData) ||
            (browserLocalDispatchDriversUrl && scopedLocalDrivers.length > 0);

        let remoteDrivers = [];
        let unscopedRemoteDriversFromHasura = [];
        const alternateUsersHasuraHost = getAlternateUsersHasuraHost(user_urls.dispatchUsersHasuraHost);
        let alternateRemoteDriversFromHasura = [];
        if (!shouldSkipBrowserHasuraFallback) {
            try {
                remoteDrivers = await fetchDriversFromUsersHasuraFallback(marketIds);
                if (remoteDrivers.length === 0 && alternateUsersHasuraHost) {
                    alternateRemoteDriversFromHasura = await fetchDriversFromUsersHasuraFallback(marketIds, alternateUsersHasuraHost);
                    remoteDrivers = alternateRemoteDriversFromHasura;
                }
                if (Array.isArray(marketIds) && marketIds.length > 0 && remoteDrivers.length === 0) {
                    unscopedRemoteDriversFromHasura = await fetchDriversFromUsersHasuraFallback();
                    if (unscopedRemoteDriversFromHasura.length === 0 && alternateUsersHasuraHost) {
                        unscopedRemoteDriversFromHasura = await fetchDriversFromUsersHasuraFallback([], alternateUsersHasuraHost);
                    }
                    remoteDrivers = unscopedRemoteDriversFromHasura.filter(driver => driverMatchesMarketScope(driver, marketIds));
                }
            } catch (error) {
                handleDispatchUnauthorizedError(error);
                setDispatchDriversDebug(previous => ({
                    ...(previous || {}),
                    lastHasuraError: String((error && error.message) || 'unknown'),
                }));
                void error;
                remoteDrivers = [];
            }
        }

        const drivers = mergeDriverRecordLists(mergeDriverRecordLists(scopedLocalDrivers, scopedRemoteDrivers), remoteDrivers);

        setDispatchDriversDebug(previous => ({
            ...(previous || {}),
            mode: 'hosted',
            marketIdsCount: Array.isArray(marketIds) ? marketIds.length : 0,
            marketIdsSample: Array.isArray(marketIds) ? marketIds.slice(0, 10) : [],
            localRestCount: Array.isArray(scopedLocalDrivers) ? scopedLocalDrivers.length : 0,
            remoteRestCount: Array.isArray(scopedRemoteDrivers) ? scopedRemoteDrivers.length : 0,
            localRestUnscopedCount: Array.isArray(unscopedLocalDrivers) ? unscopedLocalDrivers.length : 0,
            remoteRestUnscopedCount: Array.isArray(unscopedRemoteDrivers) ? unscopedRemoteDrivers.length : 0,
            remoteRestAltCount: Array.isArray(alternateRemoteApiDrivers) ? alternateRemoteApiDrivers.length : 0,
            hasuraFallbackCount: Array.isArray(remoteDrivers) ? remoteDrivers.length : 0,
            hasuraUnscopedCount: Array.isArray(unscopedRemoteDriversFromHasura) ? unscopedRemoteDriversFromHasura.length : 0,
            hasuraAltCount: Array.isArray(alternateRemoteDriversFromHasura) ? alternateRemoteDriversFromHasura.length : 0,
            mergedCount: Array.isArray(drivers) ? drivers.length : 0,
            skippedHasuraFallback: Boolean(shouldSkipBrowserHasuraFallback),
            sourceUpdatedAt: new Date().toISOString(),
        }));

        return drivers.map(driver => normalizeDriverRecord(driver, markets));
    };

    function fetchAllDrivers() {
        const requestId = dispatchDriversRequestIdRef.current + 1;
        dispatchDriversRequestIdRef.current = requestId;
        const marketIdsForDriverLoad = dispatchDriverMarketScopeIds;
        const visibleBoundsForDriverLoad = showDispatchMap ? dispatchMapVisibleBounds : null;
        const includeOfflineForDriverLoad = showDispatchMap ? dispatchMapOfflineFetchEnabled : true;

        setDispatchDriversDebug(previous => ({
            ...(previous || {}),
            effectiveScopeCount: Array.isArray(marketIdsForDriverLoad) ? marketIdsForDriverLoad.length : 0,
            effectiveScopeSource: Array.isArray(marketIdArray) && marketIdArray.length > 0 ? 'selected-market-filter' : 'all-dispatch-markets-fallback',
        }));

        const loadDriversFromFallback = () => {
            return fetchDriversByMarketFallback(marketIdsForDriverLoad, {
                visibleBounds: visibleBoundsForDriverLoad,
                includeOffline: includeOfflineForDriverLoad,
            })
                .then(driverList => {
                    if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                        return;
                    }

                    if (Array.isArray(driverList) && driverList.length === 0 && shouldPreserveLoadedDriversDuringLocalRetry()) {
                        setLoading(false);
                        return;
                    }

                    applyDispatchDriverLists(driverList, {
                        preserveTableLists: Boolean(visibleBoundsForDriverLoad),
                    });
                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        effectiveScopeCount: Array.isArray(marketIdsForDriverLoad) ? marketIdsForDriverLoad.length : 0,
                        effectiveScopeSource: Array.isArray(marketIdArray) && marketIdArray.length > 0 ? 'selected-market-filter' : 'all-dispatch-markets-fallback',
                    }));
                    if (!shouldUseLightweightDispatchDriverList({
                        visibleBounds: visibleBoundsForDriverLoad,
                        includeOffline: includeOfflineForDriverLoad,
                    })) {
                        enrichHostedDispatchDriversWithComplianceSummary(requestId, Array.isArray(driverList) ? driverList : []);
                    }
                    setLoading(false);
                })
                .catch(() => {
                    if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                        return;
                    }

                    if (!shouldPreserveLoadedDriversDuringLocalRetry()) {
                        clearDispatchDriverLists();
                    }
                    setLoading(false);
                });
        };

        if (isLocalDashboardEnvironment) {
            setLoading(true);
            fetchDriversFromLocalUsersHasuraProxy(marketIdsForDriverLoad)
                .then(proxyDrivers => {
                    if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                        return;
                    }

                    if (Array.isArray(proxyDrivers) && proxyDrivers.length > 0) {
                        applyDispatchDriverLists(proxyDrivers.map(driver => normalizeDriverRecord(driver, [])));
                        setDispatchDriversDebug(previous => ({
                            ...(previous || {}),
                            mode: 'local',
                            hasuraLocalProxyCount: proxyDrivers.length,
                            hasuraLocalProxyUnscopedCount: previous && previous.hasuraLocalProxyUnscopedCount ? previous.hasuraLocalProxyUnscopedCount : 0,
                            mergedCount: proxyDrivers.length,
                            sourceUpdatedAt: new Date().toISOString(),
                        }));
                        setLoading(false);
                        return;
                    }

                    return fetchDriversFromLocalUsersHasuraProxy([])
                        .then(unscopedProxyDrivers => {
                            if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                                return;
                            }

                            if (Array.isArray(unscopedProxyDrivers) && unscopedProxyDrivers.length > 0) {
                                applyDispatchDriverLists(unscopedProxyDrivers.map(driver => normalizeDriverRecord(driver, [])));
                                setDispatchDriversDebug(previous => ({
                                    ...(previous || {}),
                                    mode: 'local',
                                    hasuraLocalProxyCount: 0,
                                    hasuraLocalProxyUnscopedCount: unscopedProxyDrivers.length,
                                    mergedCount: unscopedProxyDrivers.length,
                                    sourceUpdatedAt: new Date().toISOString(),
                                }));
                                setLoading(false);
                                return;
                            }

                            loadDriversFromFallback();
                        })
                        .catch(error => {
                            if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                                return;
                            }

                            setDispatchDriversDebug(previous => ({
                                ...(previous || {}),
                                lastHasuraError: `local-proxy-unscoped-failed:${String((error && error.message) || error || 'unknown')}`,
                            }));

                            loadDriversFromFallback();
                        });
                })
                .catch(error => {
                    if (!isMountedRef.current || dispatchDriversRequestIdRef.current !== requestId) {
                        return;
                    }

                    setDispatchDriversDebug(previous => ({
                        ...(previous || {}),
                        lastHasuraError: `local-proxy-scoped-failed:${String((error && error.message) || error || 'unknown')}`,
                    }));

                    loadDriversFromFallback();
                });
            return;
        }

        if (isDirectUsersHasuraUnavailableLocally) {
            warnUsersHasuraUnavailable('dispatch driver map');
            setLoading(true);
            loadDriversFromFallback();
            return;
        }

        setLoading(true);
        loadDriversFromFallback();
    }

    function fetchDriverPay(shipId, driverId, driverStatus) {
        axios({
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.hasuraHost,
            data: {
                query:
                    ` {DriverPays(where: {driver_id: {_eq: "` +
                    driverId +
                    `"}, shipment_id: {_eq: "` +
                    shipId +
                    `"}, driver_status: {_in:[ "` +
                    driverStatus +
                    `", "miscellaneous"]},deleted_at : {_is_null: true}}, order_by: { created_at: asc }) {
              bonus
              distance
              distance_earning
              expedited_earning
              gratuity
              overweight_earning
              min_pay
              setup_earning
              tools_earning
              total_earning
              pay_id
              payed_status
              driver_id
              shipment_id
              driver_status
              first_name
              last_name
            }
          }`
            }
        })
            .then(response => {
                if (hasDispatchUnauthorizedPayloadError(response)) {
                    handleDispatchUnauthorizedError({
                        response: {
                            status: 401,
                            data: { errors: response.data.errors }
                        }
                    });
                }
                if (response.data.data) {
                    const payRecords = response.data.data.DriverPays || [];
                    setDriverPayRecords(payRecords);
                    if (payRecords.length === 1) {
                        setDriverPay(payRecords[0]);
                    } else if (payRecords.length > 1) {
                        let bonus = 0;
                        let total = 0;
                        payRecords.forEach(pay => {
                            bonus += pay.bonus;
                            total += pay.total_earning;
                        });
                        setDriverPay({ ...payRecords[0], bonus, total_earning: total });
                    } else {
                        setDriverPay(null);
                    }
                } else {
                    setDriverPay(null);
                    setDriverPayRecords([]);
                }
            })
            .catch(error => {
                void error;
                setDriverPay(null);
                setDriverPayRecords([]);
            });
    }

    async function resolveDriverPaymentExternally(payRecord) {
        const resolutionReference = externalPaymentReference.trim();
        const note = externalPaymentNote.trim();
        if (!resolutionReference || !note) {
            props.notify('tc', 'External payment reference and resolution note are required.', 'warning');
            return;
        }
        if (!window.confirm(`Confirm payment ${payRecord.pay_id} was completed outside Branch?`)) {
            return;
        }

        setResolvingDriverPayId(payRecord.pay_id);
        try {
            await axios({
                method: 'put',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                    'content-type': 'application/json'
                },
                url: shipment_urls.toHostedShipmentUrl(shipment_urls.getResolveExternalDriverPaymentUrl(payRecord.shipment_id, payRecord.pay_id)),
                data: {
                    resolution_reference: resolutionReference,
                    note
                }
            });
            setDriverPayRecords(records => records.map(record => record.pay_id === payRecord.pay_id ? { ...record, payed_status: true } : record));
            setExternalPaymentReference('');
            setExternalPaymentNote('');
            props.notify('tc', 'Driver payment marked resolved outside Branch.');
            void refreshLocalDispatchData();
        } catch (error) {
            props.notify('tc', extractRequestErrorMessage(error) || 'Unable to resolve driver payment.', 'danger');
        } finally {
            setResolvingDriverPayId('');
        }
    }

    useEffect(() => {
        if (selected !== 'merging') {
            return;
        }

        fetchMergingRoutes();
    }, [selected, marketIdArray, allDispatchMarketIds, mergingRouteRefreshKey]);

    useEffect(() => {
        fetchAllDrivers();
    }, [marketIdArray, allDispatchMarketIds]);

    useEffect(() => {
        if (!showDispatchMap || !dispatchMapVisibleBounds) {
            return undefined;
        }

        const timeoutId = window.setTimeout(() => {
            fetchAllDrivers();
        }, 250);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [dispatchMapOfflineFetchEnabled, dispatchMapVisibleBounds, showDispatchMap]);

    useEffect(() => {
        if (selected !== 'driverList') {
            return;
        }

        fetchAllDriversForSMS();
    }, [selected, marketIdArray]);

    //! Ready a scheduled Shipment
    function readyScheduledShipment(shipment) {
        const savedStatuses = ['shipment_saved', 'shipment_pending_saved', 'shipment_saved_pending_payment_retry'];
        if (savedStatuses.includes(shipment.status)) {
            // Saved drafts are readied via the backend /ready/override, which resolves the
            // store's real payment terms (net terms defer; prepay advances under admin override).
            forceReadyShipmentAdmin(shipment);
            return;
        }
        void runDispatchActionOnce(`ready-shipment:${shipment.shipment_id}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentEndpoint + shipment.shipment_id + '/ready'
                });
                props.notify('tc', 'Shipment Successfully Updated to Ready');
                void refreshLocalDispatchData();
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    props.notify('tc', 'This saved draft must go through checkout before it can be readied.', 'danger');
                } else if (error.response) {
                    props.notify('tc', 'Failed to mark shipment as ready.', 'danger');
                } else {
                    props.notify('tc', 'Request timed out. Please try again.', 'danger');
                }
            }
        });
    }

    const getPendingRetryAdvanceLabel = shipment => {
        if (!shipment) {
            return 'Ready';
        }

        return shipment.scheduled_for || shipment.status === 'shipment_pending_schedule' ? 'Scheduled' : 'Ready';
    };

    const openPaymentRetryModal = shipment => {
        if (!shipment) {
            return;
        }

        setSelectedShipmentForPayment(shipment);
        setPaymentRetryModalOpen(true);
    };

    const openPendingRetryInvoice = shipment => {
        const invoiceLinks = extractInvoiceLinks(shipment);

        if (!invoiceLinks || !invoiceLinks.hostedUrl) {
            const paymentError = getPaymentErrorMessage(shipment);
            props.notify('tc', paymentError || 'No invoice link is attached to this shipment yet.', 'warning');
            return;
        }

        window.open(invoiceLinks.hostedUrl, '_blank', 'noopener,noreferrer');
    };

    const copyPendingRetryInvoiceLink = async shipment => {
        const invoiceLinks = extractInvoiceLinks(shipment);

        if (!invoiceLinks || !invoiceLinks.hostedUrl) {
            props.notify('tc', 'No invoice link is attached to this shipment yet.', 'warning');
            return;
        }

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(invoiceLinks.hostedUrl);
            } else {
                const textArea = document.createElement('textarea');
                textArea.value = invoiceLinks.hostedUrl;
                textArea.setAttribute('readonly', 'readonly');
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            props.notify('tc', 'Invoice link copied to clipboard.');
        } catch (error) {
            props.notify('tc', 'Unable to copy invoice link. Open the invoice and copy it manually.', 'warning');
        }
    };

    const advancePendingPaidShipment = async shipment => {
        if (!shipment || !shipment.shipment_id) {
            return;
        }

        setPendingPaymentActionShipmentId(shipment.shipment_id);

        try {
            const result = await checkPaymentStatus(shipment.shipment_id);
            const paid = Boolean(result && result.payload && result.payload.paid);

            if (paid) {
                props.notify('tc', `Shipment moved to ${getPendingRetryAdvanceLabel(shipment).toLowerCase()}.`);
            } else {
                props.notify(
                    'tc',
                    result && result.payload && result.payload.reasonMessage
                        ? result.payload.reasonMessage
                        : 'Payment is still pending. Use the invoice link to collect payment, then try again.',
                    'warning'
                );
            }
        } catch (error) {
            const errorMessage =
                error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Unable to confirm payment right now.';
            props.notify('tc', errorMessage, 'danger');
        } finally {
            setPendingPaymentActionShipmentId('');
        }
    };

    //! complete route
    function completeRoute(route) {
        void runDispatchActionOnce(`complete-route:${route.route_id}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.completeDropRoute + route.route_id + '/complete'
                });
                props.notify('tc', 'Route Successfully Marked as Complete');
                void refreshLocalDispatchData();
                fetchAllDrivers();
            } catch (error) {
                void error;
                props.notify('tc', 'Failed to mark route as complete.', 'danger');
            }
        });
    }

    const capitalize = s => {
        if (typeof s !== 'string') return s;
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    useEffect(() => {
        if (selected === 'pending') {
            setFilter(PENDING_SHIPMENT_STATUSES);
        } else if (selected === 'saved') {
            setFilter(SCHEDULED_SHIPMENT_STATUSES);
        }
    }, [selected]);

    useEffect(() => {
        // Use the admin fallback (fetched regardless of the active tab) so the Pending
        // badge reflects new orders even when another tab is selected.
        const pendingBadgeData = adminDispatchShipmentFallbackData || effectiveShipmentSubscriptionData;
        if (pendingBadgeData && pendingBadgeData.Shipments) {
            let i = 0;
            let k = 0;
            pendingBadgeData.Shipments.forEach(element => {
                if (!isDispatchVisibleShipment(element)) {
                    return;
                }

                if (PENDING_SHIPMENT_STATUSES.includes(element.status)) {
                    i++;
                }
                if ((element.status === 'shipment_pending' || element.status === 'shipment_pending_schedule') && element.shipping_fee > 0) {
                    k++;
                }
            });
            setAmountPending(i);
            setAmountApproval(k);
            if (i > previousAmountPending) {
                playNotificationSound();
            }
        }
    }, [adminDispatchShipmentFallbackData, effectiveShipmentSubscriptionData, previousAmountPending]);

    useEffect(() => {
        if (selected === 'ready') {
            setFilterRoutes(['route_ready', 'route_temp_claimed']);
        } else if (selected === 'progressing') {
            setFilterRoutes(['route_claimed', 'route_assigned', 'route_enroute']);
        } else if (selected === 'completed') {
            setFilterRoutes(['route_completed']);
        }
    }, [selected]);

    useEffect(() => {
        if (selected === 'completed') {
            setCompletedRoutesPageIndex(0);
        }
    }, [completedRoutesPageSize, effectiveMarketScopeIds, selected]);

    useEffect(() => {
        if (!routeListSourceData || !Array.isArray(routeListSourceData.Routes) || !Array.isArray(filterRoutes) || filterRoutes.length === 0) {
            setRoutesToDisplay([]);
            return;
        }

        const shownRoutes = [];
        routeListSourceData.Routes.forEach(element => {
            if (
                (selected === 'completed' && routeMatchesCompletedTab(element))
                || (selected !== 'completed' && filterRoutes.includes(element.status) && isDispatchVisibleRoute(element))
            ) {
                shownRoutes.push(element);
            }
        });

        if (selected === 'completed') {
            shownRoutes.sort((a, b) => new Date(b.completed_at) - new Date(a.completed_at));
        }

        setRoutesToDisplay(shownRoutes);
        // setMergingCheckedState(new Array(shownRoutes.length).fill(false));
    }, [filterRoutes, routeListSourceData, selected]);

    useEffect(() => {
        if (routeListSourceData && routeListSourceData.Routes) {
            let i = 0;
            let j = 0;
            routeListSourceData.Routes.forEach(element => {
                if (element.status === 'route_ready' || element.status === 'route_temp_claimed') {
                    if (isDispatchVisibleRoute(element)) {
                        i++;
                    }
                }
                if ((element.status === 'route_claimed' || element.status === 'route_assigned') && isDispatchVisibleRoute(element)) {
                    j++;
                }
            });
            setAmountReady(i);
            setAmountDelivering(j);
            if (i > previousAmountReady) {
                playNotificationSound();
            }
        }
    }, [previousAmountReady, routeListSourceData]);

    const handleDriverSelect = driver => {
        setDriverSelected(true);
        setPrimaryDriver(driver);
    };

    const handlePassenger1Select = driver => {
        setPassenger1Selected(true);
        setPassenger1(driver);
    };

    const handlePassenger2Select = driver => {
        setPassenger2Selected(true);
        setPassenger2(driver);
    };

    const handleReassignDriverSelect = driver => {
        setDriverReassignSelected(true);
        setDriverReassign(driver);
    };

    const handlePassenger1OnlyAssignedSelect = driver => {
        setPassenger1OnlyAssignedSelected(true);
        setPassenger1OnlyAssigned(driver);
    };

    const handlePassenger2OnlyAssignedSelect = driver => {
        setPassenger2OnlyAssignedSelected(true);
        setPassenger2OnlyAssigned(driver);
    };

    const handleAssign = row => {
        setRoute(row);
        toggle();
        // fetchAllDrivers();
        fetchAllDriversForAssign();
    };

    const handleReassign = row => {
        setRoute(row);
        toggleReassign();
        // fetchAllDrivers();
        fetchAllDriversForAssign();
    };

    const handleAssignPassengerOnly = row => {
        setRoute(row);
        toggleAssignPassengerOnly();
        fetchAllDriversForAssign();
    };

    const getTotalItems = items => {
        let total = 0;
        items.forEach(item => {
            total = total + item.quantity;
        });
        return total;
    };

    const updateShippingFee = shipment => {
        if (shipment.shipping_fee > shippingFee) {
            alert(`The shipping fee you input is less than the original one $${shipment.shipping_fee}, if you think it's a mistake, please update again!`);
        }

        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.getAdminShipmentQuoteOverrideUrl(shipment.shipment_id),
            data: { shipping_fee: shippingFee, reason: shippingFeeReason }
        })
            .then(response => {
                if (response.status === 200) {
                    const updatedShipment = response.data && response.data.payload ? response.data.payload : null;

                    if (updatedShipment) {
                        replaceVisibleShipmentRecord(updatedShipment);
                    }

                    toggleShippingFee();
                    props.notify('tc', 'Successfully update shipping fee');
                    resetShippingFee();
                    resetShippingFeeReason();
                } else {
                    props.notify('tc', 'Failed to update shipping fee.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to update shipping fee.', 'danger');
            });
    };

    const chargeSetupFee = shipment => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminShipment + shipment.shipment_id + '/setup/charge',
            data: { duration: setupDuration }
        })
            .then(response => {
                if (response.status === 200) {
                    toggleSetupFee();
                    props.notify('tc', 'Successfully charged setup fee');
                    resetSetupFee();
                } else {
                    props.notify('tc', 'Failed to charge setup fee.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to charge setup fee.', 'danger');
            });
    };

    const updateBonus = driverPay => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminShipment + driverPay.shipment_id + '/driver/' + driverPay.driver_id + '/bonus',
            data: { bonus: driverBonus, reason: bonusReason }
        })
            .then(response => {
                if (response.status === 200) {
                    if (response.data.payload.overpay) {
                        alert(`Total driver(s) earnings is exceeding shipment total charges, if it's a mistake, please update again! `);
                    }
                    toggleDriverPay();
                    props.notify('tc', 'Successfully update driver bonus');
                    resetDriverBonus();
                    resetBonusReason();
                } else {
                    props.notify('tc', 'Failed to update driver bonus.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to update driver bonus.', 'danger');
            });
    };

    const updateTotalDriverPayBeforeClaim = shipment => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminShipment + shipment.shipment_id + '/driver_pay/update',
            data: { amount: driverPayBeforeClaimTotalAmount, reason: updateDriverPayBeforeClaimReason }
        })
            .then(response => {
                if (response.status === 200) {
                    toggleUpdateDriverPayBeforeClaim();
                    props.notify('tc', 'Successfully set total driver earning');
                    setDriverPayBeforeClaimTotalAmount('');
                    setUpdateDriverPayBeforeClaimReason('');
                } else {
                    props.notify('tc', 'Failed to set total driver earning.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to set total driver earning.', 'danger');
            });
    };

    const submitDemurrageDecision = (shipment, decision) => {
        if (!shipment || !shipment.billing_details || !shipment.billing_details.demurrage) {
            props.notify('tc', 'Demurrage review details are unavailable.', 'danger');
            return;
        }

        setIsSubmittingDemurrageDecision(true);

        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminShipment + shipment.shipment_id + '/demurrage/decision',
            data: {
                approved_review_amount: decision === 'approved' ? Number(shipment.billing_details.demurrage.review_amount || 0) : 0,
                decision,
                notes: demurrageDecisionNotes,
            }
        })
            .then(response => {
                if (response.status === 200) {
                    const updatedShipment = response.data && response.data.payload ? response.data.payload.shipment : null;

                    if (updatedShipment) {
                        replaceVisibleShipmentRecord(updatedShipment);
                    }

                    toggleDemurrageReviewModal();
                    props.notify('tc', decision === 'approved' ? 'Successfully applied demurrage review.' : 'Successfully denied demurrage review.');
                } else {
                    setIsSubmittingDemurrageDecision(false);
                    props.notify('tc', 'Failed to update demurrage review.', 'danger');
                }
            })
            .catch(error => {
                setIsSubmittingDemurrageDecision(false);
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to update demurrage review.', 'danger');
            });
    };

    const updateRouteDriverInfoAndPO = routeId => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminRoute + routeId + '/driver_info-and-po/update',
            data: { first_name: routeDriverFirstName, last_name: routeDriverLastName, phone: routeDriverPhone, po_number: routeDriverPONumber }
        })
            .then(response => {
                if (response.status === 200) {
                    toggleDriverInfoAndPO();
                    props.notify('tc', 'Successfully updated driver info and/or ELD #');
                    resetRouteDriverInfoAndPO();
                } else {
                    props.notify('tc', 'Failed to update driver info and ELD #.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to update driver info and ELD #.', 'danger');
            });
    };

    const updateOrderInfoForAdmin = orderId => {
        axios({
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                'content-type': 'application/json'
            },
            url: shipment_urls.adminOrder + orderId + '/update',
            data: { order_info: updateOrderInfo }
        })
            .then(response => {
                if (response.status === 200) {
                    toggleShowUpdateOrderInfo();
                    props.notify('tc', 'Successfully update order info');
                    setUpdateOrderInfo({ first_name: '', last_name: '', phone: '', business_name: '', instruction: '' });
                } else {
                    props.notify('tc', 'Failed to update order info.', 'danger');
                }
            })
            .catch(error => {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to update order info.', 'danger');
            });
    };

    const readyOrderAdmin = (shipment, order) => {
        const savedStatuses = ['shipment_saved', 'shipment_pending_saved', 'shipment_saved_pending_payment_retry'];
        if (savedStatuses.includes(shipment.status)) {
            // Saved drafts can't be per-order readied; use the admin override which resolves the store's terms.
            forceReadyShipmentAdmin(shipment);
            return;
        }
        void runDispatchActionOnce(`ready-order:${order.order_id}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.adminShipment + shipment.shipment_id + '/orders/' + order.order_id + '/ready'
                });
                props.notify('tc', 'Order Successfully be Readied');
                void refreshLocalDispatchData();
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    props.notify('tc', 'This saved draft must go through checkout before it can be readied.', 'danger');
                } else {
                    props.notify('tc', extractRequestErrorMessage(error) || 'Failed to ready order.', 'danger');
                }
            }
        });
    };

    const forceReadyShipmentAdmin = shipment => {
        void runDispatchActionOnce(`force-ready-shipment:${shipment.shipment_id}`, async () => {
            try {
                const response = await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.getAdminShipmentForceReadyUrl(shipment.shipment_id),
                    data: {
                        reason: 'admin override from pending dispatch actions',
                    }
                });
                const updatedShipment = response && response.data && response.data.payload ? response.data.payload : null;

                if (updatedShipment) {
                    replaceVisibleShipmentRecord(updatedShipment);
                }

                props.notify('tc', 'Shipment successfully forced to ready.');
                void refreshLocalDispatchData();
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to force shipment ready.', 'danger');
            }
        });
    };

    const sendRecipientTrackingLink = shipment => {
        void runDispatchActionOnce(`recipient-tracking-link:${shipment.shipment_id}`, async () => {
            try {
                await axios({
                    method: 'post',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentEndpoint + shipment.shipment_id + '/recipient-tracking-link/send',
                });
                props.notify('tc', 'Tracking link texted to the recipient.');
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to send the recipient tracking link.', 'danger');
            }
        });
    };

    // Text the live tracking link to any number the dispatcher enters (not just the recipient on file).
    const sendRecipientTrackingLinkToNumber = shipment => {
        const input = typeof window !== 'undefined' && window.prompt ? window.prompt('Text the tracking link to which phone number?') : '';
        const phone = (input || '').trim();
        if (!phone) {
            return;
        }
        void runDispatchActionOnce(`recipient-tracking-link-to:${shipment.shipment_id}:${phone}`, async () => {
            try {
                await axios({
                    method: 'post',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentEndpoint + shipment.shipment_id + '/recipient-tracking-link/send-to',
                    data: { phone },
                });
                props.notify('tc', `Tracking link texted to ${phone}.`);
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to send the tracking link.', 'danger');
            }
        });
    };

    const cancelOrderAdmin = (shipment, order) => {
        void runDispatchActionOnce(`cancel-order:${order.order_id}`, async () => {
            try {
                await axios({
                    method: 'delete',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.adminShipment + shipment.shipment_id + '/orders/' + order.order_id + '/cancel'
                });
                props.notify('tc', 'Order Successfully be Readied');
                void refreshLocalDispatchData();
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to cancel order.', 'danger');
            }
        });
    };

    const cancelShipment = shipment => {
        void runDispatchActionOnce(`cancel-shipment:${shipment.shipment_id}`, async () => {
            try {
                await axios({
                    method: 'delete',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.adminShipment + shipment.shipment_id + '/cancel'
                });
                props.notify('tc', 'Shipment Successfully canceled');
                void refreshLocalDispatchData();
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to cancel shipment.', 'danger');
            }
        });
    };

    const removeShipmentFromRoute = (routeId, shipId) => {
        void runDispatchActionOnce(`remove-shipment:${routeId}:${shipId}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentHost + '/routes/' + routeId + '/remove/' + shipId
                });
                props.notify('tc', 'Shipment removed from Route Successfully');
                void refreshLocalDispatchData();
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to remove shipment from route.', 'danger');
            }
        });
    };

    const unassignRoute = route => {
        void runDispatchActionOnce(`unassign-route:${route.route_id}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/unassign-only'
                });
                props.notify('tc', 'Route Successfully unassigned');
                void refreshLocalDispatchData();
                fetchAllDrivers();
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to unassign route.', 'danger');
            }
        });
    };

    const breakRoute = route => {
        void runDispatchActionOnce(`break-route:${route.route_id}`, async () => {
            try {
                await axios({
                    method: 'put',
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        'content-type': 'application/json'
                    },
                    url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/unmerge-entire'
                });
                props.notify('tc', 'Route Successfully broke into individual routes');
                void refreshLocalDispatchData().finally(() => {
                    fetchMergingRoutes();
                });
            } catch (error) {
                props.notify('tc', extractRequestErrorMessage(error) || 'Failed to split route.', 'danger');
            }
        });
    };

    const reassignDriverToRoute = d0 => {
        if (driverReassign !== '' && driverReassign !== null) {
            let reassignDriver = buildAssignedDriverPayload({
                driver: d0,
                status: 'driver',
                distance: route.distance
            });

            if (!reassignDriver) {
                props.notify('tc', 'Selected driver does not have a usable vehicle assignment.', 'danger');
                return;
            }

            void runDispatchActionOnce(`reassign-driver:${route.route_id}`, async () => {
                try {
                    await axios({
                        method: 'put',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                            'content-type': 'application/json'
                        },
                        url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/drivers/reassign',
                        data: reassignDriver
                    });
                    toggleReassign();
                    resetReassign();
                    void refreshLocalDispatchData();
                    fetchAllDrivers();
                    fetchAllDriversForAssign();
                } catch (error) {
                    props.notify('tc', extractRequestErrorMessage(error) || 'Failed to reassign driver.', 'danger');
                }
            });
        } else {
            props.notifyError('tc', null, 'You must reassign one new driver');
        }
    };

    const assignPassengerOnlyToRoute = (d1, d2) => {
        if (passenger1OnlyAssigned !== '') {
            let data1 = buildAssignedDriverPayload({
                driver: d1,
                status: 'passenger',
                distance: route.distance
            });

            if (!data1) {
                props.notify('tc', 'Selected passenger does not have a usable vehicle assignment.', 'danger');
                return;
            }
            void runDispatchActionOnce(`assign-passenger-only:${route.route_id}`, async () => {
                try {
                    await axios({
                        method: 'put',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                            'content-type': 'application/json'
                        },
                        url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/assign/passenger',
                        data: data1
                    });

                    if (passenger2OnlyAssigned !== '') {
                        let data2 = buildAssignedDriverPayload({
                            driver: d2,
                            status: 'passenger',
                            distance: shipment.distance
                        });

                        if (!data2) {
                            props.notify('tc', 'Selected second passenger does not have a usable vehicle assignment.', 'danger');
                            return;
                        }

                        await axios({
                            method: 'put',
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/assign/passenger',
                            data: data2
                        });
                    }

                    toggleAssignPassengerOnly();
                    resetAssignPassengerOnly();
                    void refreshLocalDispatchData();
                    fetchAllDrivers();
                    fetchAllDriversForAssign();
                } catch (error) {
                    props.notify('tc', extractRequestErrorMessage(error) || 'Failed to assign passenger.', 'danger');
                }
            });
        } else {
            props.notifyError('tc', null, 'You must assign at least one passenger');
        }
    };

    const handleConfirm = (d0, d1, d2) => {
        if (primaryDriver !== '' && primaryDriver !== null) {
            let data0 = buildAssignedDriverPayload({
                driver: d0,
                status: 'driver',
                distance: route.distance
            });

            if (!data0) {
                props.notify('tc', 'Selected driver does not have a usable vehicle assignment.', 'danger');
                return;
            }

            void runDispatchActionOnce(`assign-route:${route.route_id}`, async () => {
                try {
                    await axios({
                        method: 'put',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                            'content-type': 'application/json'
                        },
                        url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/assign/driver',
                        data: data0
                    });

                    if (passenger1 !== '' && passenger1 !== null) {
                        let data1 = buildAssignedDriverPayload({
                            driver: d1,
                            status: 'passenger',
                            distance: route.distance
                        });

                        if (!data1) {
                            props.notify('tc', 'Selected passenger does not have a usable vehicle assignment.', 'danger');
                            return;
                        }

                        await axios({
                            method: 'put',
                            headers: {
                                Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                'content-type': 'application/json'
                            },
                            url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/assign/passenger',
                            data: data1
                        });

                        if (passenger2 !== '' && passenger2 !== null) {
                            let data2 = buildAssignedDriverPayload({
                                driver: d2,
                                status: 'passenger',
                                distance: shipment.distance
                            });

                            if (!data2) {
                                props.notify('tc', 'Selected second passenger does not have a usable vehicle assignment.', 'danger');
                                return;
                            }

                            await axios({
                                method: 'put',
                                headers: {
                                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                    'content-type': 'application/json'
                                },
                                url: shipment_urls.shipmentHost + '/routes/' + route.route_id + '/assign/passenger',
                                data: data2
                            });
                        }
                    }

                    toggle();
                    reset();
                    void refreshLocalDispatchData();
                    fetchAllDrivers();
                    fetchAllDriversForAssign();
                } catch (error) {
                    const errorMessage = extractRequestErrorMessage(error);
                    props.notify('tc', errorMessage, 'danger');
                }
            });
        } else {
            props.notifyError('tc', null, 'You must assign at least one driver');
        }
    };

    const extractRequestErrorMessage = error => {
        const responseData = error && error.response ? error.response.data : null;

        if (typeof responseData === 'string' && responseData.trim() !== '') {
            return responseData;
        }

        if (responseData && typeof responseData.message === 'string' && responseData.message.trim() !== '') {
            return responseData.message;
        }

        if (responseData && typeof responseData.error === 'string' && responseData.error.trim() !== '') {
            return responseData.error;
        }

        if (error && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message;
        }

        return 'Request failed.';
    };

    const replaceVisibleShipmentRecord = updatedShipment => {
        if (!updatedShipment || !updatedShipment.shipment_id) {
            return;
        }

        setShipment(current => (current && current.shipment_id === updatedShipment.shipment_id ? mergeShipmentSnapshot(current, updatedShipment) : current));
        setCurrentRecord(current => (current && current.shipment_id === updatedShipment.shipment_id ? mergeShipmentSnapshot(current, updatedShipment) : current));
        setShipmentsData(current => {
            if (!current || !Array.isArray(current.Shipments)) {
                return current;
            }

            return {
                ...current,
                Shipments: current.Shipments.map(currentShipment =>
                    currentShipment.shipment_id === updatedShipment.shipment_id ? mergeShipmentSnapshot(currentShipment, updatedShipment) : currentShipment
                ),
            };
        });
        setShipmentsToDisplay(current => {
            if (!Array.isArray(current)) {
                return current;
            }

            return current.map(currentShipment =>
                currentShipment.shipment_id === updatedShipment.shipment_id ? mergeShipmentSnapshot(currentShipment, updatedShipment) : currentShipment
            );
        });

        if (isLocalDashboardEnvironment) {
            setLocalDispatchShipments(current => {
                if (!Array.isArray(current)) {
                    return current;
                }

                return current.map(currentShipment =>
                    currentShipment.shipment_id === updatedShipment.shipment_id ? mergeShipmentSnapshot(currentShipment, updatedShipment) : currentShipment
                );
            });
        }
    };

    const getTrProps = (rowInfo, column, cell) => {
        if (rowInfo) {
            if (column) {
                if (!apolloading) {
                    const unreadDriverMessageCount = column.original.hasOwnProperty('Shipments')
                        ? getClaimedOrderChatUnreadCountForRoute(column.original) + getSmsUnreadCountForRoute(column.original) + getRouteShipments(column.original).reduce((count, shipment) => count + getPreClaimOrderChatUnreadCountForShipment(shipment && shipment.shipment_id), 0)
                        : getTotalChatUnreadCountForShipment(column.original) + getPreClaimOrderChatUnreadCountForShipment(column.original && column.original.shipment_id);
                    const unreadRowBackground = unreadDriverMessageCount > 0
                        ? (isDarkMode ? 'rgba(245, 197, 66, 0.24)' : '#FFF3B0')
                        : rowSurfaceBackground;

                    // Preferred-driver orders get a yellow border so dispatch can spot them at a glance.
                    const preferredEffectiveShipment = column.original.hasOwnProperty('Shipments')
                        ? getPrimaryShipmentFromRoute(column.original)
                        : column.original;
                    const preferredDispatchBlob = preferredEffectiveShipment
                        && preferredEffectiveShipment.shipping_fee_blob
                        && preferredEffectiveShipment.shipping_fee_blob.preferred_dispatch;
                    if (preferredDispatchBlob && preferredDispatchBlob.driver_auth0_id) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid #FFD600',
                                textAlign: 'left'
                            }
                        };
                    }

                    if (column.original.status === 'shipment_saved_pending_payment_retry') {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid #2BBBAE',
                                textAlign: 'left'
                            }
                        };
                    }
                    if (
                        column.original.hasOwnProperty('Shipments') &&
                        isFedexShipment(getPrimaryShipmentFromRoute(column.original))
                    ) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid purple',
                                textAlign: 'left'
                            }
                        };
                    }

                    const effectiveShipment = column.original.hasOwnProperty('Shipments')
                        ? getPrimaryShipmentFromRoute(column.original)
                        : column.original;

                    if (effectiveShipment && effectiveShipment.is_ship_tomorrow) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid #1E90FF',
                                textAlign: 'left'
                            }
                        };
                    }
                    if ((column.original.status === 'shipment_pending' || column.original.status === 'shipment_pending_schedule') && column.original.shipping_fee > 0) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid green',
                                textAlign: 'left'
                            }
                        };
                    } else if ((column.original.status === 'shipment_pending' || column.original.status === 'shipment_pending_schedule') && column.original.shipping_fee === 0) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid red',
                                textAlign: 'left'
                            }
                        };
                    }

                    if (column.original.is_expedited) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid #f79400',
                                textAlign: 'left'
                            }
                        };
                    }

                    if (effectiveShipment && effectiveShipment.scheduled_for) {
                        return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                padding: '0px',
                                border: '2px solid green',
                                textAlign: 'left'
                            }
                        };
                    }

                    return {
                            onClick: e => {
                                handleRowClick(column, rowInfo, cell, e);
                            },
                            style: {
                                cursor: 'pointer',
                                height: `70px`,
                                margin: `5px`,
                                borderRadius: `5px`,
                                background: unreadRowBackground,
                                textAlign: 'left',
                                padding: '0px'
                            }
                        };
                } else {
                    return {};
                }
            }
            return {};
        }
    };

    const getTheadThProps = () => {
        return {
            style: {
                fontSize: `10px`,
                fontWeight: `600`,
                textAlign: `left`,
                color: `#cdcaca`
            }
        };
    };

    const pendingColumns = [
        {
            expander: true,
            Expander: ({ isExpanded, ...rest }) => (
                <div style={{ textAlign: 'left' }}>
                    {!isExpanded ? (
                        <span>
                            <FaCaretRight color={'#BFC0C5'} size="20" />
                        </span>
                    ) : (
                        <span>
                            <FaCaretDown color={'#BFC0C5'} size="20" />
                        </span>
                    )}
                </div>
            )
        },
        {
            Header: 'Ship_ID',
            accessor: 'shipment_friendly_id',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => {
                const unreadCount = getPreClaimOrderChatUnreadCountForShipment(row.original && row.original.shipment_id);

                return (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'inline-flex',
                            flexWrap: 'wrap',
                            gap: '8px',
                            textAlign: 'left'
                        }}
                    >
                        <span>{row.value}</span>
                        {renderClaimedOrderUnreadBadge(unreadCount, { backgroundColor: '#D62828', borderColor: '#FFFFFF' })}
                    </div>
                );
            }
        },
        {
            Header: 'Status',
            accessor: 'status',
            // width: 65,
            width: 200,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => {
                const isPendingPaymentRetry = row.original.status === 'shipment_saved_pending_payment_retry';

                return (
                    <div style={{ textAlign: 'left' }}>
                        {row.original.status === 'shipment_pending_payment' ? (
                            'Pending Invoice Payment'
                        ) : isPendingPaymentRetry ? (
                            <Badge color="warning" style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '8px 12px' }}>
                                <FaExclamationTriangle />
                                Payment Action Required
                            </Badge>
                        ) : (row.original.shipment_type === 'direct' || row.original.shipment_type === 'routed_direct' || row.original.shipment_type === 'multidrop_direct') &&
                          row.original.shipping_fee > 0 ? (
                            'Waiting Merchant Acceptance'
                        ) : (row.original.shipment_type === 'direct' || row.original.shipment_type === 'routed_direct' || row.original.shipment_type === 'multidrop_direct') &&
                          row.original.shipping_fee === 0 ? (
                            'Quote Pending'
                        ) : (
                            <span style={{ textAlign: 'left' }}>Pending Merchant Approval</span>
                        )}
                    </div>
                );
            }
        },
        {
            Header: 'Customer',
            accessor: 'customer_blob',
            width: 150,
            // width: 'auto',
            textAlign: 'left',
            Cell: props => (
                <div
                    style={{
                        // width: 1,
                        fontWeight: 'bold',
                        textAlign: 'left'
                    }}
                >
                    {props.value.store_name ? props.value.store_name : props.value.first_name + ' ' + props.value.last_name}
                </div>
            )
        },
        {
            Header: 'Customer Ph.',
            accessor: 'customer_blob',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left'
                    }}
                >
                    {props.value.phone}
                </div>
            )
        },
        {
            Header: 'Origin',
            width: 220,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getShipmentOriginLabel(props.original)}</div>
        },
        {
            Header: 'Created At',
            id: 'created_at',
            accessor: row => getImmutableCreatedAt(row),
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{formatTimestamp(props.value)}</div>
        },
        {
            Header: 'Actions',
            style: {
                paddingTop: `0px`,
                paddingBottom: `0px`
            },
            // width: 'auto',
            width: 430,
            textAlign: 'left',
            Cell: props => {
                const isPendingPaymentRetry = props.original.status === 'shipment_saved_pending_payment_retry';
                const isPendingPaymentActionLoading = pendingPaymentActionShipmentId === props.original.shipment_id;
                const pendingRetryAdvanceLabel = getPendingRetryAdvanceLabel(props.original);

                if (!apolloading) {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {isPendingPaymentRetry ? (
                                <ButtonGroup style={{ textAlign: 'left', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                    <PendingQuoteOverrideButton shipment={props.original} />
                                    <Button
                                        className="btn btn-warning"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            openPaymentRetryModal(props.original);
                                        }}
                                    >
                                        <i className="fas fa-credit-card"></i>
                                        Check Payment
                                    </Button>
                                    <Button
                                        className="btn btn-info"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            openPendingRetryInvoice(props.original);
                                        }}
                                    >
                                        <i className="fas fa-external-link-alt"></i>
                                        Invoice
                                    </Button>
                                    <Button
                                        className="btn btn-secondary"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={async e => {
                                            e.stopPropagation();
                                            await copyPendingRetryInvoiceLink(props.original);
                                        }}
                                    >
                                        <i className="fas fa-copy"></i>
                                        Copy Link
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        disabled={isPendingPaymentActionLoading}
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={async e => {
                                            e.stopPropagation();
                                            await advancePendingPaidShipment(props.original);
                                        }}
                                    >
                                        {isPendingPaymentActionLoading ? (
                                            <i className="fas fa-spinner fa-spin"></i>
                                        ) : (
                                            <i className="fas fa-check"></i>
                                        )}
                                        {pendingRetryAdvanceLabel}
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            forceReadyShipmentAdmin(props.original);
                                        }}
                                    >
                                        <i className="fas fa-bolt"></i>
                                        Force Ready
                                    </Button>
                                    {canDispatchEditActiveShipment(props.original) ? (
                                        <Button
                                            className="btn btn-info"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                openActiveOrderEditor(props.original);
                                            }}
                                        >
                                            <i className="fas fa-pen"></i>
                                            Edit
                                        </Button>
                                    ) : null}
                                    <Button
                                        className="btn btn-danger"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, alignItems: 'center', gap: '5px' }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setShipment(props.original);
                                            setShowAlertCancelShipment(true);
                                        }}
                                    >
                                        <i className="fas fa-times"></i>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            ) : props.original.shipment_type === 'direct' ||
                              props.original.shipment_type === 'connect' ||
                              props.original.shipment_type === 'routed_direct' ||
                              props.original.shipment_type === 'multidrop_direct' ? (
                                <ButtonGroup style={{ textAlign: 'left' }}>
                                                                        <PendingQuoteOverrideButton shipment={props.original} />
                                    <Button
                                        className="btn btn-danger"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setShipment(props.original);
                                            setShowAlertCancelShipment(true);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    {canDispatchEditActiveShipment(props.original) ? (
                                        <Button
                                            className="btn btn-info"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                openActiveOrderEditor(props.original);
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    ) : null}
                                    {props.original.shipping_fee > 0 && (
                                        <Button
                                            className="btn btn-default"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                forceReadyShipmentAdmin(props.original);
                                            }}
                                        >
                                            Force Ready
                                        </Button>
                                    )}
                                    <Button
                                        className="btn btn-info"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            sendRecipientTrackingLink(props.original);
                                        }}
                                    >
                                        Send Tracking Link
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            sendRecipientTrackingLinkToNumber(props.original);
                                        }}
                                    >
                                        Send to #
                                    </Button>
                                </ButtonGroup>
                            ) : null}
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }
    ];

    const mergingRoutesColumns = [
        {
            Header: () => (
                <div style={{ width: '60px' }}>
                    <input type="checkbox" checked={mergingCheckStateAllChecked} onChange={handleSelectAllMergingCheckbox} disabled={!currentUserHasMergingRecords} />
                    {'     Select All'}
                </div>
            ),
            accessor: 'updated_by',
            width: 100,
            textAlign: 'left',
            Cell: row => (
                <div onClick={e => e.stopPropagation()}>
                    <input
                        type="checkbox"
                        checked={mergingCheckState[row.index]}
                        onClick={e => e.stopPropagation()}
                        onChange={e => {
                            handleMergingCheckboxClick(row.index, e);
                        }}
                    />
                </div>
            )
        },
        {
            Header: 'Route-Ship_ID',
            accessor: 'route_friendly_id',
            // width: 'auto',
            width: 180,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left' }}>
                    {props.value}--
                    {props.original.Shipments.map((ship, index) => {
                        return index !== 0 ? `/${ship.shipment_friendly_id}` : ship.shipment_friendly_id;
                    })}
                </div>
            )
        },
        {
            Header: 'Pay($)',
            // accessor: 'status',
            // width: 'auto',
            width: 90,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{RouteTotalDriverPays(props.original.Shipments)}</div>
        },
        {
            Header: 'Customer',
            // accessor: 'status',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getCustomerNameFromRoute(props.original.Shipments)}</div>
        },
        {
            Header: 'Origin',
            width: 190,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getRouteOriginLabel(props.original)}</div>
        },
        {
            Header: 'created at',
            id: 'created_at',
            accessor: row => getImmutableCreatedAt(row),
            // width: 'auto',
            width: 110,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal' }}>{formatTimestamp(props.value)}</div>
            )
        },
        {
            Header: 'Actions',
            style: {
                paddingTop: `0px`,
                paddingBottom: `0px`
            },
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props => {
                if (!apolloading) {
                    const isSelectedForMerge = Boolean(mergingCheckState[props.index]);

                    if (props.original.status === 'route_temp_claimed_dispatch') {
                        return (
                            <div style={{ textAlign: 'left' }}>
                                <ButtonGroup style={{ textAlign: 'left' }}>
                                    <Button
                                        className={isSelectedForMerge ? 'btn btn-success' : 'btn btn-primary'}
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            handleMergingCheckboxClick(props.index, e);
                                        }}
                                    >
                                        {isSelectedForMerge ? 'Selected' : 'Select'}
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            CancelTempClaimRoutes(props.original.route_id);
                                            fetchMergingRoutes();
                                        }}
                                    >
                                        Go Ready
                                    </Button>
                                    <Button
                                        className="btn btn-info"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            handleAssign(props.original);
                                        }}
                                    >
                                        Assign
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setRoute(props.original);
                                            setRouteWaypoints(props.original.path);
                                            setShowReorderWaypoints(true);
                                        }}
                                    >
                                        Reorder
                                    </Button>
                                </ButtonGroup>
                            </div>
                        );
                    }
                    return (
                        <div style={{ textAlign: 'left' }}>
                            <Button
                                className={isSelectedForMerge ? 'btn btn-success' : 'btn btn-primary'}
                                style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                onClick={e => {
                                    handleMergingCheckboxClick(props.index, e);
                                }}
                            >
                                {isSelectedForMerge ? 'Selected' : 'Select'}
                            </Button>
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }
    ];

    const readyColumns = [
        {
            Header: 'Route-Ship_ID',
            accessor: 'route_friendly_id',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>{renderClaimedOrderRouteLabel(props.original)}</div>
        },
        {
            Header: 'Pay($)',
            // accessor: 'status',
            // width: 'auto',
            width: 90,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getRoutePayDisplay(props.original)}</div>
        },
        {
            Header: 'Customer',
            // accessor: 'status',
            // width: 'auto',
            width: 120,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {getCustomerNameFromRoute(getRouteShipments(props.original))}
                </div>
            )
        },
        {
            Header: 'Preferred Driver',
            width: 150,
            textAlign: 'left',
            Cell: props => {
                const preferred = getRoutePreferredDispatch(props.original);

                if (!preferred) {
                    return <div style={{ textAlign: 'left', color: isDarkMode ? '#6c757d' : '#adb5bd' }}>—</div>;
                }

                const expiresMs = preferred.window_expires_at ? new Date(preferred.window_expires_at).getTime() : NaN;
                const windowActive = Number.isFinite(expiresMs) ? Date.now() < expiresMs : true;
                const driverName = preferred.driver_name || 'Preferred driver';

                return (
                    <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                        <span
                            title={windowActive ? 'Exclusive preferred-driver window active' : 'Preferred window expired — open to all drivers'}
                            style={{
                                alignItems: 'center',
                                backgroundColor: windowActive ? '#1d8cf8' : (isDarkMode ? '#3c3f58' : '#e9ecef'),
                                borderRadius: '999px',
                                color: windowActive ? '#FFF' : (isDarkMode ? '#cdcaca' : '#2b3553'),
                                display: 'inline-flex',
                                fontSize: '11px',
                                fontWeight: 700,
                                padding: '2px 8px'
                            }}
                        >
                            {driverName}
                        </span>
                    </div>
                );
            }
        },
        {
            Header: 'Origin',
            width: 180,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {getRouteOriginLabel(props.original)}
                </div>
            )
        },
        {
            Header: 'created at',
            id: 'created_at',
            accessor: row => getImmutableCreatedAt(row),
            // width: 'auto',
            width: 110,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {formatTimestamp(props.value)}
                </div>
            )
        },
        {
            Header: 'Actions',
            style: {
                paddingTop: `0px`,
                paddingBottom: `0px`
            },
            // width: 'auto',
            width: 420,
            textAlign: 'left',
            Cell: props => {
                if (!apolloading) {
                    if (
                        props.original.status === 'route_ready' &&
                        !isFedexShipment(getPrimaryShipmentFromRoute(props.original))
                    ) {
                        return (
                            <div style={{ textAlign: 'left' }}>
                                <ButtonGroup style={{ textAlign: 'left' }}>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            tempClaimRoutes(props.original.route_id);
                                        }}
                                    >
                                        Go Merging
                                    </Button>
                                    <Button
                                        className="btn btn-primary"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        disabled={smartDispatchActionRouteId === props.original.route_id}
                                        onClick={e => {
                                            e.stopPropagation();
                                            startSmartDispatchRoute(props.original);
                                        }}
                                    >
                                        Smart Dispatch
                                    </Button>
                                    <Button
                                        className="btn btn-info"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            handleAssign(props.original);
                                        }}
                                    >
                                        Assign
                                    </Button>
                                    {props.original.Shipments.length > 1 && (
                                        <Button
                                            className="btn btn-warning"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                setRoute(props.original);
                                                setShowAlertBreakRoute(true);
                                            }}
                                        >
                                            Break
                                        </Button>
                                    )}
                                    {canDispatchEditActiveShipment(getPrimaryShipmentFromRoute(props.original)) ? (
                                        <Button
                                            className="btn btn-info"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                openActiveOrderEditor(getPrimaryShipmentFromRoute(props.original));
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    ) : null}
                                </ButtonGroup>
                            </div>
                        );
                    }
                    return <div></div>;
                } else {
                    return <Loading />;
                }
            }
        }
    ];

    const progressingColumns = [
        {
            Header: 'Route-Ship_ID',
            accessor: 'route_friendly_id',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>{renderClaimedOrderRouteLabel(props.original)}</div>
        },
        {
            Header: 'Pay($)',
            // accessor: 'status',
            // width: 'auto',
            width: 90,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getRoutePayDisplay(props.original)}</div>
        },
        {
            Header: 'Customer',
            // accessor: 'status',
            // width: 'auto',
            width: 120,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {getCustomerNameFromRoute(props.original.Shipments)}
                </div>
            )
        },
        {
            Header: 'Origin',
            width: 170,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {getRouteOriginLabel(props.original)}
                </div>
            )
        },
        {
            Header: 'Driver',
            // accessor: 'status',
            // width: 'auto',
            width: 135,
            textAlign: 'left',
            Cell: props => {
                const currentDriver = getCurrentRouteDriver(props.original);

                return (
                    <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                        {currentDriver && currentDriver.driver_blob
                            ? `${currentDriver.driver_blob.first_name} ${currentDriver.driver_blob.last_name}`
                            : ''}
                    </div>
                );
            }
        },
        {
            Header: 'created at',
            id: 'created_at',
            accessor: row => getImmutableCreatedAt(row),
            // width: 'auto',
            width: 110,
            textAlign: 'left',
            Cell: props => (
                <div style={{ textAlign: 'left', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', paddingTop: '2px' }}>
                    {formatTimestamp(props.value)}
                </div>
            )
        },
        {
            Header: 'Actions',
            style: {
                paddingTop: `0px`,
                paddingBottom: `0px`
            },
            // width: 'auto',
            width: 620,
            textAlign: 'left',
            Cell: props => {
                if (!apolloading) {
                    const primaryShipment = getPrimaryShipmentFromRoute(props.original);
                    const showComplete =
                        (props.original.status === 'route_assigned' || props.original.status === 'route_claimed') &&
                        !isFedexShipment(primaryShipment);
                    const showEdit = canDispatchEditActiveShipment(primaryShipment);

                    if (!showComplete && !showEdit) {
                        return <div></div>;
                    }

                    return (
                        <div style={{ textAlign: 'left' }}>
                            <ButtonGroup style={{ textAlign: 'left' }}>
                                {showComplete ? (
                                    <Button
                                        className="btn btn-danger"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            // ! needs to be complete route
                                            e.stopPropagation();
                                            completeRoute(props.original, () => {
                                                fetchAllDrivers();
                                            });
                                        }}
                                    >
                                        Complete
                                    </Button>
                                ) : null}
                                {showEdit ? (
                                    <Button
                                        className="btn btn-info"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            openActiveOrderEditor(primaryShipment);
                                        }}
                                    >
                                        Edit
                                    </Button>
                                ) : null}
                            </ButtonGroup>
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }
    ];

    const completedColumns = [
        {
            Header: 'route-ship_ID',
            accessor: 'route_friendly_id',
            // width: 'auto',
            width: 180,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{renderClaimedOrderRouteLabel(props.original)}</div>
        },
        {
            Header: 'Pay($)',
            // accessor: 'status',
            // width: 'auto',
            width: 90,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getRoutePayDisplay(props.original)}</div>
        },
        {
            Header: 'Customer',
            // accessor: 'status',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getCustomerNameFromRoute(props.original.Shipments)}</div>
        },
        {
            Header: 'Origin',
            width: 220,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getRouteOriginLabel(props.original)}</div>
        },
        {
            Header: 'created at',
            id: 'created_at',
            accessor: row => row.display_created_at || row.original_created_at || row.created_at || row.createdAt || null,
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props => {
                const createdAt = props && props.value ? moment(props.value) : null;
                const createdAtLabel = createdAt && createdAt.isValid() ? createdAt.format('lll') : 'Unavailable';

                return <div style={{ textAlign: 'left' }}>{createdAtLabel}</div>;
            }
        },
        {
            Header: 'completed at',
            accessor: 'completed_at',
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{formatTimestamp(props.value)}</div>
        }
    ];

    //! scheduled shipments column
    const savedForLaterColumns = [
        {
            Header: 'Ship_ID',
            accessor: 'shipment_friendly_id',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        textAlign: 'left'
                    }}
                >
                    {row.value}
                </div>
            )
        },
        {
            Header: 'Status',
            accessor: 'status',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left'
                    }}
                >
                    <span style={{ textAlign: 'left' }}>
                        {row.value === 'shipment_ready_for_driver' ? (
                            <FaHourglassHalf size="30" color="#be1e2d" />
                        ) : row.value === 'shipment_assigned' ? (
                            <FaPeopleCarry size="30" color="#ff6500" />
                        ) : row.value === 'shipment_enroute' ? (
                            <FaHome size="30" color="#fcb23a" />
                        ) : row.value === 'shipment_completed' ? (
                            <FaRegCheckCircle size="30" color="#2bbbae" />
                        ) : row.value === 'shipment_scheduled' ? (
                            now.isAfter(row.original.scheduled_for) ? (
                                makeReady(row.original.order_friendly_id)
                            ) : tomorrow.isAfter(row.original.scheduled_for) ? (
                                makeAlmostReady(row.original.shipment_friendly_id)
                            ) : (
                                <FaClock size="30" color="#2bbbae" />
                            )
                        ) : row.value === 'shipment_pending_saved' ? (
                            <FaHourglassHalf size="30" color="#f7941d" />
                        ) : row.value === 'shipment_saved' ? (
                            <FaBookmark size="30" color="be1e2d" />
                        ) : (
                            'None Found'
                        )}
                    </span>
                </div>
            )
        },
        {
            Header: 'Scheduled For',
            accessor: 'scheduled_for',
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props =>
                props.value ? (
                    <div
                        style={{
                            textAlign: 'left'
                        }}
                    >
                        {formatTimestamp(props.value)}
                    </div>
                ) : (
                    <div
                        style={{
                            textAlign: 'left'
                        }}
                    >
                        Not Scheduled
                    </div>
                )
        },
        {
            Header: 'Pay($)',
            // accessor: 'status',
            // width: 'auto',
            width: 100,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{RouteTotalDriverPays([props.original])}</div>
        },
        {
            Header: 'Customer',
            accessor: 'customer_blob',
            // width: 'auto',
            width: 150,
            textAlign: 'left',
            Cell: props => (
                <div
                    style={{
                        fontWeight: 'bold',
                        textAlign: 'left'
                    }}
                >
                    {/* {props.value.first_name + ' ' + props.value.last_name} */}
                    {props.value.store_name ? props.value.store_name : props.value.first_name + ' ' + props.value.last_name}
                </div>
            )
        },
        {
            Header: 'Origin',
            width: 220,
            textAlign: 'left',
            Cell: props => <div style={{ textAlign: 'left' }}>{getShipmentOriginLabel(props.original)}</div>
        },
        {
            Header: 'created at',
            id: 'created_at',
            accessor: row => getImmutableCreatedAt(row),
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props => (
                <div
                    style={{
                        textAlign: 'left'
                    }}
                >
                    {formatTimestamp(props.value)}
                </div>
            )
        },
        {
            Header: 'Actions',
            style: {
                paddingTop: `0px`,
                paddingBottom: `0px`
            },
            // width: 'auto',
            width: 200,
            textAlign: 'left',
            Cell: props => {
                if (!apolloading) {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {props.original.shipment_type === 'direct' ||
                            props.original.shipment_type === 'connect' ||
                            props.original.shipment_type === 'routed_direct' ||
                            props.original.shipment_type === 'multidrop_direct' ? (
                                <ButtonGroup style={{ textAlign: 'left' }}>
                                    <Button
                                        className="btn btn-danger"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setShipment(props.original);
                                            setShowAlertCancelShipment(true);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className="btn btn-default"
                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            readyScheduledShipment(props.original);
                                        }}
                                    >
                                        Ready
                                    </Button>
                                    {canDispatchEditActiveShipment(props.original) ? (
                                        <Button
                                            className="btn btn-info"
                                            style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                openActiveOrderEditor(props.original);
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    ) : null}
                                </ButtonGroup>
                            ) : null}
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }
    ];

    //! driver list column
    const driverListColumns = [
        {
            Header: '',
            expander: true,
            width: 36,
            sortable: false,
            resizable: false,
            Expander: ({ isExpanded }) => (
                <div style={{ textAlign: 'left', cursor: 'pointer' }}>
                    {!isExpanded ? (
                        <span><FaCaretRight color={'#BFC0C5'} size="20" /></span>
                    ) : (
                        <span><FaCaretDown color={'#BFC0C5'} size="20" /></span>
                    )}
                </div>
            )
        },
        {
            Header: 'Name',
            width: 140,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => {
                const user = row.original && row.original.User ? row.original.User : {};
                const fcmTokens = row.original && row.original.User && Array.isArray(row.original.User.FCMTokens) ? row.original.User.FCMTokens : [];
                const platform = fcmTokens.length > 0 ? String(fcmTokens[0].platform || '').toLowerCase() : null;
                const platformIcon = platform === 'ios' ? '🍎' : platform === 'android' ? '🤖' : null;

                return (
                    <div
                        style={{
                            textAlign: 'left'
                        }}
                    >
                        {[user.firstname, user.lastname].filter(Boolean).join(' ') || 'Unknown driver'}
                        {platformIcon && <span style={{ marginLeft: 4 }}>{platformIcon}</span>}
                    </div>
                );
            }
        },
        {
            Header: 'Phone',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => {
                const user = row.original && row.original.User ? row.original.User : {};

                return (
                    <div
                        style={{
                            textAlign: 'left'
                        }}
                    >
                        {user.phone || row.original.phone || ''}
                    </div>
                );
            }
        },
        {
            Header: 'On Line Status',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left'
                    }}
                >
                    {row.original.is_online && row.original.is_available ? '🟢' : row.original.is_online && !row.original.is_available ? '🟠 ' : '⚪️'}
                </div>
            )
        },
        {
            Header: 'Has Route',
            width: 100,
            // width: 'auto',
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left'
                    }}
                >
                    {row.original.is_online && row.original.is_available ? 'Available' : row.original.is_online && !row.original.is_available ? 'Enroute' : 'Unavailable'}
                </div>
            )
        },

        {
            Header: 'Vehicle Type',
            // width: 'auto',
            width: 120,
            textAlign: 'left',
            Cell: row => {
                const vehicles = row.original && Array.isArray(row.original.Vehicles) ? row.original.Vehicles : [];
                const primaryVehicle = vehicles.length === 0
                    ? null
                    : vehicles.find(vehicle => vehicle.vehicle_id === row.original.active_vehicle) || vehicles[0];

                return (
                    <div
                        style={{
                            fontWeight: 'bold',
                            textAlign: 'left'
                        }}
                    >
                        {primaryVehicle && primaryVehicle.type ? getVehicleTypeLabel(primaryVehicle.type) : 'Unknown'}
                    </div>
                );
            }
        },
        {
            Header: 'Credentials',
            // width: 'auto',
            width: 100,
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left'
                    }}
                >
                    <DriverComplianceValidBadge
                        driverAuth0Id={row.original.auth0_id}
                        driverIdentifier={row.original.driver_id || row.original.auth0_id}
                        initialStatus={getDispatchDriverBadgeStatus(row.original)}
                        shouldFetch={true}
                    />
                </div>
            )
        },
        {
            Header: 'ORIGIN Market',
            // width: 'auto',
            width: 120,
            textAlign: 'left',
            Cell: row => {
                const user = row.original && row.original.User ? row.original.User : {};
                const addresses = Array.isArray(user.Addresses) ? user.Addresses : [];

                return (
                    <div
                        style={{
                            textAlign: 'left'
                        }}
                    >
                        {addresses.length > 0 ? `${addresses[0].city}, ${addresses[0].state}` : 'No address'}
                    </div>
                );
            }
        },
        {
            Header: 'SMS',
            // width: 'auto',
            width: 50,
            textAlign: 'left',
            Cell: row => (
                <div
                    style={{
                        // width: 'auto',
                        textAlign: 'left',
                        position: 'relative',
                        display: 'inline-block'
                    }}
                >
                    <FontAwesomeIcon
                        icon={faPaperPlane}
                        onClick={e => {
                            e.stopPropagation();
                            openDriverChat(row.original);
                        }}
                        style={{
                            color: 'white', // Set the color to white for dark mode
                            cursor: 'pointer'
                        }}
                    />
                    {row.original.unread_message_count > 0 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '-7px',
                                backgroundColor: 'red',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%'
                            }}
                        ></div>
                    )}
                </div>
            )
        }
    ];

    const hasLocalDispatchData = localDispatchShipments.length > 0 || localDispatchRoutes.length > 0;
    const hasCompletedLocalDispatchLoad = localDispatchShipmentsLoaded && localDispatchRoutesLoaded;
    const showLocalNoDispatchDataNotice =
        isLocalDashboardEnvironment &&
        hasCompletedLocalDispatchLoad &&
        !hasLocalDispatchData;
    const isShipmentTabSelected = selected === 'pending' || selected === 'saved';
    const isRouteTabSelected = selected === 'ready' || selected === 'progressing' || selected === 'completed';
    const isMergingTabSelected = selected === 'merging';
    const isDriversTabSelected = selected === 'driverList';
    const activeShipmentRowsCount = Array.isArray(filteredShipmentsToDisplay) ? filteredShipmentsToDisplay.length : 0;
    const activeRouteRowsCount = Array.isArray(filteredRoutesToDisplay) ? filteredRoutesToDisplay.length : 0;
    const activeMergingRowsCount = Array.isArray(filteredMergingRoutes) ? filteredMergingRoutes.length : 0;
    const activeDriverRowsCount = Array.isArray(driverListTableData) ? driverListTableData.length : 0;
    const completedRoutePageSourceRows = selected === 'completed'
        ? (
            isLocalDashboardEnvironment
                ? localCompletedRoutesPageSourceRows
                : ((completedRoutesPageData && Array.isArray(completedRoutesPageData.Routes)) ? completedRoutesPageData.Routes : [])
        )
        : [];
    const completedRoutePageRows = selected === 'completed' && Array.isArray(filteredRoutesToDisplay) ? filteredRoutesToDisplay : [];
    const completedRoutePageHasNext = completedRoutePageSourceRows.length > completedRoutesPageSize;
    // Only show the spinner on the initial load (no page yet). A background refetch keeps
    // completedRoutesPageLoading true (notifyOnNetworkStatusChange), which must not hide an
    // already-loaded page behind a permanent spinner.
    const isCompletedTabLoading = selected === 'completed' && !isLocalDashboardEnvironment && completedRoutesPageLoading && !completedRoutesPageData;
    const shouldShowHostedRouteTabLoading = selected !== 'completed' && apolloadingRoute && activeRouteRowsCount === 0;
    const shouldShowActiveTabLoading = isLocalDashboardEnvironment
        ? (
            (isShipmentTabSelected && localDispatchShipmentsLoading && !localDispatchShipmentsLoaded && activeShipmentRowsCount === 0) ||
            (isRouteTabSelected && localDispatchRoutesLoading && !localDispatchRoutesLoaded && activeRouteRowsCount === 0) ||
            (isMergingTabSelected && localDispatchRoutesLoading && !localDispatchRoutesLoaded && activeMergingRowsCount === 0) ||
            (isDriversTabSelected && driversLoading && activeDriverRowsCount === 0)
        )
        : (
            (isShipmentTabSelected && apolloading && activeShipmentRowsCount === 0) ||
            ((isRouteTabSelected && shouldShowHostedRouteTabLoading) || isCompletedTabLoading) ||
            (isMergingTabSelected && apolloadingRoute && activeMergingRowsCount === 0) ||
            (isDriversTabSelected && driversLoading && activeDriverRowsCount === 0)
        );

    return (
        <div>
            <div className="content">
                {showLocalNoDispatchDataNotice ? (
                    <div
                        style={{
                            marginBottom: '12px',
                            padding: '10px 14px',
                            borderRadius: '8px',
                            background: isDarkMode ? 'rgba(255, 193, 7, 0.14)' : '#fff8e1',
                            border: isDarkMode ? '1px solid rgba(255, 193, 7, 0.35)' : '1px solid #ffe08a',
                            color: isDarkMode ? '#ffffff' : '#5c4700',
                            fontSize: '0.95rem'
                        }}
                    >
                        Local dispatch finished loading but returned no shipment or route data for the selected markets. That usually means the local shipments service is unavailable or the current market filter has no data.
                    </div>
                ) : null}
                <div className="float-content">
                    <div style={{ width: `65%` }}>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                gap: '10px',
                                marginBottom: '12px'
                            }}
                        >
                            {dispatchMonthlyKpiCards.map(card => {
                                const isActiveCustomersCard = card.key === 'active-customers';
                                const cardIsClickable = isActiveCustomersCard && canOpenActiveCustomersModal;

                                return (
                                    <div
                                        key={card.key}
                                        role={cardIsClickable ? 'button' : undefined}
                                        tabIndex={cardIsClickable ? 0 : undefined}
                                        onClick={cardIsClickable ? () => setActiveCustomersModalOpen(true) : undefined}
                                        onKeyDown={cardIsClickable ? event => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                event.preventDefault();
                                                setActiveCustomersModalOpen(true);
                                            }
                                        } : undefined}
                                        style={{
                                            borderRadius: '10px',
                                            padding: '10px 12px',
                                            border: isDarkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e3e6ef',
                                            background: isDarkMode ? 'rgba(33, 35, 55, 0.9)' : '#ffffff',
                                            cursor: cardIsClickable ? 'pointer' : 'default'
                                        }}
                                    >
                                    <div
                                        style={{
                                            fontSize: '0.75rem',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.03em',
                                            color: isDarkMode ? 'rgba(255, 255, 255, 0.92)' : '#344767'
                                        }}
                                    >
                                        {card.label}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '1.02rem',
                                            fontWeight: 700,
                                            marginTop: '3px',
                                            color: isDarkMode ? '#ffffff' : '#1f2a44'
                                        }}
                                    >
                                        {card.value}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '0.72rem',
                                            marginTop: '2px',
                                            color: isDarkMode ? 'rgba(255, 255, 255, 0.78)' : '#5a6788'
                                        }}
                                    >
                                        {cardIsClickable ? 'Click to view list' : currentMonthLabel}
                                    </div>
                                </div>
                                );
                            })}
                        </div>
                        <DispatchMarketsSelection memoizedOptions={memoizedOptions} regionCounts={regionCounts} activeTabLabel={activeTabLabel} />
                        {(selected === 'pending' || selected === 'saved' || selected === 'ready' || selected === 'progressing' || selected === 'completed') && (
                            <FormGroup style={{ marginTop: '12px', marginBottom: '12px' }}>
                                <Label for="dispatch-city-state-filter" style={{ fontWeight: 600 }}>
                                    City / State Filter
                                </Label>
                                <Input
                                    id="dispatch-city-state-filter"
                                    type="text"
                                    value={cityStateQuery}
                                    placeholder="Type city or state; matches any stop, e.g. Beaumont, TX or Louisiana"
                                    onChange={event => setCityStateQuery(event.target.value)}
                                />
                            </FormGroup>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Button
                                color={isRouteBuilderAccessible ? 'success' : 'secondary'}
                                name="build-routes"
                                onClick={e => {
                                    if (isRouteBuilderAccessible) {
                                        setShowAlertMergeRoute(true);
                                    }
                                }}
                                style={{ width: `18%` }}
                            >
                                Build Routes
                            </Button>
                            {isSingleMarket ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Row>
                                        <Col style={{ width: '150%' }}>
                                            <p>Updated: </p>
                                            <p style={{ color: 'orange' }}>{priceUpdateTime.slice(5, 10)} </p>
                                        </Col>
                                        <Col>
                                            <p>REGULAR:</p>
                                            <p>DIESEL:</p>
                                        </Col>
                                        <Col style={{ marginLeft: '-20px' }}>
                                            <p>
                                                <span className="digital-font" style={{ color: 'red' }}>
                                                    {Number(gasPrice).toFixed(2)}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="digital-font" style={{ color: 'green' }}>
                                                    {Number(dieselPrice).toFixed(2)}
                                                </span>
                                            </p>
                                        </Col>
                                    </Row>
                                    <Button
                                        color="warning"
                                        name="update-gas-price"
                                        onClick={e => {
                                            setShowGasPrice(true);
                                        }}
                                        style={{ width: `42%`, marginLeft: '30px' }}
                                    >
                                        Update Price
                                    </Button>
                                </div>
                            ) : <div />}
                            {!isSingleMarket && regionId && region && region.gas_price != null ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Row>
                                        <Col style={{ width: '150%' }}>
                                            <p>Updated: </p>
                                            <p style={{ color: 'orange' }}>{region.updated_at ? String(region.updated_at).slice(5, 10) : '--'} </p>
                                        </Col>
                                        <Col>
                                            <p>REGULAR:</p>
                                            <p>DIESEL:</p>
                                        </Col>
                                        <Col style={{ marginLeft: '-20px' }}>
                                            <p>
                                                <span className="digital-font" style={{ color: 'red' }}>
                                                    {Number(region.gas_price).toFixed(2)}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="digital-font" style={{ color: 'green' }}>
                                                    {Number(region.diesel_price).toFixed(2)}
                                                </span>
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            ) : <div />}
                            {isSingleMarket ? (
                                <Button
                                    color="success"
                                    name="update-market-note"
                                    onClick={e => {
                                        setShowMarketNote(true);
                                        fetchMarketNote();
                                    }}
                                    style={{ width: '20%' }}
                                >
                                    Market Note
                                </Button>
                            ) : <div />}
                        </div>
                        {!isSingleMarket && regionId && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    color="warning"
                                    name="update-gas-price-region"
                                    onClick={e => {
                                        setShowGasPriceRegion(true);
                                        fetchRegionAndMarketGasPrice();
                                    }}
                                >
                                    Update Region Gas Price
                                </Button>
                                <Button
                                    color="success"
                                    name="update-region-markets-note"
                                    onClick={e => {
                                        setShowMarketNoteRegion(true);
                                        fetchRegionAndMarketNote();
                                    }}
                                >
                                    Region Markets Note
                                </Button>
                            </div>
                        )}
                    </div>
                    <div style={{ width: `40%`, marginLeft: 0, color: 'white' }}>
                        <MapFilters marketIdArray={marketIdArray} />
                        <Button
                            size="sm"
                            className="btn btn-info"
                            style={{ padding: `5px 10px`, display: `inline-block`, marginLeft: '10px' }}
                            onClick={() => setShowDispatchMap(prev => !prev)}
                        >
                            {showDispatchMap ? 'Hide Map' : 'Show Map'}
                        </Button>
                    </div>
                </div>

                <div className="dispatch-chat-launchers">
                    <Button
                        size="sm"
                        color={openChatWindows.includes('website') ? 'primary' : 'default'}
                        className="dispatch-chat-launch-btn"
                        onClick={() => toggleChatWindow('website')}
                    >
                        <FontAwesomeIcon icon={faComment} />
                        Live Chat
                        {chatUnreadCounts.website > 0 && (
                            <span className="dispatch-chat-launch-badge">{chatUnreadCounts.website}</span>
                        )}
                    </Button>
                    <Button
                        size="sm"
                        color={openChatWindows.includes('sms') ? 'primary' : 'default'}
                        className="dispatch-chat-launch-btn"
                        onClick={() => toggleChatWindow('sms')}
                    >
                        <FontAwesomeIcon icon={faComment} />
                        SMS Messages
                        {chatUnreadCounts.sms > 0 && (
                            <span className="dispatch-chat-launch-badge">{chatUnreadCounts.sms}</span>
                        )}
                    </Button>
                    <Button
                        size="sm"
                        color={openChatWindows.includes('voice') ? 'primary' : 'default'}
                        className="dispatch-chat-launch-btn"
                        onClick={() => toggleChatWindow('voice')}
                    >
                        <FontAwesomeIcon icon={faPhone} />
                        Calls
                        {chatUnreadCounts.voice > 0 && (
                            <span className="dispatch-chat-launch-badge">{chatUnreadCounts.voice}</span>
                        )}
                    </Button>
                    <Button
                        size="sm"
                        color={openChatWindows.includes('email') ? 'primary' : 'default'}
                        className="dispatch-chat-launch-btn"
                        onClick={() => toggleChatWindow('email')}
                    >
                        <FontAwesomeIcon icon={faEnvelope} />
                        Email
                        {chatUnreadCounts.email > 0 && (
                            <span className="dispatch-chat-launch-badge">{chatUnreadCounts.email}</span>
                        )}
                    </Button>
                </div>

                {gopilotReviews.length > 0 ? (
                    <div
                        style={{
                            marginBottom: '12px',
                            padding: '14px 16px',
                            borderRadius: '10px',
                            border: '1px solid #f7941d',
                            background: isDarkMode ? 'rgba(247, 148, 29, 0.14)' : '#fff4e8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '12px',
                            flexWrap: 'wrap'
                        }}
                    >
                        <div>
                            <strong style={{ color: isDarkMode ? '#fff' : '#2b3553' }}>GoPilot Damage Review Queue</strong>
                            <p style={{ margin: '4px 0 0', color: isDarkMode ? '#cdcaca' : '#525f7f' }}>
                                {gopilotReviews.length} {gopilotReviews.length === 1 ? 'shipment is' : 'shipments are'} waiting for admin GoPilot action.
                            </p>
                        </div>
                        <Button
                            className="btn btn-warning"
                            onClick={() => {
                                setGoPilotReviewModalOpen(true);
                                if (!selectedGoPilotReviewId && gopilotReviews[0]) {
                                    setSelectedGoPilotReviewId(gopilotReviews[0].shipment_id);
                                }
                            }}
                        >
                            Open Review Queue
                        </Button>
                    </div>
                ) : null}

                <div className="float-container">
                    <ResizableBox
                        className="box"
                        width={5000}
                        height={15000}
                        minConstraints={[1000, 4000]}
                        maxConstraints={[10000, 30000]}
                        draggableOpts={{ grid: [10, 10] }}
                        axis="x"
                    >
                        <div className="float-child-table">
                            <div style={{ marginBottom: 10, width: `100%`, display: `flex`, flexDirection: `row` }}>
                                {/* <Multiplayer urls={['https://a.uguu.se/V8BHQdvyLDru_Notification-admin_1.mp3']} /> */}
                                <ButtonGroup style={{ className: 'center', width: '100%' }}>
                                    <Button
                                        className={selected === 'pending' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="pending"
                                        onClick={e => {
                                            setFilter(PENDING_SHIPMENT_STATUSES);
                                            setSelected(e.target.name);
                                            setShowMergingRoutesMap(false);
                                        }}
                                        style={{ width: `20%` }}
                                    >
                                        Pending Approval
                                        {amountApproval > 0 ? (
                                            <div className="amount-container">
                                                <p className="approval-amount">{amountApproval}</p>
                                            </div>
                                        ) : null}
                                        {amountPending > 0 ? (
                                            <div className="amount-container">
                                                <p className="total-amount">{amountPending}</p>
                                            </div>
                                        ) : null}
                                    </Button>
                                    <Button
                                        style={{ width: '20%' }}
                                        className={selected === 'saved' ? 'btn' : 'btn-simple'}
                                        name="saved"
                                        color="info"
                                        onClick={e => {
                                            setFilter(SCHEDULED_SHIPMENT_STATUSES);
                                            setSelected('saved');
                                            setShowMergingRoutesMap(false);
                                        }}
                                    >
                                        Scheduled
                                        {savedTabUnreadCount > 0 ? (
                                            <span style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
                                                {renderClaimedOrderUnreadBadge(savedTabUnreadCount, {
                                                    backgroundColor: '#D62828',
                                                    borderColor: '#FFF'
                                                })}
                                            </span>
                                        ) : null}
                                        {scheduledShipmentsVisibleCount > 0 ? (
                                            <div className="amount-container">
                                                <p className="total-amount">{scheduledShipmentsVisibleCount}</p>
                                            </div>
                                        ) : null}
                                        <Badge
                                            hidden={almostReady.length === 0}
                                            name="saved"
                                            style={{ display: 'inline-block', whiteSpace: 'nowrap', backgroundColor: '#F7941D', color: '#ffffff' }}
                                        >
                                            {almostReady.length}
                                        </Badge>
                                        <Badge
                                            hidden={ready.length === 0}
                                            name="saved"
                                            style={{ display: 'inline-block', whiteSpace: 'nowrap', backgroundColor: '#be1e2d', color: '#ffffff' }}
                                        >
                                            {ready.length}
                                        </Badge>
                                    </Button>
                                    <Button
                                        className={selected === 'ready' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="ready"
                                        onClick={e => {
                                            setFilterRoutes(['route_ready', 'route_temp_claimed']);
                                            setSelected(e.target.name);
                                            setShowMergingRoutesMap(false);
                                        }}
                                        style={{
                                            width: `20%`,
                                            backgroundColor: readyTabUnreadCount > 0 ? '#F5C542' : undefined,
                                            borderColor: readyTabUnreadCount > 0 ? '#F5C542' : undefined,
                                            color: readyTabUnreadCount > 0 ? '#12233D' : undefined,
                                            boxShadow: readyTabUnreadCount > 0 ? 'inset 0 0 0 2px rgba(18, 35, 61, 0.18)' : undefined,
                                        }}
                                    >
                                        {totalAmountReady > 0 ? (
                                            <Badge
                                                style={{
                                                    display: 'inline-block',
                                                    whiteSpace: 'nowrap',
                                                    backgroundColor: '#17a2b8',
                                                    color: '#ffffff',
                                                    fontSize: '14px',
                                                    marginRight: '5px',
                                                    minWidth: '30px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    padding: '4px 8px'
                                                }}
                                            >
                                                {totalAmountReady}
                                            </Badge>
                                        ) : null}
                                        Ready
                                        {readyTabUnreadCount > 0 ? (
                                            <span style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
                                                {renderClaimedOrderUnreadBadge(readyTabUnreadCount, {
                                                    backgroundColor: '#D62828',
                                                    borderColor: '#FFF'
                                                })}
                                            </span>
                                        ) : null}
                                        {amountReady > 0 ? (
                                            <div className="amount-container" style={{ display: 'inline-block' }}>
                                                <p className="total-amount">{amountReady}</p>
                                            </div>
                                        ) : null}
                                    </Button>
                                    <Button
                                        className={selected === 'merging' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="merging"
                                        onClick={e => {
                                            fetchMergingRoutes();
                                            setSelected(e.target.name);
                                        }}
                                        style={{ width: `20%` }}
                                    >
                                        Merging
                                        {amountMerging > 0 ? (
                                            <div className="amount-container">
                                                <p className="total-amount">{amountMerging}</p>
                                            </div>
                                        ) : null}
                                    </Button>
                                    <Button
                                        className={selected === 'progressing' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="progressing"
                                        onClick={e => {
                                            setFilterRoutes(['route_claimed', 'route_assigned', 'route_enroute']);
                                            setSelected(e.target.name);
                                            setShowMergingRoutesMap(false);
                                        }}
                                        style={{
                                            width: `20%`,
                                            backgroundColor: deliveringTabUnreadCount > 0 ? '#F5C542' : undefined,
                                            borderColor: deliveringTabUnreadCount > 0 ? '#F5C542' : undefined,
                                            color: deliveringTabUnreadCount > 0 ? '#12233D' : undefined,
                                            boxShadow: deliveringTabUnreadCount > 0 ? 'inset 0 0 0 2px rgba(18, 35, 61, 0.18)' : undefined,
                                        }}
                                    >
                                        {totalAmountDelivering > 0 ? (
                                            <Badge
                                                style={{
                                                    display: 'inline-block',
                                                    whiteSpace: 'nowrap',
                                                    backgroundColor: '#17a2b8',
                                                    color: '#ffffff',
                                                    fontSize: '14px',
                                                    marginRight: '5px',
                                                    minWidth: '30px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    padding: '4px 8px'
                                                }}
                                            >
                                                {totalAmountDelivering}
                                            </Badge>
                                        ) : null}
                                        Delivering
                                        {deliveringTabUnreadCount > 0 ? (
                                            <span style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
                                                {renderClaimedOrderUnreadBadge(deliveringTabUnreadCount, {
                                                    backgroundColor: '#D62828',
                                                    borderColor: '#FFF'
                                                })}
                                            </span>
                                        ) : null}
                                        {amountDelivering > 0 ? (
                                            <div className="amount-container" style={{ display: 'inline-block' }}>
                                                <p className="total-amount">{amountDelivering}</p>
                                            </div>
                                        ) : null}
                                    </Button>
                                    <Button
                                        className={selected === 'completed' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="completed"
                                        onClick={e => {
                                            setFilterRoutes(['route_completed']);
                                            setSelected(e.target.name);
                                            setShowMergingRoutesMap(false);
                                        }}
                                        style={{ width: `20%` }}
                                    >
                                        Completed
                                    </Button>

                                    <Button
                                        className={selected === 'driverList' ? 'btn' : 'btn-simple'}
                                        color="info"
                                        name="driverList"
                                        onClick={e => {
                                            setSelected(e.target.name);
                                            setShowMergingRoutesMap(false);
                                        }}
                                        style={{ width: `20%` }}
                                    >
                                        Drivers
                                        {totalUnreadDriverMessages > 0 ? (
                                            <div className="amount-container">
                                                <p className="total-amount">{totalUnreadDriverMessages}</p>
                                            </div>
                                        ) : null}
                                    </Button>
                                </ButtonGroup>
                            </div>
                            {selected === 'completed' ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginTop: '12px',
                                        marginBottom: '12px'
                                    }}
                                >
                                    <div style={{ fontWeight: 600 }}>
                                        {completedRoutePageSourceRows.length > 0
                                            ? `Showing completed page ${completedRoutesPageIndex + 1}${
                                                  completedRoutePageRows.length !== completedRoutePageSourceRows.length
                                                      ? ` (${completedRoutePageRows.length} shown)`
                                                      : ''
                                              }`
                                            : 'No completed routes on this page'}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Label for="completed-routes-page-size" style={{ marginBottom: 0, fontWeight: 600 }}>
                                                Orders per page
                                            </Label>
                                            <Input
                                                id="completed-routes-page-size"
                                                type="select"
                                                value={String(completedRoutesPageSize)}
                                                onChange={event => {
                                                    const nextPageSize = Number(event.target.value);
                                                    if (COMPLETED_ROUTE_PAGE_SIZE_OPTIONS.includes(nextPageSize)) {
                                                        setCompletedRoutesPageSize(nextPageSize);
                                                    }
                                                }}
                                                style={{ width: '110px' }}
                                            >
                                                {COMPLETED_ROUTE_PAGE_SIZE_OPTIONS.map(optionSize => (
                                                    <option key={`completed-page-size-${optionSize}`} value={optionSize}>
                                                        {optionSize}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>
                                        <ButtonGroup>
                                            <Button
                                                color="secondary"
                                                disabled={completedRoutesPageIndex === 0 || completedRoutesPageLoading}
                                                onClick={() => setCompletedRoutesPageIndex(previousPageIndex => Math.max(previousPageIndex - 1, 0))}
                                            >
                                                Previous Page
                                            </Button>
                                            <Button
                                                color="secondary"
                                                disabled={!completedRoutePageHasNext || completedRoutesPageLoading}
                                                onClick={() => setCompletedRoutesPageIndex(previousPageIndex => previousPageIndex + 1)}
                                            >
                                                Next Page
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </div>
                            ) : null}
                            {shouldShowActiveTabLoading ? (
                                <Loading />
                            ) : selected === 'pending' || selected === 'saved' ? (
                                <ReactTable
                                    key={`shipments-${selected}`}
                                    data={filteredShipmentsToDisplay}
                                    columns={
                                        filter.includes('shipment_scheduled')
                                            ? savedForLaterColumns
                                            : filter.includes('shipment_created') ||
                                              filter.includes('shipment_pending') ||
                                              filter.includes('shipment_pending_schedule') ||
                                              filter.includes('shipment_pending_payment') ||
                                              filter.includes('shipment_saved_pending_payment_retry')
                                            ? pendingColumns
                                            : null
                                    }
                                    sortable={true}
                                    resizable={true}
                                    defaultPageSize={50}
                                    className="-striped -highlight"
                                    getTrProps={getTrProps}
                                    getTheadThProps={getTheadThProps}
                                    onExpandedChange={handleExpandedChange}
                                    collapseOnSortingChange={true}
                                    collapseOnPageChange={true}
                                    collapseOnDataChange={false}
                                    expanded={expandedItems[selected]}
                                    SubComponent={row => {
                                        if (selected !== 'pending') {
                                            return (
                                                <div
                                                    style={{
                                                        backgroundColor: detailSurfaceBackground,
                                                        borderRadius: '6px',
                                                        paddingTop: '15px',
                                                        paddingLeft: '10px',
                                                        marginRight: '10px',
                                                        marginLeft: '10px',
                                                        marginBottom: '20px',
                                                        height: 'auto'
                                                    }}
                                                >
                                                    {selected === 'saved' ? (
                                                        <div>
                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '0px' }}>
                                                                <Col className="col-8" style={{ textAlign: 'left' }}>
                                                                    {row.original.shipment_type === 'direct' ||
                                                                    row.original.shipment_type === 'routed_direct' ||
                                                                    row.original.shipment_type === 'multidrop_direct' ? (
                                                                        <strong style={{ color: '#cdcaca', padding: '20px' }}>
                                                                            Direct Delivery -{' '}
                                                                            {row.original.status === 'shipment_scheduled'
                                                                                ? 'Scheduled for ' + formatTimestamp(row.original.scheduled_for)
                                                                                : 'Saved'}
                                                                            {row.original.is_expedited ? (
                                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                                            ) : null}
                                                                        </strong>
                                                                    ) : row.original.shipment_type === 'bridge' ? (
                                                                        <strong style={{ color: '#cdcaca', padding: '20px' }}>
                                                                            Bridge Delivery -{' '}
                                                                            {row.original.status === 'shipment_scheduled'
                                                                                ? 'Scheduled for ' + formatTimestamp(row.original.scheduled_for)
                                                                                : 'Saved'}
                                                                            {row.original.is_expedited ? (
                                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                                            ) : null}
                                                                        </strong>
                                                                    ) : row.original.shipment_type === 'connect' ? (
                                                                        <strong style={{ color: '#cdcaca', padding: '20px' }}>
                                                                            Connect Delivery -{' '}
                                                                            {row.original.status === 'shipment_scheduled'
                                                                                ? 'Scheduled for ' + formatTimestamp(row.original.scheduled_for)
                                                                                : 'Saved'}
                                                                            {row.original.is_expedited ? (
                                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                                            ) : null}
                                                                        </strong>
                                                                    ) : null}
                                                                </Col>
                                                                {row.original.shipment_type === 'direct' ||
                                                                row.original.shipment_type === 'connect' ||
                                                                row.original.shipment_type === 'routed_direct' ||
                                                                row.original.shipment_type === 'multidrop_direct' ? (
                                                                    <UpdateShippingFee shipment={row.original} />
                                                                ) : null}
                                                                <UpdateDriverPayBeforeClaim shipment={row.original} />
                                                            </Row>
                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '8px', paddingBottom: '0px' }}>
                                                                <Col className="col-12" style={{ textAlign: 'left' }}>
                                                                    <PreClaimOrderChatEntry shipment={row.original} />
                                                                </Col>
                                                            </Row>
                                                            {row.original.shipment_type === 'direct' || row.original.shipment_type === 'connect' ? (
                                                                <>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                                        <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                            <strong>Load Details</strong>
                                                                            <LoadDetails shipment={row.original} />
                                                                        </Col>
                                                                        <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                            <BasicInfoDirectPick shipment={row.original} />
                                                                        </Col>
                                                                        {row.original.Orders[1] ? (
                                                                            <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                <BasicInfoDirectDrop shipment={row.original} />
                                                                            </Col>
                                                                        ) : (
                                                                            <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                <strong>Dropoff Information</strong>
                                                                                <p>
                                                                                    {row.original.customer_blob.first_name} {row.original.customer_blob.last_name}
                                                                                </p>
                                                                                <p>{row.original.customer_blob.phone}</p>
                                                                                <p>{row.original.customer_blob.email}</p>
                                                                                <p>{row.original.customer_blob.address_1}</p>
                                                                                <p>
                                                                                    {row.original.customer_blob.city}, {row.original.customer_blob.state},{' '}
                                                                                    {row.original.customer_blob.zip}
                                                                                </p>
                                                                            </Col>
                                                                        )}
                                                                        <Col style={{ textAlign: 'left' }}>
                                                                            <strong>Delivery Status</strong>
                                                                            <p>{row.original.status === 'shipment_scheduled' ? 'Scheduled' : null}</p>
                                                                            <FileViewer shipmentId={row.original.shipment_id} showGenerateBolButton={true} />
                                                                            <FileUpload
                                                                                shipmentId={row.original.shipment_id}
                                                                                shipmentFriendlyId={row.original.shipment_friendly_id}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                        <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                            <DeliveryDescription shipment={row.original} />
                                                                        </Col>

                                                                        <RegularPickAndDropInstructions
                                                                            shipment={row.original}
                                                                            pickupClassName="col-2"
                                                                            dropoffClassName="col-2"
                                                                            dropoffStyle={{ marginLeft: '24px' }}
                                                                        />
                                                                    </Row>
                                                                    {row.original.ai_recommendation ? (
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '0px', paddingBottom: '20px' }}>
                                                                            <AIRecommendation shipment={row.original} />
                                                                        </Row>
                                                                    ) : null}
                                                                </>
                                                            ) : row.original.shipment_type === 'routed_direct' ? (
                                                                <>
                                                                    <Row
                                                                        style={{
                                                                            paddingLeft: '20px',
                                                                            paddingRight: '20px',
                                                                            paddingBottom: '10px',
                                                                            paddingTop: '10px',
                                                                            textAlign: 'left'
                                                                        }}
                                                                    >
                                                                        <BasicInfoRoutedWaypoint orders={row.original.Orders} display={hasDispatchAdminOverrideOrders(row.original.Orders)} />
                                                                        <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                            <strong>Load Details</strong>
                                                                            <LoadDetails shipment={row.original} />
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            ) : row.original.shipment_type === 'multidrop_direct' ? (
                                                                <>
                                                                    <Row
                                                                        style={{
                                                                            paddingLeft: '20px',
                                                                            paddingRight: '20px',
                                                                            paddingBottom: '10px',
                                                                            paddingTop: '10px',
                                                                            textAlign: 'left'
                                                                        }}
                                                                    >
                                                                        <BasicInfoMultidropWaypoint orders={row.original.Orders} display={hasDispatchAdminOverrideOrders(row.original.Orders)} />
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            <strong>Load Details</strong>
                                                                            <LoadDetails shipment={row.original} />
                                                                        </Col>
                                                                        <MultiDropDocuments shipment={row.original} />
                                                                    </Row>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            );
                                        } else {
                                            // for the case (selected === 'pending')
                                            return (
                                                <div className="marketplace-shipment-container">
                                                    {row.original.shipment_type === 'marketplace' ? (
                                                        <strong style={{ color: '#cdcaca', paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                            Marketplace Delivery{' '}
                                                            {row.original.is_expedited ? (
                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                            ) : (
                                                                <p></p>
                                                            )}
                                                        </strong>
                                                    ) : row.original.shipment_type === 'bridge' ? (
                                                        <strong style={{ color: '#cdcaca', paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                            Bridge Delivery{' '}
                                                            {row.original.is_expedited ? (
                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                            ) : (
                                                                <p></p>
                                                            )}
                                                        </strong>
                                                    ) : row.original.shipment_type === 'school_lunch' ? (
                                                        <strong style={{ color: '#cdcaca', paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                            School Lunch Delivery{' '}
                                                            {row.original.is_expedited ? (
                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                            ) : (
                                                                <p></p>
                                                            )}
                                                        </strong>
                                                    ) : row.original.shipment_type === 'direct' ||
                                                      row.original.shipment_type === 'routed_direct' ||
                                                      row.original.shipment_type === 'multidrop_direct' ? (
                                                        <strong style={{ color: '#cdcaca', padding: '20px' }}>
                                                            Direct Delivery{' '}
                                                            {row.original.status === 'shipment_pending_schedule'
                                                                ? ' - Scheduled for ' + formatTimestamp(row.original.scheduled_for)
                                                                : null}
                                                            {row.original.is_expedited ? (
                                                                <p style={{ color: '#f7941d', paddingLeft: '20px' }}>This is an expedited delivery</p>
                                                            ) : null}
                                                        </strong>
                                                    ) : null}
                                                    {row.original.shipment_type === 'school_lunch' ? (
                                                        <>
                                                            {row.original.Orders.map((order, index) => {
                                                                return (
                                                                    <>
                                                                        {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                                            <Col className="col-4" style={{ textAlign: 'left' }}>
                                                                                <strong>Store Info</strong>
                                                                                <p>{order.location_blob.name}</p>

                                                                                <p>{order.location_blob.address_1 + ', ' + order.location_blob.city}</p>

                                                                                <p>{order.location_blob.phone}</p>
                                                                            </Col>
                                                                            <Col className="col-4" style={{ textAlign: 'left' }}>
                                                                                <strong>Customer Info</strong>
                                                                                <p>{row.original.customer_blob.first_name + ' ' + row.original.customer_blob.last_name}</p>
                                                                                <p>
                                                                                    {row.original.customer_blob.address_1 +
                                                                                        ', ' +
                                                                                        row.original.customer_blob.city +
                                                                                        ', ' +
                                                                                        row.original.customer_blob.zip}
                                                                                </p>
                                                                                <p>{row.original.customer_blob.phone}</p>
                                                                            </Col>
                                                                            <Col className="col-4" style={{ textAlign: 'left' }}>
                                                                                <div className="order-status">
                                                                                    {order.status === 'order_created' ? (
                                                                                        <ButtonGroup>
                                                                                            <Button
                                                                                                style={{ width: `40%`, textAlign: 'center' }}
                                                                                                size="sm"
                                                                                                color="info"
                                                                                                name="ready"
                                                                                                className="btn btn-success"
                                                                                                onClick={e => {
                                                                                                    e.stopPropagation();
                                                                                                    readyOrderAdmin(row.original, order);
                                                                                                }}
                                                                                            >
                                                                                                Ready
                                                                                            </Button>
                                                                                            <Button
                                                                                                style={{ width: `40%` }}
                                                                                                size="sm"
                                                                                                color="info"
                                                                                                name="decline"
                                                                                                className="btn btn-danger"
                                                                                                onClick={() => {
                                                                                                    setShipment(row.original);
                                                                                                    setOrder(order);
                                                                                                    setShowAlertCancelOrder(true);
                                                                                                }}
                                                                                            >
                                                                                                Decline
                                                                                            </Button>
                                                                                            <Button className="btn btn-simple status-button" size="sm" color="info" disabled>
                                                                                                Awaiting Approval
                                                                                            </Button>
                                                                                        </ButtonGroup>
                                                                                    ) : order.status === 'awaiting_driver' ? (
                                                                                        <Button className="btn btn-simple status-button" color="success" disabled>
                                                                                            Approved
                                                                                        </Button>
                                                                                    ) : order.status === 'order_declined' ? (
                                                                                        <Button className="btn btn-simple status-button" color="danger" disabled>
                                                                                            Declined
                                                                                        </Button>
                                                                                    ) : null}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                                );
                                                            })}
                                                            <SchoolLunchInfo order={row.original.Orders[0]} shipment={row.original} />
                                                        </>
                                                    ) : row.original.shipment_type === 'direct' ? (
                                                        <>
                                                            {(() => {
                                                                const directShipmentOrders = Array.isArray(row.original.Orders) ? row.original.Orders.filter(Boolean) : [];
                                                                const hasDirectDropoff = directShipmentOrders.length > 1;

                                                                return (
                                                            <Row style={{ paddingTop: 10, paddingBottom: 0, marginRight: 0, marginLeft: 0, textAlign: 'center' }}>
                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                    <strong>Load Details</strong>
                                                                    <LoadDetails shipment={row.original} />
                                                                </Col>
                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                    <BasicInfoDirectPick shipment={row.original} />
                                                                </Col>
                                                                {hasDirectDropoff ? (
                                                                    <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                        <BasicInfoDirectDrop shipment={row.original} />
                                                                    </Col>
                                                                ) : null}
                                                                {QUOTE_EDITABLE_PENDING_STATUSES.includes(row.original.status) && (
                                                                    <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                        <QuoteShippingFeeButton shipment={row.original} />
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                                );
                                                            })()}
                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                    <DeliveryDescription shipment={row.original} />
                                                                </Col>

                                                                <RegularPickAndDropInstructions
                                                                    shipment={row.original}
                                                                    pickupClassName="col-2"
                                                                    dropoffClassName="col-2"
                                                                    dropoffStyle={{ marginLeft: '24px' }}
                                                                />
                                                            </Row>
                                                            {row.original.ai_recommendation ? (
                                                                <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '0px', paddingBottom: '20px' }}>
                                                                    <AIRecommendation shipment={row.original} />
                                                                </Row>
                                                            ) : null}
                                                        </>
                                                    ) : row.original.shipment_type === 'routed_direct' ? (
                                                        <>
                                                            <Row style={{ paddingTop: 10, paddingBottom: 0, marginRight: 0, marginLeft: 0, textAlign: 'left' }}>
                                                                <BasicInfoRoutedWaypoint orders={row.original.Orders} display={hasDispatchAdminOverrideOrders(row.original.Orders)} />
                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                    <strong>Load Details</strong>
                                                                    <LoadDetails shipment={row.original} />
                                                                </Col>
                                                                {QUOTE_EDITABLE_PENDING_STATUSES.includes(row.original.status) && (
                                                                    <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                        <QuoteShippingFeeButton shipment={row.original} />
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </>
                                                    ) : row.original.shipment_type === 'multidrop_direct' ? (
                                                        <>
                                                            <Row style={{ paddingTop: 10, paddingBottom: 0, marginRight: 0, marginLeft: 0, textAlign: 'left' }}>
                                                                <BasicInfoMultidropWaypoint orders={row.original.Orders} display={hasDispatchAdminOverrideOrders(row.original.Orders)} />
                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                    <strong>Load Details</strong>
                                                                    <LoadDetails shipment={row.original} />
                                                                </Col>

                                                                {QUOTE_EDITABLE_PENDING_STATUSES.includes(row.original.status) && (
                                                                    <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                        <QuoteShippingFeeButton shipment={row.original} />
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </>
                                                    ) : (
                                                        row.original.Orders.map((order, index) => {
                                                            return (
                                                                <>
                                                                    {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '10px', paddingTop: '10px' }}>
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            <strong>Store Info</strong>
                                                                            <p>
                                                                                {order.location_blob.name} - {order.location_blob.phone}
                                                                            </p>

                                                                            <p>{order.location_blob.address_1 + ', ' + order.location_blob.city}</p>

                                                                            <p>{order.location_blob.phone}</p>
                                                                            <div>
                                                                                <p
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => {
                                                                                        setOrder(order);
                                                                                        setShowOrder(true);
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-caret-right fa-md"></i> Number of Items: {getTotalItems(order.Items)}
                                                                                </p>
                                                                            </div>
                                                                        </Col>
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            <strong>Customer Info</strong>
                                                                            <p>{row.original.customer_blob.first_name + ' ' + row.original.customer_blob.last_name}</p>
                                                                            <p>
                                                                                {row.original.customer_blob.address_1 +
                                                                                    ', ' +
                                                                                    row.original.customer_blob.city +
                                                                                    ', ' +
                                                                                    row.original.customer_blob.zip}
                                                                            </p>
                                                                            <p>{row.original.customer_blob.phone}</p>

                                                                            {order.drop_off_instructions ? <p>{order.drop_off_instructions}</p> : null}
                                                                        </Col>
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            <div className="order-status">
                                                                                {order.status === 'order_created' ? (
                                                                                    <Button className="btn btn-simple status-button" color="info" disabled>
                                                                                        Awaiting Approval
                                                                                    </Button>
                                                                                ) : order.status === 'awaiting_driver' ? (
                                                                                    <Button className="btn btn-simple status-button" color="success" disabled>
                                                                                        Approved
                                                                                    </Button>
                                                                                ) : order.status === 'order_declined' ? (
                                                                                    <Button className="btn btn-simple status-button" color="danger" disabled>
                                                                                        Declined
                                                                                    </Button>
                                                                                ) : null}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            );
                                                        })
                                                    )}
                                                </div>
                                            );
                                        }
                                    }}
                                />
                            ) : selected === 'ready' || selected === 'progressing' || selected === 'completed' ? (
                                <ReactTable
                                    key={`routes-${selected}`}
                                    data={filteredRoutesToDisplay}
                                    columns={
                                        filterRoutes.includes('route_completed')
                                            ? completedColumns
                                            : filterRoutes.includes('route_ready') || filterRoutes.includes('route_temp_claimed')
                                            ? readyColumns
                                            : progressingColumns
                                    }
                                    sortable={true}
                                    resizable={true}
                                    defaultPageSize={selected === 'completed' ? completedRoutesPageSize : 50}
                                    showPagination={selected !== 'completed'}
                                    defaultSorted={selected === 'completed' ? [{ id: 'completed_at', desc: true }] : []}
                                    className="-striped -highlight"
                                    getTrProps={getTrProps}
                                    getTheadThProps={getTheadThProps}
                                    collapseOnSortingChange={true}
                                    collapseOnPageChange={true}
                                    collapseOnDataChange={false}
                                    expanded={expandedItems[selected]}
                                    SubComponent={row => {
                                        const routeShipments = getRouteShipments(row.original);

                                        return (
                                            <div
                                                style={{
                                                    backgroundColor: detailSurfaceBackground,
                                                    borderRadius: '6px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '10px',
                                                    marginRight: '10px',
                                                    marginLeft: '10px',
                                                    marginBottom: '20px',
                                                    height: 'auto'
                                                }}
                                            >
                                                <ReadyRoutePreClaimQuestions route={row.original} />
                                                {selected === 'ready' ? (
                                                    <div>
                                                        {row.original.Shipments.map((shipment, index) => {
                                                            return (
                                                                <div key={shipment.shipment_id || index}>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '0px' }}>
                                                                        <Col
                                                                            className="col-2"
                                                                            style={{ textAlign: 'left', paddingLeft: '0px', paddingRight: '2px', flex: '0 0 13%', maxWidth: '13%' }}
                                                                        >
                                                                            {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                            {shipment.shipment_type === 'direct' ||
                                                                            shipment.shipment_type === 'routed_direct' ||
                                                                            shipment.shipment_type === 'multidrop_direct' ? (
                                                                                ShipmentType({
                                                                                    shipment,
                                                                                    type: 'Direct',
                                                                                    fileViewerProps:
                                                                                        shipment.shipment_type === 'direct'
                                                                                            ? {
                                                                                                  shipmentId: shipment.shipment_id,
                                                                                                  showGenerateBolButton: true
                                                                                              }
                                                                                            : null
                                                                                })
                                                                            ) : shipment.shipment_type === 'bridge' ? (
                                                                                ShipmentType({ shipment, type: 'Bridge' })
                                                                            ) : shipment.shipment_type === 'marketplace' ? (
                                                                                ShipmentType({ shipment, type: 'Marketplace' })
                                                                            ) : shipment.shipment_type === 'school_lunch' ? (
                                                                                ShipmentType({ shipment, type: 'School Lunch' })
                                                                            ) : null}
                                                                        </Col>
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            <HeaderFileUploadColumn shipment={shipment} />
                                                                        ) : null}
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            ExpandedDeliveryStatusColumn({
                                                                                shipment,
                                                                                route: row.original,
                                                                                fileViewerProps:
                                                                                    shipment.shipment_type === 'direct'
                                                                                        ? null
                                                                                        : shipment.shipment_type === 'multidrop_direct'
                                                                                        ? {
                                                                                              shipmentId: shipment.shipment_id,
                                                                                              showGenerateBolButton: true,
                                                                                              deadDropPhotos:
                                                                                                  shipment.status === 'shipment_completed' &&
                                                                                                  Array.isArray(shipment.ShipmentHandshakes) &&
                                                                                                  shipment.ShipmentHandshakes.length > 0 &&
                                                                                                  shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                      ? [shipment.ShipmentHandshakes[0].url]
                                                                                                      : [],
                                                                                              shipFriendId: shipment.shipment_friendly_id,
                                                                                          }
                                                                                        : { shipmentId: shipment.shipment_id, showGenerateBolButton: true }
                                                                            })
                                                                        ) : null}
                                                                        {isFedexShipment(shipment) ? null : (
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                {row.original.Shipments.length === 1 && (
                                                                                    <Button
                                                                                        className="btn btn-danger"
                                                                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                                                                        onClick={() => {
                                                                                            setShipment(shipment);
                                                                                            setShowAlertCancelShipment(true);
                                                                                        }}
                                                                                    >
                                                                                        Cancel
                                                                                    </Button>
                                                                                )}
                                                                                {row.original.Shipments.length > 1 && (
                                                                                    <Button
                                                                                        className="btn btn-danger"
                                                                                        style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                                                                        onClick={() => {
                                                                                            setRoute(row.original);
                                                                                            setShipment(shipment);
                                                                                            setShowAlertRemoveShipment(true);
                                                                                        }}
                                                                                    >
                                                                                        Remove
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        )}
                                                                        <UpdateDriverPayBeforeClaim shipment={shipment} />
                                                                    </Row>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '8px', paddingBottom: '0px' }}>
                                                                        <Col className="col-12" style={{ textAlign: 'left' }}>
                                                                            <PreClaimOrderChatEntry shipment={shipment} />
                                                                        </Col>
                                                                    </Row>
                                                                    {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <BasicInfoDirectPick shipment={shipment} />
                                                                                </Col>

                                                                                <Col className="col-2" style={{ textAlign: 'left', marginLeft: '8px' }}>
                                                                                    <BasicInfoDirectDrop shipment={shipment} />
                                                                                </Col>
                                                                            </Row>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <DeliveryDescription shipment={shipment} />
                                                                                </Col>

                                                                                <RegularPickAndDropInstructions
                                                                                    shipment={shipment}
                                                                                    pickupClassName="col-2"
                                                                                    dropoffClassName="col-2"
                                                                                    dropoffStyle={{ marginLeft: '8px' }}
                                                                                />
                                                                            </Row>
                                                                            {shipment.ai_recommendation ? (
                                                                                <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '0px', paddingBottom: '20px' }}>
                                                                                    <AIRecommendation shipment={shipment} />
                                                                                </Row>
                                                                            ) : null}
                                                                        </>
                                                                    ) : shipment.shipment_type === 'routed_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingTop: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <BasicInfoRoutedWaypoint orders={shipment.Orders} display={hasDispatchAdminOverrideOrders(shipment.Orders)} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'multidrop_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    paddingTop: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <BasicInfoMultidropWaypoint orders={shipment.Orders} display={hasDispatchAdminOverrideOrders(shipment.Orders)} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'school_lunch' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Delivery Status</strong>
                                                                                    <DeliveryStatus shipment={shipment} />
                                                                                </Col>

                                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                    <strong>Pickup Information</strong>
                                                                                    <BasicInfo order={shipment.Orders[0]} />
                                                                                </Col>

                                                                                    <Col className="col-3" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>{shipment.customer_blob.first_name + ' ' + shipment.customer_blob.last_name}</p>
                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>{shipment.customer_blob.address_1}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.state +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <SchoolLunchInfo order={shipment.Orders[0]} shipment={shipment} />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <p>
                                                                                        {getVehicleTypeLabel(shipment.vehicle_type)}
                                                                                    </p>
                                                                                    <p>{shipment.weight} lbs</p>
                                                                                    <p>{shipment.num_of_gophrs} Gophrs Needed</p>
                                                                                    <p>{Number(shipment.distance || 0).toFixed(2) + ' miles'}</p>
                                                                                    <p>{'$' + formatCurrencyAmount(shipment.shipping_fee)}</p>
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Delivery Status</strong>
                                                                                    <p>
                                                                                        {shipment.status === 'shipment_ready_for_driver'
                                                                                            ? 'Ready for Driver'
                                                                                            : shipment.status === 'shipment_assigned'
                                                                                            ? 'Assigned to Driver'
                                                                                            : shipment.status === 'shipment_enroute'
                                                                                            ? 'En Route'
                                                                                            : shipment.status === 'shipment_completed'
                                                                                            ? 'Completed'
                                                                                            : shipment.status === 'shipment_scheduled'
                                                                                            ? 'Scheduled'
                                                                                            : shipment.status === 'shipment_pending_saved'
                                                                                            ? 'Pending Approval'
                                                                                            : shipment.status === 'shipment_saved'
                                                                                            ? 'Saved'
                                                                                            : null}
                                                                                    </p>
                                                                                </Col>
                                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>
                                                                                        {shipment.customer_blob.first_name} {shipment.customer_blob.last_name}
                                                                                    </p>

                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.address_1}{' '}
                                                                                        {shipment.customer_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                    </p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city}, {shipment.customer_blob.state}, {shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                                {shipment.drop_off_instructions ? (
                                                                                    <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                        <strong>Dropoff Instructions</strong>
                                                                                        <p>{shipment.drop_off_instructions}</p>
                                                                                    </Col>
                                                                                ) : null}
                                                                            </Row>
                                                                            <div style={{ color: '#f7941d', paddingLeft: '10px', paddingTop: '15px', paddingBottom: '15px' }}>
                                                                                <strong>Orders Info</strong>
                                                                            </div>
                                                                            {shipment.Orders.map((order, index) => {
                                                                                return (
                                                                                    <React.Fragment key={order.order_id || `${shipment.shipment_id || 'shipment'}-order-${index}`}>
                                                                                        {index !== 0 ? <hr style={{ backgroundColor: '#f7941d', width: '90%' }}></hr> : null}
                                                                                        <Row
                                                                                            style={{
                                                                                                paddingLeft: '20px',
                                                                                                paddingRight: '20px',
                                                                                                paddingTop: '0px',
                                                                                                paddingBottom: '5px'
                                                                                            }}
                                                                                        >
                                                                                            <Col className="col-5" style={{ textAlign: 'left' }}>
                                                                                                <div style={{ paddingBottom: '5px' }}>
                                                                                                    <strong>
                                                                                                        <p>
                                                                                                            {index + 1} . {order.location_blob.name}
                                                                                                        </p>
                                                                                                    </strong>
                                                                                                </div>
                                                                                                <p>{order.location_blob.phone}</p>
                                                                                                <p>
                                                                                                    {order.location_blob.address_1}{' '}
                                                                                                    {order.location_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                                </p>
                                                                                                <p>
                                                                                                    {order.location_blob.city}, {order.location_blob.state},{' '}
                                                                                                    {order.location_blob.zip}
                                                                                                </p>
                                                                                                <p>{order.total != null ? '$' + order.total.toFixed(2) : '$' + 0.0}</p>
                                                                                                {order.pick_up_instructions ? (
                                                                                                    <div>
                                                                                                        <p>Pick Up Instruction: {order.pick_up_instructions}</p>
                                                                                                    </div>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                            <Col className="col-5" style={{ textAlign: 'left' }}>
                                                                                                <div className="order-container">
                                                                                                    <div className="item-quantity">
                                                                                                        <strong>Qty.</strong>
                                                                                                    </div>
                                                                                                    <div className="item-name">
                                                                                                        <strong>Product</strong>
                                                                                                    </div>
                                                                                                    <div className="item-total">
                                                                                                        <strong>Price</strong>
                                                                                                    </div>
                                                                                                    <div className="item-weight">
                                                                                                        <strong>Weight</strong>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {order
                                                                                                    ? order.Items.map(item => {
                                                                                                          return (
                                                                                                              <>
                                                                                                                  <div className="item-container">
                                                                                                                      <div className="item-quantity">{item.quantity}</div>
                                                                                                                      <div className="item-name">
                                                                                                                          {item.product_blob.name + ' '}
                                                                                                                          {item.ItemOptions.length > 0
                                                                                                                              ? item.ItemOptions.map((option, index) => {
                                                                                                                                    if (index === 0) {
                                                                                                                                        return '(' + option.option_name;
                                                                                                                                    } else if (
                                                                                                                                        index > 0 &&
                                                                                                                                        index !== item.ItemOptions.length - 1
                                                                                                                                    ) {
                                                                                                                                        return ', ' + option.option_name;
                                                                                                                                    } else {
                                                                                                                                        return ', ' + option.option_name + ')';
                                                                                                                                    }
                                                                                                                                })
                                                                                                                              : null}
                                                                                                                      </div>
                                                                                                                      <div className="item-total">
                                                                                                                          ${item.product_price.toFixed(2)}
                                                                                                                      </div>
                                                                                                                      <div className="item-weight">
                                                                                                                          {item.product_blob.weight} lbs.
                                                                                                                      </div>
                                                                                                                  </div>
                                                                                                              </>
                                                                                                          );
                                                                                                      })
                                                                                                    : 'Something went wrong'}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </React.Fragment>
                                                                                );
                                                                            })}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : selected === 'progressing' ? (
                                                    <div>
                                                        {routeShipments.length === 0 ? (
                                                            <div style={{ padding: '10px 20px 20px', color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : '#6c757d' }}>
                                                                No shipment details are available for this route yet.
                                                            </div>
                                                        ) : null}
                                                        {routeShipments.map((shipment, index) => {
                                                            const routeDrivers = getRouteDriversForDisplay(row.original, shipment);
                                                            return (
                                                                <div key={shipment.shipment_id || index}>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '0px' }}>
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                            {shipment.shipment_type === 'direct' ||
                                                                            shipment.shipment_type === 'routed_direct' ||
                                                                            shipment.shipment_type === 'multidrop_direct' ? (
                                                                                ShipmentType({
                                                                                    shipment,
                                                                                    type: 'Direct',
                                                                                    fileViewerProps:
                                                                                        shipment.shipment_type === 'direct'
                                                                                            ? {
                                                                                                  shipmentId: shipment.shipment_id,
                                                                                                  showGenerateBolButton: true
                                                                                              }
                                                                                            : null
                                                                                })
                                                                            ) : shipment.shipment_type === 'bridge' ? (
                                                                                ShipmentType({ shipment, type: 'Bridge' })
                                                                            ) : shipment.shipment_type === 'marketplace' ? (
                                                                                ShipmentType({ shipment, type: 'Marketplace' })
                                                                            ) : shipment.shipment_type === 'school_lunch' ? (
                                                                                ShipmentType({ shipment, type: 'School Lunch' })
                                                                            ) : null}
                                                                        </Col>
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            <HeaderFileUploadColumn
                                                                                shipment={shipment}
                                                                                className="col-2"
                                                                                style={{ paddingLeft: '0px', paddingRight: '4px', marginLeft: '-22px', flex: '0 0 11%', maxWidth: '11%' }}
                                                                            />
                                                                        ) : null}
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            ExpandedDeliveryStatusColumn({
                                                                                shipment,
                                                                                route: row.original,
                                                                                fileViewerProps:
                                                                                    shipment.shipment_type === 'direct'
                                                                                        ? null
                                                                                        : shipment.shipment_type === 'multidrop_direct'
                                                                                        ? {
                                                                                              shipmentId: shipment.shipment_id,
                                                                                              showGenerateBolButton: true,
                                                                                              deadDropPhotos:
                                                                                                  shipment.status === 'shipment_completed' &&
                                                                                                  Array.isArray(shipment.ShipmentHandshakes) &&
                                                                                                  shipment.ShipmentHandshakes.length > 0 &&
                                                                                                  shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                      ? [shipment.ShipmentHandshakes[0].url]
                                                                                                      : [],
                                                                                              shipFriendId: shipment.shipment_friendly_id,
                                                                                          }
                                                                                        : { shipmentId: shipment.shipment_id, showGenerateBolButton: true },
                                                                                className: 'col-6',
                                                                                style: { paddingLeft: '0px', paddingRight: '8px', flex: '0 0 52%', maxWidth: '52%' },
                                                                                children: <CompactEtaStatusBlock shipment={shipment} route={row.original} />
                                                                            })
                                                                        ) : null}
                                                                        <Col className="col-2" style={{ textAlign: 'left', paddingLeft: '0px', flex: '0 0 24%', maxWidth: '24%' }}>
                                                                            {row.original.Shipments.length > 1 && (
                                                                                <Button
                                                                                    className="btn btn-warning"
                                                                                    style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                                                                    onClick={() => {
                                                                                        setRoute(row.original);
                                                                                        setShipment(shipment);
                                                                                        setShowAlertRemoveShipment(true);
                                                                                    }}
                                                                                >
                                                                                    Remove
                                                                                </Button>
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                    {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <BasicInfoDirectPick shipment={shipment} />
                                                                                </Col>

                                                                                <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                    <BasicInfoDirectDrop shipment={shipment} />
                                                                                </Col>
                                                                                <DirectRouteDriverInfo route={row.original} shipment={shipment} showWebTracking={true} className="col-2" />
                                                                            </Row>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <DeliveryDescription shipment={shipment} />
                                                                                </Col>

                                                                                <RegularPickAndDropInstructions
                                                                                    shipment={shipment}
                                                                                    pickupClassName="col-2"
                                                                                    dropoffClassName="col-2"
                                                                                    dropoffStyle={{ marginLeft: '24px' }}
                                                                                />

                                                                                <AIRecommendation shipment={shipment} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'routed_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingTop: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />

                                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap', paddingBottom: '15px' }}>
                                                                                        <p style={{ marginBottom: 0 }}>
                                                                                            {shipment.status === 'shipment_assigned'
                                                                                                ? 'Assigned to Driver'
                                                                                                : shipment.status === 'shipment_claimed'
                                                                                                ? 'Driver Claimed'
                                                                                                : shipment.status === 'shipment_completed'
                                                                                                ? 'Completed✅'
                                                                                                : null}
                                                                                        </p>
                                                                                        <DeliveringRouteActions route={row.original} />
                                                                                    </div>
                                                                                    <DriverCounts count={routeDrivers.length} />
                                                                                    <DriverPay route={row.original} shipment={shipment} driver={routeDrivers[0]} driverStatus="driver" />
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                </Col>
                                                                                <BasicInfoRoutedWaypoint orders={shipment.Orders} display={true} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'multidrop_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    paddingTop: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col className="col-4" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />

                                                                                    <div style={{ paddingBottom: '15px' }}>
                                                                                        <p style={{ marginBottom: 0 }}>
                                                                                            {shipment.status === 'shipment_assigned'
                                                                                                ? 'Assigned to Driver'
                                                                                                : shipment.status === 'shipment_claimed'
                                                                                                ? 'Driver Claimed'
                                                                                                : shipment.status === 'shipment_completed'
                                                                                                ? 'Completed✅'
                                                                                                : null}
                                                                                        </p>
                                                                                    </div>

                                                                                    <DriverCounts count={routeDrivers.length} />
                                                                                    <DriverPay route={row.original} shipment={shipment} driver={routeDrivers[0]} driverStatus="driver" />
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    <WebTrackingLink route={row.original} />
                                                                                </Col>
                                                                                <BasicInfoMultidropWaypoint orders={shipment.Orders} display={true} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'school_lunch' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                                                                                        <div>
                                                                                            <strong>Delivery Status</strong>
                                                                                            <DeliveryStatus shipment={shipment} />
                                                                                        </div>
                                                                                        <DeliveringRouteActions route={row.original} />
                                                                                    </div>
                                                                                    <p>
                                                                                        Pick up:{' '}
                                                                                        {isOrderCompletedForDisplay(shipment.Orders[0])
                                                                                            ? formatOrderCompletionForDisplay(shipment.Orders[0])
                                                                                            : 'approaching'}
                                                                                    </p>
                                                                                    <p>
                                                                                        Drop off:
                                                                                        {isOrderCompletedForDisplay(shipment.Orders[0]) && shipment.status === 'shipment_completed'
                                                                                            ? formatTimestamp(shipment.completed_at) + '✅'
                                                                                            : isOrderCompletedForDisplay(shipment.Orders[0]) &&
                                                                                              shipment.status !== 'shipment_completed'
                                                                                            ? 'delivering'
                                                                                            : 'waiting'}
                                                                                    </p>
                                                                                </Col>

                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    {' '}
                                                                                    <DriverCounts count={routeDrivers.length} />
                                                                                    <DriverPay route={row.original} shipment={shipment} driver={routeDrivers[0]} driverStatus="driver" />
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                </Col>

                                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                    <strong>Pickup Information</strong>
                                                                                    <BasicInfo order={shipment.Orders[0]} />
                                                                                </Col>

                                                                                <Col className="col-3" style={{ textAlign: 'left', marginLeft: '8px' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>{shipment.customer_blob.first_name + ' ' + shipment.customer_blob.last_name}</p>
                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>{shipment.customer_blob.address_1}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.state +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <SchoolLunchInfo order={shipment.Orders[0]} shipment={shipment} />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <p>
                                                                                        {getVehicleTypeLabel(shipment.vehicle_type)}
                                                                                    </p>
                                                                                    <p>{shipment.weight} lbs</p>
                                                                                    <p>{shipment.num_of_gophrs} Gophrs Needed</p>
                                                                                    <p>{Number(shipment.distance || 0).toFixed(2) + ' miles'}</p>
                                                                                    <p>{'$' + formatCurrencyAmount(shipment.shipping_fee)}</p>
                                                                                </Col>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <Row>
                                                                                        <Col style={{ textAlign: 'left' }}>
                                                                                            <strong>Delivery Status</strong>
                                                                                            <p>
                                                                                                {shipment.status === 'shipment_ready_for_driver'
                                                                                                    ? 'Ready for Driver'
                                                                                                    : shipment.status === 'shipment_assigned'
                                                                                                    ? 'Assigned to Driver'
                                                                                                    : shipment.status === 'shipment_enroute'
                                                                                                    ? 'En Route'
                                                                                                    : shipment.status === 'shipment_completed'
                                                                                                    ? 'Completed'
                                                                                                    : shipment.status === 'shipment_scheduled'
                                                                                                    ? 'Scheduled'
                                                                                                    : null}
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row style={{ textAlign: 'left' }}>
                                                                                        {routeDrivers[0] ? (
                                                                                            <Col style={{ textAlign: 'left', paddingTop: '30px' }}>
                                                                                                <DriverCounts count={routeDrivers.length} />
                                                                                                <p>
                                                                                                    {routeDrivers[0].driver_blob.first_name}{' '}
                                                                                                    {routeDrivers[0].driver_blob.last_name}
                                                                                                </p>
                                                                                                {routeDrivers[1] ? (
                                                                                                    <p>
                                                                                                        {routeDrivers[1].driver_blob.first_name}{' '}
                                                                                                        {routeDrivers[1].driver_blob.last_name}
                                                                                                    </p>
                                                                                                ) : null}
                                                                                                {routeDrivers[2] ? (
                                                                                                    <p>
                                                                                                        {routeDrivers[2].driver_blob.first_name}{' '}
                                                                                                        {routeDrivers[2].driver_blob.last_name}
                                                                                                    </p>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                        ) : null}
                                                                                    </Row>
                                                                                </Col>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>
                                                                                        {shipment.customer_blob.first_name} {shipment.customer_blob.last_name}
                                                                                    </p>

                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.address_1}{' '}
                                                                                        {shipment.customer_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                    </p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city}, {shipment.customer_blob.state}, {shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                                {shipment.drop_off_instructions ? (
                                                                                    <Col style={{ textAlign: 'left' }}>
                                                                                        <strong>Dropoff Instructions</strong>
                                                                                        <p>{shipment.drop_off_instructions}</p>
                                                                                    </Col>
                                                                                ) : null}
                                                                            </Row>
                                                                            <div style={{ color: '#f7941d', paddingLeft: '10px', paddingTop: '15px', paddingBottom: '15px' }}>
                                                                                <strong>Orders Info</strong>
                                                                            </div>
                                                                            {shipment.Orders.map((order, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index !== 0 ? <hr style={{ backgroundColor: '#f7941d', width: '90%' }}></hr> : null}
                                                                                        <Row
                                                                                            style={{
                                                                                                paddingLeft: '20px',
                                                                                                paddingRight: '20px',
                                                                                                paddingTop: '0px',
                                                                                                paddingBottom: '5px'
                                                                                            }}
                                                                                        >
                                                                                            <Col style={{ textAlign: 'left' }}>
                                                                                                <div style={{ paddingBottom: '5px' }}>
                                                                                                    <strong>
                                                                                                        <p>
                                                                                                            {index + 1} . {order.location_blob.name}
                                                                                                        </p>
                                                                                                    </strong>
                                                                                                </div>
                                                                                                <p>{order.location_blob.phone}</p>
                                                                                                <p>
                                                                                                    {order.location_blob.address_1}{' '}
                                                                                                    {order.location_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                                </p>
                                                                                                <p>
                                                                                                    {order.location_blob.city}, {order.location_blob.state},{' '}
                                                                                                    {order.location_blob.zip}
                                                                                                </p>
                                                                                                <p>{order.total != null ? '$' + order.total.toFixed(2) : '$' + 0.0}</p>
                                                                                                {order.pick_up_instructions ? (
                                                                                                    <div>
                                                                                                        <p>Pick Up Instruction: {order.pick_up_instructions}</p>
                                                                                                    </div>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                            <Col style={{ textAlign: 'left' }}>
                                                                                                <div className="order-container">
                                                                                                    <div className="item-quantity">
                                                                                                        <strong>Qty.</strong>
                                                                                                    </div>
                                                                                                    <div className="item-name">
                                                                                                        <strong>Product</strong>
                                                                                                    </div>
                                                                                                    <div className="item-total">
                                                                                                        <strong>Price</strong>
                                                                                                    </div>
                                                                                                    <div className="item-weight">
                                                                                                        <strong>Weight</strong>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {order
                                                                                                    ? order.Items.map(item => {
                                                                                                          return (
                                                                                                              <div className="item-container">
                                                                                                                  <div className="item-quantity">{item.quantity}</div>
                                                                                                                  <div className="item-name">
                                                                                                                      {item.product_blob.name + ' '}
                                                                                                                      {item.ItemOptions.length > 0
                                                                                                                          ? item.ItemOptions.map((option, index) => {
                                                                                                                                if (index === 0) {
                                                                                                                                    return '(' + option.option_name;
                                                                                                                                } else if (
                                                                                                                                    index > 0 &&
                                                                                                                                    index !== item.ItemOptions.length - 1
                                                                                                                                ) {
                                                                                                                                    return ', ' + option.option_name;
                                                                                                                                } else {
                                                                                                                                    return ', ' + option.option_name + ')';
                                                                                                                                }
                                                                                                                            })
                                                                                                                          : null}
                                                                                                                  </div>
                                                                                                                  <div className="item-total">${item.product_price.toFixed(2)}</div>
                                                                                                                  <div className="item-weight">{item.product_blob.weight} lbs.</div>
                                                                                                              </div>
                                                                                                          );
                                                                                                      })
                                                                                                    : 'Something went wrong'}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : selected === 'completed' ? (
                                                    <div>
                                                        {(() => {
                                                            const completedRouteRecord = currentRecordId && currentRecord && row.original && row.original.route_id === currentRecordId
                                                                ? currentRecord
                                                                : row.original;
                                                            const completedRouteShipments = getRouteShipments(completedRouteRecord);

                                                            return completedRouteShipments.map((shipment, index) => {
                                                            const routeDrivers = getRouteDriversForDisplay(completedRouteRecord, shipment);
                                                            return (
                                                                <div key={shipment.shipment_id || index}>
                                                                    <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '0px' }}>
                                                                        <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                            {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                            {shipment.shipment_type === 'direct' ||
                                                                            shipment.shipment_type === 'routed_direct' ||
                                                                            shipment.shipment_type === 'multidrop_direct' ? (
                                                                                ShipmentType({
                                                                                    shipment,
                                                                                    type: 'Direct',
                                                                                    fileViewerProps:
                                                                                        shipment.shipment_type === 'direct'
                                                                                            ? {
                                                                                                  shipmentId: shipment.shipment_id,
                                                                                                  showGenerateBolButton: true,
                                                                                                  deadDropPhotos:
                                                                                                      shipment.ShipmentHandshakes.length > 0 && shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                          ? [shipment.ShipmentHandshakes[0].url]
                                                                                                          : [],
                                                                                                  shipFriendId: shipment.shipment_friendly_id
                                                                                              }
                                                                                            : null
                                                                                })
                                                                            ) : shipment.shipment_type === 'bridge' ? (
                                                                                ShipmentType({ shipment, type: 'Bridge' })
                                                                            ) : shipment.shipment_type === 'marketplace' ? (
                                                                                ShipmentType({ shipment, type: 'Marketplace' })
                                                                            ) : shipment.shipment_type === 'school_lunch' ? (
                                                                                ShipmentType({ shipment, type: 'School Lunch' })
                                                                            ) : null}
                                                                        </Col>
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            <HeaderFileUploadColumn shipment={shipment} />
                                                                        ) : null}
                                                                        {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                            ExpandedDeliveryStatusColumn({
                                                                                shipment,
                                                                                route: completedRouteRecord,
                                                                                fileViewerProps:
                                                                                    shipment.shipment_type === 'direct'
                                                                                        ? null
                                                                                        : shipment.shipment_type === 'multidrop_direct'
                                                                                        ? {
                                                                                              shipmentId: shipment.shipment_id,
                                                                                              showGenerateBolButton: true,
                                                                                              deadDropPhotos:
                                                                                                  Array.isArray(shipment.ShipmentHandshakes) &&
                                                                                                  shipment.ShipmentHandshakes.length > 0 &&
                                                                                                  shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                      ? [shipment.ShipmentHandshakes[0].url]
                                                                                                      : [],
                                                                                              shipFriendId: shipment.shipment_friendly_id
                                                                                          }
                                                                                        : {
                                                                                              shipmentId: shipment.shipment_id,
                                                                                              showGenerateBolButton: true,
                                                                                              deadDropPhotos:
                                                                                                  shipment.ShipmentHandshakes.length > 0 && shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                      ? [shipment.ShipmentHandshakes[0].url]
                                                                                                      : [],
                                                                                              shipFriendId: shipment.shipment_friendly_id
                                                                                          },
                                                                                className: 'col-4'
                                                                            })
                                                                        ) : null}
                                                                        <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                            <Button
                                                                                className="btn btn-success"
                                                                                style={{ padding: `5px 10px`, margin: 0, display: `flex`, flexDirection: `column` }}
                                                                                onClick={() => {
                                                                                    setShipment(shipment);
                                                                                    setShowChargeSetupFee(true);
                                                                                }}
                                                                            >
                                                                                Setup Fee
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                    {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={completedRouteRecord} />
                                                                                    {hasShipmentSetupFee(shipment) && (
                                                                                        <p>{'$' + Number(getShipmentFeeBlob(shipment).setup_fee || 0).toFixed(2)}(setup_fee)</p>
                                                                                    )}
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <BasicInfoDirectPick shipment={shipment} route={completedRouteRecord} />
                                                                                </Col>

                                                                                <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                    <BasicInfoDirectDrop shipment={shipment} />
                                                                                </Col>
                                                                                <DirectRouteDriverInfo route={completedRouteRecord} shipment={shipment} className="col-2" />
                                                                            </Row>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <DeliveryDescription shipment={shipment} />
                                                                                </Col>

                                                                                <RegularPickAndDropInstructions
                                                                                    shipment={shipment}
                                                                                    pickupClassName="col-2"
                                                                                    dropoffClassName="col-2"
                                                                                    dropoffStyle={{ marginLeft: '24px' }}
                                                                                />

                                                                                <AIRecommendation shipment={shipment} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'routed_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingTop: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={completedRouteRecord} />
                                                                                    {hasShipmentSetupFee(shipment) && (
                                                                                        <p>{'$' + Number(getShipmentFeeBlob(shipment).setup_fee || 0).toFixed(2)}(setup_fee)</p>
                                                                                    )}
                                                                                    <DeliveryStatus shipment={shipment} />

                                                                                    {routeDrivers[0] ? (
                                                                                        <>
                                                                                            <DriverCounts count={routeDrivers.length} />
                                                                                            <DriverPay
                                                                                                route={completedRouteRecord}
                                                                                                shipment={shipment}
                                                                                                driver={routeDrivers[0]}
                                                                                                driverStatus="driver"
                                                                                            />
                                                                                        </>
                                                                                    ) : null}
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}

                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                </Col>
                                                                                <BasicInfoRoutedWaypoint orders={shipment.Orders} display={true} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'multidrop_direct' ? (
                                                                        <>
                                                                            <Row
                                                                                style={{
                                                                                    paddingLeft: '20px',
                                                                                    paddingRight: '20px',
                                                                                    paddingBottom: '10px',
                                                                                    paddingTop: '10px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                                                                                        <div>
                                                                                            <strong>Delivery Status</strong>
                                                                                            <DeliveryStatus shipment={shipment} />
                                                                                        </div>
                                                                                        <DeliveringRouteActions route={completedRouteRecord} />
                                                                                    </div>

                                                                                    {hasShipmentSetupFee(shipment) && (
                                                                                        <p>{'$' + Number(getShipmentFeeBlob(shipment).setup_fee || 0).toFixed(2)}(setup_fee)</p>
                                                                                    )}
                                                                                    <DeliveryStatus shipment={shipment} />

                                                                                    <DriverCounts count={routeDrivers.length} />
                                                                                    {routeDrivers[0] ? <DriverPay route={completedRouteRecord} shipment={shipment} driver={routeDrivers[0]} driverStatus="driver" /> : null}
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                </Col>
                                                                                <BasicInfoMultidropWaypoint orders={shipment.Orders} display={true} />
                                                                            </Row>
                                                                        </>
                                                                    ) : shipment.shipment_type === 'school_lunch' ? (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                                </Col>
                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <strong>Delivery Status</strong>
                                                                                    <DeliveryStatus shipment={shipment} />
                                                                                </Col>

                                                                                <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                    <DriverCounts count={routeDrivers.length} />
                                                                                    {routeDrivers[0] ? <DriverPay route={completedRouteRecord} shipment={shipment} driver={routeDrivers[0]} driverStatus="driver" /> : null}
                                                                                    {routeDrivers[1] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[1]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                    {routeDrivers[2] ? (
                                                                                        <DriverPay
                                                                                            shipment={shipment}
                                                                                            driver={routeDrivers[2]}
                                                                                            driverStatus="passenger"
                                                                                        />
                                                                                    ) : null}
                                                                                </Col>

                                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                    <strong>Pickup Information</strong>
                                                                                    <BasicInfo order={shipment.Orders[0]} />
                                                                                </Col>

                                                                                <Col className="col-3" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>{shipment.customer_blob.first_name + ' ' + shipment.customer_blob.last_name}</p>
                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>{shipment.customer_blob.address_1}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.state +
                                                                                            ', ' +
                                                                                            shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                            </Row>
                                                                            <SchoolLunchInfo order={shipment.Orders[0]} shipment={shipment} />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <strong>Load Details</strong>
                                                                                    <p>
                                                                                        {getVehicleTypeLabel(shipment.vehicle_type)}
                                                                                    </p>
                                                                                    <p>{shipment.weight} lbs</p>
                                                                                    <p>{shipment.num_of_gophrs} Gophrs Needed</p>
                                                                                    <p>{Number(shipment.distance || 0).toFixed(2) + ' miles'}</p>
                                                                                    <p>{'$' + formatCurrencyAmount(shipment.shipping_fee)}</p>
                                                                                </Col>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <Row>
                                                                                        <Col style={{ textAlign: 'left' }}>
                                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                                                                                                <div>
                                                                                                    <strong>Delivery Status</strong>
                                                                                                    <p>
                                                                                                        {shipment.status === 'shipment_ready_for_driver'
                                                                                                            ? 'Ready for Driver'
                                                                                                            : shipment.status === 'shipment_assigned'
                                                                                                            ? 'Assigned to Driver'
                                                                                                            : shipment.status === 'shipment_enroute'
                                                                                                            ? 'En Route'
                                                                                                            : shipment.status === 'shipment_completed'
                                                                                                            ? 'Completed'
                                                                                                            : shipment.status === 'shipment_scheduled'
                                                                                                            ? 'Scheduled'
                                                                                                            : null}
                                                                                                    </p>
                                                                                                </div>
                                                                                                <DeliveringRouteActions route={row.original} />
                                                                                            </div>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row style={{ textAlign: 'left' }}>
                                                                                        {routeDrivers[0] ? (
                                                                                            <Col style={{ textAlign: 'left', paddingTop: '30px' }}>
                                                                                                <DriverCounts count={routeDrivers.length} />
                                                                                                <p>
                                                                                                    {routeDrivers[0].driver_blob.first_name}{' '}
                                                                                                    {routeDrivers[0].driver_blob.last_name}
                                                                                                </p>
                                                                                                {routeDrivers[1] ? (
                                                                                                    <p>
                                                                                                        {routeDrivers[1].driver_blob.first_name}{' '}
                                                                                                        {routeDrivers[1].driver_blob.last_name}
                                                                                                    </p>
                                                                                                ) : null}
                                                                                                {routeDrivers[2] ? (
                                                                                                    <p>
                                                                                                        {routeDrivers[2].driver_blob.first_name}{' '}
                                                                                                        {routeDrivers[2].driver_blob.last_name}
                                                                                                    </p>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                        ) : null}
                                                                                    </Row>
                                                                                </Col>
                                                                                <Col style={{ textAlign: 'left' }}>
                                                                                    <strong>Dropoff Information</strong>
                                                                                    <p>
                                                                                        {shipment.customer_blob.first_name} {shipment.customer_blob.last_name}
                                                                                    </p>

                                                                                    <p>{shipment.customer_blob.phone}</p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.address_1}{' '}
                                                                                        {shipment.customer_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                    </p>
                                                                                    <p>
                                                                                        {shipment.customer_blob.city}, {shipment.customer_blob.state}, {shipment.customer_blob.zip}
                                                                                    </p>
                                                                                </Col>
                                                                                {shipment.drop_off_instructions ? (
                                                                                    <Col style={{ textAlign: 'left' }}>
                                                                                        <strong>Dropoff Instructions</strong>
                                                                                        <p>{shipment.drop_off_instructions}</p>
                                                                                    </Col>
                                                                                ) : null}
                                                                            </Row>
                                                                            <div style={{ color: '#f7941d', paddingLeft: '10px', paddingTop: '15px', paddingBottom: '15px' }}>
                                                                                <strong>Orders Info</strong>
                                                                            </div>
                                                                            {shipment.Orders.map((order, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index !== 0 ? <hr style={{ backgroundColor: '#f7941d', width: '90%' }}></hr> : null}
                                                                                        <Row
                                                                                            style={{
                                                                                                paddingLeft: '20px',
                                                                                                paddingRight: '20px',
                                                                                                paddingTop: '0px',
                                                                                                paddingBottom: '5px'
                                                                                            }}
                                                                                        >
                                                                                            <Col style={{ textAlign: 'left' }}>
                                                                                                <div style={{ paddingBottom: '5px' }}>
                                                                                                    <strong>
                                                                                                        <p>
                                                                                                            {index + 1} . {order.location_blob.name}
                                                                                                        </p>
                                                                                                    </strong>
                                                                                                </div>
                                                                                                <p>{order.location_blob.phone}</p>
                                                                                                <p>
                                                                                                    {order.location_blob.address_1}{' '}
                                                                                                    {order.location_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                                </p>
                                                                                                <p>
                                                                                                    {order.location_blob.city}, {order.location_blob.state},{' '}
                                                                                                    {order.location_blob.zip}
                                                                                                </p>
                                                                                                <p>{order.total != null ? '$' + order.total.toFixed(2) : '$' + 0.0}</p>
                                                                                                {order.pick_up_instructions ? (
                                                                                                    <div>
                                                                                                        <p>Pick Up Instruction: {order.pick_up_instructions}</p>
                                                                                                    </div>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                            <Col style={{ textAlign: 'left' }}>
                                                                                                <div className="order-container">
                                                                                                    <div className="item-quantity">
                                                                                                        <strong>Qty.</strong>
                                                                                                    </div>
                                                                                                    <div className="item-name">
                                                                                                        <strong>Product</strong>
                                                                                                    </div>
                                                                                                    <div className="item-total">
                                                                                                        <strong>Price</strong>
                                                                                                    </div>
                                                                                                    <div className="item-weight">
                                                                                                        <strong>Weight</strong>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {order
                                                                                                    ? order.Items.map(item => {
                                                                                                          return (
                                                                                                              <div className="item-container">
                                                                                                                  <div className="item-quantity">{item.quantity}</div>
                                                                                                                  <div className="item-name">
                                                                                                                      {item.product_blob.name + ' '}
                                                                                                                      {item.ItemOptions.length > 0
                                                                                                                          ? item.ItemOptions.map((option, index) => {
                                                                                                                                if (index === 0) {
                                                                                                                                    return '(' + option.option_name;
                                                                                                                                } else if (
                                                                                                                                    index > 0 &&
                                                                                                                                    index !== item.ItemOptions.length - 1
                                                                                                                                ) {
                                                                                                                                    return ', ' + option.option_name;
                                                                                                                                } else {
                                                                                                                                    return ', ' + option.option_name + ')';
                                                                                                                                }
                                                                                                                            })
                                                                                                                          : null}
                                                                                                                  </div>
                                                                                                                  <div className="item-total">${item.product_price.toFixed(2)}</div>
                                                                                                                  <div className="item-weight">{item.product_blob.weight} lbs.</div>
                                                                                                              </div>
                                                                                                          );
                                                                                                      })
                                                                                                    : 'Something went wrong'}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </>
                                                                    )}
                                                                    <DispatchShipmentReview shipment={shipment} />
                                                                </div>
                                                            );
                                                        });
                                                        })()}
                                                    </div>
                                                ) : null}
                                            </div>
                                        );
                                    }}
                                />
                            ) : selected === 'merging' ? (
                                <ReactTable
                                    key="3"
                                    data={filteredMergingRoutes}
                                    columns={mergingRoutesColumns}
                                    sortable={true}
                                    resizable={true}
                                    defaultPageSize={50}
                                    className="-striped -highlight"
                                    getTrProps={getTrProps}
                                    getTheadThProps={getTheadThProps}
                                    onExpandedChange={handleExpandedChange}
                                    collapseOnSortingChange={true}
                                    collapseOnPageChange={true}
                                    collapseOnDataChange={false}
                                    expanded={expandedItems[selected]}
                                    SubComponent={row => {
                                        return (
                                            <div
                                                style={{
                                                    backgroundColor: detailSurfaceBackground,
                                                    borderRadius: '6px',
                                                    paddingTop: '15px',
                                                    paddingLeft: '10px',
                                                    marginRight: '10px',
                                                    marginLeft: '10px',
                                                    marginBottom: '20px',
                                                    height: 'auto'
                                                }}
                                            >
                                                <div>
                                                    {row.original.Shipments.map((shipment, index) => {
                                                        return (
                                                            <div key={shipment.shipment_id || index}>
                                                                <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '5px', paddingBottom: '0px' }}>
                                                                    <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                        {index !== 0 ? <hr style={{ backgroundColor: '#cdcaca' }}></hr> : null}
                                                                        {shipment.shipment_type === 'direct' ||
                                                                        shipment.shipment_type === 'routed_direct' ||
                                                                        shipment.shipment_type === 'multidrop_direct' ? (
                                                                            ShipmentType({
                                                                                shipment,
                                                                                type: 'Direct',
                                                                                fileViewerProps:
                                                                                    shipment.shipment_type === 'direct'
                                                                                        ? {
                                                                                              shipmentId: shipment.shipment_id,
                                                                                              showGenerateBolButton: true
                                                                                          }
                                                                                        : null
                                                                            })
                                                                        ) : shipment.shipment_type === 'bridge' ? (
                                                                            ShipmentType({ shipment, type: 'Bridge' })
                                                                        ) : shipment.shipment_type === 'marketplace' ? (
                                                                            ShipmentType({ shipment, type: 'Marketplace' })
                                                                        ) : shipment.shipment_type === 'school_lunch' ? (
                                                                            ShipmentType({ shipment, type: 'School Lunch' })
                                                                        ) : null}
                                                                    </Col>
                                                                    {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                        <HeaderFileUploadColumn shipment={shipment} />
                                                                    ) : null}
                                                                    {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' || shipment.shipment_type === 'multidrop_direct' ? (
                                                                        ExpandedDeliveryStatusColumn({
                                                                            shipment,
                                                                            route: row.original,
                                                                            fileViewerProps:
                                                                                shipment.shipment_type === 'direct'
                                                                                    ? null
                                                                                    : shipment.shipment_type === 'multidrop_direct'
                                                                                    ? {
                                                                                          shipmentId: shipment.shipment_id,
                                                                                          showGenerateBolButton: true,
                                                                                          deadDropPhotos:
                                                                                              Array.isArray(shipment.ShipmentHandshakes) &&
                                                                                              shipment.ShipmentHandshakes.length > 0 &&
                                                                                              shipment.ShipmentHandshakes[0].type === 'dead_drop'
                                                                                                  ? [shipment.ShipmentHandshakes[0].url]
                                                                                                  : [],
                                                                                          shipFriendId: shipment.shipment_friendly_id,
                                                                                      }
                                                                                    : { shipmentId: shipment.shipment_id, showGenerateBolButton: true },
                                                                            className: 'col-4'
                                                                        })
                                                                    ) : null}
                                                                    <UpdateDriverPayBeforeClaim shipment={shipment} />
                                                                </Row>
                                                                {shipment.shipment_type === 'direct' || shipment.shipment_type === 'connect' ? (
                                                                    <>
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                            </Col>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <BasicInfoDirectPick shipment={shipment} />
                                                                            </Col>

                                                                            <Col className="col-2" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                <BasicInfoDirectDrop shipment={shipment} />
                                                                            </Col>
                                                                        </Row>
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '20px' }}>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <DeliveryDescription shipment={shipment} />
                                                                            </Col>

                                                                            <RegularPickAndDropInstructions
                                                                                shipment={shipment}
                                                                                pickupClassName="col-2"
                                                                                dropoffClassName="col-2"
                                                                                dropoffStyle={{ marginLeft: '24px' }}
                                                                            />
                                                                        </Row>
                                                                        {shipment.ai_recommendation ? (
                                                                            <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '0px', paddingBottom: '20px' }}>
                                                                                <AIRecommendation shipment={shipment} />
                                                                            </Row>
                                                                        ) : null}
                                                                    </>
                                                                ) : shipment.shipment_type === 'routed_direct' ? (
                                                                    <>
                                                                        <Row
                                                                            style={{
                                                                                paddingLeft: '20px',
                                                                                paddingRight: '20px',
                                                                                paddingTop: '20px',
                                                                                paddingBottom: '10px',
                                                                                textAlign: 'left'
                                                                            }}
                                                                        >
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                            </Col>
                                                                            <BasicInfoRoutedWaypoint orders={shipment.Orders} display={hasDispatchAdminOverrideOrders(shipment.Orders)} />
                                                                        </Row>
                                                                    </>
                                                                ) : shipment.shipment_type === 'multidrop_direct' ? (
                                                                    <>
                                                                        <Row
                                                                            style={{
                                                                                paddingLeft: '20px',
                                                                                paddingRight: '20px',
                                                                                paddingBottom: '10px',
                                                                                paddingTop: '10px',
                                                                                textAlign: 'left'
                                                                            }}
                                                                        >
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                            </Col>
                                                                            <BasicInfoMultidropWaypoint orders={shipment.Orders} display={hasDispatchAdminOverrideOrders(shipment.Orders)} />
                                                                        </Row>
                                                                    </>
                                                                ) : shipment.shipment_type === 'school_lunch' ? (
                                                                    <>
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Load Details</strong>
                                                                                    <LoadDetails shipment={shipment} route={row.original} />
                                                                            </Col>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Delivery Status</strong>
                                                                                <DeliveryStatus shipment={shipment} />
                                                                            </Col>

                                                                            <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                <strong>Pickup Information</strong>
                                                                                <BasicInfo order={shipment.Orders[0]} />
                                                                            </Col>

                                                                            <Col className="col-3" style={{ textAlign: 'left', marginLeft: '24px' }}>
                                                                                <strong>Dropoff Information</strong>
                                                                                <p>{shipment.customer_blob.first_name + ' ' + shipment.customer_blob.last_name}</p>
                                                                                <p>{shipment.customer_blob.phone}</p>
                                                                                <p>{shipment.customer_blob.address_1}</p>
                                                                                <p>
                                                                                    {shipment.customer_blob.city +
                                                                                        ', ' +
                                                                                        shipment.customer_blob.state +
                                                                                        ', ' +
                                                                                        shipment.customer_blob.zip}
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                        <SchoolLunchInfo order={shipment.Orders[0]} shipment={shipment} />
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Row style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '20px', paddingBottom: '10px' }}>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Load Details</strong>
                                                                                <p>
                                                                                    {getVehicleTypeLabel(shipment.vehicle_type)}
                                                                                </p>
                                                                                <p>{shipment.weight} lbs</p>
                                                                                <p>{shipment.num_of_gophrs} Gophrs Needed</p>
                                                                                <p>{Number(shipment.distance || 0).toFixed(2) + ' miles'}</p>
                                                                                <p>{'$' + formatCurrencyAmount(shipment.shipping_fee)}</p>
                                                                            </Col>
                                                                            <Col className="col-2" style={{ textAlign: 'left' }}>
                                                                                <strong>Delivery Status</strong>
                                                                                <p>
                                                                                    {shipment.status === 'shipment_ready_for_driver'
                                                                                        ? 'Ready for Driver'
                                                                                        : shipment.status === 'shipment_assigned'
                                                                                        ? 'Assigned to Driver'
                                                                                        : shipment.status === 'shipment_enroute'
                                                                                        ? 'En Route'
                                                                                        : shipment.status === 'shipment_completed'
                                                                                        ? 'Completed'
                                                                                        : shipment.status === 'shipment_scheduled'
                                                                                        ? 'Scheduled'
                                                                                        : null}
                                                                                </p>
                                                                            </Col>
                                                                            <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                <strong>Dropoff Information</strong>
                                                                                <p>
                                                                                    {shipment.customer_blob.first_name} {shipment.customer_blob.last_name}
                                                                                </p>

                                                                                <p>{shipment.customer_blob.phone}</p>
                                                                                <p>
                                                                                    {shipment.customer_blob.address_1}{' '}
                                                                                    {shipment.customer_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                </p>
                                                                                <p>
                                                                                    {shipment.customer_blob.city}, {shipment.customer_blob.state}, {shipment.customer_blob.zip}
                                                                                </p>
                                                                            </Col>
                                                                            {shipment.drop_off_instructions ? (
                                                                                <Col className="col-3" style={{ textAlign: 'left' }}>
                                                                                    <strong>Dropoff Instructions</strong>
                                                                                    <p>{shipment.drop_off_instructions}</p>
                                                                                </Col>
                                                                            ) : null}
                                                                        </Row>
                                                                        <div style={{ color: '#f7941d', paddingLeft: '10px', paddingTop: '15px', paddingBottom: '15px' }}>
                                                                            <strong>Orders Info</strong>
                                                                        </div>
                                                                        {shipment.Orders.map((order, index) => {
                                                                            return (
                                                                                <>
                                                                                    {index !== 0 ? <hr style={{ backgroundColor: '#f7941d', width: '90%' }}></hr> : null}
                                                                                    <Row
                                                                                        style={{
                                                                                            paddingLeft: '20px',
                                                                                            paddingRight: '20px',
                                                                                            paddingTop: '0px',
                                                                                            paddingBottom: '5px'
                                                                                        }}
                                                                                    >
                                                                                        <Col className="col-5" style={{ textAlign: 'left' }}>
                                                                                            <div style={{ paddingBottom: '5px' }}>
                                                                                                <strong>
                                                                                                    <p>
                                                                                                        {index + 1} . {order.location_blob.name}
                                                                                                    </p>
                                                                                                </strong>
                                                                                            </div>
                                                                                            <p>{order.location_blob.phone}</p>
                                                                                            <p>
                                                                                                {order.location_blob.address_1}{' '}
                                                                                                {order.location_blob.address_2 !== null ? shipment.customer_blob.address_2 : ''}
                                                                                            </p>
                                                                                            <p>
                                                                                                {order.location_blob.city}, {order.location_blob.state}, {order.location_blob.zip}
                                                                                            </p>
                                                                                            <p>{order.total != null ? '$' + order.total.toFixed(2) : '$' + 0.0}</p>
                                                                                            {order.pick_up_instructions ? (
                                                                                                <div>
                                                                                                    <p>Pick Up Instruction: {order.pick_up_instructions}</p>
                                                                                                </div>
                                                                                            ) : null}
                                                                                        </Col>
                                                                                        <Col className="col-5" style={{ textAlign: 'left' }}>
                                                                                            <div className="order-container">
                                                                                                <div className="item-quantity">
                                                                                                    <strong>Qty.</strong>
                                                                                                </div>
                                                                                                <div className="item-name">
                                                                                                    <strong>Product</strong>
                                                                                                </div>
                                                                                                <div className="item-total">
                                                                                                    <strong>Price</strong>
                                                                                                </div>
                                                                                                <div className="item-weight">
                                                                                                    <strong>Weight</strong>
                                                                                                </div>
                                                                                            </div>
                                                                                            {order
                                                                                                ? order.Items.map(item => {
                                                                                                      return (
                                                                                                          <>
                                                                                                              <div className="item-container">
                                                                                                                  <div className="item-quantity">{item.quantity}</div>
                                                                                                                  <div className="item-name">
                                                                                                                      {item.product_blob.name + ' '}
                                                                                                                      {item.ItemOptions.length > 0
                                                                                                                          ? item.ItemOptions.map((option, index) => {
                                                                                                                                if (index === 0) {
                                                                                                                                    return '(' + option.option_name;
                                                                                                                                } else if (
                                                                                                                                    index > 0 &&
                                                                                                                                    index !== item.ItemOptions.length - 1
                                                                                                                                ) {
                                                                                                                                    return ', ' + option.option_name;
                                                                                                                                } else {
                                                                                                                                    return ', ' + option.option_name + ')';
                                                                                                                                }
                                                                                                                            })
                                                                                                                          : null}
                                                                                                                  </div>
                                                                                                                  <div className="item-total">${item.product_price.toFixed(2)}</div>
                                                                                                                  <div className="item-weight">{item.product_blob.weight} lbs.</div>
                                                                                                              </div>
                                                                                                          </>
                                                                                                      );
                                                                                                  })
                                                                                                : 'Something went wrong'}
                                                                                        </Col>
                                                                                    </Row>
                                                                                </>
                                                                            );
                                                                        })}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    }}
                                />
                            ) : (
                                <div>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px', justifyContent: 'flex-end' }}>
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            value={driverNameSMS}
                                            onChange={filterDriverSMS}
                                            style={{
                                                fontSize: '12px',
                                                padding: '8px',
                                                borderRadius: '8px',
                                                width: '200px'
                                            }}
                                        />
                                        <div style={{ minWidth: '210px' }}>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="Select Status"
                                                value={DRIVER_STATUS_FILTER_OPTIONS.filter(option => statusFilter.includes(option.value))}
                                                onChange={handleStatusFilterChange}
                                                options={DRIVER_STATUS_FILTER_OPTIONS}
                                                className="react-select info"
                                                classNamePrefix="react-select"
                                                styles={driverFilterSelectStyles}
                                            />
                                        </div>
                                        <div style={{ minWidth: '250px' }}>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="All Vehicles"
                                                value={DRIVER_VEHICLE_FILTER_OPTIONS.filter(option => vehicleTypeFilter.includes(option.value))}
                                                onChange={handleVehicleTypeFilterChange}
                                                options={DRIVER_VEHICLE_FILTER_OPTIONS}
                                                className="react-select info"
                                                classNamePrefix="react-select"
                                                styles={driverFilterSelectStyles}
                                            />
                                        </div>
                                        <div style={{ minWidth: '190px' }}>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="All Permits"
                                                value={DRIVER_PERMIT_FILTER_OPTIONS.filter(option => permitFilter.includes(option.value))}
                                                onChange={handlePermitFilterChange}
                                                options={DRIVER_PERMIT_FILTER_OPTIONS}
                                                className="react-select info"
                                                classNamePrefix="react-select"
                                                styles={driverFilterSelectStyles}
                                            />
                                        </div>
                                    </div>
                                    <ReactTable
                                        key="4"
                                        data={driverListTableData}
                                        columns={driverListColumns}
                                        sortable={true}
                                        resizable={true}
                                        defaultPageSize={50}
                                        className="-striped -highlight"
                                        getTrProps={getTrProps}
                                        getTheadThProps={getTheadThProps}
                                        onExpandedChange={handleExpandedChange}
                                        collapseOnSortingChange={true}
                                        collapseOnPageChange={true}
                                        collapseOnDataChange={false}
                                        expanded={expandedItems[selected]}
                                        SubComponent={row => {
                                            return (
                                                <div
                                                    style={{
                                                        backgroundColor: detailSurfaceBackground,
                                                        borderRadius: '6px',
                                                        padding: '15px 10px 20px',
                                                        marginRight: '10px',
                                                        marginLeft: '10px',
                                                        marginBottom: '20px',
                                                        height: 'auto'
                                                    }}
                                                >
                                                    <div style={{ display: 'grid', gap: '16px' }}>
                                                        <DriverCompliancePanel
                                                            driverAuth0Id={row.original.auth0_id}
                                                            driverIdentifier={row.original.driver_id || row.original.auth0_id}
                                                            variant="dispatch"
                                                            dispatchContext={{
                                                                branch_id: row.original.branch_id || null,
                                                                driverSnapshot: row.original,
                                                                vehicle: row.original.Vehicles && row.original.Vehicles.length > 0
                                                                    ? (row.original.Vehicles.find(vehicle => vehicle.vehicle_id === row.original.active_vehicle) || row.original.Vehicles[0])
                                                                    : null,
                                                            }}
                                                            headerAside={
                                                                <DriverPartnerPanel
                                                                    driverId={row.original.driver_id}
                                                                    driverAuth0Id={row.original.auth0_id}
                                                                    driverContext={{
                                                                        driver_id: row.original.driver_id,
                                                                        user_id: row.original.user_id,
                                                                        auth0_id: row.original.auth0_id,
                                                                        carrying_capacity: row.original.carrying_capacity,
                                                                        employment_type: row.original.employment_type,
                                                                        default_market_id: row.original.default_market_id,
                                                                        phone: row.original.phone || (row.original.User && row.original.User.phone) || '',
                                                                        user: {
                                                                            auth0_id: row.original.User && row.original.User.auth0_id,
                                                                            username: row.original.User && row.original.User.username,
                                                                            firstname: row.original.User && row.original.User.firstname,
                                                                            lastname: row.original.User && row.original.User.lastname,
                                                                            email: row.original.User && row.original.User.email,
                                                                            phone: row.original.User && row.original.User.phone,
                                                                        },
                                                                    }}
                                                                    title="Referral and Affiliate Mode"
                                                                    containerStyle={{
                                                                        display: 'flex',
                                                                        width: '100%',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        textAlign: 'center'
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </ResizableBox>
                    {openChatWindows.includes('website') && (
                        <FloatingChatWindow
                            channel="website"
                            title="Live Chat"
                            defaultPosition={{ x: Math.max(16, window.innerWidth - 592), y: 96 }}
                            onClose={() => closeChatWindow('website')}
                        />
                    )}
                    {openChatWindows.includes('sms') && (
                        <FloatingChatWindow
                            channel="sms"
                            title="SMS Messages"
                            defaultPosition={{ x: Math.max(16, window.innerWidth - 592), y: 140 }}
                            onClose={() => closeChatWindow('sms')}
                        />
                    )}
                    {openChatWindows.includes('voice') && (
                        <FloatingChatWindow
                            channel="voice"
                            title="Calls"
                            defaultPosition={{ x: Math.max(16, window.innerWidth - 592), y: 184 }}
                            onClose={() => closeChatWindow('voice')}
                        />
                    )}
                    {openChatWindows.includes('email') && (
                        <FloatingChatWindow
                            channel="email"
                            title="Email"
                            defaultPosition={{ x: Math.max(16, window.innerWidth - 592), y: 228 }}
                            onClose={() => closeChatWindow('email')}
                        />
                    )}
                    {showDispatchMap && (
                        <ResizableBox
                            className="box"
                            width={3000}
                            height={1200}
                            minConstraints={[1000, 1000]}
                            maxConstraints={[10000, 2000]}
                            draggableOpts={{ grid: [10, 10] }}
                            axis="x"
                        >
                            <div className="float-child-map">
                                <DispatchMap
                                    drivers={driversToDisplay}
                                    coordinates={coordinates}
                                    trafficLayer={trafficLayer}
                                    weatherLayer={weatherLayer}
                                    statusFilter={statusFilter}
                                    onDriverMarkerClick={openDriverChat}
                                    onVisibleBoundsChange={handleDispatchMapVisibleBoundsChange}
                                    focusedDriver={focusedDriverOnMap}
                                    hasActiveOrderExpansion={hasExpandedRows(expandedItems[selected])}
                                    routeClick={routeClick || null}
                                    readyRoutes={readyRoutes || []}
                                    deliveringRoutes={deliveringRoutes || []}
                                    enrouteClickDriver={enrouteClickDriver || null}
                                />
                            </div>
                        </ResizableBox>
                    )}
                </div>
            </div>
            <div hidden={!showOrder}>
                <ReactBSAlert
                    style={{ display: 'block', width: '700px' }}
                    title={order ? order.location_blob.name : 'Something Went Wrong'}
                    onConfirm={() => {}}
                    onCancel={() => {
                        setShowOrder(false);
                        setOrder(null);
                    }}
                    cancelBtnBsStyle="default"
                    cancelBtnText="Close"
                    showConfirm={false}
                    showCancel
                    btnSize=""
                >
                    <div className="order-container">
                        <div className="item-quantity">
                            <strong>Qty.</strong>
                        </div>
                        <div className="item-name">
                            <strong>Product</strong>
                        </div>
                        <div className="item-total">
                            <strong>Price</strong>
                        </div>
                        <div className="item-weight">
                            <strong>Weight</strong>
                        </div>
                    </div>
                    {order
                        ? order.Items.map(item => {
                              return (
                                  <div className="item-container">
                                      <div className="item-quantity">{item.quantity}</div>
                                      <div className="item-name">
                                          {item.product_blob.name + ' '}
                                          {item.ItemOptions.length > 0
                                              ? item.ItemOptions.map((option, index) => {
                                                    if (index === 0) {
                                                        return '(' + option.option_name;
                                                    } else if (index > 0 && index !== item.ItemOptions.length - 1) {
                                                        return ', ' + option.option_name;
                                                    } else {
                                                        return ', ' + option.option_name + ')';
                                                    }
                                                })
                                              : null}
                                      </div>
                                      <div className="item-total">${item.product_price.toFixed(2)}</div>
                                      <div className="item-weight">{item.weight} lbs.</div>
                                  </div>
                              );
                          })
                        : 'Something went wrong'}
                </ReactBSAlert>
            </div>
            <div id="warning-alert" hidden={!showAlert}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        reassignDriverToRoute(route);
                        setShowAlert(false);
                        resetExpand();
                    }}
                    onCancel={() => setShowAlert(false)}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to reassign a new driver.</div>
                    <div>Please, ensure you've checked route status and only 1 driver can be reassigned.</div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <div id="warning-alert-cancel-order" hidden={!showAlertCancelOrder}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        cancelOrderAdmin(shipment, order);
                        setShowAlertCancelOrder(false);
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertCancelOrder(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to cancel the order on behalf of the merchant. Please, ensure you've contacted the merchant before doing so.</div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <div id="warning-alert-cancel-shipment" hidden={!showAlertCancelShipment}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        cancelShipment(shipment);
                        setShowAlertCancelShipment(false);
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertCancelShipment(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to cancel a shipment.</div>
                    <div>Please, ensure you've contacted the merchant and if any Gophrs assigned to it.</div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <div id="warning-alert-remove-shipment" hidden={!showAlertRemoveShipment}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        removeShipmentFromRoute(route.route_id, shipment.shipment_id);
                        setShowAlertRemoveShipment(false);
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertRemoveShipment(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to remove shipment from route.</div>
                    <div>Please, ensure you've contacted the driver if driver is currently on the route. Removed shipment will be ready immediately.</div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>

            <div id="warning-alert-unassign-route" hidden={!showAlertUnassignRoute}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        unassignRoute(route);
                        setShowAlertUnassignRoute(false);
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertUnassignRoute(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to unassign a route.</div>
                    <div>
                        Please, ensure you've confirmed with the driver/passenger(s) and <span style={{ color: 'red' }}>make sure no waypoint has been completed yet.</span> The
                        route will be ready as a whole.
                    </div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <div id="warning-alert-break-route" hidden={!showAlertBreakRoute}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        breakRoute(route);
                        setShowAlertBreakRoute(false);
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertBreakRoute(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to break a route.</div>
                    <div>
                        Please, ensure you've confirmed with the driver/passenger(s) and <span style={{ color: 'red' }}>make sure no waypoint has been completed yet.</span> The
                        selected route will be broke into individual ones and ready immediately.
                    </div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <div id="warning-alert-merge-route" hidden={!showAlertMergeRoute}>
                <ReactBSAlert
                    warning
                    style={{ display: 'block', marginTop: '-200px' }}
                    title="Are you sure?"
                    onConfirm={() => {
                        buildRoutes(mergeRoutesList);
                        setShowAlertMergeRoute(false);
                        fetchMergingRoutes();
                        resetExpand();
                    }}
                    onCancel={() => {
                        setShowAlertMergeRoute(false);
                    }}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                    showCancel
                    btnSize=""
                >
                    <div>You are about to merge selected routes.</div>
                    <div>
                        Please, ensure you've selected the desired routes for merging. <span style={{ color: 'red' }}>A new route will be generated.</span>
                    </div>
                    <div>This action cannot be undone.</div>
                </ReactBSAlert>
            </div>
            <CompleteOrderModal
                isOpen={completeOrderModal.isOpen}
                shipmentId={completeOrderModal.shipmentId}
                orderId={completeOrderModal.orderId}
                actionType={completeOrderModal.actionType}
                stopLabel={completeOrderModal.stopLabel}
                notify={props.notify}
                onClose={closeCompleteOrderModal}
            />
            <ArrivalOverrideRequestModal
                isOpen={arrivalOverrideModalOpen && Boolean(selectedArrivalOverrideRequest)}
                requestItem={selectedArrivalOverrideRequest}
                currentUserSub={SUB}
                notify={props.notify}
                onClose={closeArrivalOverrideModal}
                onRequestUpdated={requestItem => {
                    if (!requestItem || !requestItem.requestKey) {
                        return;
                    }

                    dismissedArrivalOverrideRequestKeysRef.current.delete(requestItem.requestKey);
                    setSelectedArrivalOverrideRequest(requestItem);
                    setArrivalOverrideModalOpen(true);
                }}
                onRefresh={() => {
                    if (isLocalDashboardEnvironment) {
                        void refreshLocalDispatchData();
                    }
                }}
            />
            <Modal isOpen={activeCustomersModalOpen} toggle={() => setActiveCustomersModalOpen(false)}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'left', display: 'block', maxHeight: '70vh', overflowY: 'auto' }}>
                    <h4 style={{ color: '#000' }}>Active Customers</h4>
                    <p style={{ color: '#000', marginBottom: '12px' }}>{currentMonthLabel}</p>
                    {activeCustomerNames.length === 0 ? (
                        <div style={{ color: '#000' }}>No active customers found for the selected month.</div>
                    ) : (
                        <ol style={{ margin: 0, paddingLeft: '20px', color: '#000' }}>
                            {activeCustomerNames.map((customerName, index) => (
                                <li key={`${customerName}-${index}`} style={{ marginBottom: '4px', color: '#000' }}>
                                    {customerName}
                                </li>
                            ))}
                        </ol>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setActiveCustomersModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={gopilotReviewModalOpen} toggle={closeGoPilotReviewModal} size="lg">
                <ModalBody style={{ alignSelf: 'left', textAlign: 'left', display: 'block', maxHeight: '70vh', overflowY: 'auto' }}>
                    <h4 style={{ color: '#000' }}>GoPilot Damage Review Queue</h4>
                    <p style={{ color: '#000', marginBottom: '12px' }}>
                        Review failed pickup requests and signed delivery holds before the shipment can proceed.
                    </p>
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        <div style={{ flex: '0 0 260px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {gopilotReviewsLoading && gopilotReviews.length === 0 ? <Loading /> : null}
                            {gopilotReviews.map(review => {
                                const customerName = review && review.customer_blob
                                    ? review.customer_blob.store_name || `${review.customer_blob.first_name || ''} ${review.customer_blob.last_name || ''}`.trim()
                                    : 'Customer unavailable';
                                const primaryDriver = review && review.Route && Array.isArray(review.Route.RouteDrivers) && review.Route.RouteDrivers[0]
                                    ? review.Route.RouteDrivers[0]
                                    : null;
                                const driverName = primaryDriver && primaryDriver.driver_blob
                                    ? `${primaryDriver.driver_blob.firstname || ''} ${primaryDriver.driver_blob.lastname || ''}`.trim()
                                    : 'Driver unavailable';
                                const isSelected = selectedGoPilotReviewId === review.shipment_id;
                                const reviewStageLabel = review && review.gopilot_review_stage === 'pickup' ? 'Pickup' : 'Delivery';
                                const reviewTypeLabel = review && review.gopilot_review_type === 'stage_override_request' ? `${reviewStageLabel} Admin Review` : 'Delivery Completion Review';

                                return (
                                    <button
                                        key={review.shipment_id}
                                        type="button"
                                        onClick={() => setSelectedGoPilotReviewId(review.shipment_id)}
                                        style={{
                                            border: isSelected ? '2px solid #f7941d' : '1px solid #d9dee7',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            background: isSelected ? '#fff4e8' : '#ffffff',
                                            textAlign: 'left',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <div style={{ fontWeight: 700, color: '#2b3553' }}>Ship ID {review.shipment_friendly_id}</div>
                                        <div style={{ color: '#525f7f', marginTop: '4px' }}>{customerName || 'Customer unavailable'}</div>
                                        <div style={{ color: '#8898aa', marginTop: '4px', fontSize: '12px' }}>{driverName || 'Driver unavailable'}</div>
                                        <div style={{ color: '#f7941d', marginTop: '6px', fontSize: '12px', fontWeight: 700 }}>{reviewTypeLabel}</div>
                                    </button>
                                );
                            })}
                        </div>
                        <div style={{ flex: '1 1 420px', minWidth: '280px' }}>
                            {selectedGoPilotReview ? (
                                <>
                                    <div
                                        style={{
                                            background: summarySurfaceBackground,
                                            color: summaryTextColor,
                                            borderRadius: '10px',
                                            padding: '14px',
                                            marginBottom: '12px'
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                                            <Badge color="warning">Pending Review</Badge>
                                            <Badge color="info">Ship ID {selectedGoPilotReview.shipment_friendly_id}</Badge>
                                            <Badge color={selectedGoPilotReviewStage === 'pickup' ? 'primary' : 'secondary'}>
                                                {selectedGoPilotReviewStage === 'pickup' ? 'Pickup' : 'Delivery'}
                                            </Badge>
                                        </div>
                                        <p style={{ marginBottom: '6px', color: summaryTextColor }}>
                                            <strong>Customer:</strong>{' '}
                                            {selectedGoPilotReview.customer_blob
                                                ? selectedGoPilotReview.customer_blob.store_name || `${selectedGoPilotReview.customer_blob.first_name || ''} ${selectedGoPilotReview.customer_blob.last_name || ''}`.trim()
                                                : 'Customer unavailable'}
                                        </p>
                                        <p style={{ marginBottom: '6px', color: summaryTextColor }}>
                                            <strong>Status:</strong>{' '}
                                            {selectedGoPilotReview.GoPilotWorkflow
                                                ? selectedGoPilotReviewStage === 'pickup'
                                                    ? selectedGoPilotReview.GoPilotWorkflow.pickup_status || 'review_pending'
                                                    : selectedGoPilotReview.GoPilotWorkflow.delivery_status || 'review_pending'
                                                : 'review_pending'}
                                        </p>
                                        <p style={{ marginBottom: '6px', color: summaryTextColor }}>
                                            <strong>Review Type:</strong>{' '}
                                            {selectedGoPilotReviewType === 'stage_override_request'
                                                ? `${selectedGoPilotReviewStage === 'pickup' ? 'Pickup' : 'Delivery'} admin decision`
                                                : 'Delivery completion approval'}
                                        </p>
                                        <p style={{ marginBottom: 0, color: summaryTextColor }}>
                                            <strong>Updated:</strong> {formatTimestamp(selectedGoPilotReview.gopilot_review_requested_at || selectedGoPilotReview.updated_at)}
                                        </p>
                                    </div>
                                    {selectedGoPilotReviewLoading ? (
                                        <Loading />
                                    ) : selectedGoPilotReviewSummary ? (
                                        <div
                                            style={{
                                                background: '#ffffff',
                                                border: '1px solid #d9dee7',
                                                borderRadius: '10px',
                                                padding: '14px'
                                            }}
                                        >
                                            <p style={{ color: '#2b3553', marginBottom: '8px' }}>
                                                <strong>{selectedGoPilotReviewStage === 'pickup' ? 'Pickup' : 'Delivery'} Summary:</strong>{' '}
                                                {selectedGoPilotStageAttempt && selectedGoPilotStageAttempt.summary
                                                    ? selectedGoPilotStageAttempt.summary
                                                    : `No ${selectedGoPilotReviewStage} summary provided.`}
                                            </p>
                                            <p style={{ color: '#2b3553', marginBottom: '8px' }}>
                                                <strong>Driver Notes:</strong> {selectedGoPilotStageAttempt && selectedGoPilotStageAttempt.notes ? selectedGoPilotStageAttempt.notes : 'None'}
                                            </p>
                                            {selectedGoPilotReview && selectedGoPilotReview.gopilot_review_reason ? (
                                                <p style={{ color: '#2b3553', marginBottom: '8px' }}>
                                                    <strong>Review Request:</strong> {selectedGoPilotReview.gopilot_review_reason}
                                                </p>
                                            ) : null}
                                            <p style={{ color: '#2b3553', marginBottom: '8px' }}>
                                                <strong>Detected Change:</strong>{' '}
                                                {selectedGoPilotStageAttempt && selectedGoPilotStageAttempt.comparison && selectedGoPilotStageAttempt.comparison.changed ? 'Yes' : 'No'}
                                            </p>
                                            <p style={{ color: '#2b3553', marginBottom: '8px' }}>
                                                <strong>Issues:</strong>{' '}
                                                {selectedGoPilotStageAttempt && Array.isArray(selectedGoPilotStageAttempt.issues) && selectedGoPilotStageAttempt.issues.length > 0
                                                    ? selectedGoPilotStageAttempt.issues.join(', ')
                                                    : 'None listed'}
                                            </p>
                                            {selectedGoPilotConversationNotes.length > 0 ? (
                                                <div style={{ marginBottom: '12px' }}>
                                                    <strong style={{ color: '#2b3553', display: 'block', marginBottom: '8px' }}>Conversation Timeline</strong>
                                                    <div
                                                        style={{
                                                            border: '1px solid #d9dee7',
                                                            borderRadius: '8px',
                                                            background: '#f8fafc',
                                                            maxHeight: '220px',
                                                            overflowY: 'auto',
                                                            padding: '10px'
                                                        }}
                                                    >
                                                        {selectedGoPilotConversationNotes.map(note => (
                                                            <div
                                                                key={note.id}
                                                                style={{
                                                                    borderBottom: '1px solid #e5e7eb',
                                                                    paddingBottom: '8px',
                                                                    marginBottom: '8px'
                                                                }}
                                                            >
                                                                <div style={{ color: '#2b3553', fontSize: '12px', marginBottom: '4px' }}>
                                                                    <strong>{note.submitter_name || 'Unknown user'}</strong>
                                                                    {' • '}
                                                                    {formatGoPilotConversationAction(note)}
                                                                    {' • '}
                                                                    {formatTimestamp(note.created_at)}
                                                                </div>
                                                                <div style={{ color: '#2b3553', fontSize: '13px', whiteSpace: 'pre-wrap' }}>
                                                                    {note.message}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : null}
                                            {selectedGoPilotReviewStage === 'delivery' ? (
                                                <p style={{ color: '#2b3553', marginBottom: '12px' }}>
                                                    <strong>Report:</strong> {selectedGoPilotReviewSummary.report_file_name || 'No report file attached'}
                                                </p>
                                            ) : null}
                                            {(selectedGoPilotBeforePhotos.length > 0 || selectedGoPilotAfterPhotos.length > 0) ? (
                                                <div style={{ marginBottom: '12px' }}>
                                                    <div style={{ color: '#2b3553', fontWeight: 600, marginBottom: '8px' }}>
                                                        GoPilot Photos (Before &amp; After)
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                                        {[
                                                            { key: 'before', label: 'Before — Pickup', photos: selectedGoPilotBeforePhotos },
                                                            { key: 'after', label: 'After — Delivery', photos: selectedGoPilotAfterPhotos },
                                                        ].map(section => (
                                                            <div key={section.key} style={{ flex: '1 1 220px', minWidth: '220px' }}>
                                                                <div style={{ color: '#2b3553', fontSize: '12px', fontWeight: 600, marginBottom: '6px' }}>
                                                                    {section.label}
                                                                </div>
                                                                {section.photos.length > 0 ? (
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                                        {section.photos.map(photo => (
                                                                            <a
                                                                                key={photo.fileId}
                                                                                href={photo.url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                title={`${photo.metadata.capturedAtLabel} • ${photo.metadata.locationLabel}`}
                                                                                style={{ display: 'inline-block' }}
                                                                            >
                                                                                <img
                                                                                    src={photo.url}
                                                                                    alt={`GoPilot ${section.key} ${photo.metadata.photoIndex + 1}`}
                                                                                    style={{
                                                                                        width: '96px',
                                                                                        height: '96px',
                                                                                        objectFit: 'cover',
                                                                                        borderRadius: '6px',
                                                                                        border: '1px solid #d1d5db',
                                                                                    }}
                                                                                />
                                                                            </a>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ color: '#6c757d', fontSize: '12px' }}>No photos captured</div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : null}
                                            {selectedGoPilotStagePhotos.length > 0 ? (
                                                <div style={{ marginBottom: '12px' }}>
                                                    <PhotoGallery
                                                        photos={selectedGoPilotStagePhotos}
                                                        buttonText={`View ${selectedGoPilotReviewStage} photos`}
                                                        buttonStyle={{ color: '#2b3553', textDecoration: 'underline' }}
                                                        altTextPrefix={`GoPilot ${selectedGoPilotReviewStage}`}
                                                    />
                                                </div>
                                            ) : null}
                                            <FormGroup style={{ marginBottom: 0 }}>
                                                <Label style={{ color: '#2b3553' }}>Review Note</Label>
                                                <Input
                                                    type="textarea"
                                                    rows="3"
                                                    value={gopilotReviewApprovalReason}
                                                    onChange={event => setGoPilotReviewApprovalReason(event.target.value)}
                                                    placeholder="Optional context for the audit trail"
                                                    style={{ color: '#2b3553' }}
                                                />
                                            </FormGroup>
                                        </div>
                                    ) : (
                                        <p style={{ color: '#000', marginBottom: 0 }}>No GoPilot review details found for this shipment.</p>
                                    )}
                                </>
                            ) : (
                                <p style={{ color: '#000', marginBottom: 0 }}>No pending GoPilot reviews.</p>
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {selectedGoPilotReviewType === 'stage_override_request' ? (
                        <Button
                            className="btn btn-secondary"
                            onClick={denySelectedGoPilotReview}
                            disabled={!selectedGoPilotReview || gopilotReviewActionShipmentId === (selectedGoPilotReview && selectedGoPilotReview.shipment_id)}
                        >
                            {gopilotReviewActionShipmentId === (selectedGoPilotReview && selectedGoPilotReview.shipment_id) ? 'Working...' : 'Deny Review'}
                        </Button>
                    ) : null}
                    <Button
                        className="btn btn-warning"
                        onClick={approveSelectedGoPilotReview}
                        disabled={!selectedGoPilotReview || gopilotReviewActionShipmentId === (selectedGoPilotReview && selectedGoPilotReview.shipment_id)}
                    >
                        {gopilotReviewActionShipmentId === (selectedGoPilotReview && selectedGoPilotReview.shipment_id)
                            ? 'Approving...'
                            : selectedGoPilotReviewType === 'stage_override_request'
                                ? `Approve ${selectedGoPilotReviewStage === 'pickup' ? 'Pickup' : 'Delivery'}`
                                : 'Approve Completion'}
                    </Button>
                    <Button className="btn btn-secondary" onClick={closeGoPilotReviewModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showSmartDispatchSummary} toggle={() => setShowSmartDispatchSummary(false)}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'left', display: 'block', maxHeight: '70vh', overflowY: 'auto' }}>
                    <h4 style={{ color: '#000' }}>Smart Dispatch Summary</h4>
                    <p style={{ color: '#000', marginBottom: '6px' }}>
                        Route: {smartDispatchSummaryContext && smartDispatchSummaryContext.routeFriendlyId
                            ? smartDispatchSummaryContext.routeFriendlyId
                            : smartDispatchSummaryRouteId || '-'}
                    </p>
                    <p style={{ color: '#000', marginBottom: '10px' }}>
                        Ship ID: {smartDispatchSummaryContext && smartDispatchSummaryContext.shipmentFriendlyId
                            ? smartDispatchSummaryContext.shipmentFriendlyId
                            : (
                                (smartDispatchSummaryPayload && smartDispatchSummaryPayload.shipment_friendly_id)
                                || (smartDispatchSummaryContext && smartDispatchSummaryContext.shipmentId)
                                || (smartDispatchSummaryPayload && smartDispatchSummaryPayload.shipment_id)
                                || '-'
                            )}
                    </p>
                    {smartDispatchSummaryLoading ? (
                        <Loading />
                    ) : smartDispatchSummaryPayload ? (
                        (() => {
                            const notifiedDrivers = deriveSmartDispatchNotifiedDrivers(smartDispatchSummaryPayload);
                            return (
                                <>
                                    <div style={{ marginBottom: '12px' }}>
                                        <Badge color="default">Drivers Notified: {notifiedDrivers.length}</Badge>
                                    </div>
                                    {notifiedDrivers.length > 0 ? (
                                        <div
                                            style={{
                                                background: summarySurfaceBackground,
                                                color: summaryTextColor,
                                                padding: '12px',
                                                borderRadius: '6px',
                                                marginBottom: 0
                                            }}
                                        >
                                            {notifiedDrivers.map((driver, index) => (
                                                <p key={`${driver.name}-${index}`} style={{ marginBottom: index === notifiedDrivers.length - 1 ? 0 : '8px', color: summaryTextColor }}>
                                                    {driver.name} - {driver.lastAction}
                                                </p>
                                            ))}
                                        </div>
                                    ) : (
                                        <p style={{ color: '#000', marginBottom: 0 }}>No drivers have been notified yet.</p>
                                    )}
                                </>
                            );
                        })()
                    ) : (
                        <p style={{ color: '#000', marginBottom: 0 }}>No smart dispatch summary found for this route.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn btn-default"
                        onClick={() => {
                            if (smartDispatchSummaryRouteId) {
                                openSmartDispatchSummary(smartDispatchSummaryContext || smartDispatchSummaryRouteId);
                            }
                        }}
                        disabled={smartDispatchSummaryLoading || !smartDispatchSummaryRouteId}
                    >
                        Refresh
                    </Button>
                    <Button className="btn btn-secondary" onClick={() => setShowSmartDispatchSummary(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalBody style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <h4 style={{ color: '#000' }}>Route Description</h4>
                    {/* <p>{route.distance.toFixed(2) + ' miles'}</p> */}
                    <h4 style={{ color: '#000' }}>Select drivers and passengers</h4>
                    <UncontrolledDropdown>
                        <DropdownToggle caret id="driver-dropdown">
                            {primaryDriver
                                ? primaryDriver.User.firstname + ' ' + primaryDriver.User.lastname + ' - ' + primaryDriver.Vehicles[0].type.replace(/_/, ' ')
                                : 'Select a Driver'}
                        </DropdownToggle>
                        <DropdownMenu>
                            <Input
                                type="text"
                                value={driverName}
                                onChange={filterDriver}
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Driver Name"
                                id="driver-filter"
                            />

                            {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                filterDriversForAssign.map((driver, key) => {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handleDriverSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    return null;
                                })
                            ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                driversForAssign.map((driver, key) => {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handleDriverSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    // }
                                    return null;
                                })
                            ) : (
                                <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                            )}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    <div hidden={!driverSelected}>
                        <UncontrolledDropdown>
                            <DropdownToggle caret id="passenger1-dropdown">
                                {passenger1
                                    ? passenger1.User.firstname + ' ' + passenger1.User.lastname + ' - ' + passenger1.Vehicles[0].type.replace(/_/, ' ')
                                    : 'Select a Passenger'}
                            </DropdownToggle>
                            <DropdownMenu>
                                <Input
                                    type="text"
                                    value={driverName}
                                    onChange={filterDriver}
                                    style={{ color: 'black', alignSelf: 'left' }}
                                    placeholder="Driver Name"
                                    id="driver-filter"
                                />
                                {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                    filterDriversForAssign.map((driver, key) => {
                                        if (primaryDriver !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger1Select(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                    driversForAssign.map((driver, key) => {
                                        if (primaryDriver !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger1Select(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    <div hidden={!passenger1Selected}>
                        <UncontrolledDropdown>
                            <DropdownToggle caret id="passenger2-dropdown">
                                {passenger2
                                    ? passenger2.User.firstname + ' ' + passenger2.User.lastname + ' - ' + passenger2.Vehicles[0].type.replace(/_/, ' ')
                                    : 'Select a Passenger'}
                            </DropdownToggle>
                            <DropdownMenu>
                                <Input
                                    type="text"
                                    value={driverName}
                                    onChange={filterDriver}
                                    style={{ color: 'black', alignSelf: 'left' }}
                                    placeholder="Driver Name"
                                    id="driver-filter"
                                />
                                {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                    filterDriversForAssign.map((driver, key) => {
                                        // if((primaryDriver !== driver && passenger1 !== driver) && (driver.is_available === "true" || driver.is_available === true) && driver.Vehicles.length > 0) {
                                        if (primaryDriver !== driver && passenger1 !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger2Select(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                    driversForAssign.map((driver, key) => {
                                        // if((primaryDriver !== driver && passenger1 !== driver) && (driver.is_available === "true" || driver.is_available === true) && driver.Vehicles.length > 0) {
                                        if (primaryDriver !== driver && passenger1 !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger2Select(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggle();
                            reset();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => handleConfirm(primaryDriver, passenger1, passenger2)}>
                        Confirm
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalReassign} toggle={toggleReassign}>
                <ModalBody style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <h4 style={{ color: '#000' }}>Reassign Driver</h4>
                    <p>You can only reassign driver once</p>
                    <h4 style={{ color: '#000' }}>Select new driver</h4>
                    <UncontrolledDropdown>
                        <DropdownToggle caret id="driver-dropdown">
                            {driverReassign
                                ? driverReassign.User.firstname + ' ' + driverReassign.User.lastname + ' - ' + driverReassign.Vehicles[0].type.replace(/_/, ' ')
                                : 'Select a Driver'}
                        </DropdownToggle>
                        <DropdownMenu>
                            <Input
                                type="text"
                                value={driverName}
                                onChange={filterDriver}
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Driver Name"
                                id="driver-filter"
                            />
                            {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                filterDriversForAssign.map((driver, key) => {
                                    // if(driver.is_available === true || driver.is_available === "true") {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handleReassignDriverSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    // }
                                    return null;
                                })
                            ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                driversForAssign.map((driver, key) => {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handleReassignDriverSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    // }
                                    return null;
                                })
                            ) : (
                                <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                            )}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleReassign();
                            resetReassign();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => reassignDriverToRoute(driverReassign)}>
                        Confirm
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalAssignPassengerOnly} toggle={toggleAssignPassengerOnly}>
                <ModalBody style={{ alignSelf: 'center', textAlign: 'center' }}>
                    <h4 style={{ color: '#000', textAlign: 'left', marginLeft: '5px' }}>Route: {route.route_friendly_id}</h4>
                    {/* <p>{route.distance.toFixed(2) + ' miles'}</p> */}
                    <p style={{ fontSize: 14, marginTop: '-5px', textAlign: 'left', marginLeft: '25px' }}>
                        Requires <span style={{ color: 'red' }}>{route.num_of_gophrs}</span> Gophrs, and now <span style={{ color: 'blue' }}>{route.RouteDrivers.length}</span> on
                        it
                    </p>
                    <hr style={{ backgroundColor: '#cdcaca' }}></hr>
                    <h4 style={{ color: '#000' }}>Select passenger(s)</h4>

                    <UncontrolledDropdown>
                        <DropdownToggle caret id="passenger1-dropdown">
                            {passenger1OnlyAssigned
                                ? passenger1OnlyAssigned.User.firstname +
                                  ' ' +
                                  passenger1OnlyAssigned.User.lastname +
                                  ' - ' +
                                  passenger1OnlyAssigned.Vehicles[0].type.replace(/_/, ' ')
                                : 'Select a Passenger'}
                        </DropdownToggle>
                        <DropdownMenu>
                            <Input
                                type="text"
                                value={driverName}
                                onChange={filterDriver}
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Driver Name"
                                id="driver-filter"
                            />
                            {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                filterDriversForAssign.map((driver, key) => {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger1OnlyAssignedSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    return null;
                                })
                            ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                driversForAssign.map((driver, key) => {
                                    if (driver.Vehicles.length > 0) {
                                        return (
                                            <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger1OnlyAssignedSelect(driver)}>
                                                <DriverList driver={driver} />
                                            </DropdownItem>
                                        );
                                    }
                                    return null;
                                })
                            ) : (
                                <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                            )}
                        </DropdownMenu>
                    </UncontrolledDropdown>

                    <div hidden={!passenger1OnlyAssignedSelected}>
                        <UncontrolledDropdown>
                            <DropdownToggle caret id="passenger2-dropdown">
                                {passenger2OnlyAssigned
                                    ? passenger2OnlyAssigned.User.firstname +
                                      ' ' +
                                      passenger2OnlyAssigned.User.lastname +
                                      ' - ' +
                                      passenger2OnlyAssigned.Vehicles[0].type.replace(/_/, ' ')
                                    : 'Select a Passenger'}
                            </DropdownToggle>
                            <DropdownMenu>
                                <Input
                                    type="text"
                                    value={driverName}
                                    onChange={filterDriver}
                                    style={{ color: 'black', alignSelf: 'left' }}
                                    placeholder="Driver Name"
                                    id="driver-filter"
                                />
                                {filterDriversForAssign.length > 0 && isFilterDrivers ? (
                                    filterDriversForAssign.map((driver, key) => {
                                        // if((primaryDriver !== driver && passenger1 !== driver) && (driver.is_available === "true" || driver.is_available === true) && driver.Vehicles.length > 0) {
                                        if (passenger1OnlyAssigned !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger2OnlyAssignedSelect(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : filterDriversForAssign.length === 0 && !isFilterDrivers ? (
                                    driversForAssign.map((driver, key) => {
                                        // if((primaryDriver !== driver && passenger1 !== driver) && (driver.is_available === "true" || driver.is_available === true) && driver.Vehicles.length > 0) {
                                        if (passenger1OnlyAssigned !== driver && driver.Vehicles.length > 0) {
                                            return (
                                                <DropdownItem key={getDriverOptionKey(driver, key)} onClick={() => handlePassenger2OnlyAssignedSelect(driver)}>
                                                    <DriverList driver={driver} />
                                                </DropdownItem>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    <p style={{ color: 'red', margin: 10, marginLeft: 25 }}>No drivers found</p>
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                    {(passenger1OnlyAssignedSelected && passenger2OnlyAssignedSelected ? 2 : passenger1OnlyAssignedSelected ? 1 : 0) + route.RouteDrivers.length >
                    route.num_of_gophrs ? (
                        <p style={{ color: 'red', fontSize: 15, marginTop: '10px', textAlign: 'left', marginLeft: '25px' }}>
                            You try to assign{' '}
                            {(passenger1OnlyAssignedSelected && passenger2OnlyAssignedSelected ? 2 : passenger1OnlyAssignedSelected ? 1 : 0) +
                                route.RouteDrivers.length -
                                route.num_of_gophrs}{' '}
                            more Gophrs than required, are you sure? If so confirm, else cancel
                        </p>
                    ) : null}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="warning"
                        onClick={() => {
                            toggleAssignPassengerOnly();
                            resetAssignPassengerOnly();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="success" onClick={() => assignPassengerOnlyToRoute(passenger1OnlyAssigned, passenger2OnlyAssigned)}>
                        Confirm
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showDriverMessageForm} toggle={toggleDriverMessageForm} className="iphone-chat-modal">
                <ModalBody className="iphone-chat-modal-body">
                    <div className="iphone-chat-header">
                        <div className="iphone-chat-header__title-row">
                            <div className="iphone-chat-header__avatars">
                                {messageRecipientInfo && messageRecipientInfo.chatReadOnly ? (
                                    <>
                                        <div className="iphone-chat-avatar iphone-chat-avatar--self">{getChatNameInitials(messageRecipientInfo.chatCustomerDisplayName)}</div>
                                        <div className="iphone-chat-avatar iphone-chat-avatar--recipient">{getChatNameInitials(messageRecipientInfo.chatDriverDisplayName)}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className="iphone-chat-avatar iphone-chat-avatar--self">You</div>
                                        <div className="iphone-chat-avatar iphone-chat-avatar--recipient">{getChatNameInitials(getChatDisplayName(messageRecipientInfo))}</div>
                                    </>
                                )}
                            </div>
                            <div className="iphone-chat-header__meta">
                                <h4 className="iphone-chat-header__title">{getChatTitle(messageRecipientInfo)}</h4>
                                <p className="iphone-chat-header__subtitle">
                                    {getChatDisplayName(messageRecipientInfo)}
                                    {messageRecipientInfo.chatShipmentFriendlyId ? ` • Shipment #${messageRecipientInfo.chatShipmentFriendlyId}` : ''}
                                </p>
                            </div>
                        </div>
                        {messageRecipientInfo.chatMode === 'order-thread' ? null : (
                            <DriverSMSRefreshButton retrieveMessage={retrieveMessage} messageRecipient={messageRecipientInfo} />
                        )}
                    </div>

                    <MessageLogsContainer driverMessageRetrieved={driverMessageRetrieved} messageRecipientInfo={messageRecipientInfo} />

                    {messageRecipientInfo && messageRecipientInfo.chatReadOnly ? null : (
                    <div className="iphone-chat-composer">
                        <textarea
                            id="driver-message"
                            value={driverMessage}
                            onChange={e => {
                                setDriverMessage(e.target.value);
                            }}
                            className="iphone-chat-composer__input"
                            placeholder={`Message ${getChatDisplayName(messageRecipientInfo)}...`}
                        />
                        <div className="iphone-chat-composer__actions">
                            {messageRecipientInfo.chatMode === 'order-thread' ? null : (
                                <>
                                    <label className="iphone-chat-attachment-button">
                                        <FontAwesomeIcon icon={faPaperclip} />
                                        {' '}Attach file
                                        <input
                                            type="file"
                                            accept="image/*,application/pdf,.doc,.docx,.odt"
                                            onChange={handleDriverMessageAttachmentChange}
                                        />
                                    </label>
                                    {driverMessageAttachment ? (
                                        <div className="iphone-chat-attachment-pill">
                                            <span>{driverMessageAttachment.name}</span>
                                            <button type="button" className="iphone-chat-attachment-pill__remove" onClick={removeDriverMessageAttachment}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        </div>
                                    ) : null}
                                    {driverMessageAttachmentError ? <div className="iphone-chat-attachment-error">{driverMessageAttachmentError}</div> : null}
                                </>
                            )}
                        </div>
                    </div>
                    )}
                </ModalBody>
                <ModalFooter className="iphone-chat-modal-footer">
                    <Button
                        color="default"
                        onClick={() => {
                            toggleDriverMessageForm();
                            resetDriverMessageComposer();
                        }}
                    >
                        Close
                    </Button>
                    {messageRecipientInfo && messageRecipientInfo.chatReadOnly ? null : (
                    <Button color="warning" onClick={() => sendMessage(driverMessage, messageRecipientInfo)}>
                        <FontAwesomeIcon icon={faPaperPlane} />
                        {' '}Send
                    </Button>
                    )}
                </ModalFooter>
            </Modal>
            <Modal isOpen={showUpdateShippingFee} toggle={toggleShippingFee}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Update Shipping Fee</h4>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Reason:{' '}
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="shipping-fee-reason"
                                value={shippingFeeReason}
                                onChange={e => {
                                    setShippingFeeReason(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="extra weights && MS(initial)"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px` }}>
                            Ship_fee($):
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="shipping-fee"
                                value={shippingFee}
                                onChange={e => {
                                    setShippingFee(e.target.value);
                                }}
                                type="number"
                                style={{ color: 'black' }}
                                placeholder="18.25"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleShippingFee();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => updateShippingFee(shipment)}>
                        Update
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showChargeSetupFee} toggle={toggleSetupFee}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Charge Setup Fee</h4>
                    <FormGroup row>
                        <Label sm={4} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'right' }}>
                            Setup Time (hr):
                        </Label>
                        <Col sm={7}>
                            <Input
                                id="setup-fee"
                                value={setupDuration}
                                onChange={e => {
                                    setSetupDuration(e.target.value);
                                }}
                                type="number"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="1.0"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleSetupFee();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => chargeSetupFee(shipment)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showDriverPay} toggle={toggleDriverPay}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Driver Pay Info</h4>
                    <div style={{ textAlign: 'center', marginBottom: 10, marginLeft: 30 }}>
                        <Row>
                            <Col style={{ textAlign: 'left', marginLeft: 50 }}>
                                <p>name:</p>
                                <p>status: </p>
                                <p>distance earning: </p>
                                <p>expedited earning: </p>
                                <p>overweight earning: </p>
                                <p>setup earning: </p>
                                <p>tools earning: </p>
                                <p>gratuity: </p>
                                <p>bonus: </p>
                                <p>min pay: </p>
                                <p>total earning: </p>
                            </Col>
                            <Col style={{ textAlign: 'right', marginRight: 80 }}>
                                <p>
                                    {driverPay && driverPay.first_name ? driverPay.first_name : ''} {driverPay && driverPay.last_name ? driverPay.last_name : ''}
                                </p>
                                <p> {driverPay && driverPay.driver_status ? driverPay.driver_status : ''}</p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.distance_earning)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.expedited_earning)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.overweight_earning)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.setup_earning)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.tools_earning)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.gratuity)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.bonus)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.min_pay)} </p>
                                <p> ${formatCurrencyAmount(driverPay && driverPay.total_earning)} </p>
                            </Col>
                        </Row>
                    </div>

                    {driverPayRecords.some(pay => !pay.payed_status) && (
                        <div style={{ borderTop: '1px solid #ddd', marginTop: 16, paddingTop: 16, textAlign: 'left' }}>
                            <h4 style={{ color: 'orange', textAlign: 'center' }}>Resolve payment outside Branch</h4>
                            <FormGroup>
                                <Label for="external-payment-reference">Payment reference</Label>
                                <Input
                                    id="external-payment-reference"
                                    value={externalPaymentReference}
                                    onChange={event => setExternalPaymentReference(event.target.value)}
                                    maxLength={200}
                                    style={{ color: 'black' }}
                                    placeholder="ACH, check, or transaction reference"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="external-payment-note">Resolution note</Label>
                                <Input
                                    id="external-payment-note"
                                    value={externalPaymentNote}
                                    onChange={event => setExternalPaymentNote(event.target.value)}
                                    maxLength={1000}
                                    style={{ color: 'black' }}
                                    placeholder="How and when the driver was paid"
                                />
                            </FormGroup>
                            {driverPayRecords.filter(pay => !pay.payed_status).map(pay => (
                                <Button
                                    key={pay.pay_id}
                                    color="success"
                                    block
                                    disabled={resolvingDriverPayId !== '' || !externalPaymentReference.trim() || !externalPaymentNote.trim()}
                                    onClick={() => resolveDriverPaymentExternally(pay)}
                                >
                                    {resolvingDriverPayId === pay.pay_id
                                        ? 'Resolving...'
                                        : `Mark $${formatCurrencyAmount(pay.total_earning)} resolved`}
                                </Button>
                            ))}
                        </div>
                    )}

                    <h4 style={{ color: 'orange' }}>Update bonus</h4>

                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Reason:
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="bonus-reason"
                                value={bonusReason}
                                onChange={e => {
                                    setBonusReason(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="extra miles && MS(initial)"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Bonus($):{' '}
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="bonus"
                                value={driverBonus}
                                onChange={e => {
                                    setDriverBonus(e.target.value);
                                }}
                                type="number"
                                style={{ color: 'black', alignSelf: 'center' }}
                                placeholder="10.00"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleDriverPay();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => updateBonus(driverPay)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showDriverInfoAndPO} toggle={toggleDriverInfoAndPO}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Driver Info</h4>
                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            First Name:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="route-driver-first-name"
                                value={routeDriverFirstName}
                                onChange={e => {
                                    setRouteDriverFirstName(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="John"
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Last Name:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="route-driver-last-name"
                                value={routeDriverLastName}
                                onChange={e => {
                                    setRouteDriverLastName(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Doe"
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Phone:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="route-driver-phone"
                                value={routeDriverPhone}
                                onChange={e => {
                                    setRouteDriverPhone(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="3371234567"
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            ELD #
                        </Label>

                        <Col sm={9}>
                            <Input
                                id="route-driver-po#"
                                value={routeDriverPONumber}
                                onChange={e => {
                                    setRouteDriverPONumber(e.target.value);
                                }}
                                type="number"
                                style={{ color: 'black', alignSelf: 'center' }}
                                placeholder="1234567"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleDriverInfoAndPO();
                        }}
                    >
                        Cancel
                    </Button>
                    {(routeDriverFirstName !== '' || routeDriverLastName !== '' || routeDriverPhone !== '' || routeDriverPONumber !== '') && (
                        <Button color="info" onClick={() => updateRouteDriverInfoAndPO(routeDriverRouteId)}>
                            Save
                        </Button>
                    )}
                </ModalFooter>
            </Modal>

            <Modal isOpen={showUpdateOrderInfo} toggle={toggleShowUpdateOrderInfo}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Update Order Info</h4>
                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            First Name:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="update-order-first_name"
                                value={updateOrderInfo.first_name}
                                onChange={e => {
                                    setUpdateOrderInfo({ ...updateOrderInfo, first_name: e.target.value });
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="John"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Last Name:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="update-order-last_name"
                                value={updateOrderInfo.last_name}
                                onChange={e => {
                                    setUpdateOrderInfo({ ...updateOrderInfo, last_name: e.target.value });
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Doe"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Phone:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="update-order-phone"
                                value={updateOrderInfo.phone}
                                onChange={e => {
                                    setUpdateOrderInfo({ ...updateOrderInfo, phone: e.target.value });
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="3371234567"
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Business Name:
                        </Label>
                        <Col sm={9}>
                            <Input
                                id="update-order-business_name"
                                value={updateOrderInfo.business_name}
                                onChange={e => {
                                    setUpdateOrderInfo({ ...updateOrderInfo, business_name: e.target.value });
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="Home Depot"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={3} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            {orderType} Instruction:
                        </Label>

                        <Col sm={9}>
                            <Input
                                id="update-order-instruction"
                                value={updateOrderInfo.instruction}
                                onChange={e => {
                                    setUpdateOrderInfo({ ...updateOrderInfo, instruction: e.target.value });
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'center' }}
                                placeholder="call 10 minutes before arrival"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleShowUpdateOrderInfo();
                        }}
                    >
                        Cancel
                    </Button>
                    {Object.values(updateOrderInfo).some(value => value.trim() !== '') && (
                        <Button color="info" onClick={() => updateOrderInfoForAdmin(orderId)}>
                            Save
                        </Button>
                    )}
                </ModalFooter>
            </Modal>

            <Modal isOpen={showReorderWaypoints} toggle={toggleReorderWaypoints}>
                <ModalBody style={{ alignSelf: 'center', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Reorder Route</h4>
                    <div style={{ alignSelf: 'center' }}>
                        <ReorderWaypoints routeWaypoints={routeWaypoints} setRouteWaypoints={setRouteWaypoints} />
                        {isReorderError && <h5 style={{ color: 'red' }}>{reorderError}</h5>}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleReorderWaypoints();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => handleReorder(route.route_id, routeWaypoints)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showGasPrice} toggle={toggleGasPrice}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'black' }}>
                        Update Fuel Price(s) for Market: <span style={{ color: 'red' }}>{marketName} </span>
                    </h4>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Gas($):
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="gas-price"
                                value={gasPriceUpdate}
                                onChange={e => {
                                    setGasPriceUpdate(e.target.value);
                                    if (e.target.value !== '') {
                                        if (e.target.value <= 0 || e.target.value >= 10) {
                                            setGasPriceError(true);
                                        } else {
                                            setGasPriceError(false);
                                        }
                                    } else {
                                        setGasPriceError(false);
                                    }
                                }}
                                type="number"
                                style={{ color: 'black' }}
                                placeholder="3.99"
                            />
                        </Col>
                    </FormGroup>
                    {gasPriceError && (
                        <p style={{ color: 'red', fontSize: 13, marginTop: '10px', textAlign: 'left', marginLeft: '80px', marginBottom: '10px' }}>
                            Make Sure to input the right value
                        </p>
                    )}
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Diesel($):
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="diesel-price"
                                value={dieselPriceUpdate}
                                onChange={e => {
                                    setDieselPriceUpdate(e.target.value);
                                    if (e.target.value !== '') {
                                        if (e.target.value <= 0 || e.target.value >= 10) {
                                            setDieselPriceError(true);
                                        } else {
                                            setDieselPriceError(false);
                                        }
                                    } else {
                                        setDieselPriceError(false);
                                    }
                                }}
                                type="number"
                                style={{ color: 'black' }}
                                placeholder="4.99"
                            />
                        </Col>
                    </FormGroup>
                    {dieselPriceError && (
                        <p style={{ color: 'red', fontSize: 13, marginTop: '10px', textAlign: 'left', marginLeft: '80px', marginBottom: '10px' }}>
                            Make Sure to input the right value
                        </p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleGasPrice();
                        }}
                    >
                        Cancel
                    </Button>
                    {!gasPriceError && !dieselPriceError && ((gasPriceUpdate !== null && gasPriceUpdate !== '') || (dieselPriceUpdate !== null && dieselPriceUpdate !== '')) && (
                        <Button color="info" onClick={() => handleGasPriceUpdate(gasPriceUpdate, dieselPriceUpdate)}>
                            Save
                        </Button>
                    )}
                </ModalFooter>
            </Modal>

            <Modal isOpen={showGasPriceRegion} toggle={toggleGasPriceRegion}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    {region && (
                        <div>
                            <h4 style={{ color: 'black' }}>
                                Update Fuel Price(s) for Region: <span style={{ color: 'red' }}>{region.region_name}</span>
                            </h4>

                            <h5 style={{ color: 'black', fontSize: '1.1em' }}>Current Region Fuel Price</h5>
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', fontWeight: 'bold' }}>
                                    <div style={{ flex: 1 }}>Region</div>
                                    <div style={{ flex: 1 }}>Gas Price($)</div>
                                    <div style={{ flex: 1 }}>Diesel Price($)</div>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ flex: 1 }}>{region.region_name}</div>
                                    <div style={{ flex: 1 }}>{formatFuelPrice(region.gas_price)}</div>
                                    <div style={{ flex: 1 }}>{formatFuelPrice(region.diesel_price)}</div>
                                </div>
                            </div>

                            <h5 style={{ color: 'black', fontSize: '1.1em' }}>Current Fuel Price For Each Market </h5>
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', fontWeight: 'bold' }}>
                                    <div style={{ flex: 1 }}>Market</div>
                                    <div style={{ flex: 1 }}>Gas Price($)</div>
                                    <div style={{ flex: 1 }}>Diesel Price($)</div>
                                </div>
                                {region.Markets.map((market, index) => (
                                    <div key={getMarketRowKey(market, index)} style={{ display: 'flex' }}>
                                        <div style={{ flex: 1 }}>{market.market_name}</div>
                                        <div style={{ flex: 1 }}>{formatFuelPrice(market.fuel_prices && market.fuel_prices.gas_price)}</div>
                                        <div style={{ flex: 1 }}>{formatFuelPrice(market.fuel_prices && market.fuel_prices.diesel_price)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Gas($):
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="gas-price"
                                value={gasPriceUpdate}
                                onChange={e => {
                                    setGasPriceUpdate(e.target.value);
                                    if (e.target.value !== '') {
                                        if (e.target.value <= 0 || e.target.value >= 10) {
                                            setGasPriceError(true);
                                        } else {
                                            setGasPriceError(false);
                                        }
                                    } else {
                                        setGasPriceError(false);
                                    }
                                }}
                                type="number"
                                style={{ color: 'black' }}
                                placeholder="3.99"
                            />
                        </Col>
                    </FormGroup>
                    {gasPriceError && (
                        <p style={{ color: 'red', fontSize: 13, marginTop: '10px', textAlign: 'left', marginLeft: '80px', marginBottom: '10px' }}>
                            Make Sure to input the right value
                        </p>
                    )}
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Diesel($):
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="diesel-price"
                                value={dieselPriceUpdate}
                                onChange={e => {
                                    setDieselPriceUpdate(e.target.value);
                                    if (e.target.value !== '') {
                                        if (e.target.value <= 0 || e.target.value >= 10) {
                                            setDieselPriceError(true);
                                        } else {
                                            setDieselPriceError(false);
                                        }
                                    } else {
                                        setDieselPriceError(false);
                                    }
                                }}
                                type="number"
                                style={{ color: 'black' }}
                                placeholder="4.99"
                            />
                        </Col>
                    </FormGroup>
                    {dieselPriceError && (
                        <p style={{ color: 'red', fontSize: 13, marginTop: '10px', textAlign: 'left', marginLeft: '80px', marginBottom: '10px' }}>
                            Make Sure to input the right value
                        </p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleGasPriceRegion();
                        }}
                    >
                        Cancel
                    </Button>
                    {!gasPriceError && !dieselPriceError && ((gasPriceUpdate !== null && gasPriceUpdate !== '') || (dieselPriceUpdate !== null && dieselPriceUpdate !== '')) && (
                        <Button color="info" onClick={() => handleGasPriceUpdateThroughRegion(gasPriceUpdate, dieselPriceUpdate)}>
                            Save
                        </Button>
                    )}
                </ModalFooter>
            </Modal>

            <Modal isOpen={showMarketNote} toggle={toggleMarketNote}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'black' }}>
                        Update Note for Market: <span style={{ color: 'red' }}>{marketName} </span>
                    </h4>
                    <p style={{ textAlign: 'left', marginBottom: '20px' }}>
                        <span style={{ color: 'blue' }}>Current Note:</span> {marketNote.note}
                    </p>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Note:
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="market-note"
                                value={marketNoteUpdate}
                                onChange={e => {
                                    setMarketNoteUpdate(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black' }}
                                placeholder="Keep empty and save to clear note"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleMarketNote();
                        }}
                    >
                        Cancel
                    </Button>

                    <Button color="info" onClick={() => handleMarketNoteUpdate(marketNoteUpdate)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showMarketNoteRegion} toggle={toggleMarketNoteRegion}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    {regionNote && (
                        <div>
                            <h4 style={{ color: 'black' }}>
                                Update Market Note for Region: <span style={{ color: 'red' }}>{regionNote.region_name}</span>
                            </h4>

                            <h5 style={{ color: 'black', fontSize: '1.1em' }}>Current Note For Each Market </h5>
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', fontWeight: 'bold' }}>
                                    <div style={{ flex: 1 }}>Market</div>
                                    <div style={{ flex: 3 }}>Note</div>
                                </div>
                                {regionNote.Markets.map((market, index) => (
                                    <div key={getMarketRowKey(market, index)} style={{ display: 'flex' }}>
                                        <div style={{ flex: 1, color: 'blue' }}>{market.market_name}</div>
                                        <div style={{ flex: 3, textAlign: 'left' }}>{market.note}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Note:
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="region-market-note"
                                value={marketNoteUpdate}
                                onChange={e => {
                                    setMarketNoteUpdate(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black' }}
                                placeholder="Keep empty and save to clear note"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleMarketNoteRegion();
                        }}
                    >
                        Cancel
                    </Button>

                    <Button color="info" onClick={() => handleMarketNoteUpdateThroughRegion(marketNoteUpdate)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showUpdateDriverPayBeforeClaim} toggle={toggleUpdateDriverPayBeforeClaim}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Driver Pay Info</h4>
                    <div style={{ textAlign: 'center', marginBottom: 10, marginLeft: 30 }}>
                        <Row>
                            <Col style={{ textAlign: 'left', marginLeft: 50 }}>
                                <p>distance earning: </p>
                                <p>expedited earning: </p>
                                <p>overweight earning: </p>
                                <p>setup earning: </p>
                                <p>tools earning: </p>
                                <p>gratuity: </p>
                                <p>bonus: </p>
                                <p>min pay: </p>
                                <p>total earning: </p>
                            </Col>
                            {shipment && (
                                <Col style={{ textAlign: 'right', marginRight: 80 }}>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.distanceEarning_1099)} </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.expeditedEarning_1099)} </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.weightEarning)} </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.setup_earning)} </p>
                                    <p> ${formatCurrencyAmount(driverPay && driverPay.tools_earning)} </p>
                                    <p> $0.00 </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.bonus)} </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.minDriverPay_1099)} </p>
                                    <p> ${formatCurrencyAmount(shipment.shipping_fee_blob && shipment.shipping_fee_blob.driverEarning && shipment.shipping_fee_blob.driverEarning.driver_1099_earning)} </p>
                                </Col>
                            )}
                        </Row>
                    </div>

                    <h4 style={{ color: 'orange' }}>Update Total Earning</h4>

                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Reason:
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="total-earning-reason"
                                value={updateDriverPayBeforeClaimReason}
                                onChange={e => {
                                    setUpdateDriverPayBeforeClaimReason(e.target.value);
                                }}
                                type="text"
                                style={{ color: 'black', alignSelf: 'left' }}
                                placeholder="extra miles && MS(initial)"
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                            Total($):{' '}
                        </Label>
                        <Col sm={10}>
                            <Input
                                id="bonus"
                                value={driverPayBeforeClaimTotalAmount}
                                onChange={e => {
                                    setDriverPayBeforeClaimTotalAmount(e.target.value);
                                }}
                                type="number"
                                style={{ color: 'black', alignSelf: 'center' }}
                                placeholder="10.00"
                            />
                        </Col>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            toggleUpdateDriverPayBeforeClaim();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button color="info" onClick={() => updateTotalDriverPayBeforeClaim(shipment)}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showDemurrageReviewModal} toggle={toggleDemurrageReviewModal}>
                <ModalBody style={{ alignSelf: 'left', textAlign: 'center', display: 'block' }}>
                    <h4 style={{ color: 'orange' }}>Review Demurrage</h4>
                    {shipment && shipment.billing_details && shipment.billing_details.demurrage ? (
                        <>
                            <p style={{ color: '#494747', marginBottom: '8px' }}>
                                Shipment {shipment.shipment_friendly_id || shipment.shipment_id}
                            </p>
                            <p style={{ color: '#494747', marginBottom: '8px' }}>
                                Review Amount: ${Number(shipment.billing_details.demurrage.review_amount || 0).toFixed(2)}
                            </p>
                            <p style={{ color: '#494747', marginBottom: '8px' }}>
                                Driver Pay Increase: ${Number((shipment.billing_details.demurrage.review_amount || 0) * 0.75).toFixed(2)}
                            </p>
                            {Array.isArray(shipment.billing_details.demurrage.stops) && shipment.billing_details.demurrage.stops.length > 0 ? (
                                <div style={{ color: '#494747', marginBottom: '16px', textAlign: 'left' }}>
                                    <strong>Stop Breakdown</strong>
                                    {shipment.billing_details.demurrage.stops.map((stop, index) => {
                                        const stopLabel = stop && stop.stop_type ? String(stop.stop_type) : `Stop ${index + 1}`;
                                        const waitMinutes = Number((stop && stop.wait_minutes) || 0);
                                        const freeMinutes = Number((stop && stop.free_minutes) || 0);
                                        const billableMinutes = Number((stop && stop.billable_minutes) || 0);
                                        const amount = Number((stop && stop.amount) || 0);
                                        const stopOrderInfo = getDemurrageStopOrderInfo(shipment, stop);

                                        return (
                                            <div key={`${stop && stop.stop_id ? stop.stop_id : stopLabel}-${index}`} style={{ marginTop: '8px' }}>
                                                <div>
                                                    <strong>{stopLabel}</strong>
                                                </div>
                                                {stopOrderInfo.orderFriendlyId ? (
                                                    <div>
                                                        Order: {stopOrderInfo.orderFriendlyId}
                                                    </div>
                                                ) : null}
                                                {stopOrderInfo.addressLabel ? (
                                                    <div>
                                                        Address: {stopOrderInfo.addressLabel}
                                                    </div>
                                                ) : null}
                                                <div>
                                                    Wait: {waitMinutes}m / Free: {freeMinutes}m / Billable: {billableMinutes}m
                                                </div>
                                                <div>Fee: ${amount.toFixed(2)}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : null}
                            {Array.isArray(shipment.billing_details.demurrage.stops) && shipment.billing_details.demurrage.stops.some(stop => Array.isArray(stop.review_reasons) && stop.review_reasons.length > 0) ? (
                                <p style={{ color: '#494747', marginBottom: '16px' }}>
                                    Flags:{' '}
                                    {Array.from(new Set(shipment.billing_details.demurrage.stops.flatMap(stop => stop.review_reasons || []))).join(', ')}
                                </p>
                            ) : null}
                            <FormGroup row>
                                <Label sm={2} style={{ color: `#494747`, fontSize: `12px`, textAlign: 'left' }}>
                                    Notes:
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        id="demurrage-decision-notes"
                                        value={demurrageDecisionNotes}
                                        onChange={e => {
                                            setDemurrageDecisionNotes(e.target.value);
                                        }}
                                        type="textarea"
                                        style={{ color: 'black', alignSelf: 'left' }}
                                        placeholder="Optional admin note"
                                    />
                                </Col>
                            </FormGroup>
                        </>
                    ) : (
                        <p style={{ color: '#494747' }}>Demurrage details are unavailable.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="default" onClick={toggleDemurrageReviewModal} disabled={isSubmittingDemurrageDecision}>
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        onClick={() => submitDemurrageDecision(shipment, 'rejected')}
                        disabled={isSubmittingDemurrageDecision || !(shipment && shipment.billing_details && shipment.billing_details.demurrage)}
                    >
                        {isSubmittingDemurrageDecision ? 'Working...' : 'Deny'}
                    </Button>
                    <Button
                        color="warning"
                        onClick={() => submitDemurrageDecision(shipment, 'approved')}
                        disabled={
                            isSubmittingDemurrageDecision ||
                            !(shipment && shipment.billing_details && shipment.billing_details.demurrage) ||
                            Number(shipment.billing_details.demurrage.review_amount || 0) <= 0
                        }
                    >
                        {isSubmittingDemurrageDecision ? 'Working...' : 'Apply'}
                    </Button>
                </ModalFooter>
            </Modal>
            <FedexLabelModal isOpen={showFedexLabel} toggle={() => setShowFedexLabel(false)} shipmentId={selectedShipmentId} />
            <FedexTrackingModal isOpen={showTracking} toggle={() => setShowTracking(false)} shipmentId={selectedShipmentId} />

            {/* Payment Retry Modal */}
            {paymentRetryModalOpen && selectedShipmentForPayment && (
                <PaymentRetryModal
                    isOpen={paymentRetryModalOpen}
                    toggle={() => {
                        setPaymentRetryModalOpen(false);
                        setSelectedShipmentForPayment(null);
                    }}
                    shipmentId={selectedShipmentForPayment.shipment_id}
                    shipmentFriendlyId={selectedShipmentForPayment.shipment_friendly_id}
                    shipmentData={selectedShipmentForPayment}
                    fromOrderCreation={false}
                    onSuccess={data => {
                        void data;
                        setPaymentRetryModalOpen(false);
                        setSelectedShipmentForPayment(null);
                        // Apollo subscription will automatically refresh the table
                        // Success message is shown in the modal itself
                    }}
                    onClose={() => {}}
                />
            )}
        </div>
    );
};

export default DispatchOrderTable;
